// to run this script: tap cmd-shift-1 on keyboard; enter `ga_ela_supp_info`
if (!window.custom_scripts) window.custom_scripts = {}
window.custom_scripts.ga_ela_supp_info = {
	input_required: false,
	pre_fn: function(input) {
		return new Promise((resolve, reject)=>{
			let fr = vapp.case_tree_component.framework_record

			// make hash of Standards by hcs; navigate tree to put them in order
			let hcs_hash = {}
			window.custom_scripts.ga_ela_supp_info.get_hcs_hash(hcs_hash, fr.cfo.cftree)
			// console.log(hcs_hash)

			let output = ''
			let lines = window.custom_scripts.ga_ela_supp_info.data.split('\n')

			let data = {}
			let grade_band, grade_band_start, grade_band_end
			let hcs_count = 0, unique_hcs_count = 0
			let current_xhcs
			let hcs_section = 'xxx'
			let hcs_section_text = ''

			// ------------------------------------
			// process each line
			for (let line of lines) {
				// trim, then skip empties and lines we don't want to process
				line = line.trim()
				if (empty(line)) continue
				if (line.search(/<(\/)?(html|body)>$/) > -1) continue
				if (line.search(/^---+$/) == 0) continue

				// ------------------------------------
				// note when we get to a grade band
				let gba = line.match(/^######((\d+)-(\d+))/)
				if (gba) {
					grade_band = gba[1]
					grade_band_start = gba[2] * 1
					grade_band_end = gba[3] * 1
					// console.warn(grade_band_start, grade_band_end)
					continue
				}

				// ------------------------------------
				// when we encounter a hcs, start parsing it
				let hcs, xhcs
				if (line.search(/^([#*][#*]+\s*)?([1-9K-]+\.[A-Z0-9.-]+)/) > -1) {
					// this catches most things
					hcs = RegExp.$2
				}
				// K-12. P. EICC.2
				else if (line.search(/^([#*]+\s*)*([1-9K-]+\.) +([A-Z0-9.-]+) +([A-Z0-9.-]+)/) > -1) {
					hcs = RegExp.$2 + RegExp.$3 + RegExp.$4
					// console.warn('caught! ' + hcs + ' - ' + line)
				}
				// ### **K.F.PA.1:**
				else if (line.search(/^([#*]+\s*[#*]+\s*)?([1-9K-]+\.[A-Z0-9.-]+)/) > -1) {
					hcs = RegExp.$2
					// console.warn('caught: ' + hcs + ' - ' + line)
				}
				// <p>3-5.T.C.2</p>
				else if (line.search(/^(<p>)([1-9K-]+\.[A-Z0-9.-]+)/) > -1) {
					hcs = RegExp.$2
					// console.warn('caught(1): ' + hcs + ' - ' + line)
				}
				// <pre>3-5.T.C.2
				else if (line.search(/^(<pre>)([1-9K-]+\.[A-Z0-9.-]+)/) > -1) {
					hcs = RegExp.$2
					// console.warn('caught(2): ' + hcs + ' - ' + line)
				}
				// <h2>3-5.T.C.2
				else if (line.search(/^(<h2>)([1-9K-]+\.[A-Z0-9.-]+)/) > -1) {
					hcs = RegExp.$2
					// console.warn('caught(3): ' + hcs + ' - ' + line)
				}

				if (hcs) {
					// correct some things from the input
					hcs = hcs.replace(/\.$/, '')

					// --------------------
					let hcs_arr = []
					let status = ' '
					let arr = hcs.match(/^([K1-9]+)(-([K1-9]+))?\.(.*)/)
					// if (hcs.search(/^([K1-9]+)(-([K1-9]+))?\.(.*)/) > -1) {
					if (arr) {
						let start = arr[1]
						let end = arr[3]
						if (empty(end)) end = start
						let rest = arr[4]

						// // if invalid hcs, flag; note that I did this when I started writing the script and added the corrections above to compensate, so this should no longer be relevant
						// let hcss = `${start}.${rest}`
						// if (empty(hcs_hash[hcss])) {
						// 	status = 'x'
						// }

						// translate K to 0 and make them numbers
						if (start == 'K') start = 0
						if (end == 'K') end = 0
						start = start * 1
						end = end * 1

						// get the list of individual hcs's as coded in the CASE doc
						// e.g. 3-5.T.C.2 goes with 3.T.C.2, 4.T.C.2, 5.T.C.2
						for (let i = grade_band_start; i <= grade_band_end; ++i) {
							if (i >= start && i <= end) {
								// if invalid hcs, flag
								let hcss = `${i||'K'}.${rest}`
								// console.log(hcss)
								hcs_arr.push(hcss)
								if (empty(hcs_hash[hcss])) {
									status = 'x'
								} else {
									hcs_hash[hcss].count += 1
								}
							}
						}

					} else {
						// this never happened in our input
						status = 'z'
					}

					xhcs = `${grade_band}::${hcs}`
					++hcs_count
					if (empty(data[xhcs])) {
						data[xhcs] = {
							xhcs: xhcs,
							hcs: hcs,
							hcs_arr: hcs_arr,
							status: status,
							count: 1,
						}
						++unique_hcs_count
					} else {
						data[xhcs].count += 1
					}

					// if we didn't find an hcs_section heading for the previous header, report an error
					if (empty(hcs_section)) {
						// we have weeded all of these out now
						output += `no section found: ${current_xhcs.xhcs}\n`
					
					// else record the hcs_section_text for the previous header
					} else if (current_xhcs) {
						current_xhcs[hcs_section] = hcs_section_text
					}

					current_xhcs = data[xhcs]

					hcs_section = ''

					// done processing the hcs, so go on to the next line
					continue
				}

				// ------------------------------------
				// not an hcs or grade band...
				// so if we just clocked an hcs, we need to find a line indicating what "section" this actually represents
				if (empty(hcs_section)) {
					let skip_line = true
					let lc_text = line.toLowerCase().replace(/<.*?>/g, '').replace(/[^a-z ]/g, '')

					if (lc_text == 'overview of standard') hcs_section = 'Overview of Standard'

					if (lc_text == 'vocabulary') hcs_section = 'Vocabulary'

					if (lc_text == 'instructional strategies for teachers') hcs_section = 'Instructional Strategies for Teachers'
					if (line.search(/• /) == 0) {
						hcs_section = hcs_section = 'Instructional Strategies for Teachers'
						skip_line = false
					}

					if (lc_text == 'evidence of student learning') hcs_section = 'Evidence of Student Learning'
					if (lc_text == 'evidence of learning') hcs_section = 'Evidence of Student Learning'
					if (line == '<table>') {
						hcs_section = 'Evidence of Student Learning'
						skip_line = false
					}

					// this forces processing of the final section
					if (line == 'PROCESS FINAL SECTION') hcs_section = 'PROCESS FINAL SECTION'

					// if we found the section, get ready to process it
					if (!empty(hcs_section)) {
						hcs_section_text = ''
						// then skip this line unless it's one of the special cases
						if (skip_line) {
							continue
						}
					}
				}

				// ------------------------------------
				// process the line!
				// for 'Instructional Strategies for Teachers'
				if (hcs_section == 'Instructional Strategies for Teachers') {
					if (line.search(/• +(.*)/) == 0) {
						line = RegExp.$1
						line = `<li>${line}</li>`
					} else {
						output += `error for ist(${current_xhcs.xhcs}): ${line}\n`
					}
				} else if (hcs_section == 'Vocabulary') {
					line = `<li>${line}</li>`
				}
				
				hcs_section_text += `${line}\n`
			}

			console.log(data)

			// I used this early in script development to make sure we had data for all items coded
			// output = `Unique Count: ${unique_hcs_count}\nTotal Count: ${hcs_count}\n\n${output}`
			// output = `Unique Count: ${unique_hcs_count}\nTotal Count: ${hcs_count}\n\n`
			// for (let xhcs in data) {
			// 	let x = data[xhcs]
			// 	output += `${x.status}\t${xhcs}\t\t${x.hcs}\t${x.count}\n`
			// }
			// // we have exactly 4 for all relevant ones now
			// for (let hcs in hcs_hash) {
			// 	if (hcs_hash[hcs].count != 4) {
			// 		output += `${hcs_hash[hcs].count}\t${hcs}\n`
			// 	}
			// }

			// -----------------------------------
			// Output!
			let count = 0
			for (let key in data) {
				// skip closing key
				if (key == '9-12::K-12.END') continue

				let o = data[key]

				// skip singleton standards from k-2; we get them below
				if (o.hcs_arr.length < 2 && empty(o['Overview of Standard'])) continue


				for (let hcs of o.hcs_arr) {
					++count
					// if (count < 7) continue

					let s = ''

					s += `<hr>\n<p><strong>Overview of Standard</strong></p>\n`
					s += `<p>${o['Overview of Standard']}</p>\n`

					s += `<hr>\n<p><strong>Teacher Vocabulary</strong> <a href="https://lor2.gadoe.org/gadoe/file/d81b2c71-7aca-4f4b-9c86-f200d36e2c08/1/GaDOE-ELA-Standards-Glossary.pdf" target="_blank">K-12 ELA glossary with definitions</a></p>\n`
					s += `<ul>${o['Vocabulary']}</ul>\n`

					s += `<hr>\n<p><strong>Instructional Strategies for Teachers</strong></p>\n`
					s += `<ul>${o['Instructional Strategies for Teachers']}</ul>\n`

					// do some replacements for esl
					let esl = o['Evidence of Student Learning']
					if (empty(esl)) {
						// look elsewhere in data
						let alt_key = key.replace(/::.*/, `::${hcs}`)
						if (!empty(data[alt_key])) {
							esl = data[alt_key]['Evidence of Student Learning']
							// console.log('found it!')
						} else {
							console.warn('xxx: ' + key, o)
						}
					}

					if (!empty(esl)) {
						esl = esl.replace(/<table>/, '<table style="width: 100%;">')
						esl = esl.replace(/<th.*?>Teacher Prompt/, '<th style="width:54%">Teacher Prompt')
						esl = esl.replace(/<th.*?>Student Response/, '<th style="width:46%">Student Response')
						s += `<hr>\n<p><strong>Evidence of Student Learning</strong></p>\n`
						s += `${esl}`
					}

					// process all items with this hcs
					if (empty(hcs_hash[hcs].items)) {
						console.warn('couldn’t find items: ' + hcs)
						continue
					}
					for (let item of hcs_hash[hcs].items) {
						// note that we don't output the fullStatement, because we're not updating it; ItemImportInterface will take care of ensuring we don't "blank out" the fullStatement
						// we do include humanCodingScheme so that the output of this script is readable
						output += `- * {${item.identifier}} :${item.humanCodingScheme}\n`
						output += `EX-IMPORT:\n${s}\n\n`
						// use this to short-circuit to just a few items
						// if (count == 5) {
						// 	resolve(output)
						// 	return
						// }
					}
				}
			}

			resolve(output)
		})
	},

	get_hcs_hash: function(hcs_hash, node) {
		if (node.cfitem.CFItemType == 'Standard') {
			// skip items that include 'This progression begins' or 'This progression ends'
			if (node.cfitem.fullStatement.search(/(This progression (begins|ends))|(This standard only applies)/) > -1) {
				// console.warn(`skipping ${node.cfitem.humanCodingScheme}: ${node.cfitem.fullStatement}`)
			} else {
				if (empty(hcs_hash[node.cfitem.humanCodingScheme])) {
					hcs_hash[node.cfitem.humanCodingScheme] = {
						items: [node.cfitem],
						count: 0
					}
				} else {
					// sometimes there are multiple items that have the same hcs
					hcs_hash[node.cfitem.humanCodingScheme].items.push(node.cfitem)
				}
			}
		}
		if (node.children) for (let child of node.children) {
			window.custom_scripts.ga_ela_supp_info.get_hcs_hash(hcs_hash, child)
		}
	},

	data: `
######0-2
### K.F.PA.1

**Overview of Standard**
In kindergarten, students will work to build a strong foundation of their phonological awareness skills. This standard helps young students to develop a new way to view sounds and words by listening for the parts that sound the same and those that sound different. Rhyming activities used to master this standard can also help show students the proper inflection, pitch, rhythm, and cadence needed to communicate effectively.

---

### K.F.PA.2

**Overview of Standard**
This standard provides students with oral language development by building their understanding of how words and sentences work together to form complete thoughts. Segmenting phrases and sentences into words supports this understanding and serves as building blocks for further literacy development.

---

### K.F.PA.3

**Overview of Standard**
In kindergarten, students work to build a strong foundation of their phonological awareness skills. This standard helps young students develop an understanding of compound words by allowing them to blend and segment words into spoken compound words and then add, delete, and substitute individual words within spoken compound words. Having students work with larger word chunks in compound words supports the work of more complex phonological awareness skills of smaller word parts when working with syllables.

---

### K-1.F.PA.4

**Overview of Standard**
In kindergarten, this standard focuses on helping young students develop an understanding that spoken words are composed of syllables, or word parts, and allows them to learn how to identify and work with those various syllables. Students should be able to count syllables, blend and segment syllables together, and begin to delete syllables in spoken words. In first grade, the standard has students adding, deleting, and substituting various syllables in spoken words.  Manipulating syllables is a crucial skill for students to have as they move into decoding and encoding multisyllabic words. 

---

### K-1.F.PA.5

**Overview of Standard**
This standard has students put sounds together to make a word and break words apart into individual sounds. In Kindergarten, students will blend and segment the initial consonant of a word with the vowel and consonants that follow in one-syllable words. In first grade, students will increase the complexity of this skill to include blends, digraphs, and trigraphs. The ability to blend and segment onsets and rimes helps build the foundational skills necessary to become successful readers and writers by working to recognize common patterns in words.

---

### K-1.F.PA.6

**Overview of Standard**
This standard has students using their oral language skills to identify individual sounds heard at the beginning, end, and middle of spoken words. Students will also strengthen these skills through blending and segmenting these individual sounds to make words. As these skills are solidified, students will work with manipulating individual sounds as they add, delete, and substitute phonemes in spoken words. Research shows us that phonemic awareness and the ability to identify and manipulate individual sounds can be a reliable predictor of reading success.

---

### K.F.CP.1

**Overview of Standard**
This standard allows students to develop an awareness that texts and images communicate messages. This includes students being able to distinguish between letters, words, numerical digits, and graphics. Students will also understand how to interpret print messages they encounter in their environment.

---

### K.F.CP.2

**Overview of Standard**
This standard allows students to explore text through books to solidify their understanding of how books are organized and use that knowledge to maneuver them for their intended purpose. This includes knowing how to correctly hold a book and to begin reading from the front, then turning pages from right to left. It also builds the understanding that we read from top to bottom and left to right. In addition, students can distinguish the front and back covers of a book, while also identifying the elements of those book parts, including author and illustrator.

---

### K.F.CP.3

**Overview of Standard**
This standard builds the knowledge base of print conventions for learners. This includes recognizing that words are made up of letters and separated by spaces. This standard also develops the understanding that sentences have beginning capitalization and end punctuation.

---

### K.F.CP.4

**Overview of Standard**
This standard provides foundational knowledge of the alphabet. Students will be expected to recite the alphabet in order and name and identify each capital and lowercase letter in random order. Alphabet knowledge is a crucial skill in learning to read and is a predictor of future reading success.

---

### K-2.F.P.1

**Overview of Standard**
In this standard, students identify and produce consonants and vowels (graphemes), while also producing their corresponding sounds (phonemes). Kindergarten students will focus on the most frequently used sound for each consonant and long and short vowels. First graders will progress to frequently-used consonant blends and digraphs, final –e, and vowel digraphs. Second graders will be expected to identify and produce correspondences for all consonants and for vowels including final -e, vowel digraphs, r-controlled vowels, and diphthongs.

---

### K-2.F.P.2

**Overview of Standard**
In this standard, students will use phonemic awareness skills (e.g., blending individual sounds) as they apply their knowledge of phoneme-grapheme correspondence and spelling patterns to accurately decode words in context and in isolation. As students develop their decoding skills, they will be able to recognize familiar words quickly and figure out words they haven’t seen before, leading them to become proficient readers. Decoding is a key component in reading fluency and ultimately reading comprehension.

---

### K-2.F.P.3

**Overview of Standard**
Encoding is the counterpart to decoding. In this standard, students will use phonemic awareness skills (e.g., segmenting individual sounds) as they apply their knowledge of phoneme-grapheme correspondences and spelling patterns to accurately encode words in context and in isolation. As students develop their encoding skills, they will be able to spell words more automatically. This spelling fluency will support students as they become proficient writers.

---

### K-2.F.F.1

**Overview of Standard**
In this standard, students begin to learn to read with fluency to ensure they comprehend grade-level texts. When students can read grade-level texts with fluency, it allows them to focus their full efforts on understanding the text. In kindergarten, students begin to practice fluency by reading names and reading chorally with purpose, appropriate rate, and volume. First graders advance their fluency skills by becoming more accurate; adding in prosody; and self-correcting their mistakes. In second grade, students become increasingly automatic with increasingly complex text.

---

### K-2.F.H.1

**Overview of Standard**
In this standard, teachers provide explicit instruction to model the formation of letters and words. Explicit instruction on letter formation is important for students, including demonstrations by the teacher coupled with verbal explanations of the process. The development of fine motor skills will aid students in correct letter and word formation. The progression of this standard allows students to become more accurate and consistent in first grade, leading them towards efficiency in second grade.

---

### K-2.F.H.2

**Overview of Standard**
In this standard, students focus on spelling and handwriting skills. These foundational skills are essential for students to begin putting their thoughts into written form. When students achieve automaticity and fluency with spelling and handwriting, they can begin to concentrate on other aspects of writing.

---

### K-2.L.GC.1

**Overview of Standard**
In this standard, students are introduced to several grammar, usage, and mechanics skills that will allow them to develop a firm foundation in Standard English for the purposes of speaking and writing. These skills will be learned and applied through the interpreting and constructing of varied texts. See the K-12 Grammar, Usage, & Mechanics (GUM) Chart for information regarding specific grade levels for introducing, continuing, and mastering these skills.

---

### K-2.L.GC.2

**Overview of Standard**
In this standard, students deepen their understanding of how sentences are constructed to continue developing their syntactic awareness. Understanding varying sentence structures helps students interpret and construct texts. Students analyze model sentences as a basis for composing their own sentences and to aid in comprehending increasingly complex texts.

---

### K-2.L.V.1

**Overview of Standard**
In this standard, students will acquire and use vocabulary with accuracy and precision. They will expand their vocabulary by studying words in context rather than in isolation. Students will explore a wide range of common words used across multiple subjects and in everyday language; words frequently used in academic contexts across various disciplines; and subject-specific terms essential for understanding specific fields or topics. Students deepen their understanding and ability to use words effectively across a range of contexts.

---

### 1-2.L.V.2

**Overview of Standard**
In this standard, students will begin to identify frequently used root words and affixes (prefixes, suffixes) to allow them to deconstruct words to determine meaning. They will also use those same frequently used roots and affixes to construct words. This standard will help students build work analysis skills (morphology) which will allow them to build meaning around unknown words they encounter in text.

---

### K-2.L.V.3

**Overview of Standard**
In this standard, students will begin to develop an understanding that the meaning of words can be determined through context. They will explore synonyms and antonyms, as well as the shades of meaning of various vocabulary words, to help them develop an awareness of how to decipher meaning as they encounter words in text. They will also begin to learn how to use reference materials such as glossaries and dictionaries, both print and digital, to help them clarify the meaning of unknown words. These skills will then be used for students to make choices about word use when speaking and writing. 

---

**K.F.PA.1**
**Vocabulary**

Rhyme

---

**K.F.PA.2**
**Vocabulary**

Word
Sentence
Phrase
Segment

---

**K.F.PA.3**
**Vocabulary**

Compound Words
Segment
Add
Blend
Delete
Substitute

---

**K-1.F.PA.4**
**Vocabulary**

Syllables
Multisyllabic
Add
Delete
Blend
Substitute
Segment
Add
Delete
Substitute

---

**K-1.F.PA.5**
**Vocabulary**

Blend
Onset
Rime
Syllable
Consonant Blend
Digraphs
Trigraphs
Segment


---

**K-1.F.PA.6**
**Vocabulary**

Phonemic awareness
Initial
Final
Medial
Blend
Segment
Phonemic
Phoneme
Short vowel
Long vowel
Consonant Blend
Digraph

---

**K.F.CP.1**
**Vocabulary**

Texts
Labels
Letters
Digits
Images
Signs
Words
Graphics

---

**K.F.CP.2**
**Vocabulary**

Author
Illustrator
Graphic

---

**K.F.CP.3**
**Vocabulary**

Words
Spaces
Capital letters
Letters
Sentences
Punctuation

---

**K.F.CP.4**
**Vocabulary**

Alphabet
Uppercase letter
Letters
Lowercase letters

---

**K-2.F.P.1**
**Vocabulary**

Initial
Final
Medial
Phoneme
Short vowel
Long vowel

---

**K-2.F.P.2**
**Vocabulary**

Blend
Decode
High-frequency word
Irregularly spelled
Nonsense words
Syllable type
Regularly spelled


---

**K-2.F.P.3**
**Vocabulary**

Phoneme
Grapheme
Encode
High-frequency word
Regularly spelled
Irregularly spelled
Nonsense words
Syllable type
Regularly spelled

---

**K-2.F.F.1**
**Vocabulary**

Fluency
Intonation
Irregularly spelled words
Regularly spelled words
Frequency
Automaticity
Oral reading fluency
Prosody

---

**K-2.F.H.1**
**Vocabulary**

Uppercase letters
Lowercase letters

---

**K-2.F.H.2**
**Vocabulary**

Transcription
Fluency
Letters
Words
Sentences

---

**K-2.L.GC.1**
**Vocabulary**

Nouns
Verbs
Singular nouns
Plural nouns
Interrogatives
Capitalize
Pronouns
Adjectives
Adverbs
Common nouns/Proper nouns
Simple verb tense
Determiners
Articles
Possessive determiners
Demonstrative adjectives
Periods
Personal pronouns
Exclamation marks
Question marks
Prepositions
Commas

---

**K-2.L.GC.2**
**Vocabulary**

Subject
Predicate
Complete and incomplete sentences
Sentence type (declarative, interrogatory, imperative, exclamatory)
Simple sentences
Compound sentences
Singular and plural subjects
Subject-Verb Agreement
Adjectives
Adverbs

---

**K-2.L.V.1**
**Vocabulary**

General Vocabulary
Academic Vocabulary
Specialized Vocabulary

---

**1-2.L.V.2**
**Vocabulary**

Root words
Inflectional endings
Affixes

---

**K-2.L.V.3**
**Vocabulary**

Context Clues 
Multiple-meaning words  
Synonyms 
Antonyms 
Shades of Meaning 
Glossaries 
Dictionary 

---

### **K.F.PA.1:**

<b>Instructional Strategies for Teachers</b>
• Select texts to read that have rhyme patterns (e.g., nursery rhymes, poems, books, songs) and identify rhyming words.
• Write texts with rhyme patterns on chart paper and have students identify rhyming words.
• Write texts with rhyme patterns on chart paper and leave out a rhyming word for students to fill in.
• Sing a song with rhyming words and use hand motions when you hear a rhyming word.
• Use picture cards (e.g., star, car, fish) to practice identifying those that rhyme and those that do not.
• Use picture cards (e.g., star, car, fish) to practice producing a rhyming word for a chosen card.
• Have students identify pairs of words that rhyme from favorite texts and illustrate them for a class book.

---

### **K.F.PA.2:**

<b>Instructional Strategies for Teachers</b>
• Say a phrase or sentence aloud and have students clap or move a manipulative for each word they hear.
• Use letters in students’ names to represent the idea that words have distinct meaning.
• Display a phrase cut up into words for students to see (e.g., into the water). Scramble the words and put them together to demonstrate how words in a phrase are put in a certain order to make sense.
• Have students choose one card from each of three bags (bag 1: prepositional phrase, bag 2: grammatical article, bag 3: noun) to make silly phrases. Put the words together to make a silly phrase (e.g., under the pizza). Challenge students to use the phrase in a complete sentence.
• Display a sentence cut up into words for students to see (e.g., The cat is on the red mat.). Scramble the words and put them together to demonstrate how words in a sentence are put in a certain order to form complete thoughts. You can even try building a “human sentence” with white boards, pens, and students.

---

### **K.F.PA.3:**

<b>Instructional Strategies for Teachers</b>
• Use images to teach common compound words.
• Have students play compound word games orally and participate in cut and paste activities with compound word pictures.
• Have students draw pictures to represent compound words (dog + house = doghouse).
• Point out compound words in read-aloud text.
• Create a word wall where students can add compound words they hear throughout the day.
• Play Add, Subtract, Substitute the Compound Word.
• Guide students in determining the meaning of compound words by using their knowledge of the individual words within the compound word.

---

### **K-1.F.PA.4:**

<b>Instructional Strategies for Teachers</b>
• Introduce students to the concept of syllables by leading them in clapping and counting syllables in their own names and the names of classmates.
• Students can reinforce their abilities to count, produce, blend, and segment syllables in spoken words by clapping and counting syllables in a variety of different words found in story books and poetry.
• Model blending and segmenting syllables in words during whole and small group instruction, leading students through guided practice and allowing students to practice blending and segmenting skills.
• Use the prompt, “Break the word,” or “Break the word into parts/syllables” when working with students on multisyllabic words.
• Provide students with opportunities to find one or two syllable words in read aloud/choral read/shared reading and make a chart of those words.
• Practice breaking words into syllables using manipulatives and motions.

---

### **K-1.F.PA.5:**

<b>Instructional Strategies for Teachers</b>
• Use hand motions to blend or segment one-syllable spoken words (e.g. clapping, chopping).
• Use picture cards to blend or segment one-syllable spoken words.
• Move small objects when blending and segmenting one-syllable spoken words.
• Segment words on picture cards and sort picture cards by like rimes.
• Practice segmenting a one-syllable word (b-ag) and changing the onset to various blends, digraphs, and trigraphs to make new words (fl-ag).
• Use colored tiles to represent onsets and rimes in a one-syllable word, and have students change the first tile to represent different onsets to make new words using the given rime.

---

### **K-1.F.PA.6:**

<b>Instructional Strategies for Teachers</b>
• Consistently and explicitly provide opportunities for students to work with individual sounds in spoken words, including words read or heard during shared reading activities.
• Use picture cards to isolate and pronounce individual sounds (initial, final, or medial) of one-syllable words.
• Use hand motions or manipulatives to tap out/count the phonemes they hear in spoken words.
• Move small objects when blending and segmenting phonemes in one-syllable spoken words.
• Use colored tiles to represent phonemes in a one-syllable word, and have students manipulate (add, delete, substitute) different phonemes in the word using the colored tiles.

---

### **K.F.CP.1:**

<b>Instructional Strategies for Teachers</b>
• Provide opportunities for daily shared reading of big books and mentor texts to help develop the awareness that text and images communicate a message.
• Demonstrate that print has meaning and represents spoken language in written form by pointing to or highlighting words and images/graphics.
• Explain how the images/graphics in a story help the reader to understand the text.
• Ask children to tell why the pictures appear where they do in a text.
• Label items in your classroom and around the school.
• Share print and images found in our environment such as stop signs, fast-food signs, school signs, restroom signs, etc.
• Have students use environmental print such as labels on packaging to demonstrate understanding of meaning gathered from the print text and their associated images.
• During daily reading of various texts, provide experiences identifying letters and words in the text.
• Have students count the words in a line of print or clap for each word read aloud.
• Point out digits used in both content area learning and reading materials to attach meaning (e.g., 5 means five of an item).

---

### **K.F.CP.2:**

<b>Instructional Strategies for Teachers</b>
• Discuss print directionality when using mentor texts and big books for shared reading routines.
• Model and practice holding books in small groups.
• Try holding a book upside down to read and allow students to correct you.
• Model how to follow words on a page with big books, charts, and various texts using a pointer to track text (top to bottom, left to right) when reading aloud to students.
• Provide several books for students that identify the different parts (front cover, back cover, title, graphics); these parts would be labeled with sticky notes on each book.
• Provide opportunities throughout the day during book readings that call attention to and explain the roles of the author and illustrator of a story.
• Prompt children to answer questions about the author and illustrator (e.g., What is the job of an illustrator? What does it mean to be an author?).
• Provide opportunities for students to demonstrate their knowledge of book layout by asking specific questions as students hold a book (e.g., Where do we begin reading the text? Where is the top of the page? Which way should I turn the page to keep reading?).
• Encourage students to track print by having them point to each individual word in big books, charts, and small group texts.
• Place a green sticker on the top left of student desks to help them with directionality.


---

### **K.F.CP.3:**

<b>Instructional Strategies for Teachers</b>
• Use mentor texts and big books to draw attention to words, letters, and spaces.
• Provide students daily opportunities to participate in shared reading to help develop their awareness that written language carries meaning.
• Have students count letters in familiar words such as their name.
• During daily reading of various texts, provide experiences identifying words in the text and the spaces between each word.
• Guide the students in recognizing that words are separated by spaces by using a pocket chart with sentences that show the amount of space between each word and have students use a manipulative (small craft stick, sticky note, etc.) to represent the spaces.
• Using charts, poems, and big books, have students snap their fingers when they see a space between words.
• Demonstrate what print would look like if there were no spaces between words and have students draw a line to show where spaces should go to separate words.
• Using mentor texts, point to the first letter and punctuation of the sentence and explain to students why the first letter of the sentence is capitalized and why there is punctuation at the end.
• Allow students to identify beginning capitals and end punctuation in mentor texts through highlighting, pointing to capitals and punctuation on the board or in the book.
• Use model or mentor sentences to identify beginning capital letter and end punctuation.
• Allow students an opportunity to construct simple sentences using correct beginning capitalization and end punctuation.
• Use student writing samples to identify correct capitalization and end punctuation within sentences.

---

### **K.F.CP.4:**

<b>Instructional Strategies for Teachers</b>
• Read and reread various alphabet books. As the book is read, ask students to identify the letter(s) on the page as they look around the room to find matches to the letter named in the book.
• Use letter tiles to help students recognize and name all uppercase and lowercase letters. Show the tile and say the letter with the students.
• Students will also express if the letter is uppercase or lowercase.
• Use flashcards, songs, and games to teach and reinforce letter recognition. For example, use a beach ball with letters written on the ball. Toss the ball, and the child who catches it will name the letter closest to their right thumb, noting whether the letter is uppercase or lowercase.
• Provide opportunities for students to print letters, skywrite letters, and use materials such as sand or shaving cream to explore letters kinesthetically.
• Engage the students in matching activities to match uppercase/lowercase letters correctly.
• Play games with letters of the alphabet such as drawing a letter from a bowl and saying the letter name. If the letter is in the student’s name, keep that letter.
• Work with students in small groups and one-on-one to name letters of the alphabet while recognizing the difference in upper and lowercase.

---

### **K-2.F.P.1:**

<b>Instructional Strategies for Teachers</b>
• Daily instruction should involve opportunities for students to identify printed letters and their sounds.
• Read and reread a variety of books, stories, and other meaningful text to provide experiences in letter/sound relationships.
• Play “I Spy,” looking for objects by saying their beginning sound(s) (e.g., I spy something that begins with a /b/ sound. (Ball)).
• Create an alphabet rainbow arc by having letters written on cards and drawn from a deck. Students say the letter name drawn, the sound, and place the 3-D letter on the rainbow arc.
• Use playdough to build letters and words.
• Match letter cards with matching picture cards by beginning sounds (e.g., sl – slide).
• Create noun charts of people, places, and things for specific phoneme-grapheme correspondences.
• Use mirrors to help students understand the articulation of sounds and how the mouth looks and feels while making letter sounds.

---

### **K-2.F.P.2:**

<b>Instructional Strategies for Teachers</b>
• Provide frequent opportunities for students to apply what they are learning about phoneme-grapheme correspondences to the reading of words, phrases, and sentences through decodable texts.
• Have students practice decoding regularly spelled high-frequency words as they match to phoneme-grapheme correspondences being taught during phonics instruction.
• Have students identify decodable parts of irregularly spelled high-frequency words as they match up to previously taught phoneme-grapheme correspondences and learn the non-decodable parts “by heart.”
• Draw lines to divide syllables for two-syllable words and apply knowledge of spelling patterns and syllable types to decode.
• Sort nonsense words by syllable type and practice decoding.
• Play “Heads Up” using decodable words written on index cards.
• Brainstorm verbs for specific phoneme-grapheme correspondences (e.g., thr– throw) and write them on index cards. Have each student draw a card, decode the verb, and act it out for others to guess.

---

### **K-2.F.P.3:**

<b>Instructional Strategies for Teachers</b>
• Provide frequent opportunities for students to apply what they are learning about phoneme-grapheme correspondences to the spelling of words in context and isolation.
• Have students practice encoding regularly spelled high-frequency words as they match up to phoneme-grapheme correspondences being taught during phonics instruction.
• Have students encode parts of irregularly spelled high-frequency words as they match up to previously taught phoneme-grapheme correspondences and spell the non-decodable parts “by heart.”
• Encourage students to use their knowledge of phoneme-grapheme correspondences to phonetically spell words while engaging in writing activities.
• Use tactile activities (e.g., shaving cream on desks/tables) to encode words, paying close attention to correct letter formation.
• Practice segmenting the individual sounds (phonemes) of one-syllable words and mapping the sounds to their corresponding letter or letter groups.
• Using Elkonin boxes, have students unscramble letter tiles to make words.
• Segment syllables in spoken words, arrange sticky notes to represent the number of syllables, and use knowledge of phoneme-grapheme correspondences to encode word parts on sticky notes.
• Using word ladders, have students spell words and make new words by changing a letter(s) at the beginning, middle, or end.
• Provide opportunities for students to participate in interactive writing activities throughout the day.


---

### **K-2.F.F.1:**

<b>Instructional Strategies for Teachers</b>
• Model fluent reading for students. Think aloud and engage in discussion with students about rate versus prosody.
• Engage students in various fluency-building activities (repeated reading, paired reading, performance reading, recorded reading, reading buddies [with a lower or higher grade], and choral reading).
• During read-aloud, model self-correcting and rereading as necessary to understand a text.
• Build sight word vocabulary through the instruction of high-frequency words, including games, music, word cards, kinesthetic activities, etc.
• Model fluent reading and have students read the same texts orally several times (up to four for fluency impact).
• Focus on fluency building at word, phrase, and text levels.
• Provide instruction in how to parse or chunk sentences to help students understand juncture/pause.
• Teach and model monitoring and self-correction strategies.
• Help students set goals related to accuracy.
• Progress-monitor oral reading fluency, student goals, and growth.

---

### **K-2.F.H.1:**

<b>Instructional Strategies for Teachers</b>
• Directly and explicitly model the formation of each letter aligned to your phonics scope and sequence.
• Model proper spacing using tangible objects.
• Practice similarly-formed letters together (also called letter families because they share similar shapes and strokes).
• Progress from lowercase to uppercase letters once students demonstrate proficiency.
• Use tactile supports (rice, shaving cream, sandpaper, air writing) to practice forming letters and words.
• Use auditory cues (e.g., “touch down,” “touch around”) to help students internalize the movement patterns.
• Utilize handwriting notebooks for guided and independent practice.
• Have students practice writing letters and words using a highlighter and then tracing with a pencil.
• Create activities that help build fine motor muscles (squeezing stress balls or picking up items with tweezers).
• Spiral back to review previously taught letters.
• At first, focus on having students learn the correct motor movement to form a letter. Focus attention on legibility once there is motor memory. This can be done by sky writing to practice movement and strokes with their arm before moving to writing on paper.
• Always provide visual guidance for what a letter should look like and use visual aids such as arrow cues for stroke direction and dotted letters for tracing.


---

### **K-2.F.H.2:**

<b>Instructional Strategies for Teachers</b>
• Utilize manipulatives for students to physically form letters and words (e.g., move rice into the shape of letters, move letter tiles into words, paint the letters/word).
• Incorporate dictation and transcription into phonics instruction.
• Pair students to practice spelling and letter formation together.
• Incorporate daily practice to reinforce muscle memory.
• Provide immediate feedback and corrections to ensure proper technique.
• Model proper letter formation and spelling.
• Use verbal cues such as “curve around, pull down” to describe the strokes for letters and visual aids (charts, pictures, etc.) of letters and associated strokes to help students see and hear as they correctly form letters.
• Use spelling and letter games to make learning fun and engaging.


---

### **K-2.L.GC.1:**

<b>Instructional Strategies for Teachers</b>
• Use authentic examples from texts to introduce grammar, usage, and mechanics skills, including the vocabulary of grammar, by using proper terms and definitions.
• Create charts of skills for students to reference as needed.
• Allow students time to interact with newly-introduced skills through guided practice, text searches, discussion, and mentor sentences.
• Provide examples and non-examples of skills.
• Use mentor sentence protocols to introduce, practice, and continue learning skills.
• Have students purposefully add the skill into their writing, even highlighting where they used it.
• Provide feedback to students on the use of skills within their writing.
• Make it fun by using oral and interactive games.
• Use multimodal texts for teaching grammar, usage, and mechanics skills.

---


### **K-2.L.GC.2:**

<b>Instructional Strategies for Teachers</b>
• Provide students with hands-on, multisensory activities that work on awareness of sentence completeness and sentence structure.
• Provide students opportunities to manipulate sets of word cards and/or phrase cards to build syntactic awareness.
• Model sentence-level work by answering the questions who, what, action, where, when, and how.
• Use mentor sentences to provide students with examples of well-constructed sentences and effective grammar usage in authentic texts.
• Model sentence expansion activities (adding adjectives, adverbs).
• Work to identify sentence types and practice using the various types of sentences based on task, purpose, and audience.
• Include examples and non-examples during explicit instruction (for example, Robin ate the banana pudding. vs. The banana pudding ate Robin.)
• Focus on specific sentence structures in short, targeted lessons.
• Use kernel sentences (simple, declarative sentence with one verb – e.g., The dog ran.) and sentence starters (short, predetermined portions of sentence to help the writer get started – e.g., The first reason ___ ) to scaffold learning to allow students to develop more elaborate sentences.


---

### **K-2.L.V.1:**

<b>Instructional Strategies for Teachers</b>
• Regularly read texts aloud, modeling the use and pronunciation of new vocabulary.
• Provide multiple exposures to new vocabulary in texts.
• Provide opportunities for students to make real-life connections to new vocabulary (e.g., something cozy from home).
• Incorporate movement to help students interpret the meaning of vocabulary words.
• Use visual images of vocabulary words to provide an additional way for students to access and understand the material.
• Organize vocabulary around themes or subjects to help students make connections across different contexts.
• Use authentic texts where new vocabulary appears naturally.
• Focus instruction on academic and specialized vocabulary encountered in text.
• Have students work to sort words into those encountered daily and those found in specialized texts (e.g., door and car vs. cocoon and caterpillar).
• Use research-based protocols for teaching new vocabulary.
• Provide opportunities for students to engage in the building of oral vocabulary. Then progress to the building of vocabulary within reading and writing as students become more competent.


---

### **1-2.L.V.2:**

<b>Instructional Strategies for Teachers</b>
• Help students identify words that have inflectional endings and affixes. They can add a line to show where the affix starts/ends, and they can circle or underline the root word. (<i>un | help | ful</i>)
• Teach students the meaning of frequently encountered affixes such as <i>re-</i> and <i>-ful</i> and the way they change the meaning and use of the root word.
• Teach students to break down words into roots, prefixes, and suffixes to understand word meanings.
• Provide students with opportunities to practice using prefixes and suffixes to construct new words.
• Model reading aloud and using a known root word to help determine the meaning of an unknown word with the same root.
• Implement the use of a word matrix (a map of a word family) or word sum (<i>un + help + ful = unhelpful</i>) to help build understanding.
• Encourage independent word analysis of previously taught vocabulary through journaling, games, or class discussions.

---

### **K-2.L.V.3:**
<b>Instructional Strategies for Teachers</b>
• Demonstrate the use of sentence-level context clues to determine the meanings of a word.  
• Help build word consciousness for students. This will allow them to make decisions about which words are important to understanding the text.  
• Introduce grade-level appropriatem multiple-meaning words. Use context to help determine meaning. Students can create journals, charts, and act out words to show the multiple meanings.  
• Explore shades of meaning with common adjectives such as good and verbs such as walk. Create charts to show the meaning and their increase in intensity. 
• Have students categorize groups of words from weakest to strongest shades of meaning (e.g., whisper, talk, shout, scream).  
• Use mentor texts to identify words that can have various shades of meaning. They can work with partners to create lists of words that could be substituted in the text.   
• Teach students how to read a glossary entry and a dictionary entry. Create a reference chart.  
• Model using a dictionary (print and digital) to look up an unknown word to determine its meaning.
• Allow students to look up words in dictionaries and glossaries and create kid-friendly definitions they can share.  

----

K.F.PA.1:

Evidence of Student Learning

<table>
  <thead>
    <tr>
      <th>Teacher Prompt</th>
      <th>Student Response</th>
    </tr>
  </thead>
  <tbody>
    <tr>
      <td>Ask students, Do these two words rhyme? mat, rat</td>
      <td>yes</td>
    </tr>
    <tr>
      <td>Ask students, Do these two words rhyme? run, rose</td>
      <td>no</td>
    </tr>
    <tr>
      <td>Ask students, Which word does not rhyme? mat, cat, sun</td>
      <td>sun</td>
    </tr>
    <tr>
      <td>Say to students, Tell me a word that rhymes with sun.</td>
      <td>run<br/>(answers may vary)</td>
    </tr>
  </tbody>
</table>

----

K.F.PA.2:

Evidence of Student Learning

<table>
  <thead>
    <tr>
      <th>Teacher Prompt</th>
      <th>Student Response</th>
    </tr>
  </thead>
  <tbody>
    <tr>
      <td>Say to students, Listen to the<br/>sentence I say and count the<br/>number of words you hear.<br/>My dog plays in the yard.<br/><br/>Ask students, How many words did<br/>you hear?</td>
      <td>6</td>
    </tr>
    <tr>
      <td>Ask students, What words do you<br/>hear when I say the phrase on the<br/>rug?</td>
      <td>on the rug</td>
    </tr>
  </tbody>
</table>

----

K.F.PA.3:

Evidence of Student Learning


<table>
  <thead>
    <tr>
      <th>Teacher Prompt</th>
      <th>Student Response</th>
    </tr>
  </thead>
  <tbody>
    <tr>
      <td>Ask students, How do we combine bird and bath to make a compound word?</td>
      <td>birdbath</td>
    </tr>
    <tr>
      <td>Ask students, Which word(s) could I add before ball to make a compound word?</td>
      <td>base, foot, basket</td>
    </tr>
    <tr>
      <td>Ask students, If I have the word eggplant, and I take away the word plant, what word am I left with?</td>
      <td>egg</td>
    </tr>
    <tr>
      <td>Ask students, What compound word can I make if I substitute shine in sunshine with the word beam?</td>
      <td>sunbeam</td>
    </tr>
  </tbody>
</table>

---

K.F.PA.4:

Evidence of Student Learning 

<table>
  <thead>
    <tr>
      <th>Teacher Prompt</th>
      <th>Student Response</th>
    </tr>
  </thead>
  <tbody>
    <tr>
      <td>Say to students, Let’s clap the syllables we hear in Julie’s name. How many syllables did we clap? (substitute any name)</td>
      <td>2</td>
    </tr>
    <tr>
      <td>Ask students, What word do you hear when you blend the syllables /wa/ and /ter/?</td>
      <td>water</td>
    </tr>
    <tr>
      <td>Say to students, I will say a word and you tell me what syllables you hear. candle</td>
      <td>/can/  /dle/</td>
    </tr>
  </tbody>
</table>
-----
1.F.PA.4:

Evidence of Student Learning 

<table>
  <thead>
    <tr>
      <th>Teacher Prompt</th>
      <th>Student Response</th>
    </tr>
  </thead>
  <tbody>
    <tr>
      <td>Say to students, Let’s say hamper without /ham/.</td>
      <td>/per/</td>
    </tr>
    <tr>
      <td>Say to students, Say raining. Substitute/change /ing/ to /ee/. What is the new word?</td>
      <td>rainy</td>
    </tr>
  </tbody>
</table>

----

K.F.PA.5:

Evidence of Student Learning
<table>
  <thead>
    <tr>
      <th>Teacher Prompt</th>
      <th>Student Response</th>
    </tr>
  </thead>
  <tbody>
    <tr>
      <td>Say to students, Blend these sounds to make a word. /b/ /ig/</td>
      <td>big</td>
    </tr>
    <tr>
      <td>Say to students, Say this word in two parts. mop</td>
      <td>/m/ /op/</td>
    </tr>
  </tbody>
</table>
-----
1.F.PA.5:

Evidence of Student Learning

<table>
  <thead>
    <tr>
      <th>Teacher Prompt</th>
      <th>Student Response</th>
    </tr>
  </thead>
  <tbody>
    <tr>
      <td>Ask students, What word am I saying? /sh/, /ark/</td>
      <td>shark</td>
    </tr>
    <tr>
      <td>Say to students, Segment (or break apart) the sounds you hear in this word into an onset and rime. dodge</td>
      <td>/d/ /odge/</td>
    </tr>
  </tbody>
</table>

----

K.F.PA.6:
Evidence of Student Learning
<table>
  <thead>
    <tr>
      <th>Teacher Prompt</th>
      <th>Student Response</th>
    </tr>
  </thead>
  <tbody>
    <tr>
      <td>Ask students, What sound do you hear at the beginning of sun?</td>
      <td>/s/</td>
    </tr>
    <tr>
      <td>Ask students, How many sounds do you hear in the word lake?</td>
      <td>3</td>
    </tr>
  </tbody>
</table>
----
1.F.PA.6: 
Evidence of Student Learning
<table>
  <thead>
    <tr>
      <th>Teacher Prompt</th>
      <th>Student Response</th>
    </tr>
  </thead>
  <tbody>
    <tr>
      <td>Ask students, What is the vowel sound you hear in the word tree? Is it a short or long vowel sound?</td>
      <td>/ee/<br>long</td>
    </tr>
    <tr>
      <td>Say to students, Tell me the sounds you hear in the word stone.</td>
      <td>/s/ /t/ /o/ /n/</td>
    </tr>
    <tr>
      <td>Now change the /n/ to /v/. What is the new word?</td>
      <td>stove</td>
    </tr>
  </tbody>
</table>

----

K.F.CP.1:

<h3>Evidence of Student Learning</h3>

<table>
  <thead>
    <tr>
      <th>Teacher Prompt</th>
      <th>Student Response</th>
    </tr>
  </thead>
  <tbody>
    <tr>
      <td>Display a picture of a common environmental sign – such as a wet floor sign. Ask student, What does this sign tell us? How does it help us?</td>
      <td>The student will explain how the sign tells us the floor is wet and helps us to be safe.</td>
    </tr>
    <tr>
      <td>Tell student, Clap the words you see in this sentence. The cow jumped over the moon.</td>
      <td>The student will clap for each of the six words.</td>
    </tr>
    <tr>
      <td>Tell student, Touch (or count) the letters in your name.</td>
      <td>The student will touch each letter in their name (or count if able).</td>
    </tr>
    <tr>
      <td>Tell student, Use the highlighter to show the digit in this sentence. I ate 5 cookies.</td>
      <td>The student will highlight the digit 5.</td>
    </tr>
  </tbody>
</table>

---
K.F.CP.2:

<h3>Evidence of Student Learning</h3>

<table>
  <thead>
    <tr>
      <th>Teacher Prompt</th>
      <th>Student Response</th>
    </tr>
  </thead>
  <tbody>
    <tr>
      <td>Say to student, Show me how to hold this book if I wanted to read it.</td>
      <td>The student would hold the book upright and facing the correct way.</td>
    </tr>
    <tr>
      <td>Ask student, Where do I start to read?</td>
      <td>The student would open the book to the first page at the front of the book.</td>
    </tr>
    <tr>
      <td>Ask student, Can you show me where to go next to keep reading?</td>
      <td>The student may point to the next line or to the next page.</td>
    </tr>
    <tr>
      <td>Ask student, Where can I find the title of this book?</td>
      <td>The student would point to the cover or title page of the book.</td>
    </tr>
  </tbody>
</table>

----

K.F.CP.3:

Evidence of Student Learning


<table>
  <thead>
    <tr>
      <th>Teacher Prompt</th>
      <th>Student Response</th>
    </tr>
  </thead>
  <tbody>
    <tr>
      <td>Say to student, Underline the beginning capital letter and the end punctuation in this sentence: Mary had a little lamb. Highlight every space.</td>
      <td>Mary had a little lamb.</td>
    </tr>
    <tr>
      <td>Say to student, Touch (or count) the letters in the words dog and balloon. Which word has the most letters?</td>
      <td>The student will touch each letter in the words dog and balloon (or count if able). Balloon.</td>
    </tr>
  </tbody>
</table>


----
K.F.CP.4

<h3>Evidence of Student Learning</h3>

<table>
  <thead>
    <tr>
      <th>Teacher Prompt</th>
      <th>Student Response</th>
    </tr>
  </thead>
  <tbody>
    <tr>
      <td>Ask students, Can you match these lowercase letters to their uppercase?</td>
      <td>Students will be able to match lowercase letters to their uppercase letters.</td>
    </tr>
    <tr>
      <td>Ask students, Can you find the letter _____? Provide a variety of letters to choose from.</td>
      <td>Students will accurately locate letter ____.</td>
    </tr>
    <tr>
      <td>Ask students, Can you sort the letters you found into two piles – uppercase letters and lowercase letters?</td>
      <td>Students will sort the letters into two correct piles – uppercase and lowercase.</td>
    </tr>
  </tbody>
</table>


------
K.F.P.1
Evidence of Student Learning

<table>
  <thead>
    <tr><th>Teacher Prompt</th><th>Student Response</th></tr>
  </thead>
  <tbody>
    <tr>
      <td>Say to students, What sound does this letter make? Bb</td>
      <td>/b/</td>
    </tr>
    <tr>
      <td>Say to students, What letter makes this sound? /m/</td>
      <td>Mm</td>
    </tr>
  </tbody>
</table>

-----
1.F.P.1
Evidence of Student Learning

<table>
  <thead>
    <tr><th>Teacher Prompt</th><th>Student Response</th></tr>
  </thead>
  <tbody>
    <tr>
      <td>Say to students, What sound do these letters make? sh</td>
      <td>/sh/</td>
    </tr>
    <tr>
      <td>Say to students, What letters make this sound? /bl/</td>
      <td>bl</td>
    </tr>
  </tbody>
</table>

-----
2.F.P.1
 Evidence of Student Learning

<table>
  <thead>
    <tr><th>Teacher Prompt</th><th>Student Response</th></tr>
  </thead>
  <tbody>
    <tr>
      <td>Say to students, What sound do these letters make? er</td>
      <td>/r/</td>
    </tr>
    <tr>
      <td>Say to students, What letters make this sound? /ow/</td>
      <td>ow, ou</td>
    </tr>
  </tbody>
</table>

----


K.F.P.2

Evidence of Student Learning

<table>
  <thead>
    <tr>
      <th>Teacher Prompt</th>
      <th>Student Response</th>
    </tr>
  </thead>
  <tbody>
    <tr>
      <td>Say to students, Read this word. up (VC)</td>
      <td>up</td>
    </tr>
    <tr>
      <td>Say to students, Decode this word. ram (CVC)</td>
      <td>ram</td>
    </tr>
  </tbody>
</table>

----
1.F.P.2

Evidence of Student Learning

<table>
  <thead>
    <tr>
      <th>Teacher Prompt</th>
      <th>Student Response</th>
    </tr>
  </thead>
  <tbody>
    <tr>
      <td>Say to students, Read this high-frequency word. that (CCVC)</td>
      <td>that</td>
    </tr>
    <tr>
      <td>Say to students, Decode this nonsense word. choap (CCVVC)</td>
      <td>choap</td>
    </tr>
  </tbody>
</table> 

-----
2.F.P.2

Evidence of Student Learning 

<table>
  <thead>
    <tr>
      <th>Teacher Prompt</th>
      <th>Student Response</th>
    </tr>
  </thead>
  <tbody>
    <tr>
      <td>Say to students, Read this word. teacher (CVVCC)</td>
      <td>teacher</td>
    </tr>
    <tr>
      <td>Say to students, Decode this word. cradle (2 syllables – open and consonant –le)</td>
      <td>cradle</td>
    </tr>
  </tbody>
</table> 

----

K.F.P.3

Evidence of Student Learning
<table>
  <thead>
    <tr>
      <th>Teacher Prompt</th>
      <th>Student Response</th>
    </tr>
  </thead>
  <tbody>
    <tr>
      <td>Say to students, Spell/write this word. at (VC)</td>
      <td>Me</td>
    </tr>
    <tr>
      <td>Say to students, Encode this word. top (CVC)</td>
      <td>top</td>
    </tr>
  </tbody>
</table>

-----
1.F.P.3

Evidence of Student Learning
<table>
  <thead>
    <tr>
      <th>Teacher Prompt</th>
      <th>Student Response</th>
    </tr>
  </thead>
  <tbody>
    <tr>
      <td>Say to students, Spell/write this high-frequency word. this (CCVC)</td>
      <td>This</td>
    </tr>
    <tr>
      <td>Say to students, Encode this nonsense word. frine (CCVe)</td>
      <td>frine</td>
    </tr>
  </tbody>
</table>

-----
2.F.P.3

Evidence of Student Learning
<table>
  <thead>
    <tr>
      <th>Teacher Prompt</th>
      <th>Student Response</th>
    </tr>
  </thead>
  <tbody>
    <tr>
      <td>Say to students, Spell/write this word. tiger (VCV)</td>
      <td>tiger</td>
    </tr>
    <tr>
      <td>Say to students, Encode this word. flower (2 syllables- diphthong and r-controlled)</td>
      <td>flower</td>
    </tr>
  </tbody>
</table>

-----



K.F.F.1

Evidence of Student Learning
<table>
  <thead>
    <tr>
      <th>Teacher Prompt</th>
      <th>Student Response</th>
    </tr>
  </thead>
  <tbody>
    <tr>
      <td>Say to students, I am going to read this portion of our text, and I need you to tell me if my speed, or reading rate, sounds like a strong reader. <br><br>Reads very quickly.</td>
      <td>No!</td>
    </tr>
    <tr>
      <td>Say to students, I am going to read this portion of our text, and I need you to tell me if my speed, or reading rate, sounds like a strong reader. <br><br>Reads very slowly.</td>
      <td>No!</td>
    </tr>
    <tr>
      <td>Say to students, I am going to read this portion of our text, and I need you to tell me if my speed, or reading rate, sounds like a strong reader. <br><br>Reads at an appropriate rate.</td>
      <td>Yes!</td>
    </tr>
    <tr>
      <td>Say to students, Now let’s read it together at the ‘just right’ rate.</td>
      <td></td>
    </tr>
  </tbody>
</table>

----
1.F.F.1

Evidence of Student Learning
<table>
  <thead>
    <tr>
      <th>Teacher Prompt</th>
      <th>Student Response</th>
    </tr>
  </thead>
  <tbody>
    <tr>
      <td>Say to students, Let’s reread this text to make sure that we know the words and how to read them together fluently.</td>
      <td>Students will engage in multiple readings of the same text to increase accuracy.  <br><br>Accuracy- 95% or above</td>
    </tr>
  </tbody>
</table>

----
2.F.F.1

Evidence of Student Learning
<table>
  <thead>
    <tr>
      <th>Teacher Prompt</th>
      <th>Student Response</th>
    </tr>
  </thead>
  <tbody>

    <tr>
      <td>Say to students, Read this portion of text based on your goals for _________ (automaticity, prosody).<br><br>Say to students, Listen to me read this text and make self-corrections when I notice an error. Read this text and see if you find a place where you make an error and need to stop and correct yourself (self-correcting).</td>
      <td><p><strong>Look Fors</strong></p>
<ul>
  <li>Phrasing – scooping words and phrases together</li>
  <li>Expression – adjusting volume, attending to punctuation, noting dialogue tags</li>
  <li>Juncture/Pause – using correct pauses for various types of punctuation, pausing for effect</li>
  <li>Tone – varying tone, pitch, and volume to make meaning clear</li>
  <li>Automaticity – effortless word recognition with expression</li>
  <li>Self-correction – recognizes errors and rereads section needed to ensure meaning</li>
</ul></td>
    </tr>
  </tbody>
</table>

----



K.F.H.1

Evidence of Student Learning
<table>
  <thead>
    <tr>
      <th>Teacher Prompt</th>
      <th>Student Response</th>
    </tr>
  </thead>
  <tbody>
    <tr>
      <td>Write the letter m on the board or chart paper. As you write, say, Let’s learn how to form the letter ‘m’. Watch as I write the letter ‘m’.<br><br>Say to students, First, start on the midline and pull down to the baseline. Without picking up your pencil, pull back up to the midline and make a hump to the baseline, then up to the midline and another hump to the baseline.<br><br>After you have written the ‘m’, point to it and say ‘m’, /m/.</td>
      <td>Students observe as the teacher forms the letter ‘m’.</td>
    </tr>
    <tr>
      <td>Say to students, Now you try it. Use verbal prompts as you model correct letter formation.<br><br>Say to students, Pick up your pencil, start on the midline and pull down to the baseline. Without picking up your pencil, pull back up to the midline and make a hump to the baseline, then up to the midline and another hump to the baseline.<br><br>Repeat several times, giving students multiple opportunities to practice writing the letter.</td>
      <td>Students form the letter ‘m’ guided by the teacher.</td>
    </tr>
  </tbody>
</table>
----
1.F.H.1

Evidence of Student Learning
<table>
  <thead>
    <tr>
      <th>Teacher Prompt</th>
      <th>Student Response</th>
    </tr>
  </thead>
  <tbody>
    <tr>
      <td>Write the word ship on the board or chart paper. As you write, say, Let’s practice forming letters in the word ship with proper formation and spacing.<br><br>Use verbal prompts as you model writing the word ‘ship’.<br><br>After you have written the word ship, point to it and say, /sh/ /i/ /p/.</td>
      <td>Students observe as the teacher forms the word with proper spacing.</td>
    </tr>
    <tr>
      <td>Say to students, Now you try it.<br><br>Guide students in properly forming the letters in the word ship with proper spacing.<br><br>Repeat this with similar words that students are learning about in their phonics instruction.</td>
      <td>Students practice forming the word guided by the teacher.</td>
    </tr>
  </tbody>
</table>

----
2.F.H.1

Evidence of Student Learning
<table>
  <thead>
    <tr>
      <th>Teacher Prompt</th>
      <th>Student Response</th>
    </tr>
  </thead>
  <tbody>
    <tr>
      <td>Write the sentence The toy made a loud noise. on the board or chart paper. As you write, say, Let’s practice writing words in sentences with correct letter formation and spacing.<br><br>Use verbal prompts as you model writing the sentence.<br><br>After you have written the sentence, model reading the sentence aloud.</td>
      <td>Students observe as the teacher forms each word in the sentence with proper spacing.</td>
    </tr>
    <tr>
      <td>Say, Now you try it. Guide students in properly forming the words with proper spacing.<br><br>Repeat this using similar words that students are learning about in their phonics instruction.</td>
      <td>Students practice forming the words in the sentence with proper spacing.</td>
    </tr>
  </tbody>
</table>

---

K.F.H.2

Evidence of Student Learning

<table>
  <thead>
    <tr>
      <th>Teacher Prompt</th>
      <th>Student Response</th>
    </tr>
  </thead>
  <tbody>
    <tr>
      <td>Say to students, I will say a word and you will write down the graphemes you hear. Watch me first.</td>
      <td>Students observe as the teacher models the tasks. Pencils are down.</td>
    </tr>
    <tr>
      <td>Say the word cat. Model writing the graphemes for each phoneme.</td>
      <td></td>
    </tr>
    <tr>
      <td>Say to students, Now it’s your turn. Your word is run.</td>
      <td>Students pick up their pencils and write the graphemes for the phonemes in the word run.</td>
    </tr>
    <tr>
      <td>Model writing the graphemes for the word run, saying one phoneme at a time. Have students correct any errors they made.</td>
      <td></td>
    </tr>
    <tr>
      <td>Repeat by incorporating previously learned phonics skills.</td>
      <td></td>
    </tr>
  </tbody>
</table>
---
1.F.H.2

Evidence of Student Learning

<table>
  <thead>
    <tr>
      <th>Teacher Prompt</th>
      <th>Student Response</th>
    </tr>
  </thead>
  <tbody>
    <tr>
      <td>Say to students, I will say a sentence and you will write down the words you hear with correct spelling, letter formation, and spacing. Watch me first.</td>
      <td>Students observe as the teacher models. Pencils are down.</td>
    </tr>
    <tr>
      <td>Say, The ship is very big. Model writing each word by sounding out the phonemes and writing the corresponding graphemes.</td>
      <td></td>
    </tr>
    <tr>
      <td>Say to students, Now it’s your turn. Listen carefully as I read the sentence. The boy ran fast. Pause between each word to allow students time to write. Repeat the whole sentence.</td>
      <td>Students pick up their pencils and transcribe the dictated sentence.</td>
    </tr>
    <tr>
      <td>Circulate the room, providing assistance and feedback as needed.</td>
      <td>Students make corrections as needed.</td>
    </tr>
    <tr>
      <td>Repeat by incorporating previously learned phonics and GUM skills.</td>
      <td></td>
    </tr>
  </tbody>
</table>
----
2.F.H.2

Evidence of Student Learning

<table>
  <thead>
    <tr>
      <th>Teacher Prompt</th>
      <th>Student Response</th>
    </tr>
  </thead>
  <tbody>
    <tr>
      <td>Say to students, I will say a sentence and you will write down the words you hear with correct spelling, letter formation, and spacing. Watch me first.</td>
      <td>Students observe as the teacher models. Pencils are down.</td>
    </tr>
    <tr>
      <td>Say, I packed an apple, a sandwich, and a cookie in my lunchbox. Model writing each word by sounding out the phonemes and writing the corresponding graphemes.</td>
      <td></td>
    </tr>
    <tr>
      <td>Say, Now it’s your turn. Listen carefully as I read the sentence. On the weekend, I like to swim, bike, and read. Repeat the sentence two more items.</td>
      <td>Students pick up their pencils and transcribe the dictated sentence.</td>
    </tr>
    <tr>
      <td>Circulate the room, providing assistance and feedback as needed.</td>
      <td>Students make corrections as needed.</td>
    </tr>
    <tr>
      <td>Repeat by incorporating previously learned phonics and GUM skills.</td>
      <td></td>
    </tr>
  </tbody>
</table>

-----
K.L.GC.1

Evidence of Student Learning


<table>
  <thead>
    <tr><th>Teacher Prompt</th><th>Student Response</th></tr>
  </thead>
  <tbody>
    <tr>
      <td>Say to students, Listen to the sentence from the nursery rhyme.<br><br>The cow jumped over the moon.</td>
      <td></td>
    </tr>
    <tr>
      <td>Ask students, Who or what was that sentence about? That will tell us a noun.</td>
      <td>The cow</td>
    </tr>
    <tr>
      <td>Ask students, What was that cow doing?</td>
      <td>Jumping (or jumping over the moon)</td>
    </tr>
    <tr>
      <td>Say to students, So, we found the noun (a thing) that the sentence was about and then we found the verb that showed action in the sentence.</td>
      <td>Answers will vary.</td>
    </tr>
  </tbody>
</table>
-----
1.L.GC.1
Evidence of Learning

<table>
  <thead>
    <tr><th>Teacher Prompt</th><th>Student Response</th></tr>
  </thead>
  <tbody>
    <tr>
      <td>Say to students, In our story today the author used this sentence.<br><br>Six cats climbed over the fence.</td>
      <td></td>
    </tr>
    <tr>
      <td>Ask students, Why did the author add an -s to the noun /cat/?</td>
      <td>To show us there was more than one cat</td>
    </tr>
    <tr>
      <td>Ask students, Why didn’t the author use –es?</td>
      <td>Cat ends in a consonant, but not s, sh, ch, x, or z (referencing chart in the room)</td>
    </tr>
    <tr>
      <td>Ask students, Why did the author add the –ed to climb?</td>
      <td>To show that it had already happened (in the past)</td>
    </tr>
    <tr>
      <td>Ask students, How could we rewrite this sentence to show only one cat doing something right now?</td>
      <td>Answers may vary.<br><br>The cat eats his food.</td>
    </tr>
  </tbody>
</table>
----

2.L.GC.1
Evidence of Learning

<table>
  <thead>
    <tr><th>Teacher Prompt</th><th>Student Response</th></tr>
  </thead>
  <tbody>
    <tr>
      <td>Say to students, In our mentor sentence from our story, we want to identify the adjectives, the proper noun, and the end punctuation.<br><br>Edna ate twelve giant donuts before I could stop her!</td>
      <td></td>
    </tr>
    <tr>
      <td>Ask students, What are the adjectives in this sentence?</td>
      <td>Adjectives – twelve, giant</td>
    </tr>
    <tr>
      <td>Ask students, What are the proper nouns in this sentence?</td>
      <td>Proper Noun – Edna</td>
    </tr>
    <tr>
      <td>Say to students, Write a sentence that correctly uses a proper noun, adjective, and end punctuation, like our author.</td>
      <td>Answers will vary.</td>
    </tr>
  </tbody>
</table>

----

K.L.GC.2

Evidence of Student Learning

<table>
  <thead>
    <tr><th>Teacher Prompt</th><th>Student Response</th></tr>
  </thead>
  <tbody>
    <tr>
      <td>
        Ask students, In this sentence from our story, what is the subject (who the sentence is about) and the predicate (what is happening in the sentence)?<br>
        Molly marched.
      </td>
      <td>
        Subject – Molly<br>
        Predicate – marched
      </td>
    </tr>
    <tr>
      <td>
        Say to students, Let’s expand that sentence by telling our partner why, where, or how Molly marched.
      </td>
      <td>
        Answers will vary.<br>
        Examples might include:<br>
        Molly marched fast. (how)<br>
        Molly marched around the playground. (where)
      </td>
    </tr>
  </tbody>
</table>
----
1.L.GC.2
Evidence of Student Learning
<table>
  <thead>
    <tr><th>Teacher Prompt</th><th>Student Response</th></tr>
  </thead>
  <tbody>
    <tr>
      <td>
        Say to students, We are going to take a sentence kernel and work to expand the sentence.<br>
        Bear dives.<br>
        Ask students who, what, when, where, why, and how to create various types of sentences (including declarative, exclamatory, interrogative).
      </td>
      <td>
        Answers will vary.<br>
        Examples might include:<br>
        The bear dives after the fish.<br>
        Why did the brown bear and his brother dive into the cool lake?<br>
        Don’t dive near that bear!
      </td>
    </tr>
  </tbody>
</table>
-----
2.L.GC.2

Evidence of Student Learning
<table>
  <thead>
    <tr><th>Teacher Prompt</th><th>Student Response</th></tr>
  </thead>
  <tbody>
    <tr>
      <td>
        Ask students, When given the sentence below, how do we get the subject and the verb to agree?<br>
        The monsters eats the soup.
      </td>
      <td>
        Make corrections to subject or to predicate to show correctness based on context.<br>
        The monster ate the soup.<br>
        &nbsp;&nbsp;&nbsp;&nbsp;or<br>
        The monsters eat the soup.
      </td>
    </tr>
    <tr>
      <td>
        How can we combine these simple sentences to develop a compound sentence?<br>
        Elephants are large. Elephants do not move quickly.
      </td>
      <td>
        Elephants are large, so they do not move quickly.
      </td>
    </tr>
    <tr>
      <td>
        What could we do to make this compound sentence more elaborate to engage our audience?<br>
        Edna found her dog, but he was dirty.
      </td>
      <td>
        Answers will vary.<br>
        Example:<br>
        Edna found her small furry dog, but he was covered in sticky burrs and gooey mud.
      </td>
    </tr>
  </tbody>
</table>

<br>
----
K.L.V.1

Evidence of Student Learning

<table>
  <thead>
    <tr><th>Teacher Prompt</th><th>Student Response</th></tr>
  </thead>
  <tbody>
    <tr>
      <td>Say to students, “This week, as we read about acorns, we looked at vocabulary that would help us understand the text. Which word(s) in this sentence would be a vocabulary word that would help us understand?”<br><br>The green lizard shed his skin.</td>
      <td>Student answers may include lizard, shed, and/or skin.</td>
    </tr>
    <tr>
      <td>Ask “How do these words help us understand what we read?”</td>
      <td>Answers may relate to how these words helped them identify what the sentence was about, how shed is an important word, and what skin is to help know what the lizard was actually shedding.</td>
    </tr>
  </tbody>
</table>

-----
1.L.V.1

Evidence of Student Learning

<table>
  <thead>
    <tr><th>Teacher Prompt</th><th>Student Response</th></tr>
  </thead>
  <tbody>
    <tr>
      <td>Provide students with a list of words from a mentor text and have them sort them into two categories – Everyday Words and Special Vocabulary.<br><br><i>moss&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;outside</i><br><i>lichen&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;fungus</i><br><i>log&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;tree</i><br><i>rain</i></td>
      <td>Student should be able to sort vocabulary from a previously read text, one with multiple exposures, or those from vocabulary instruction.<br><br><i>Everyday Words&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Special Vocab</i><br><i>log&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;moss</i><br><i>rain&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;lichen</i><br><i>outside&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;fungus</i><br><i>tree</i></td>
    </tr>
  </tbody>
</table>

-----
2.L.V.1

Evidence of Student Learning

<table>
  <thead>
    <tr><th>Teacher Prompt</th><th>Student Response</th></tr>
  </thead>
  <tbody>
    <tr>
      <td>Say, “Since we have read the word ____ and studied it, how can we work to use this word in our own writing.”<br><br>Use words previously taught that can easily be transferred into writing. Model this before expecting students to complete it independently.<br><br><i>Examples – hilarious, devastated, glanced</i></td>
      <td>Students should be able to incorporate these words into their writing after a teacher model.</td>
    </tr>
  </tbody>
</table>

-----

1.L.V.2

Evidence of Student Learning

<table>
  <thead>
    <tr><th>Teacher Prompt</th><th>Student Response</th></tr>
  </thead>
  <tbody>
    <tr>
      <td>
        Ask students, What words can I make if I add this root word and each of these endings?<br><br>
        Root Word&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Inflectional Ending<br>
        Wait&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;- ed<br>
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;- s<br>
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;- ing
      </td>
      <td>
        Waited<br>
        Waits<br>
        Waiting
      </td>
    </tr>
    <tr>
      <td>
        Say to students, Let’s see if we can break these words into the root word and their inflectional endings. Use a line to break them apart and then underline the root word.<br><br>
        Cooking<br>
        Danced
      </td>
      <td>
        Cook | ing<br>
        Dance | ed
      </td>
    </tr>
  </tbody>
</table>

-----
2.L.V.2
Evidence of Student Learning 

<table>
  <thead>
    <tr><th>Teacher Prompt</th><th>Student Response</th></tr>
  </thead>
  <tbody>
    <tr>
      <td>
        Ask students, In the following sentence, what word parts do we know that could help figure out the unknown word?<br><br>
        Ed felt insecure on the back of the horse.
      </td>
      <td>
        In- means not and secure means safe. So, Ed does not feel safe.
      </td>
    </tr>
    <tr>
      <td>
        Using word sums, determine which new words can be made from this root word and affixes.<br><br>
        Prefix&nbsp;&nbsp;&nbsp;&nbsp;Root Word&nbsp;&nbsp;&nbsp;Suffix<br>
        Un-&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;friend&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;- ly<br>
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;-s<br>
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;-ful<br>
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;-er<br>
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Help&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;-ed
      </td>
      <td>
        Friendly<br>
        Unfriendly<br>
        Unfriend<br>
        Friends<br>
        Friended<br>
        Helper<br>
        Unhelpful<br>
        Helpful<br>
        Helped
      </td>
    </tr>
  </tbody>
</table>
-----


K.L.V.3

Evidence of Student Learning

<table>
  <thead>
    <tr>
      <th>Teacher Prompt</th>
      <th>Student Response</th>
    </tr>
  </thead>
  <tbody>
    <tr>
      <td>Say to students, While we were reading our text, we read that, “The dragon was delighted with his dinner.” One of those words was important to help us know what was happening and how the dragon was feeling- what was it?</td>
      <td>Delighted</td>
    </tr>
    <tr>
      <td>Ask students, What did it mean?</td>
      <td>Very happy (answers may vary)</td>
    </tr>
    <tr>
      <td>Ask students, How did we know that is what it meant?</td>
      <td>We used clues. The dragon ate it all up and rubbed his tummy.</td>
    </tr>
    <tr>
      <td>Turn to your partner and try to use delighted in a sentence.</td>
      <td>Students should be able to try to use delighted in a manner that shows something or someone being very happy.</td>
    </tr>
  </tbody>
</table>
----

1.L.V.3

Evidence of Student Learning
<table>
  <thead>
    <tr>
      <th>Teacher Prompt</th>
      <th>Student Response</th>
    </tr>
  </thead>
  <tbody>
    <tr>
      <td>Say, “We have learned that some words can mean more than one thing. We call these ‘multiple-meaning words.’ I am going to give you a word, and I would love it if you would draw at least two pictures to show me different meanings of this word. Be ready to share!”<br><br>fly&nbsp;&nbsp;&nbsp;&nbsp;star&nbsp;&nbsp;&nbsp;&nbsp;ring&nbsp;&nbsp;&nbsp;&nbsp;nails</td>
      <td>Students should be able to draw and explain at least two meanings for the word provided.</td>
    </tr>
  </tbody>
</table>
-----

2.L.V.3

Evidence of Student Learning
<table>
  <thead>
    <tr>
      <th>Teacher Prompt</th>
      <th>Student Response</th>
    </tr>
  </thead>
  <tbody>
    <tr>
      <td>Use a children’s dictionary (print or digital).<br><br>Say, “We have learned how to use alphabetical order to find words in the dictionary. Let’s try a short scavenger hunt to find words we have read about in our book this week. Be ready to share the word and its definition. Tell us if the definition matches the way the word was used in our text.”<br><br>holiday&nbsp;&nbsp;&nbsp;&nbsp;Thanksgiving&nbsp;&nbsp;&nbsp;&nbsp;table&nbsp;&nbsp;&nbsp;&nbsp;family&nbsp;&nbsp;&nbsp;&nbsp;costume&nbsp;&nbsp;&nbsp;&nbsp;celebrate</td>
      <td>Students should be able to locate the words, determine their definition, and discuss if the definition given matches the words from the class mentor text.</td>
    </tr>
  </tbody>
</table>

-----
K-12.P.EICC.1
**Overview of Standard**
In this standard, students develop their reader and writer identities for both their personal and academic lives by building a toolkit to engage with texts both as consumers and producers. Students’ confidence will grow as they engage with and create various types of texts, allowing them to seek out new reading materials and writing opportunities.  

K-12.P.EICC.2
**Overview of Standard**
In this standard, students engage in purposeful conversation as both author and audience to explore ideas, share knowledge, and respond to texts. Through these interactions, students make intentional connections within and across texts, deepening their understanding, constructing meaning, and using language to fulfill their purposes.  

K-12.P.EICC.3
**Overview of Standard**
In this standard, students will read and comprehend a variety of complex texts across genres, disciplines, and purposes. They will preview texts, activate prior knowledge, set goals, and predict content. Students will also monitor their own understanding while asking questions and summarizing sections of the text, and then reflect on meaning, summarize the text, and apply what they’ve learned.  

K-12.P.EICC.4
**Overview of Standard**
In this standard, students will create a variety of texts based on audience(s) and purpose(s). They will take an intentional journey through the writing processes such as planning, drafting, evaluating, revising, and editing, making choices based on the audience and purpose of the text.   

K-12.P.ST.1
**Overview of Standard**
In this standard, students are encouraged to go beyond the surface of a text and consider the broader circumstances that shape its meaning and impact. Understanding the author’s life, purpose, and historical backdrop of the text will help students explain motivations, themes, and perspectives. Students will analyze how historical and contemporary events, along with technological developments, affect texts, helping them understand how ideas evolve over time.   

K-12.P.ST.2
**Overview of Standard**
In this standard, students will become critical readers and intentional writers by understanding how texts are shaped to suit specific audiences and purposes. They will analyze how authors use language, structure, tone, and techniques to connect with their intended audience. Students will identify the purpose of a text and evaluate the effectiveness of the strategies and techniques used in achieving that purpose. They will also apply knowledge of audience and purpose when creating original texts, using text structures, text techniques, and stylistic choices to engage a target audience.  

K-12.P.AC.1
**Overview of Standard**
In this standard, students will interpret texts by examining how an author’s craft choices, such as structure, language, tone, and techniques, shape meaning and influence the reader’s experience. They will identify specific techniques, analyzing the techniques’ purposes and effects, and evaluate how they connect to the reader’s own reactions, thoughts, decisions, and questions. Through this standard, students will develop deeper literary analysis skills, fostering critical thinking and personal engagement with texts.  

K-12.P.AC.2
**Overview of Standard**
In this standard, students will construct texts by considering the target audience as they make decisions about craft choices, such as structure, language, tone, and techniques, to shape meaning and achieve a specific purpose. They will integrate specific techniques to appeal to a target audience, and craft words and phrases to influence the reader’s responses, thoughts, decisions, and questions. Through this standard, students will develop deeper literary skills as they utilize their knowledge of context, author, audience, and purpose to construct texts.  

K-12.P.AC.3
**Overview of Standard**
In this standard, students will analyze how the design and structure of a text influence its effectiveness for different audiences and purposes. They will evaluate how the structure and features of a text support or interfere with its purpose. Students will make deliberate choices about text design when constructing their own texts, tailoring their approach to suit the intended audience and the specific purpose of the text.  

K-12.P.CP.1
**Overview of Standard**
In this standard, students will articulate their thoughts clearly and listen to others effectively as they participate in structured group projects. Students will be active participants, holding each other accountable to maintain an amicable and productive group dynamic. They will engage in discussions to reach a consensus or solve a problem. They will use strategies for resolving conflicts, providing constructive feedback, and maintaining a growth mindset. This prepares students for real-world scenarios involving meaningful collaboration and communication to enhance their skills in engaging with others across a variety of settings and for different purposes.  

K-12.P.CP.2
**Overview of Standard**
In this standard, students will use presentation skills to communicate ideas, information, and texts effectively to target audiences for specific purposes. They will make intentional choices about modes, genres, tone, pacing, and nonverbal gestures to enhance their message. Students will also engage their audiences through interactive dialogue. Through these practices, they will develop the skills to present ideas clearly and purposefully in a wide variety of contexts.  

-----

K-12.P.EICC.1
**Vocabulary**
Goals
Preferences
Interest
Relevance
Comprehension
Composition
Community
Independence
Autonomy

K-12. P. EICC.2
**Vocabulary**
Dialogue
Analysis
Evaluation
Concepts
Processes
Problems
Solutions
Background
Knowledge
Skills
Ideas

K-12.P.EICC.3
**Vocabulary**
Purpose
Goals
Comprehension
Prior Knowledge
Summarize
Visualize
Predictions
Inferences
Academic Vocabulary
Unfamiliar Words

K-12.P.EICC.4
**Vocabulary**
Purpose
Audience
Goals
Modes
Genres
Structures
Craft techniques
Writing process
Comprehension
Composition

K-12.P.ST.1
**Vocabulary**
Context
Prior knowledge
Background
knowledge
Research
Purposes
Author
Audience

K-12.P.ST.2
**Vocabulary**
Author
Audience
Context
Purpose
Point of view
Perspective
Text design
Accessibility
Word choice (diction)
Language
structures
Craft techniques

K-12.P.AC.1
**Vocabulary**
Author’s lens
Craft techniques
Literary
techniques
Expository
techniques
Opinion
techniques
Rhetorical
techniques
Target audience
Purpose
Word choice (diction)
Sentence structure
Syntax
Formats
Structures
Patterns
Features
Accessibility

K-12.P.AC.2
**Vocabulary**
Craft techniques
Literary techniques
Expository techniques
Opinion techniques
Target audience
Purpose
Word choice (diction)
Sentence structure
Syntax
Formats
Structures
Patterns
Features
Accessibility

K-12.P.AC.3
**Vocabulary**
Text design
Audience
Purpose
Modes
Multimodal texts
Genres
Features
Meaning
Tone
Style
Craft techniques

K-12.P.CP.1
**Vocabulary**
Collaboration
Group discussions
Group norms
Shared Goals
Procedures
Productivity
Shared Project
Feedback

K-12.P.CP.2
**Vocabulary**
Presentation                        
Purpose                               
Audience                             
Texts
Modes
Genres
Tone
Pace
Nonverbal gestures
Dialogue
Background knowledge
Recitation
Poems
Speeches

------

K-12.P.EICC.1
Instructional Strategies for Teachers
• Create a community of readers and writers by immersing students in a variety of texts (e.g., picture books, chapter books, poems, songs) in a variety of modes (print, digital, auditory, visual) and in a variety of settings (whole group, small group, independently).
• Encourage students to create personal “Book Bucket Lists”: a list of books they want to read before the end of the year.
• Read aloud from a variety of different texts and model think-alouds to help students make connections to their own experiences and emotions. Allow students to add these books to their “Book Bucket List”.
• Allow time for students to have conversations with peers about what they are reading and writing (e.g., reading buddies, author’s chair, reader spotlight board, book reviews) and provide feedback.
• Create anchor charts with sentence stems to establish conversation norms for sharing and feedback.
• Provide opportunities for students to write for a variety of audiences and purposes.
• Create time for sharing and celebrating “publications” of students’ constructed texts.
• Create anchor charts of possible topics of interest for reading and writing. Then implement student interest surveys to help students identify their individual topics of interest.
• Have students create two identity charts: “Me as a Reader” and “Me as a Writer”, encouraging them to include their topic preferences, environment preferences, strengths, challenges, and goals.
• Work with students to develop reading and writing goals based on a variety of variables (e.g., stamina, pace, length, genre types, skill practice).
• Work with students to develop reading and writing plans based on their goals, encouraging autonomy.
• Schedule times for progress check-ins and provide timely, specific feedback about goals and plans.
• Allow students to form small groups or book clubs based on shared reading interests. Provide a selection of books for students to choose from, encouraging autonomy. 

K-12. P. EICC.2
Instructional Strategies for Teachers
• Build a community of readers and writers by making organizational decisions related to various types of texts including different genres, text modes, purpose in a whole group or small group setting.
• Model and practice basic conversation skills such as listening attentively, making eye contact, taking turns, and using appropriate body language.
• Introduce and use language frames such as “Questions, comments, or connections?” to help students respond to peers and deepen discussions.
• Provide students with texts that appeal to their senses or emotions.
• Provide scaffolds like anchor charts with question stems or prompts to support students as they discuss characters, events, and messages in stories.
• Utilize think-alouds to build students’ comprehension skills.
• Model and allow students to engage in peer dialogue.
• Create anchor charts to explain the various purposes when reading a text and when constructing a text.
• Utilize graphic organizers and writing notebooks for generating ideas and exploring personal interests.
• Work with students individually or in small groups as they engage in the writing process.
• Allow students time to collaborate with their peers and share their connection to the text.
• Create anchor charts with prompts to allow students to share questions or ideas about the text. 

K-12.P.EICC.3
Instructional Strategies for Teachers
• Create KWL charts (What I Know, What I Want to Know, and What I Learned) to help get students thinking about a text.
• Create “Thinking Maps” to make connections across a text(s).
• Writing About Reading (WAR): Utilize student journals combined with writing prompts to get students thinking and reflecting on what they’ve read and extend that thinking further.
• Create a Beginning, Middle, End (BME) chart to track the events in a text.
• Work with students to summarize what they read using the five-finger strategy “Somebody Wanted But So Then” (SWBST).
• Use a timeline to track important events/dates and/or changing perspectives through the beginning, middle, and end of a text.
• Use “speech bubble” and “thinking bubble” sticks to discuss what a character may be thinking or says in a text to help understand the events taking place.
• Encourage students to look for “repeats” in words or pictures to identify the author’s purpose and audience.
• Work with students to be “word aware” and stop to think about words they may or may not know. Help them build a repertoire of strategies to use when they do not know a word.  

K-12.P.EICC.4
Instructional Strategies for Teachers
• Provide ample modeling for students as they engage in each step of the writing process through shared and independent writing
• Model deciding on a purpose for writing and determining the intended audience.
• Model brainstorming and preplanning.
• Model how to organize information using a graphic organizer based on the mode or genre you want to use.
• Model first drafts to allow students to see the ‘sloppy copy’ that can then be used for revision tasks.
• Model giving and receiving feedback to improve the effectiveness of a text.
• Model revision of the first draft to add details, adjust word choice, add techniques.
• Model editing with an emphasis on previously learned skills.
• Engage in shared writing of a variety of texts with class input over a shared topic or experience; this shared piece could serve as an anchor chart and text to use for revision and editing.
• Teach the organizational structures for common modes and genres.
• Provide a checklist to allow students to self-assess their writing.
• Have students work together in partnerships to provide feedback and make suggestions to help strengthen their writing. This will require modeling, teacher support, and potential stems at this level. <ul><li>Partners may offer 3 Stars and 1 wish (three things the student did well, and one suggestion or question).</li><li>Remind students to use the language of the mode or genre when offering a star or a wish (“You captured my interest when you said……” or “I wish you had included more details so that I could really get a picture in my head of what the character looked like”).</li>
• Allow students to reuse the draft for revisions by making the revisions in another color. If students skip lines when writing, it will provide room on the paper for revisions. Students can also add strips of paper to create additional lines using tape, creating a ‘lift the flap” with the purpose of adding text or elaborating.
• Create or use exemplar texts with errors that the students commonly make. Guide students to revise the exemplar text.
• Use mentor texts to demonstrate various writing examples that students can emulate as they work through the writing process, especially revision.
• Schedule individual conferences; focus on the next best step that this writer needs to improve his writing rather than correcting all errors in the piece.
• Engage students in whole class, individual, and small group research projects.
• Teachers provide opportunities for students to connect writing with science and social studies content.  

K-12.P.ST.1
Instructional Strategies for Teachers
• Use a mentor text to model how to identify background information: where the story is taking place (geographical location) and cultural influences within the text.
• Model how to annotate the text during close reading to guide students in application and understanding (how and why) context impacts the meaning of the text. For example, use a big book and add sticky notes to show when you notice something about the setting and characters.
• Provide explicit instruction by using an anchor chart to define context and context clues.
• Use a word wall with pictures or picture books to help students visually associate words related to context to make meaning.
• Teach students to analyze how context shapes the meaning of texts. For example, guide students in understanding how the time period of the setting may impact character actions and dialogue.
• Allow students to collaborate in small groups or with a partner to identify how various aspects of the texts’ context impact the authors’ purpose and audience.
• Develop text sets to be used to increase background knowledge and that include multiple modalities and genres to explore aspects of context. For example, a text set designed around a specific topic, such as alligators, could be used to explore the impact of how people feel about alligators on how the author approached the purpose and audience.
• Provide students with opportunities to identify context clues in sentences and paragraphs.
• Guide students in constructing a shared writing piece using historical, geographical context or cultural context.
• Have students construct a text about living in the particular setting/time period of the mentor text.  

K-12.P.ST.2
Instructional Strategies for Teachers
• Model reading book blurbs found on the back cover or inside flaps of books that tell about the author and/or illustrator. Prompt discussion through questions about the author and illustrator (e.g., How does what we learned about the author help us understand why they wrote this text?).
• Model how to research the authors of texts, using guiding questions such as: What can we learn about the author of this text? Where are they from? What is their background? What are their interests?
• Create anchor charts to support brainstorming discussions on different reasons why an author would create a text (purposes) and on different groups of people that an author creates a text for (audiences).
• Use mentor texts to model how to identify the purpose and audience of a text.
• Conduct author/illustrator studies to look for common characteristics across texts (e.g., characters, style, structure, themes).
• Use dialogue from various parts of a previously read text and ask guiding questions such as: Who said this? How do we know who is speaking? In what point of view is this text written? What is the perspective of the speaker or narrator? What does it tell us about the text?
• Create anchor charts for pronoun clues when determining 1st, 2nd, or 3rd person point of view (who) of a text.
• Use a T-chart to compare/contrast point of view (who) vs. perspective (how).
• Construct shared texts with a specific purpose and audience in mind. Discuss as a class why certain choices were made during the construction of the text.
• Take a familiar mentor text and model how to change who is telling the story to a different character in the text. Model this using dialogue from characters in the story. How did it change from the original story? Why?
• Use a graphic organizer to determine aspects of the context in which a text is written: who wrote the text, who the text was written for, where the text was written, when the text was written, what was happening during that time, what background knowledge is needed to understand the text.
• Model how to consider context when analyzing a text’s design or when designing a text. 

K-12.P.AC.1
Instructional Strategies for Teachers
• Provide students with opportunities to explore and identify text features and their purposes. For example, bold print shows important vocabulary; captions explain images; and headings and subheadings help with organization of ideas in expository or opinion text.
• Provide students with exposure to a variety of literary texts read aloud by the teacher that can be used to explore narrative techniques and their impact on the audience. For example, The Magic of 3 is a technique used in many fairy tales to build the rising action.
• Model how to identify commonalities between different types of text and text features and how they help the author convey their purpose. For example, many informational articles also have photographs and captions because it helps the author show their main points in a visual way.
• Create charts of the techniques and elements of a variety of genres and text types (folk tales, fairy tales, poems, infographics, etc.).
• Allow students to identify text features and various techniques in texts they read and add to a class chart.
• Choose texts rich in figurative language and guide students in noticing the differences in language and how that impacts the audience and purpose. For example, using onomatopoeia helps a young audience interact with text and adds interest and clarity.
• Provide examples of literal and nonliteral language found in various texts.
• Help students understand how word choices can affect the meaning of the story. Have them explore creating texts and using a variety of word choices from a class list. Discuss which choices add meaning or clarity to the writing.
• Build a beginning understanding of sentence structure and syntax by reading texts and having students identify simple versus longer sentences, as well as more complex sentences. Keep a tally chart of each. Explore how different sentences impact the text.
• Have students engage in a Sentence a Day protocol, where they learn to manipulate syntax and make purposeful decisions about word choice, sentence length, etc.
• Begin learning about the different types of organizations for texts through read-alouds and the use of simple graphic organizers that can be created together as a class and then displayed. For example, read a narrative story, chart the organization of beginning, middle, end, and then use the chart for future reference. Read an informational text and chart the main idea and detail structure.
• Begin to explore accessibility with young students by having them explore texts with varying size fonts, colored backgrounds, images, etc., and then engaging in discussions about what makes these easy or difficult to see and read. Discuss ways you make these texts more accessible to an audience.  

K-12.P.AC.2
Instructional Strategies for Teachers
• Provide opportunities for writing across the day and build off students’ knowledge as readers.
• Allow ample exposure for students to engage with interpreting texts across a wide variety of contexts, purposes, and audiences using mentor texts.
• Conduct shared writing experiences based on a chosen purpose and audience.
• Utilize various scaffolding strategies such as sentence stems, partner writing, or sketching.
• Refer to charts and/or graphic organizers on techniques, structure, text features, and language to incorporate into writing.
• Create pattern books as a class, building off information from other content areas.
• Model how to plan and organize writing using 3 pages for Beginning, Middle, and End.
• Have students “act out” parts of the writing and then “write it down” while it is fresh on their minds.
• Have students create “alphaboxes” (boxes for each letter of the alphabet) to organize words on a specific topic that they can use in their writing.
• Create story arcs to plan out narrative writing.
• Model how to engage in the writing process to draft a writing with the purpose and audience in mind, evaluate the writing to gauge the effectiveness of the writing to meet its purpose and audience, and revising and editing the writing to ensure the choices made are based on the purpose and audience.
• Use knowledge of sentence structure and various sentence types to make decisions on which to use for specific purposes and audiences.
• Use knowledge of figurative language and word choice to add meaning or clarity to writing.
• Utilize writing partners that allow students to provide feedback and suggestions to others.  

K-12.P.AC.3
Instructional Strategies for Teachers
• Use the P.AC.3 Text Design Considerations resource to examine the various components that shape how texts are constructed and presented and to leverage these insights to strengthen instruction by helping students recognize, analyze, and apply text design features in their own reading and writing.
• Use mentor texts from a variety of genres (narrative, opinion, expository, etc.) to model and teach text features.
• Provide opportunities for students to compare genres and text features by asking questions about how modes contribute to the meaning of the text.
• Guide students in exploring meaning and purpose across various texts.
• Provide opportunities for students to engage in interactive read alouds to analyze text features (students can engage in a text feature sorting activity).
• Ask open-ended questions and encourage students to make predictions about the text.
• Use an anchor chart to guide students in understanding the beginning and middle of a story.
• Teach students to refer to anchor charts as they engage in independent writing.
• Use an anchor chart to guide students in each phase of the writing process (drafting, revising and publishing) as they construct texts.
• Provide students with graphic organizers (Venn diagram, story maps, etc.) to engage in the writing process by using sentence starters or prompts.
• Allow opportunities for students to engage with multimodal texts (print, digital etc.).
• Provide opportunities for students to create multimodal texts (drawings, podcast, voice recording, etc.).
• Model and teach students how to include craft techniques in their own writing pieces.
• Provide opportunities for students to collaborate with peers to share their work, retell stories and identify text features/craft techniques.
• Conference with students individually or in a small group setting regarding their construction of texts.  

K-12.P.CP.1
Instructional Strategies for Teachers
• Have students pair up to discuss a question or idea briefly as a turn and talk.
• Have students engage in a Think-Pair-Share: Students think individually, discuss with a partner, then share with the group.
• Give each student a specific job or assigned role (e.g., recorder, speaker, materials manager) to promote responsibility and teamwork.
• Use cooperative learning activities such as a jigsaw. Divide a topic among students. Each student becomes an ‘expert’ on one part and teaches it to others.
• Demonstrate what good collaboration looks like through modeling taking turns, using kind words, and listening.
• Role-play scenarios where students practice solving problems or sharing materials.
• Post collaborative norm reminders on anchor charts (e.g., We listen, We take turns, We help each other).
• Provide sentence starters for partner/group work like “I agree because…” or “Can you help me with…?”
• Daily group discussions such as morning meetings help build community and give students practice with taking turns and listening respectfully.
• Board games, building centers, and dramatic play encourage natural collaboration.
• STEM challenges (e.g., building a bridge with blocks) promote teamwork and problem-solving.
• Use specific praise to reinforce positive collaboration (“I noticed how you waited for your turn.”).
• Reflect with students after group activities: What went well? What can we do better next time? 

K-12.P.CP.2
Instructional Strategies for Teachers
• Develop audience awareness through role play. Have students present the same message to different audiences (e.g., explaining a game to a friend vs. to a grandparent). Ask: “Who are you talking to?”, “What do they need to know?”, “What words would help them understand?”
• Engage in show and tell with a purpose. Modify the show and tell for various purposes.
• Entertain: Tell a funny story about an object.
• Inform: Describe how something works.
• Persuade: Convince the class why it's the best toy.
• Use sentence starters to help students organize their ideas before they share in groups (“Today, I want to tell you about…” “I chose this because…” “I hope you learned that…”)
• Provide simple visuals (charts, drawings, photos) to support communication.
• Regularly model expressive speaking, eye contact, volume control, and posture.
• Use student-friendly videos or peers as examples of good presentation habits.
• Practice one skill at a time (e.g., using a loud voice, looking at the audience).
• Create a basic presentation rubric with icons. After each presentation, let peers give one compliment and one suggestion.
• Have students give a presentation for a real purpose (e.g., share research findings with another class, give announcements to the school or community, explain how they solved a math problem to the class).
• Provide scaffolding for presentations. Use small group rehearsals or whisper partners before speaking to the full class.
• Encourage students to use props or drawings to stay on topic and stay confident.
• Encourage students to explore the sounds and rhythm of language through fun recitation activities (e.g., poems, rhymes, choral speaking, dramatic performance, storytelling).
• Give students an opportunity to develop presentation skills on individual and collaborative group presentations. 

------

K-12.P.EICC.1

<h3>Evidence of Student Learning</h3>
<table>
  <thead>
    <tr>
      <th>Teacher Prompt</th>
      <th>Student Response</th>
    </tr>
  </thead>
  <tbody>
    <tr>
      <td>Provide students with a variety of books to choose from.</td>
      <td>Allow students to engage with the books with a partner, in a small group, or independently.  </td>
    </tr>
    <tr>
      <td>Encourage students to select a book, hold it upright with the front cover facing them, and begin reading.</td>
      <td></td>
    </tr>
    <tr>
      <td>Circulate around the room and observe students as they interact with the books using an observation checklist. Provide support and guidance as needed, reminding students to hold the books upright and pointing out the front covers.</td>
      <td></td>
    </tr>
    <tr>
      <td>Possible prompts: <br>- Can you show me how you hold a book when you are ready to read?<br> - Can you show me where the front of the book is? - Where do we begin reading the text?<br> - Can you show me how you read the words on this page?<br> - Let’s turn the next page together. Which way do we turn the page?<br> - At the end of this page, where do I read next? </td>
      <td>Students should be holding books in the correct upright position with the cover at the front.<br><br> The student should open the book to a random page where the teacher can observe if the student follows the text from top to bottom and left to right. <br><br> The student should turn the page from right to left.<br><br>The student should point to the next page to read next.
    </td>
    <tr>
      <td>Gather students together and facilitate a brief discussion about their book exploration experience. Ask students to share which books they explored and what they noticed.</td>
      <td></td>
    </tr>
    <tr>
      <td>Reinforce the importance of holding books upright and starting at the front cover when reading.</td>
      <td></td>
    </tr>
  </tbody>
</table>

----

K-12.P.EICC.2

Evidence of Student Learning

<table>
  <thead>
    <tr>
      <th>Teacher Prompt</th>
      <th>Student Response</th>
    </tr>
  </thead>
  <tbody>
    <tr>
      <td>Provide students with a variety of texts and story books from different genres that appeal to the senses or emotions, and/or feelings.</td>
      <td>Allow students to engage with texts independently, with a partner or in small groups.</td>
    </tr>
    <tr>
      <td>Encourage students to select a text and hold it upright with the front cover facing them.</td>
      <td>Students should be holding books in an upright position reading from left to right.</td>
    </tr>
    <tr>
      <td>Gather students to examine the text title, illustrations, and text structure. Guide students to look for interesting and descriptive words and illustration throughout the text.</td>
      <td>Students should identify the authors and illustrators of books. <br><br> Students should explain the role of an author and illustrator of a book.<br><br>  Students should identify how the descriptive words or illustrations appeal to their senses within texts.</td>
    </tr>
    <tr>
      <td>Possible Prompts <b>before</b> reading: <br>-Can you tell me what the author of a book does? <br>-Can you tell me what an illustrator does? <br>- How do the pictures and words on the cover work together to make meaning? <br>- Does the topic of this text remind you of something you have heard or seen?</td>
      <td>Responses will vary but could include: <br>- The author is the person telling the story.  <br>- The illustrator draws the pictures.  <br>- The pictures and words on the cover help me understand what the book is about. </td>
    </tr>
    <tr>
      <td>Facilitate a discussion about the topic, encouraging students to share their thoughts and experiences. Help students understand the organizational structure of text types (e.g., narrative, expository, informational, opinion or argumentative)</td>
      <td></td>
    </tr>
    <tr>
      <td>Possible prompts <b>during</b> reading: <br>- Authors write books for different reasons. What do you think the author wanted you to know? <br>- What went through your mind when...? - How did you feel when the character...? <br>- How could the information in the story be used to make a picture or graphic?</td>
      <td>The author wanted you to know more information about a topic.<br> The author may want to share how he/she felt about something.<br> The author wanted to share their opinion or argument about a topic.</td>
    </tr>
    <tr>
      <td>Encourage students to create mental images of the characters, setting and events in the text.</td>
      <td></td>
    </tr>
    <tr>
      <td>Possible prompts <b>after</b> reading: <br>- What is your favorite part of the story? Why? <br>- Retell some of the information the author gave to support his/her point of view. <br>- From whose point of view have we heard the story? How would the story change if a different character were telling the story? </td>
      <td>Responses will vary but could include:  <br>- My favorite part of the story was (the beginning, middle, end or when the problem is solved).  <br>- If a different character was telling the story, it would be different because they might feel different things or see things another way.   </td>
    </tr>
  </tbody>
</table>

----

K-12.P.EICC.3

Evidence of Student Learning

<table>
  <thead>
    <tr>
      <th>Teacher Prompt</th>
      <th>Student Response</th>
    </tr>
  </thead>
  <tbody>
    <tr>
      <td>
        Choose a mentor text to read aloud or share with students. This could be a printed, digital, visual, or auditory text.<br/>
        *A narrative text is being used in this example.<br/><br>
        Before sharing the text, say to students, Today, we are going to look at a special text together. Let’s look at the cover and take a sneak peek inside to see if we can figure out why the author wrote this text.<br/><br>
        Model how to think-aloud about the title, images on the cover, and some of the text features found on a few pages throughout the book. Have the pages chosen and marked ahead of time to ensure that none of the major events are revealed through the book walk.<br/><br/>
    </td>
    </tr>
    <tr>
      <td>
        Possible prompts for <b>before</b> reading:<br/>
        - Based on the title and cover, what do we think this book is about? Do we think it’s going to tell us a story about ___, give us information about ___, share an opinion about ___, or explain how ___ works?<br/>
        - Let’s take a look at this page. What kind of text features do we see? Does this feature (e.g., illustrations, captions, diagram) support the purpose we think the author had for writing this text?<br/>
        - Make predictions: Based on our book walk, what are we thinking might happen in this story? Why do you think that? Let’s read and see if our predictions are right! We can stop along the way when we come to a place that supports our predictions.
      </td>
      <td>
        Listen to student responses and clear up any misconceptions.<br/><br/>
        For this example, students should notice the illustrations depicting a setting, characters, and events.<br/><br/>
        Allow students time to think about and discuss their predictions with each other. Encourage students to give reasons to support their predictions.
      </td>
    </tr>
    <tr>
      <td>
        Possible think-alouds and prompts for <b>during</b> reading:<br/>
        - I love this part where the author is describing the character’s actions. My heart starts racing just thinking about how scared he must be! The author is doing a good job telling the story and making me feel like I’m there watching.<br/>
        - I want you to think about a part in the book we’ve read so far that makes you stop and think, “This is a good story! It makes me think of ___.” Now, pair up with the person next to you and share that connection. What does the author and/or illustrator do to make this such a good story?<br/>
        - Monitor for understanding: Let’s take a moment to think about the part where ... (insert a major event in the story between two characters). How did what happened impact the character’s feelings and actions? What does this tell us about their relationship.
      </td>
      <td>
        Responses will vary. An example might be, The illustrator made the pictures detailed and they matched the words the author used so I could imagine the story in my mind like a movie.<br/><br/>
        Responses will vary.
      </td>
    </tr>
    <tr>
      <td>
        Possible think-alouds and prompts for <b>after</b> reading:<br/>
        - What a great book! What were some of your favorite parts? I like how the characters talked about how they were feeling. That dialogue really helped me understand the story. That’s one thing a good author does when trying to tell a story- they add dialogue.<br/>
        - Summarize: If we wanted to tell a friend about this story, how could we summarize it for them? What do they need to know?
      </td>
      <td>
        Responses will vary.<br/><br/>
        Responses will vary.
      </td>
    </tr>
  </tbody>
</table>

------

K-12.P.EICC.4

Evidence of Student Learning

<table>
  <thead>
    <tr>
      <th>Teacher Prompt</th>
      <th>Student Response</th>
    </tr>
  </thead>
  <tbody>
    <tr>
      <td>Say, Since we have been working on writing stories with narrative techniques that capture the audience, today we are going to try revising the story we wrote together about the day the bird got inside our classroom. I made you a copy of the story and gave you a highlighter and a red pen.</td>
      <td></td>
    </tr>
    <tr>
      <td>I am going to read the story aloud for us and as I read, I want you to listen for two things. First, I want to see if we can find a place to add dialogue, like the dialogue we have read in our mentor stories. A place where the dialogue will be interesting to our audience. When you find a place that sounds like it could have dialogue, I want you to highlight that spot.</td>
      <td></td>
    </tr>
    <tr>
      <td>Read aloud as students highlight. Allow students to work with a partner to discuss the dialogue they think needs to be added, as well as how it would be interesting to the audience.</td>
      <td>Areas highlighted by students may vary.</td>
    </tr>
    <tr>
      <td>Model selecting a place to add dialogue as a narrative technique. Then have students use their red pens to add dialogue. It is okay if they choose to add the same dialogue you modeled, or they may choose to add dialogue in a different place.</td>
      <td></td>
    </tr>
    <tr>
      <td>Say, I also want to see if we can find a place to make our major event more interesting. Since our purpose is to tell an entertaining story, we want our audience to feel like they are right there. This time as I read, I want you to listen to the part where the bird was flying around. Highlight when you find a place where we could revise our story to make that scene more vivid for our audience- just like they were here that day.</td>
      <td></td>
    </tr>
    <tr>
      <td>Read aloud as students highlight. Allow students to work with a partner to discuss the additions for purpose and audience that are needed.</td>
      <td>Areas highlighted by students may vary.</td>
    </tr>
    <tr>
      <td>Model selecting a place to add to the major event as a narrative technique. Then have students use their red pens to add to their copy. It is okay if they choose to add the same portion you modeled, or they may choose to add a different detail.</td>
      <td></td>
    </tr>
    <tr>
      <td>Say, Now that we have worked to revise our class story, I want you to use your highlighter and read the story you have started drafting. Look for one place you can add dialogue and one place you can add to the main event, and highlight them. Then you will revise your story and write in your changes in red pen.</td>
      <td></td>
    </tr>
    <tr>
      <td>Circulate around the room, conferencing with students to determine their understanding of revision, dialogue, and adding to the main event. Provide feedback and encourage them to try again if needed.</td>
      <td></td>
    </tr>
    <tr>
      <td>* This lesson may require more than one writing session.</td>
      <td></td>
    </tr>
  </tbody>
</table>


------

K-12.P.ST.1

Evidence of Student Learning

<table>
  <thead>
    <tr>
      <th>Teacher Prompt</th>
      <th>Student Response</th>
    </tr>
  </thead>
  <tbody>
    <tr>
      <td>
        <p>Select a mentor text to read aloud or share with students. This could be printed digital, visual, or auditory text.<br>
        *A narrative text is being used in this example from a different time period such as the wild west.</p>
        <p><b>Before</b> reading, guide students in a “picture walk” to predict the setting and characters within the book by looking at the illustrations within the text.</p>
        <p>Ask students, What do the pictures in the story tell us? Why do you think this?</p>
        <p>Guide students to notice the differences from when this story happened compared to current day.</p>
      </td>
      <td>
        <p>Responses will vary, but could include:</p>
        <p>- I think the story is about being kind.<br>
        - I think the story is about cowboys because I see horses and cowboy hats.</p>
      </td>
    </tr>
    <tr>
      <td>
        <p><b>During</b> reading, ask students questions to guide their understanding of the text.</p>
        <p>Ask, Where is the story happening? Who are the characters in the story? How do you know?”</p>
      </td>
      <td>
        <p>Responses will vary, but could include:</p>
        <p>- This story happened a long time ago. I can tell because they are riding horses. They have to pull up their water from a well.</p>
      </td>
    </tr>
    <tr>
      <td>
        <p><b>After</b> reading, facilitate a discussion to help students identify how the story compares to their life experiences.</p>
        <p>Ask, Do you think this story is from the past or present? How do you know What parts of the story are like your life? What parts of the story are different?</p>
      </td>
      <td>
        <p>Responses will vary, but could include:</p>
        <p>- We ride on a bus to school, and we go places in a car. There were no cars in this story.<br>
        - We get our water from the sink.</p>
      </td>
    </tr>
  </tbody>
</table>

------

K-12.P.ST.2

<h3>Evidence of Student Learning</h3>

<table>
  <thead>
    <tr>
      <th>Teacher Prompt</th>
      <th>Student Response</th>
    </tr>
  </thead>
  <tbody>
    <tr>
      <td>Select a mentor text that students are familiar with. *A narrative is used in this example.</td>
      <td></td>
    </tr>
    <tr>
      <td>Take a brief picture walk with students to remind them of the story elements of the chosen text.</td>
      <td></td>
    </tr>
    <tr>
      <td>Using a T-chart, show students various pieces of dialogue from the text. Be sure to include dialogue from various characters.</td>
      <td></td>
    </tr>
    <tr>
      <td>Prompt students to discuss who is speaking: <br>- Who do we think said this? <br>- What is the point of view of the narrator or speaker? <br>- How do we know this? What clues has the author given us? </td>
      <td>Responses will vary. An example answer may be:  <br>- I think ___ said this because the tag says ___.  <br>- I think this text is being told in first person because the author uses the pronouns I and we.</td>
    </tr>
    <tr>
      <td>Encourage deeper thinking by modeling how to consider the context of the text and how it affected the author’s choices about speakers and point of view:  <br>- What does this dialogue tell us about the character(s)? <br>- How are the characters the same? Different? <br>- Why do we think the author included these different perspectives? <br>- What do we know about the text that helps us understand the author’s choices (author background, time period, etc.)? </td>
      <td>Responses will vary. An example answer may be: <br>- The character is feeling sad because ______. <br>- This character seems more confident while the other character seems unsure about what is going on. <br>- The author included both to show us how not everyone deals with conflict in the same ways. <br>- We know this text was set during the _______ time in our history when people were feeling ____.  </td>
    </tr>
  </tbody>
</table>

------

K-12.P.AC.1<br>
Evidence of Student Learning

<table>
  <thead>
    <tr>
      <th>Teacher Prompt</th>
      <th>Student Response</th>
    </tr>
  </thead>
  <tbody>
    <tr>
      <td>
        Show students an expository text about volcanoes.<br>
        Say, We have been learning about the text features and techniques used in expository texts. What are some things that help us identify this text type?<br><br></td>
        <td>        Students may say:<br>
        - Text features like bolded words, real photos, a glossary, etc.<br>
        - Techniques like using facts.<br><br></td>
    </tr>
    <tr>
        <td>
        Ask, Why do you think the author chose to use _____ text feature in this text? How does it help us as the audience? How did it help the author with their purpose?<br><br></td>
        <td>Responses might include:<br>
        - They chose this feature because it helps people understand.<br>
        - It helped me as the audience because now I know what a volcano looks like when the author talks about it.<br>
        - The purpose was to teach us about volcanoes, so this feature helps to teach us.<br><br></td>
    </tr>
    <tr>
        <td>
        Say, Right here, the author chose to use the word ‘enormous’ when describing the volcano. Why do you think they chose to use this word here? What descriptive words could help the audience understand more about volcanoes?<br><br></td>      <td>
        Students may say:<br>
        - I think they chose enormous so we would know a volcano is bigger than just big.<br>
        - Words might include giant, huge, rocky, fiery, etc.<br><br>
        </td>
    </tr>
    <tr>
        <td>
        Have students work in partners to generate words. Then they can rewrite the sentence using their choice of words.
      </td>
      <td>
        Responses will vary.
      </td>
    </tr>
  </tbody>
</table>

------

K-12.P.AC.2
Evidence of Student Learning

<table>
  <thead>
    <tr>
      <th>Teacher Prompt</th>
      <th>Student Response</th>
    </tr>
  </thead>
  <tbody>
    <tr>
      <td>
        <p>Remind students about their recent study about volcanoes. Say, We have been learning about volcanoes and have noticed many techniques used in expository texts to teach us about volcanoes. Today, we are going to take what we’ve learned and do a shared writing about volcanoes.</p>
        <p>Say, First, we must decide who our audience is and what our purpose is. Who has some suggestions?</p>
        </td><td>Reponses might include: <br>- We can write for the class next door to teach them about volcanoes. <br>- We can write for the 3rd grade science teacher to help them teach about volcanoes. </td>
        </tr>
    <tr><td>
        <p>After deciding on a purpose and an audience, plan and brainstorm what might be included in the writing on the topic of volcanoes: facts, definitions, text features, etc. Then, begin a draft of a shared writing on volcanoes.</p>
        <p>Ask, What text feature might we choose to help teach our audience about ________?</p></td><td>
       Responses might include: <br>- Let’s use a diagram/illustration because it helps people understand what a volcano looks like.  <br>- The purpose is to teach the audience about volcanoes, and labels help teach. </td>
       </tr>
       <tr>
        <td>
        <p>Say, We know the authors in the expository texts we looked at chose to use specific vocabulary words to really help teach us about volcanoes. Using our “alphabox” of vocabulary words we’ve collected, what words can we use to help the audience understand more about volcanoes? Is there a place in our writing where we can use these words?</p></td><td>Students may say:  <br>- Words might include rocky, fiery, lava, eruption, crater, etc.</td>
       </tr>
       <tr> <td>        <p>Have students work in partners to find a sentence they can revise to use vocabulary acquired in their study of volcanoes. Then, they can rewrite the sentence and use their choice of words.</p>
      </td>
      <td>
        <p>Responses will vary.</p>
      </td>
    </tr>
    <tr><td>Extension Opportunity A student sample text could be used as a mentor text with students to help them create and analyze their own creations. (Teachers may pull from their own personal student work libraries; also, a sample is provided in the K-2.P.AC.2 Student Resource Sample). <br><br>Provide students with a final context, purpose, and audience. Have each student draft an individual short text for the writing task, thinking about their choices while they do so. </td><td></td></tr>
  </tbody>
</table>

----

K-12.P.AC.3<br>
Evidence of Student Learning

<table>
  <thead>
    <tr>
      <th>Teacher Prompt</th>
      <th>Student Response</th>
    </tr>
  </thead>
  <tbody>
    <tr>
      <td>Select a mentor text to read aloud to students. This could be printed digital, visual, or auditory text.</td>
      <td></td>
    </tr>
    <tr>
      <td>Share possible prompts before reading the texts. Say, Today we are going to read a new book. Remember when we talked about authors creating books that have different text designs? Look at the front cover of this book. What do you think this book is about when you look at the front cover?</td>
      <td>Student responses will vary but could include:<br><br>- The book’s title is in big silly letters so it might be a funny book.<br><br>- The book has a lot of colorful pictures inside.</td>
    </tr>
    <tr>
      <td>During the reading, ask open-ended questions to guide students in making predictions about the text. Guide students in identifying text features and craft techniques.</td>
      <td></td>
    </tr>
    <tr>
      <td>Ask, What makes this book entertaining? Who do you think the author wrote this book for? Why do you think the author wrote this book?</td>
      <td>Student responses will vary but could include:<br><br>- The book has silly pictures and funny jokes inside.<br><br>- The pictures make me laugh.</td>
    </tr>
    <tr>
      <td>After reading, provide students with sentence starters to engage them in understanding the purpose and audience of the text.<br><br>Sample sentence starters:<br><br>- I laughed when….<br><br>- I think the author made the book funny by…<br><br>- The pictures in the book are funny because…</td>
      <td>…the balls all came tumbling down on the clown’s head.<br><br>…making the clowns say silly things.<br><br>…the tall clown is wearing a flower pot on her head!</td>
    </tr>
    <tr>
      <td>As a culminating activity, guide students in constructing their own texts using text design features previously introduced.</td>
      <td>Responses will vary.</td>
    </tr>
    <tr>
      <td>Guide students in constructing their text by providing them with the following questions:<br><br>- What will I create?<br><br>- Who will I create the text for? (audience)<br><br>- Why am I creating this text? (purpose)<br><br>- What text features can I include in my text?</td>
      <td></td>
    </tr>
  </tbody>
</table>

-----

K-12.P.CP.1

<h3>Evidence of Student Learning</h3>
<table>
  <thead>
    <tr>
      <th>Teacher Prompt</th>
      <th>Student Response</th>
    </tr>
  </thead>
  <tbody>
    <tr>
      <td>
        Say, After we have worked to learn about volcanoes, you will work together with a partner to develop a text that uses expository techniques to help our audience understand more about volcanoes.<br><br>
        Have students work with a partner to create an expository text in a single mode such as a print flyer, a video recording using hand drawn pictures as visual supports, creating a slideshow, etc.<br><br>
        Provide students with a rubric for the assignment based on the mode used.<br><br></td></tr>
    <tr><td>
        Provide time for them to work together. Assign roles as needed in various partnerships. Remind students of norms for working with a partner.<br><br>
        Provide feedback on each pair’s collaboration. Encourage students that are working well within partnerships. Model for those who may need support.
      </td>
      <td>
        Students will co-construct an expository text in the assigned mode with their partner using the rubric provided.<br><br>
        Students will follow established group norms with teacher support.
      </td>
    </tr>
  </tbody>
</table>

----

K-12.P.CP.2

<table>
  <thead>
    <tr>
      <th>Teacher Prompt</th>
      <th>Student Response</th>
    </tr>
  </thead>
  <tbody>
    <tr>
      <td>

        Say, We have researched and studied volcanoes, and now you are going to have a chance to present what you’ve learned. You will be able to choose what you use to present, and your audience will be _____.
        <br><br>
        Provide students with audiences such as a younger student, family members, etc.
        <br><br>
        Have students work to develop their presentation, including visuals as appropriate.
        <br><br>
        Model for students what makes an effective presentation, including volume, speed, eye contact, etc. You may choose to use a rubric for this portion.
        <br><br></td></tr>
    <tr><td>
        Scaffold for students by having them practice their presentation with a partner or small group. If using the rubric, have partners provide basic feedback. You can also provide feedback to strengthen presentation skills.
        <br><br></td>      <td>
        Students share their learning about volcanoes with a selected audience with appropriate eye contact, confidence, and knowledge.
      </td></tr>
    <tr><td>
        <strong>Extension Opportunity:</strong><br>
        Have students collaborate with partners or a small group to carry out a presentation. Provide planning templates (sample planning template) or sentence starters for students who need additional support. A rubric (sample rubric) could also be provided for clarity. These resources should be aligned to local instruction.
      </td>
    </tr>
  </tbody>
</table>

----

K-2.T.C.1
Overview of Standard
In this standard, students are learning to interpret texts by identifying and determining the general purpose of why a text was created and who the author had in mind as the target audience for the text. Students will also learn to identify and recognize the different modes in which a text can be communicated. They will then begin creating texts in various modes with teacher support. 

K-2.T.C.2
Overview of Standard
In this standard, students are beginning to understand that a story or text has both an author (the person who wrote it) and a speaker (the voice telling the story). They are learning to identify the author and the speaker, understanding that sometimes the author and the speaker in the text are the same. Students will identify the author and the illustrator and explain what each person does to help the story. They will practice identifying who is speaking or telling the story, moving to determining the point of view used in the text. 

K-2.T.SS.1
Overview of Standard
In this standard, students are learning to recognize how texts are organized and why certain text features are used. They will explore and use features (e.g., diagrams, table of contents, illustrations, headings) to help them understand the topic of the text and find information more easily. Students will then go beyond recognizing text features to understanding why they are there and how they add meaning and support to the text’s structure. They will start to include features in their own writing to make it clear and more engaging, and to use transition words/phrases and conjunctions to show the order of events in a text.  

K-2.T.SS.2
Overview of Standard
In this standard, students begin to identify descriptive and engaging language that can include sensory and feeling words. As they grow in their understanding of descriptive language, they will identify the difference between literal and nonliteral language, and practice expressing feelings and sensory details through words. They will construct texts using descriptive language to convey information and ideas.

K-2.T.T.1
Overview of Standard
In this standard, students are developing their knowledge of storytelling as they interpret and construct narrative texts. Students apply their understanding of narrative techniques as they construct texts tailored to a specific purpose and audience, shaping the overall meaning of the text. Georgia’s K-12 ELA Standards shift from fixed text types to the flexible use of techniques, emphasizing purpose and audience, with authentic texts often blending narrative, expository, argumentative, and poetic techniques.

K-2.T.T.2
Overview of Standard
In this standard, students develop the ability to understand and apply expository techniques to shape meaning as they engage with texts. Students also learn to analyze how authors use expository techniques to clarify and organize ideas and apply them in their own writing. Through interpreting and constructing expository texts, students produce clear, purposeful writing that effectively communicates information and ideas. Georgia’s K-12 ELA Standards shift from fixed text types to the flexible use of techniques, emphasizing purpose and audience, with authentic texts often blending narrative, expository, argumentative, and poetic techniques.

K-2.T.T.3
Overview of Standard
In this standard, students learn how to express their thoughts and ideas clearly so others can understand them. They will practice giving reasons for their opinions and learn how to explain what they think in thoughtful ways. Students will also explore how authors use words, examples, and evidence to share their beliefs. Through reading, speaking, and writing, students will build the skills to communicate their ideas, listen to others, and use opinion strategies to make their thinking strong and convincing. Georgia’s K-12 ELA Standards shift from fixed text types to the flexible use of techniques, emphasizing purpose and audience, with authentic texts often blending narrative, expository, argumentative, and poetic techniques.

K-2.T.T.4
Overview of Standard
In this standard, students learn to recognize and apply poetic techniques that shape meaning and deepen their understanding of texts. By exploring sound devices, figurative language, rhythm, structure, and imagery, they discover how poets use language to evoke emotion, create musicality, and express ideas with power and precision. As students analyze these techniques in published poems, they also practice using them in their own writing to enhance expression and style. This process builds interpretive insight and creative fluency, helping students read poetry thoughtfully and write with intention. Georgia’s K-12 ELA Standards shift from fixed text types to the flexible use of techniques, emphasizing purpose and audience, with authentic texts often blending narrative, expository, argumentative, and poetic techniques.

K-2.T.RA.1
Overview of Standard
In this standard, students begin developing the foundational skills of research by generating and asking questions about topics of interest. They learn to gather information from multiple sources, including print, digital, and personal, and to organize that information using simple supports, such as charts and graphic organizers. Students also practice communicating their findings in a variety of modes, building both accuracy and relevance in their work. Through these experiences, they grow as curious learners who use inquiry to expand their knowledge of the world. 

K-2.T.RA.2
Overview of Standard
In this standard, students begin developing the ability to recognize and use sources of information to support their ideas, questions, and opinions. With adult guidance, they explore different types of sources (e.g., print, digital, and personal communications) and practice noticing where information comes from and how it connects to their thinking. As they grow, students move toward independently referring to parts of texts and identifying information and evidence to support their responses and explain their learning. These experiences help them build the foundational skills of evidence use, source awareness, and responsible information gathering, preparing them for deeper research and analysis in later grades. 

-------

K-2.T.C.1
Vocabulary
Purpose
Audience
Modes
Print
Digital
Auditory
Visual 

K-2.T.C.2
Vocabulary
Authors
Speaker
Text mode
Print
Digital
Auditory
Text features
Point of view
First person
Third person 

K-2.T.SS.1
Vocabulary
Text features
Text mode
Coherence
Cohesion
Clarity
Techniques
Sequence
Transition words/phrases
Conjunctions 

K-2.T.SS.2
Vocabulary
Descriptive language
Literal language
Nonliteral language
Engaging texts 

K-2.T.T.1
Vocabulary
Author
Audience
Characters
Setting
Major events
Central message, lesson, or moral
Dialogue
Plot (problem and solution)
Conflict
Narrator
Narrative techniques
Point of view
Purpose 

K-2.T.T.2
Vocabulary
Expository techniques
Expository texts
Main topic
Supporting details
Facts and Definitions
Concluding statement
Author
Audience
Compare and contrast
Cause and effect
Problem and solution 

K-2.T.T.3
Vocabulary
Opinion
Supporting reasons
Linking words
Facts
Evidence
Author
Audience 

K-2.T.T.4
Vocabulary
Author
Audience
Alliteration
Illustration
Imagery
Metaphor
Poem
Poetry
Line
Repetition
Rhyme
Rhythm
Sound
Simile
Title 

K-2.T.RA.1
Vocabulary
Knowledge
Questions
Topics of interest
Research
Sources
Print
Digital
Personal
Relevant information
Accurate information
Related information
Topic
Graphic organizers
Support aids
Modes 

K-2.T.RA.2
Vocabulary
Parts of texts
Topics
Questions
Sources
Information
Ideas
Answers
Opinions
Sources
Print communication
Digital communication
Personal  communication
Connections 

-------

K-2.T.C.1
Instructional Strategies for Teachers
• Establish the purpose for reading a text by presenting the cover of a book to be shared (or a text in any mode). Ask students to predict what the text will be about once they hear or read the title. Then challenge students to go page-by-page, studying the images to predict the general purpose of the text (e.g., to tell a story, provide information, share opinions, or explain).
• During reading, model think-alouds, demonstrating how to make connections from the text to the purpose. Stop and have students think-pair-share about their connections to the purpose of the text.
• After reading, determine a target audience for the text. Facilitate discussions on who the audience of the text could be based on knowledge about the purpose.
• Engage students in group reading activities (e.g., read-alouds, language experience stories, choral reading, Reader’s Theater, guest readers, digital presentations of texts, small group reading, and independent reading) to discuss various purposes (why a text was written) and audiences (for whom a text was written) for a variety of texts.
• Create opportunities for students to explore texts written in different modes (print, digital, auditory, and visual) and make connections to the senses that are used in each (print- sight; digital- senses may vary based on the text; auditory- hearing; and, visual- sight).   

K-2.T.C.2
Instructional Strategies for Teachers
• During read-alouds, explain the roles of the author and the illustrator of a text.
• Prompt students to answer questions about the author and illustrator: What is the job of an illustrator? What does it mean to be an author? Why do you think the illustrator chose to use certain colors in the illustrations? What colors do you see in the illustrations?
• Create anchor charts to show the differences between authors, speakers, and illustrators.
• Model and provide opportunities for students to identify the speaker within a text.
• Provide students with prompts about the text: Who is telling the story? How do they feel? Why do you think the author chose this speaker?
• Use familiar texts to model first-person and third-person point of view. Read one text in first-person and one in third-person point-of-view and create an anchor chart comparing the two.
• Model rewriting a simple story from a different point of view before guiding students to do the same.
• Create visual charts with speech bubbles and icons to help students visualize first-person and third-person narration.
• Use graphic organizers to compare speakers, narrators and author’s purpose between texts.
• Provide sentence frames from the texts to engage students in constructing their own texts.   

K-2.T.SS.1
Instructional Strategies for Teachers
• Activate students’ background knowledge by asking guiding questions prior to reading a text through prompts or using a KWL chart to help students to visually organize ideas.
• Provide students with a variety of nonfiction texts as well as a text feature checklist (with pictures) that includes Table of contents, Headings, Captions, Diagrams, Bold words. Have students hunt for and highlight the features and discuss how the feature helps the reader understand the text.
• Create an anchor chart to guide students to identify parts of a story (beginning, middle, and end).
• T-chart with students where you define text features and provide examples of each.
• Ask students guiding questions about a text’s features and provide opportunities for them to think-pair-share. Sample guiding questions are Why do you think this word is bolded and underlined? How does this picture help us understand the text better? Reference the P.AC.3 Text Design Considerations resource.
• Provide cards with text feature names, visuals, and functions. Have students match or sort into categories such as Helps me find information, Helps me understand the picture, and Helps organize the text.
• Model think-alouds to help students identify organizational patterns while reading a text.
• Create an anchor chart for transition words (first, next, then and last)
• Play an interactive game using pictures or words to help students visually understand the arrangement of events or words in order.
• Provide opportunities for students to act out a routine with their peers (e.g., going to lunch at school).
• Create timelines to help students understand sequence and cause and effect.
• Model writing sentences using transition words.
• Engage students retelling the parts of the text through writing and sharing with a partner for peer review.   

K-2.T.SS.2
Instructional Strategies for Teachers
• Use a mystery bag filled with objects. Have students reach in, feel an object, and describe its texture. Then, pull the object out and describe its other characteristics, such as how it looks, smells, or sounds.
• Create an anchor chart or graphic organizer for sensory words (with pictures) and feeling words (with pictures or symbols) found in texts.
• Model how to describe a favorite object by using sensory details such as how it looks, feels, sounds, smells, or tastes.
• Read a text with rich descriptive language, then have students draw what they imagine based on the text. Follow up with a class discussion about the author’s purpose for using descriptive details.
• Have students create texts using descriptive language, then read them aloud while a partner draws what they visualize based on the description.
• Create a class anchor chart of favorite descriptive language to use as a reference when students are constructing texts.
• Go on scavenger hunts using authentic texts to find and record examples of nonliteral language.
• Engage students in word sorts and charades to explore and differentiate between literal and nonliteral language.
• Use sentence stems and add descriptive details (sensory language, feelings language, literal or nonliteral language)
• Model “trading” nondescriptive language for more descriptive words
• Practice drawing and labeling items in the picture before writing about an event
• Provide prompts (e.g., a favorite gift or special place) that encourage students to write using descriptive language and strong emotions, then have them identify the descriptive words and phrases in their own writing.   

K-2.T.T.1
Instructional Strategies for Teachers
• Use visuals to help students identify the elements of a story (character , setting,  events, etc.).
• Develop a community of readers and writers by providing opportunities for students to engage in a variety of texts (e.g., poems, songs, picture books) in a variety of modes (auditory, print, digital and visual) within small group, whole group and independent settings.
• Explicitly teach story elements and create anchor charts of story elements with visual examples (e.g., What is a narrative story? What is a setting?  What is a character?).
• During focused mini lessons, use mentor texts to describe, analyze, and apply narrative techniques. After modeling, have students identify and annotate the techniques they find.
• Model how to break down texts by examining mentor texts, facilitating discussion about the author’s choices.
• Use puppets or role-playing activities to retell the story.
• Use graphic organizers to identify narrative techniques and how they are used within a text.
• Use plot/problem scenarios to engage students in exploring the problem and identifying a solution.
• Model think-aloud strategies using sentence starters to help students make connections to the text.
• Provide opportunities for students to partner with peers to create or act out skits of dialogue between characters.
• Create anchor charts to compare narrative techniques within and between texts using visual illustrations.
• Provide opportunities for students to share real or imagined experiences that tell or include stories for different purposes and audiences.   

K-2.T.T.2
Instructional Strategies for Teachers
• Explicitly teach what expository texts are as well as the expository techniques found in grade-level expectations and the Text Techniques resource.
• Teach key expository vocabulary (topic, detail, fact, explain, conclude) with picture cards and simple definitions. Reinforce these during lessons with visuals to help retention.
• Create an anchor chart to introduce the “Big Five” questions (who, what, where, when, why). Model answering these questions about familiar topics (favorite color, favorite food) and provide opportunities for students to practice answering questions with their peers.
• Use simple mentor texts to highlight main topic and supporting details.
• Create an anchor chart listing expository techniques (e.g., main topic, facts, definitions, and concluding statements) and refer to the chart during read-alouds.
• Use movement, sorting activities, matching games, etc. to show a sequence of events.
• Use picture cards that represent steps in a process (like planting a seed or making a sandwich). Have students arrange them in order and explain the sequence aloud or in writing, highlighting connections between steps.
• During nonfiction read-alouds, pause to model how to find the main topic and details. Model making connections such as “This event happened because…,” or “This fact helps us understand…”
• Give students a simple nonfiction text and a list of questions to find facts that support the main topic. They can underline or highlight key details, then share findings.
• Guide students to write their own short texts that apply expository techniques using a scaffold and providing sentence starters and word banks for support:
• Introduce a topic sentence (e.g., “Dogs are great pets.”)
• Write 2–3 facts to explain the topic
• End with a closing sentence (“That’s why dogs make good friends.”)
• Provide opportunities for students to engage in oral language practice with their peers to share techniques before writing. For example, “Share with your partner how these two butterflies are alike and different.”
• Provide opportunities for shared writing experiences by co-creating expository texts with students.
• Select an expository structure (sequencing, steps in a process, etc.) and model for students as a shared writing opportunity.
• Use graphic organizers (problem/solution, cause/effect, compare/contrast, sequencing) to guide students in organizing their thoughts and ideas as they engage with texts.   

K-2.T.T.3
Instructional Strategies for Teachers
• Model identifying opinions vs. facts during read-alouds, using sentence stems (e.g., “****is a fact because****,” “ I think_____ because_____.”) as needed.
• Use picture cards (e.g., hamburger vs. hot dog, dog vs. cat) to guide students in sharing their opinion and explaining their choices.
• Create an anchor chart illustrating the difference between fact and opinion.
• Use scenarios that appeal to student emotions.
• Guide students to write their own short texts that apply opinion techniques, providing sentence starters and word banks for support:
• Introduce a topic (e.g., “I’ve played baseball for two years.”)
• State an opinion (e.g., “Baseball is the best sport.”)
• Write 2–3 reasons to support the opinion.
• Use linking words (1st: and, because; 2nd: (e.g., because, and, also))
• End with a conclusion (closing sentence) (2nd): (“That’s why baseball is the best sport.”)
• Conduct whole-class opinion writing pieces where students contribute reasons and the teacher scribes what students share.
• Use graphic organizers (e.g., OREO [Opinion-Reason-Example-Opinion Restated]) to help students plan their writing.
• Engage students in oral rehearsal where they practice stating an opinion and using a linking word in their responses to a partner.
• Highlight then discuss the use of linking words and/or conclusions during the reading of a shared mentor text.
• Model concluding (wrap-up sentences), demonstrating how to restate an opinion at the end, providing sentence stems (e.g., “That is why _________,” “I think ________ is the best.”) for support as needed.   

K-2.T.T.4
Instructional Strategies for Teachers
• Read, sing or listen to a familiar nursery rhyme with students to activate their understanding of sound and rhythm.
• Provide opportunities for students to clap, snap, or tap when they hear sounds and rhyme.
• Create anchor charts to teach poetic techniques and provide visual examples of each.
• Engage students in word play activities by playing games with rhyming words (e.g., “What words rhyme with moon?”).
• Model reading and performing poems with gestures, expression, or echo reading, and allow opportunities for students to practice with their peers.
• Provide students with a short and guide them in identifying poetic techniques with a short poem.
• Use creative play centers for students to engage in various opportunities to identify rhyme (e.g., rhyming cards), alliteration (e.g., using sentences), imagery (e.g., using illustrations) and rhythm (e.g., creating rhythm by rearranging poetry lines).
• Use simple sentence frames (“I am like a ____ because____.”) to engage students in creative writing opportunities.   

K-2.T.RA.1
Instructional Strategies for Teachers
• Record questions asked by students during instruction to generate authentic questions. For older students, designate a “parking lot” area in class for students to post questions.
• Model the steps in the research process and conduct think-alouds to show how to generate a question and then how answering one question might generate another question (or questions).
• Provide “I wonder…” and “How does…” stems to help scaffold student-generated questions.
• Curiosity Walks: Take students on a walk (indoors or outdoors) to notice things and generate research questions.
• Informational Gallery Walk: Use nonfiction picture books and model extracting information from images and captions to arrive at understandings and to generate questions.
• Create a simple anchor chart to record information from different modes and/or genres (e.g., print book, digital article, conversation, presentation). Include student observations of “best uses” for each type.
• Curate sources for students to use in research; the curated sources may be differentiated based on student need and/or topic.
• Use K-W-L charts (Know-Want to Know-Learned) to scaffold question-asking.
• Invite school staff (e.g., principal, nurse, custodian, cafeteria worker) for short Q&As; students prepare and record questions.
• Design flexible grouping to allow students’ opportunity to research shared topics of interest.
• Use simple graphic organizers (e.g., concept webs, T-charts) to organize facts from different sources to help students organize facts from different sources that can then be used as a springboard for constructing texts or presentations about the information.
• After gathering information, have students engage in oral rehearsal by sharing with a partner before presenting to the class.
• Allow students to present their research and explain how they selected the mode of their texts.
• Research Theatre: Have students act out what they learned (e.g., life cycle of a butterfly) to demonstrate their understanding.   

K-2.T.RA.2
Instructional Strategies for Teachers
• When engaging with a text to answer a question, support an idea, or support an opinion, notice where the necessary information is located, and have students notice and note where they find information in a variety of texts.
• Create a simple anchor chart to note examples of information sources as they encounter them (print, digital, and personal).
• Create simple scavenger hunts to support student interaction with various print, digital, and personal communications.
• Depending on grade level, require students to note or describe where they found information to support a question, idea, or opinion.
• Create a “Wonder Wall” where students post questions they have about various topics. As students find answers in different sources, they can add “Evidence Cards” which list the fact, the source, and how the fact answers the question.
• Use guided inquiry circles to allow students to explore a topic using multiple sources with guidance. Pick a common topic (e.g., How do animals survive winter?) and provide 2-3 curated sources (e.g., a nonfiction print book, a student-friendly website or short video, a guest speaker). In small groups, students explore each source and record: What did we learn? Where did we learn it? How does it help us answer our question?
• Use a mini-lesson to teach students how to begin using text-based evidence to support their answers and ideas. After a short read-aloud, ask a question such as Why did the character feel scared? Model finding a quote or sentence in the text that shows the answer, using sentence stems (e.g., “In the story, it says ___ which shows ___” or “On page ___, it says ___, so I think ___.”) Highlight or color-code the evidence during the shared reading or use sticky notes to mark the evidence.   

-------

K-2.T.C.1

Evidence of Student Learning 

<table>
  <thead>
    <tr>
      <th>Teacher Prompt</th>
      <th>Student Response</th>
    </tr>
  </thead>
  <tbody>
    <tr>
      <td>
        Select a text to read aloud or share with students. This could be a printed, digital, visual, or auditory text. <br><br>
        *A nonfiction text is being used in this example. <br><br>
        Before sharing the text, say, Today, we are going to look at a text together. Let’s go on a journey! We’ll start by looking at the front cover and the inside of the book to see if we can find out why the author wrote this text. Are you ready?  <br><br>Model how to scan the text by looking at the title, images, and text features throughout pages within the book. <br><br></td></tr>
    <tr>
        <td>
        Possible <b>before-reading</b> prompts: <br><br>
        - Why do you think the author wrote this book?  <br>
        - What do you notice about the title and pictures?<br>
        - Do you think this book will tell a story or teach us something?
      </td>
      <td>
        Student responses will vary but could include:  <br>
        - I think the author wrote this book to teach us about ladybugs. <br>
        - The title has the word ladybug in it. <br>
        - The pictures show different parts of the ladybug’s body. <br>
        - I think this book will teach us about ladybugs.
      </td>
    </tr>
    <tr>
      <td>
        Begin reading the text aloud, pausing during the reading to address unknown words and to ask clarifying questions. <br><br>
        Possible <b>during-reading </b>prompts: <br><br>
        - Is the author giving us steps, descriptions, or factual details in the text? <br>
        - What does the word ____ mean? What clues can we use to figure it out?  <br>
        - Do you think this book is written for kids or adults? Why?
      </td>
      <td>
        Student responses will vary but could include:  <br>
        - The author is giving facts about ladybugs. <br>
        - I think the word larva means a baby ladybug. The pictures showed how a baby ladybug turns into a big ladybug. <br>
        - I think this book is for kids because there are lots of pictures.
      </td>
    </tr>
    <tr>
      <td>
        Possible <b>after-reading</b> prompts: <br><br>
        - What did you learn that you didn’t know before reading the book? <br><br>
        - Teach your partner three facts that you learned from this text.
      </td>
      <td>
        Student responses will vary but could include:  <br>
        - I learned that ladybugs have spots, and they help eat bugs that hurt plants. I didn’t know that before! <br>
        - I learned three facts about ladybugs from this text. Ladybugs are red with black spots. They eat tiny bugs that hurt plants. They can fly with their hidden wings.
      </td>
    </tr>
  </tbody>
</table>

-----
K-2.T.C.2

Evidence of Student Learning

<table>
  <thead>
    <tr>
      <th>Teacher Prompt</th>
      <th>Student Response</th>
    </tr>
  </thead>
  <tbody>
    <tr>
      <td>
        Provide students with a variety of texts from different genres. Select texts with narrative voices that appeal to the senses, to feelings, and/or to emotions.<br><br> Allow students to explore the front cover, back cover, text title, illustrations, and text features. Choose one of the texts to explore as a class before reading it aloud.<br><br></td></tr>
    <tr><td>
        Say, Remember our lesson on authors and illustrators? We learned that authors are the people who write the book. We also learned that illustrators are the people that create the pictures. Who is the author of this book? Who is the illustrator?
      </td>
      <td>
        Student responses should name the author and illustrator of the current text.
      </td>
    </tr>
    <tr>
      <td>
        Before beginning the read aloud, say, Today we are going to think about who is actually telling a story. A story has both an author (the person who wrote it) and a speaker (the voice telling the story). Sometimes the author and the speaker in the text are the same, but sometimes they are different. While we’re reading this book, I want you to think about who is telling the story.<br><br></td></tr>
    <tr><td>
        Read the story aloud, pausing while reading to ask questions such as:<br>
        - Who do you think is telling the story?<br>
        - Is the speaker someone in the story or outside the story?<br>
        - How does the speaker feel?<br>
        - What is the speaker thinking?
      </td>
      <td>
        Student responses should correctly answer the questions, but could include:<br>
        - I think the rabbit is telling the story.<br>
        - The rabbit is inside the story.<br>
        - The rabbit is feeling sad because the pictures show him sitting all by himself by the pond and his head is down.<br>
        - The rabbit is thinking that it would be nice to have a friend.
      </td>
    </tr>
    <tr>
      <td>
        After reading, have students answer the questions below with a partner.<br>
        - Who was the author? Who was the speaker?<br>
        - Why do you think the author chose to use ___ to tell the story?<br>
        - How did the speaker make you feel?
      </td>
      <td>
        Student responses should correctly answer the questions, but could include:<br>
        - I think the author used the rabbit to tell the story because rabbits are cute and sweet and I wanted her to be happy at the end.<br>
        - The speaker made me feel happy because she ate ice cream and played with friends at the end of the story.
      </td>
    </tr>
    <tr>
      <td>
        *Extension Opportunity: Provide students with opportunities to compare two versions of the same story and identify the differences between the speakers within each text.
      </td>
      <td></td>
    </tr>
  </tbody>
</table>

-----

K-2.T.SS.1

Evidence of Student Learning

<table>
  <thead>
    <tr>
      <th>Teacher Prompt</th>
      <th>Student Response</th>
    </tr>
  </thead>
  <tbody>
    <tr>
      <td>
        Select a text rich in sequencing that uses a clear structure. This could be a text from another content area, such as the text used in this example.  
      </td>
    </tr>
    <tr>
        <td>Show students a nonfiction book and ask, How do we find things quickly in books? What helps us understand pictures or special words?  </td>
      <td>Student responses will vary but could include: 
        <ul>
          <li>We can look at the table of contents or the headings.</li>
          <li>We can look for bold words or use the index.</li>
          <li>Pictures help us see what the story or text is about.</li>
          <li>Special words might be bold or underlined, and they help us know what’s important.</li>
        </ul>
      </td>
    </tr>
    <tr>
      <td>
        Introduce the term text features and show examples such as the table of contents, diagrams, and headings. Create a class anchor chart with the definition of text features as well as examples.  <br><br> Read the nonfiction book aloud or display it digitally. Point out and discuss 2-3 text features. <br>- Table of contents: Let’s find the page about sharks!  <br>- Diagram: This picture shows the body parts of a shark.  <br><br>Say to students, We are going to use this book and go on a Text Feature Hunt! We’ll use our anchor chart to help us find different text features in our book about sharks. When we come to one of the text features in our shark book, say “Stop!” and we can talk about the feature you found.  
      </td></tr>
      <tr>
        <td>Begin reading aloud, pausing when students see a familiar text feature. Provide prompts as needed to ensure several features are identified. Discuss the features as a class and add to the class anchor chart.  </td>
      <td>Student responses may vary but could include:  
        <ul>
          <li>There is a heading on page 4 that says, “What are Sharks?” It starts a new section.</li>
          <li>“Predator” and “gills” are in bold, so those are important words.</li>
        </ul>
      </td>
    </tr>
    <tr>
      <td>
        Give students a copy of a “Text Feature Hunt” organizer with pictures and/or descriptions of common text features. In small groups, have students look through classroom nonfiction books to match features from the organizer. Have a few groups share out what they found on their hunt.
      </td>
      <td>Student responses may vary but could include: 
        <ul>
          <li>We found a diagram about how bees make honey!</li>
          <li>We saw a picture of a mother barn owl with her baby. The caption told us that!</li>
        </ul>
      </td>
    </tr>
    <tr>
      <td>
        If time allows, have groups rotate so students can hunt through a few different books. <br><br>
        </td></tr>
    <tr><td>
        For a summarizer, provide students with the prompt below. <br><br> Pick one text feature you found. Write what it helped you learn. I found a ___. It helped me learn ___.  
      </td>
      <td>Student responses may vary but could include:  
        <ul>
          <li>I found a picture of a colonial kitchen. It helped me learn how people cooked their food using fireplaces instead of stoves.</li>
          <li>I found a chart of old and new transportation. It helped me learn how people used horses and wagons in the past and now use cars and airplanes to travel faster.</li>
        </ul>
      </td>
    </tr>
  </tbody>
</table>

----

K-2.T.SS.2

Evidence of Student Learning

<table>
  <thead>
    <tr>
      <th>Teacher Prompt</th>
      <th>Student Response</th>
    </tr>
  </thead>
  <tbody>
    <tr>
      <td>Say, We have been noticing how authors use descriptive language to paint pictures in our minds and how this language makes stories much more interesting. Today, we are going to write stories of our own!</td>
      <td></td>
    </tr>
    <tr>
      <td>Refer to a previously created anchor chart on ways descriptive language can make stories more interesting.</td>
      <td></td>
    </tr>
    <tr>
      <td>Say, Sometimes we know exactly how to describe something to create a picture in our reader’s mind. But other times, because we already know how it looked, sounded, or felt, we forget that our reader doesn’t — and we need to show them with our words. What could we do if we get stuck or forget to describe and make our story more interesting?</td>
      <td>Student responses may vary but could include:<br> - We could draw it first. <br>- We could act it out in our heads first. <br>- We could use the anchor chart. <br>- We could read it to a friend and ask them to draw what they see</td>
    </tr>
    <tr>
      <td>Say, I can tell you have been working hard and thinking about how authors use descriptive language! Before you start writing, I’m going to show you how you might think about your writing and how to make sure it’s interesting.</td>
      <td></td>
    </tr>
    <tr>
      <td>Model writing a short sentence, then revise it together to make it more interesting.<br><br>- Before: The dog ran.<br>- After: The big, muddy dog raced through the wet grass, barking loudly.</td>
      <td></td>
    </tr>
    <tr>
      <td>Ask, What words helped you see or hear what was happening?</td>
      <td>Student responses may vary but could include:<br>- big, muddy<br>- raced<br>- wet grass, barking loudly</td>
    </tr>
    <tr>
      <td>Say to students, Now that we’ve made that first sentence so interesting, I want to add another interesting sentence about the dog. I have a sentence that I need help with, so I’m going to write it on the board.<br><br>- Before: His ears moved to get the water off.</td>
      <td></td>
    </tr>
    <tr>
      <td>Say, What are some descriptive words I could use to help my audience see, hear, and feel what’s happening in that sentence?</td>
      <td>Student responses may vary but could include:<br>- floppy ears<br>- bounced<br>- shook off<br>- freezing water</td>
    </tr>
    <tr>
      <td>Use student responses to rewrite the original sentence. For example,<br><br>- His floppy ears bounced when he shook off the freezing water.<br><br>Ask, How did the second sentence add more detail and make the story more interesting?</td>
      <td>Student responses may vary but could include:<br>- I could see the dog shaking his head and his big ears moving around!<br>- I don’t like freezing water, so I felt cold like the dog felt.</td>
    </tr>
    <tr>
      <td>Say, Okay, now it’s your turn to practice using descriptive words to make your story interesting. I want you to write a short story about something fun you’ve done. Maybe it was going to a park, maybe it was making cookies, or maybe it was playing in the rain. Think about your fun thing and when you’re ready to write, try to use descriptive words that help the reader see, hear, or feel what’s happening.</td>
      <td></td>
    </tr>
    <tr>
      <td>Encourage students to use at least two descriptive words, to focus on one small moment, and to think about what they saw, heard, felt, or smelled during that fun thing. Provide a word bank of sensory and feeling words for support as needed.</td>
      <td></td>
    </tr>
    <tr>
      <td>As students finish their two-sentence story, have them read their writing to a partner.</td>
      <td></td>
    </tr>
    <tr>
      <td>Say, When your partner is reading their story, see if you can get a picture in your head of what’s happening. After you hear the story, tell your partner what word or words helped you imagine the story.</td>
      <td></td>
    </tr>
    <tr>
      <td>Do a quick group share, asking students, Who would like to share one descriptive sentence they’re proud of?</td>
      <td>Student responses will vary.</td>
    </tr>
    <tr>
      <td>As students share, provide positive feedback, encouraging students to do the same.</td>
      <td></td>
    </tr>
  </tbody>
</table>

--------

K-2.T.T.1

Evidence of Student Learning

<table>
  <thead>
    <tr>
      <th>Teacher Prompt</th>
      <th>Student Response</th>
    </tr>
  </thead>
  <tbody>
    <tr>
      <td>Ask students, What do all good stories have? Think about that for just a minute and we’ll add items to our class anchor chart.<br><br>As students respond, add to anchor chart, including any lesson-specific vocabulary students may not have mentioned (characters, setting, problem, solution, character traits, moral/message). Use visuals as needed.</td>
      <td>
        Student responses may vary but should include:
        <ul>
          <li>characters</li>
          <li>a place where something happens (setting)</li>
          <li>something happens to the characters (problem) but they figure it out (solution)</li>
        </ul>
      </td>
    </tr>
    <tr>
      <td>Say to students, Today, we are going to read a short text and think about the characters, the setting, the problem and solution, and the message that the author has included in the text. As I read, I want you to pay close attention to those things. <br><br> Use clothespins to clip an arrow to the anchor chart, highlighting each of the story/narrative techniques you want students to listen for.  </td>
      <td></td>
    </tr>
    <tr>
      <td>Read aloud a familiar story or fable that has an easily identified moral/message (theme) or use The Squirrel and the Rock.<br><br>Pause during reading to ask guiding questions, such as:<br> - Who are the main characters?<br> - Where does this story take place?<br> - What problem does the main character have?<br> - How is the problem solved?</td>
      <td>
        Student responses:<br>
        - Sammy the Squirrel and Tilly the Turtle<br>
        - A big forest on a sunny morning<br>
        - Sammy tries to jump over a big rock without thinking carefully, and he trips and falls.<br>
        - Tilly tells Sammy to go around the rock.
      </td>
    </tr>
    <tr>
      <td>After reading, ask, How would you describe the squirrel? What did the squirrel do that shows us that? What about the turtle? How would we describe her?</td>
      <td>
        Student responses may vary but could include:<br>
        - Sammy is fast and brave. He tried to jump over a big rock because he thought he could do it.<br>
        - Sammy wasn’t careful. He didn’t look where he was going. He jumped too fast and fell.<br>
        - Tilly is careful and smart. She went around the rock and told Sammy to be careful, too.<br>
        - Tilly is kind. She helped Sammy when he fell and she didn’t laugh at him.
      </td>
    </tr>
    <tr><td>Introduce a few common traits (confident, brave, willing to learn, energetic, careful, patient, helpful). Add student responses to an anchor chart for both the squirrel and the turtle. </td><td></td></tr>
    <tr>
      <td>Ask students, Which character had a problem in the story? What was the problem?</td>
      <td>
        Student response:<br>
        - Sammy had a problem. He tried to jump over a big rock too fast and fell down.
      </td>
    </tr>
    <tr>
      <td>Ask students, How did Sammy solve his problem?</td>
      <td>
        Student response:<br>
        - Sammy listened to Tilly and decided to be more careful next time.
      </td>
    </tr>
    <tr>
      <td>Ask students, Which character seemed to learn something in this story? Was it Sammy or Tilly? What lesson did he or she learn?<br><br>*Guide students to understanding that Sammy was the character who learned something in the story.  </td>
      <td>
        Student responses may vary but could include:<br>
        - Sammy learned something. He learned to be more careful.<br>
        - Sammy learned that listening to others can help solve a problem.
      </td>
    </tr>
    <tr>
      <td>Ask students, What can WE learn from this story?</td>
      <td>
        Student responses may vary but could include:<br>
        - We can learn to be careful.<br>
        - We can learn to listen to good advice.
      </td>
    </tr>
    <tr>
      <td>Say, Tomorrow, you are going to read another story with your partner and answer those same questions together.</td>
      <td></td>
    </tr>
  </tbody>
</table>

------
K-2.T.T.2

Evidence of Student Learning

<table>
  <thead>
    <tr>
      <th>Teacher Prompt</th>
      <th>Student Response</th>
    </tr>
  </thead>
  <tbody>
    <tr>
      <td>Review previously taught expository techniques.</td>
      <td></td>
    </tr>
    <tr>
      <td>Read a short nonfiction text aloud (e.g., about an animal or a simple science topic). Discuss how the text starts by introducing the topic, gives facts and definitions, and ends with a conclusion.</td>
      <td></td>
    </tr>
    <tr>
      <td>Create or show an anchor chart highlighting the three parts:<br><ul><li>Introduction: Introduce the topic clearly.</li><li>Facts and definitions: Explain and give information about the topic.</li><li>Conclusion: Wrap up and summarize the topic.</li></ul></td>
      <td></td>
    </tr>
    <tr>
      <td>Model filling out a graphic organizer for the All About Cats nonfiction text.</td>
      <td></td>
    </tr>
    <tr>
      <td>Choose a new class topic (e.g., “Dogs”) and guide students to brainstorm facts and simple definitions from the All About Dogs text. Have students fill in the graphic organizer together with a partner.</td>
      <td></td>
    </tr>
    <tr>
      <td>Students will select a topic from a prepared list or one they choose. Using the graphic organizer, students will plan their own nonfiction paragraph by using the expository techniques of introduction/main idea, facts and definitions, and conclusion.</td>
      <td></td>
    </tr>
    <tr>
      <td>Before students begin working on their graphic organizer, remind them of these requirements:<br><ul><li>a clear introduction sentence</li><li>2–3 facts or definitions to explain the topic</li><li>a concluding sentence</li></ul></td>
      <td></td>
    </tr>
    <tr>
      <td>While students are working on their graphic organizers, circulate the room, providing feedback and support as needed.</td>
      <td></td>
    </tr>
    <tr>
      <td>As students complete their graphic organizers, pull them together in pairs or small groups for a mini lesson on turning the sentences in their graphic organizers into a paragraph.</td>
      <td></td>
    </tr>
    <tr>
      <td>Invite a few students to share their completed paragraphs. Use student paragraphs to review the expository techniques of introduction/main idea, facts and definitions, and conclusion.</td>
      <td>Student responses may vary but could include:<br>– Penguins are birds that live in cold places. They have black and white feathers. Penguins cannot fly, but they are great swimmers. A baby penguin is called a chick. Penguins waddle when they walk, and they slide on their bellies in the snow. Penguins are amazing animals that are fun to learn about.</td>
    </tr>
  </tbody>
</table>

-----

K-2.T.T.3

Evidence of Student Learning

<table>
  <thead>
    <tr>
      <th>Teacher Prompt</th>
      <th>Student Response</th>
    </tr>
  </thead>
  <tbody>
    <tr>
      <td>Review previously taught opinion techniques.</td>
      <td></td>
    </tr>
    <tr>
      <td>Ask students, What is your favorite snack—cookies or apples? Have students vote with a show of hands.</td>
      <td></td>
    </tr>
    <tr>
      <td>Say, When you share what you like best and tell why, you’re sharing your opinion.</td>
      <td></td>
    </tr>
    <tr>
      <td>Read aloud an opinion-based mentor text, discussing how the character or narrator gives opinions and backs them up with reasons. Highlight examples of linking words such as because and and.</td>
      <td></td>
    </tr>
    <tr>
      <td>Use an anchor chart to model writing a short opinion piece using the OREO method:<br>
      - O—Opinion: I think dogs are the best pet.<br>
      - R—Reason: They are friendly.<br>
      - E—Example/Another Reason: They can play catch.<br>
      - O—Restate: That’s why I like dogs best.</td>
      <td></td>
    </tr>
    <tr>
      <td>As a class, choose a topic (e.g., Should recess be longer? or What is the best ice cream flavor?).<br><br>
      Fill in a shared OREO graphic organizer together.</td>
      <td></td>
    </tr>
    <tr>
      <td>Write a class opinion paragraph using sentence frames:<br>
      - I think ___ is the best because ___ and ___.<br>
      - That is why I like ___.</td>
      <td></td>
    </tr>
    <tr>
      <td>Have students choose from a list of familiar topics or create their own (e.g., favorite food, favorite season, favorite animal) and then complete the OREO graphic organizer to plan their writing.</td>
      <td></td>
    </tr>
    <tr>
      <td>Students will then use their completed graphic organizer to write their own paragraph.</td>
      <td></td>
    </tr>
    <tr>
      <td>Circulate while students write, providing feedback and support as needed.</td>
      <td></td>
    </tr>
    <tr>
      <td>Invite a few students to share their paragraph with the class or in pairs, pointing out where and how they used the opinion techniques of opinion statement, reasons and evidence, and a concluding statement.</td>
      <td>Student responses may vary but could include:<br>
      - I think summer is the best season. I like summer because there is no school and I can play all day. I also like it because the weather is warm and I can go swimming. Summer is fun and exciting. That’s why summer is my favorite season!</td>
    </tr>
  </tbody>
</table>

-----

K-2.T.T.4

Evidence of Student Learning

<table>
  <thead>
    <tr>
      <th>Teacher Prompt</th>
      <th>Student Response</th>
    </tr>
  </thead>
  <tbody>
    <tr>
      <td>Say, Poems are like music. They have sounds that repeat to make them fun to say out loud. Today, we’ll explore two special tools poets use—rhyme and alliteration.</td>
      <td></td>
    </tr>
    <tr>
      <td>Ask students, Can anyone tell me what rhyme and alliteration are?<br><br> Affirm student responses and address any misconceptions. </td>
      <td>
        Student responses will vary but may include:<br>
        - Rhyme means words sound the same!<br>
        - Alliteration is when words start with the same sound!
      </td>
    </tr>
    <tr>
      <td>Ask students, Why do you think an author would write a poem?</td>
      <td>
        Student responses will vary but may include:<br>
        - to be funny<br>
        - to talk about something that happened to them<br>
        - to paint a word picture
      </td>
    </tr>
    <tr>
      <td>
        Display a copy of selected nursery rhyme or poem mentor text on the board or on an anchor chart. Activate any prior knowledge. An example poem is provided below.<br><br>
        Read the nursery rhyme or poem aloud to students.<br><br>
        <em>Soccer for the Win</em><br>
        Speedy soccer ball, soaring so high,<br>
        Sailing and spinning across the blue sky.<br><br>
        Kicking and keeping, we cheer as a team,<br>
        Scoring together—our soccer day dream.
      </td>
      <td></td>
    </tr>
    <tr>
      <td>Ask students, What is this poem about?</td>
      <td>
        Student responses will vary on mentor text selected, but may include:<br>
        - Kids playing soccer.<br>
        - Soccer game
      </td>
    </tr>
    <tr>
      <td>Ask students, Can anyone tell me any rhyming words they heard?<br><br>Label the poem on the board or anchor chart, underlining the identified rhyming words.<br><br> Say, Yes, that’s correct. Rhyming happens when the words sound the same at the end, just like you picked out. </td>
      <td>
        Student responses will vary on mentor text selected, but may include:<br>
        - “high” and “sky”<br>
        - “team” and “dream”
      </td>
    </tr>
    <tr>
      <td>Ask students, How about alliteration? Did anyone see examples of alliteration?<br><br>Label the poem on the board or anchor chart, circling the identified alliteration. <br><br>Say, Yes, that’s correct. Alliteration is when the words share the same beginning sound, just like you picked out. </td>
      <td>
        Student responses will vary on mentor text selected, but may include:<br>
        - “speedy,” “soccer,” “soaring,” “sailing, “spinning”<br>
        - “kicking,” “keeping”<br>
        - “day,” “dream”
      </td>
    </tr>
    <tr>
      <td>Ask students, Why do you think an author would use rhymes or alliteration?<br><br>Label the poem on the board or anchor chart, circling the identified alliteration. <br><br>Say, Yes, that’s correct. Alliteration is when the words share the same beginning sound, just like you picked out. </td>
      <td>
        Student responses will vary but may include:<br>
        - to make it more fun to say<br>
        - to help you remember it more
      </td>
    </tr>
    <tr>
      <td>Say, Now, I want you to practice what we just did together. Provide students with a copy of the handout below and partner students together. Leave the annotated mentor text posted on the board. 
        </td>
      <td></td>
    </tr>
    <tr>
      <td>
        Circulate and facilitate students working through the first three steps of reading the poem, underlining the rhyming words, and circling examples of alliteration. 
      </td>
      <td>Student responses should include:  <br>- Rhyme: slow/go; shy/sky <br>- Alliteration: slimy, snail, sliding, slow, silvery, softly, silently, small, shy, snoozing, starry, sky</td>
    </tr>
    <tr>
      <td>Say, Now, for the last step, I want everyone to write your own two-line poem and try to use rhyme and alliteration. <br><br>Encourage students to share their short poems aloud.</td>
      <td>
        Student responses will vary but may include:<br>
        - Bouncy bunnies bake a pie,<br>
        They giggle and giggle as the birds fly by.
      </td>
    </tr>
    <tr>
      <td>Ask students, How do rhyme and alliteration make a poem fun to write—and to read aloud?</td>
      <td>
        Student responses will vary but may include:<br>
        - It’s fun to think about how the words will go together.<br>
        - Rhyming is fun to say.
      </td>
    </tr>
  </tbody>
</table>

-----

K-2.T.RA.1

Evidence of Student Learning

<table>
  <thead>
    <tr>
      <th>Teacher Prompt</th>
      <th>Student Response</th>
    </tr>
  </thead>
  <tbody>
    <tr>
      <td>Select a nonfiction text previously read as a launchpad for this standard; an example is provided below based on a nonfiction text about bears and hibernation.<br><br>Say, In our readings recently, we have been recording questions we have about different topics. We have also been thinking about different ways authors share information (refer to multimodal text anchor chart). Today we are going to explore one of our questions through some of the different ways authors communicate information.</td>
      <td></td>
    </tr>
    <tr>
      <td>Prompt students, Last week we read a story about a bear who ate and ate and ate and then went to take a long nap we call...who remembers?</td>
      <td>Hibernation!</td>
    </tr>
    <tr>
      <td>Say, Yes, hibernation!<br><br></td>
    </tr>
    <tr>
      <td>Ask students, What do bears do when they hibernate?</td>
      <td>Student responses will vary but may include:<br>- The bear takes a nap.<br>- They curl up in their den.</td>
    </tr>
    <tr>
      <td>Say, Yes, the bears sleep very deeply. Their hearts beat more slowly, and they breathe more slowly.<br><br>Say, I’d like to learn more about hibernation, but I’m not sure which questions I need to ask.</td>
      <td></td>
    </tr>
    <tr>
      <td><br><br>Ask students, Think back to our book. What questions do you have about hibernation?<br><br>Record students’ questions on a shared anchor chart.<br><br></td>
      <td>Student responses will vary based on the text used but may include:<br>- What do bears do when they wake up?<br>- When do bears wake up?<br>- How do they survive while not eating when they are hibernating?</td>
    </tr>
    <tr><td>Say, These are all great questions! Today, we’re going to research together and find answers.</td><td></td></tr>
    <tr>
      <td>Ask students, Where might we find information to answer our questions?</td>
      <td>Student responses may vary but include: the Internet, the media center, from some of our books, videos, etc.</td>
    </tr>
    <tr>
      <td>Say, These are all excellent ideas. We can learn more about the answers to our questions using different resources.<br><br>Project an image that shows a bear coming out of hibernation.<br><br></td><td></td></tr>
      <tr><td>Say, Take a quiet moment to look at this picture. Think about the bear’s appearance. Notice the environment around the bear to determine when this picture might have been taken. Think about what we can learn from this picture.<br><br>Record student observations on the anchor chart with the questions; students could also use graphic organizers to capture their own thoughts.</td>
      <td>Student responses may vary but include:<br>- The bear looks skinny; he may be hungry and will seek food as soon as possible.<br>- The bear looks kind of sleepy still.<br>- The ground is showing some green but may not look like full spring or summer yet.</td>
    </tr>
    <tr>
      <td>Ask students, How do our observations from this image help to answer our question about __________________?</td>
      <td>Student responses will vary based on the questions asked and the image presented.</td>
    </tr>
    <tr>
      <td>Showcase additional sources from a range of modalities (e.g., a time lapse video of bears hibernating, an article with pictures, a poster warning any hikers of hibernating bears).<br><br></td></tr>
      <tr><td>
      Facilitate students’ observations and connect them back to students’ questions about the topic. Record student observations and answers to questions on the anchor chart.</td>
      <td>Based on the text the teacher shows, students’ responses may vary but could include<br>- Bears could be dangerous to humans when they wake up because they’re hungry.<br>- Hunger may wake up a bear from hibernation.</td>
    </tr>
    <tr>
      <td>Today we conducted research using different texts to answer our questions (repeats questions). Tell your neighbor one type of text we used to answer our questions. Think for a quiet moment, which text did you think gave the most information? Was one type of text more interesting to you than another? Did one text tell us everything we needed to know?</td>
      <td>Students will name the different texts they reviewed. Responses may vary but could include evaluative types of responses. Some may have enjoyed one type of text over another or thought that one was more informative. Many may conclude that they learned from each kind of text because of how it was presented.</td>
    </tr>
  </tbody>
</table>

-----

K-2.T.RA.2

Evidence of Student Learning

<table>
  <thead>
    <tr>
      <th>Teacher Prompt</th>
      <th>Student Response</th>
    </tr>
  </thead>
  <tbody>
    <tr>
      <td>Ask students, Have you ever told someone a cool fact, and they asked you, “How do you know that?”<br><br>
    Say, Today, we’re going to learn how to find information in different sources and how to tell others where we learned it. That’s called being a responsible information user!  <br><br>To help students become familiar with various sources of information, introduce three kinds of sources with real examples: <br>- Print (hold up a nonfiction book) <br>- Digital (show a brief video or website screenshot) <br>- Personal (share a short “interview” or message from an expert) <br><br>
    Use an anchor chart to track: - What each source is (book, website, poster, interview) <br>- What we learned from it <br>- How we can tell others where we got the info <br><br>
    Model answering a research question such as “How do birds build nests?” 
    <br><br>
    Say, I want to learn some neat facts about birds, so I need to come up with a question to answer. I really want to learn how they build nests, so I’ll turn that into a question.  <br><br>Read aloud as you write the sentence on the board: How do birds build nests? 
    </td>
      </tr>
    <tr>
        <td>Ask one student to repeat the question for you to answer. </td>
      <td>One student will ask, How do birds build nests?  
      </td>
    </tr>
    <tr>
      <td>Answer student by saying, I read a book about birds. Birds use twigs and grass to build nests. The book showed pictures and explained the steps.  <br><br>Say, That’s how I can answer a friend if they ask me a question, or if they ask me where I found my answer. <br><br> Say, Now you’ll do the same thing in your   group. I’m going to give each group one source (a different short passage, a short video, or a prepared script from an “expert”). In your group, you will read or watch your source and answer a research question. When you are able to answer your research question, write down what you learned, what type of source you used, and how you know the information is true.  <br><br>Give each group a source and a research question (RQ) that can be answered from that source. For example: How do plants grow? Circulate while students access their source and record their responses, providing feedback and support as needed. <br><br>Ask a few groups to share and discuss their responses as a whole class.  </td>
        <td></td>
    </tr>
    <tr>
      <td>Review the lesson by asking, What’s one thing you learned today, and how do you know it’s true?  Allow students to turn-and-talk to share their responses. </td>
      <td>Student responses may vary but could include:  <br>- We learned that plants grow by starting as seeds. They need water, sunlight, and soil to grow. <br>- We used a video to get our answer. <br>- The video showed a plant growing step by step. The speaker explained what each part does. </td>
    </tr>
  </tbody>
</table>

       
######3-5


3-5.F.P.4
Overview of Standard
In this standard, students continue to use their acquired knowledge of phonics, including the sounds of spoken language (phonemes) and the letters of written language (graphemes) to read and write (decode and encode). Students in grades 3-5 will decode and encode single and multisyllabic words of all syllable types. They will also work with common prefixes and suffixes to decode and encode words.

3-5.F.F.1
Overview of Standard
In this standard, students learn to read with fluency to ensure that they comprehend grade-level texts. When students can read grade level texts with fluency, it safeguards their access to comprehension, as they can focus their full efforts on understanding the text. The ability to read aloud with appropriate prosody is another way to ensure that students can comprehend text without interference. This standard also indicates that third  graders are beginning to self-correct.

3-5.F.H.3
Overview of Standard
In this standard, students learn to read texts written in cursive. Third grade students are expected to begin reading phrases and sentences. In fourth grade, they move into reading short text written in cursive. Fifth graders are then expected to be able to read a variety of texts written in cursive.

3-5.F.H.4
Overview of Standard
In this standard, students learn to write letters, words, and sentences in legible cursive. In third grade, students are expected to correctly form letters and connectors as they add adequate spacing between words. In fourth grade, this expectation extends to words with accurate spacing in sentences across lines. By fifthh grade, this foundational skill is utilized to craft texts efficiently in cursive

3-5.L.GC.1
Overview of Standard
In this standard, students continue to develop their grammar, usage, and mechanics skills. These skills provide students with a firm foundation in Standard English for the purposes of speaking and writing. The grade-level expectations below represent skills that should be mastered in third, fourth, and fifth grade respectively. See the K-12 Grammar, Usage, & Mechanics (GUM) Chart for information regarding specific grade levels for introducing, continuing, and mastering these skills.

3-5.L.GC.2
Overview of Standard
In this standard, students deepen their understanding of how sentences are constructed to continue developing their syntactic awareness. Understanding varying sentence structures helps students interpret and construct texts. Students analyze model sentences as a basis for composing their own sentences and to aid in comprehending increasingly complex texts.

3-5.L.V.1
Overview of Standard
In this standard, students will acquire and use vocabulary with accuracy and precision. They will expand their vocabulary by studying words in context rather than in isolation. Students will explore a wide range of common words used across multiple subjects and in everyday language; words frequently used in academic contexts across various disciplines; and subject-specific terms essential for understanding particular fields or topics. Students deepen their understanding and ability to use words effectively across a range of contexts.

3-5.L.V.2
Overview of Standard
In this standard, students will acquire and apply word analysis skills effectively. This involves understanding the meaning of words and using language with precision across various contexts. The standard emphasizes enhancing students’ vocabulary, comprehension, and communication skills.

3-5.L.V.3
Overview of Standard
In this standard, students will expand their vocabulary by understanding the relationships between words and phrases. Students will make meaningful connections between words to improve reading comprehension. Students will continue to use morphology and context clues to determine or clarify meanings of words. Students will apply vocabulary knowledge in diverse settings and for different purposes, such as academic discussions, writing assignments, and everyday conversations.

------------------------------

3-5.F.P.4

Vocabulary

Decode
Encode
Grapheme
Syllable

Multi-syllabic
Prefixes
Suffixes

---

3-5.F.F.1

Vocabulary

Fluency
Intonation
Irregularly spelled words
Regularly spelled words
Frequency

Automaticity
Oral reading fluency
Prosody

---

3-5.F.H.3

Vocabulary

Cursive 
Connectors

---

3-5.F.H.4

Vocabulary

Cursive
Connectors
Fine motor skills

---

3-5.L.GC.1

Vocabulary

Apostrophe
Contraction
Noun
    Irregular
    Plural
    Singular Possessive
    Collective
    Abstract
    Plural Possessive
Verbs
    Past Tense
    Irregular
    Helping
    Linking
Conjunctions
    Coordinating
    Subordinating
Clauses
Pronoun
    Reflexive
    Antecedent Agreement
    Relative
    Indefinite
    Intensive
Independent Clause
Hyphens
Line Breaks
Prepositional Phrase
Adjectives
    Comparative
    Superlative
    Proper
Adverb
    Comparative
    Superlative
    Relative
Capitalization
Quotation Mark
Commas
Dialogue
Interjections
Frequently Confused Words
Abbreviations
Formal Titles
Direct Address
Italics
Titles of Works

---

3-5.L.GC.2

Vocabulary

Sentence Structure Patterns (simple, compound, complex, compound-complex)
Subject-Verb Agreement
Verb Tense
Adjectives
Adverbs

---

3-5.L.V.1

Vocabulary

General Vocabulary
Academic Vocabulary
Specialized Vocabulary

---

3-5.L.V.2

Vocabulary

Affix
Base word
Prefix
Suffix
Morpheme
Morphology

---

3-5.L.V.3

Vocabulary

Context Clues
Homophones
Homographs
Synonyms
Antonyms
Shades of Meaning

---------------------------------------------

3-5.F.P.4

Instructional Strategies for Teachers
• Teach strategies for identifying multi-syllabic words (e.g., break down words into smaller units, look for syllables, affixes, or phonograms).
• Engage students in making word activities focused on phonograms, syllable patterns, morphemes, advanced phonemic awareness (deletion, substitution, reversal of phonemes), and derivation morphology (Latin roots, prefixes, suffixes).
• Provide opportunities for students to practice using syllabication.
• After introducing phonics skills, include practice with decodable texts with high proportion of words that have been taught.
• Include interactive word walls or posters with syllable types, etc., to help students apply decoding and encoding strategies.
• Provide differentiated, small group instruction in phonics and word analysis using grade-level texts.
• Utilize word sorts to teach students to make and read words by adding prefixes and suffixes to known bases words.
• Include activities for advanced word study.
• Have students keep a journal for morphology (roots and affixes).
• Explicit, direct teaching of new phoneme-grapheme correspondence or letter patterns in texts.
• Teacher-led practice blending words, reading pattern-based words, phrases, and sentences.
• Transfer to text activities (read-alouds, reading activities).
• Phoneme-grapheme mapping to help students understand the relationship between sounds and their corresponding spellings.
• Multisensory activities (build words with magnetic tiles, letter cards, acting out word meanings, etc.).
• Utilize verbal and gestural cues, word marking, and dictation.

---

3-5.F.F.1

Instructional Strategies for Teachers
• Model fluent reading for students. Think aloud and engage in discussion with students about rate versus prosody.
• Focus on fluency building at word, phrase, and text levels.
• Provide opportunities for students to read aloud grade-level text with purpose and understanding (choral, echo, partner reading, and auto-assisted reading).*
• Provide opportunities for repeated reading practice.
• Provide instruction in how to parse or chunk sentences to help students understand juncture/pause.
• Engage students in various fluency building activities (repeated reading, paired reading, performance reading, recorded reading, reading buddies (with a lower or higher grade) and choral reading).
• Teach and model monitoring and self-correction strategies.
• Help students set goals related to accuracy.
• Progress monitor oral reading fluency, student goals, and growth.

---

3-5.F.H.3

Instructional Strategies for Teachers
• Pair students to read common words or phrases to each other in cursive (days of the week, months, names, directions, etc.).
• Provide opportunities for students to read cursive in varied fonts.
• Encourage students to discuss any difficult letters or words.
• Provide varied reading experiences and increase exposure (poems, primary documents, etc.).
• Provide opportunities for repeated practice.
• Provide immediate feedback and support.

---

3-5.F.H.4

Instructional Strategies for Teachers
• Directly and explicitly model the formation of each cursive letter and proper spacing.
• Teach cursive letters in groups based on similar strokes (e.g., "a," "c," "d," "g" for looped letters) to build muscle memory and confidence.
• Progress from lowercase to uppercase letters once students demonstrate proficiency.
• Use auditory cues (e.g., saying “up, over, down”) to help students internalize the movement patterns.
• Create cursive writing norms (such as paper placement, body posture, grip, etc.).
• Encourage students to use cursive writing in real-life contexts, such as writing letters, journal entries, or creative stories.
• Utilize guided practice and positive reinforcement to build confidence.

---

3-5.L.GC.1

Instructional Strategies for Teachers
• Use mentor sentence protocols to provide students with examples of well-constructed sentences and effective grammar, usage, and mechanics examples in authentic texts.
• Analyze excerpts from text(s) to identify and discuss the use of varied sentence structures and grammatical conventions.
• Model sentence expansion activities (adding adjectives, adverbs, and dependent clauses).
• Focus on specific grammar, usage, and mechanics rules in short, targeted lessons while keeping instruction in context of what students are learning.
• Use multimodal texts for teaching grammar, usage, and mechanics.
• Utilize activities that focus on oral and interactive games.
• Provide examples and non-examples.
• Have students purposefully add new skills to their writing and hold them accountable for previously introduced skills.
• Utilize anchor charts for students to reference while also allowing students to create their own mini anchor charts.

---

3-5.L.GC.2

Instructional Strategies for Teachers
• Provide students with hands-on, multisensory activities that work on awareness of sentence completeness and sentence structure.
• Provide students opportunities to manipulate sets of word cards and/or phrase cards to build syntactic awareness.
• Model sentence-level work by answering the questions who, what, where, when, and how.
• Use mentor sentences to provide students with examples of well-constructed sentences and effective grammar usage in authentic texts.
• Analyze excerpts from text(s) to identify and discuss the use of varied sentence structures and grammatical conventions.
• Model sentence expansion activities (adding adjectives, adverbs, and dependent clauses).
• Teach students how to differentiate between phrases and clauses.
• Combine oral language modeling and input with written language.
• Include examples and non-examples during explicit instruction (for example, Robin ate the banana pudding. vs. The banana pudding ate Robin.)
• Focus on specific grammar rules or sentence structures in short, targeted lessons.

---

3-5.L.V.1

Instructional Strategies for Teachers
• Encourage students to maintain personal vocabulary journals where they record new words, their meanings, and examples of usage.
• Organize vocabulary around themes or subjects to help students make connections across different contexts.
• Regularly read texts aloud, modeling the use and pronunciation of new vocabulary.
• Facilitate group discussions where students share insights about vocabulary and its use in texts.
• Design projects that require vocabulary usage across subjects.
• Use authentic texts where new vocabulary appears naturally.
• Incorporate movement to interpret the meaning of vocabulary words.
• Use visual images of vocabulary words to provide an additional way for students to access and understand the material.

---

3-5.L.V.2

Instructional Strategies for Teachers
• Teach students to break down words into roots, prefixes, and suffixes to understand word meanings.
• Develop students’ categorization and analytical skills through word work activities.
• Provide students with opportunities to practice using prefixes and suffixes to construct new words.
• Teach students to use context to infer word meanings in addition to word analysis skills.
• Enhance phonemic awareness skills.
• Encourage independent word analysis of previously-taught strategies.
• Reinforce vocabulary and spelling.
• Visualize and reinforce word relationships by using strategies such as word maps, Venn diagrams, interactive word walls, and picture-based activities.
• Use tools such as graphic organizers to explore definitions, characteristics, examples, and non-examples.

---

3-5.L.V.3

Instructional Strategies for Teachers
• Teach students word relationship strategies such as cause/effect, part/whole, and item/category.
• Help students build an understanding of words with similar and opposite meanings to enhance comprehension and expression.
• Encourage students to work in groups to explore word meanings and relationships through discussions and collaborative projects.
• Create visual maps of word relationships to support understanding and retention.
• Use digital tools to create stories that incorporate new vocabulary and support precise word choices.
• Use online resources and apps for quick and efficient vocabulary assistance.
• Provide students with opportunities to explore reference materials (e.g., dictionaries and thesauruses).

-----------------------------------------------------------
3-5.F.P.4

Evidence of Student Learning

<table>
  <thead>
    <tr>
      <th>Teacher Prompt</th>
      <th>Student Response</th>
    </tr>
  </thead>
  <tbody>
    <tr>
      <td>Say a grade level multi-syllabic word (election).</td>
      <td>Students repeat the word election.</td>
    </tr>
    <tr>
      <td>Ask students, What is the base word in the word election?</td>
      <td>Students say elect.</td>
    </tr>
    <tr>
      <td>Model writing the graphemes for the word elect using a mapping template (boxes) and verbally stretching out the phonemes.</td>
      <td>Students observe during an I do exercise or participate during a we do exercise.</td>
    </tr>
    <tr>
      <td>elect</td>
      <td></td>
    </tr>
    <tr>
      <td>Ask students, What is the suffix in the word election?</td>
      <td>Students say ion</td>
    </tr>
    <tr>
      <td>Ask students, How does the /t/ in elect change when we add the suffix -ion?</td>
      <td>Students say it changes to /sh/</td>
    </tr>
    <tr>
      <td>Model stretching out the phonemes in the third syllable /sh/ // /n/ and writing the graphemes on the board using the mapping template (boxes).</td>
      <td>Students can observe during an I do exercise or participate during a we do exercise.</td>
    </tr>
    <tr>
      <td>*Grammar connection – The verb elect changes to a noun (election) when you add the suffix -ion.</td>
      <td></td>
    </tr>
  </tbody>
</table>


3-5.F.F.1

Evidence of Student Learning

<table>
  <thead>
    <tr>
      <th>Teacher Prompt</th>
      <th>Student Response</th>
    </tr>
  </thead>
  <tbody>
    <tr>
      <td>Listen to me read this portion of the text with correct _________ (phrasing, expression, juncture/pause, intonation). Now you try it.</td>
      <td></td>
    </tr>
    <tr>
      <td>Read this portion of the text based on your goals for _________ (accuracy, automaticity, expression).</td>
      <td></td>
    </tr>
    <tr>
      <td>Read this new text with an eye on self-correcting.</td>
      <td></td>
    </tr>
  </tbody>
</table>



3-5.F.H.3

Evidence of Student Learning

<table>
  <thead>
    <tr>
      <th>Teacher Prompt</th>
      <th>Student Response</th>
    </tr>
  </thead>
  <tbody>
    <tr>
      <td>Say to students, Look at this cursive letter. Show students the cursive letter r. Ask students, Can you identify its print counterpart?</td>
      <td>That is the letter r.</td>
    </tr>
    <tr>
      <td>Ask students, Can you find the word “Saturday” in the text?</td>
      <td>Student highlights the word Saturday in the text.</td>
    </tr>
    <tr>
      <td>Show students the clause practice makes perfect. Ask students, Can you read aloud this clause?</td>
      <td>practice makes perfect</td>
    </tr>
    <tr>
      <td>Say to students, Underline the nouns in this cursive sentence: The dog ran to the park to play. What did you find?</td>
      <td>The student underlines the words dog and park.</td>
    </tr>
  </tbody>
</table>




3-5.F.H.4

Evidence of Student Learning

<table>
  <thead>
    <tr>
      <th>Teacher Prompt</th>
      <th>Student Response</th>
    </tr>
  </thead>
  <tbody>
    <tr>
      <td>Begin by modeling the formation of a cursive letter such as r on the board or under the document camera. Verbalize each stroke and its direction, helping students understand the process. Use the I do, We do, You do approach for guided practice.</td>
      <td>Students participate in guided practice to form the letter r.</td>
    </tr>
    <tr>
      <td>The teacher models how to connect cursive letters in a familiar word or name.</td>
      <td>Students practice connecting the cursive letters in their name.</td>
    </tr>
    <tr>
      <td>The teacher models how to correctly write a sentence in cursive with appropriate spacing.</td>
      <td>Students practice sentences in cursive with appropriate spacing.</td>
    </tr>
  </tbody>
</table>



3-5.L.GC.1

Evidence of Student Learning

<table>
  <thead>
    <tr>
      <th>Teacher Prompt</th>
      <th>Student Response</th>
    </tr>
  </thead>
  <tbody>
    <tr>
      <td>Discuss the definition of a collective noun and an abstract noun.</td>
      <td></td>
    </tr>
    <tr>
      <td>Ask students, What is a noun?</td>
      <td>A person, place, thing, or idea.</td>
    </tr>
    <tr>
      <td>Introduce the term collective noun. Tell students, A collective noun refers to a group of people, animals, or things like a “committee of people” or “herd of cattle.”</td>
      <td></td>
    </tr>
    <tr>
      <td>Introduce the term abstract noun. Tell students, An abstract noun represents an idea, feeling, or quality that cannot be physically touched like “love” or “happiness.”</td>
      <td></td>
    </tr>
    <tr>
      <td>Show students a list of nouns and have students categorize them as collective or abstract. team, courage, pride, swarm, honesty, family, peace, crowd</td>
      <td>Collective nouns- team, pride, family, crowd<br>Abstract nouns- courage, pride, honesty, peace</td>
    </tr>
    <tr>
      <td>Discuss how pride can refer to a group of lions or a human emotion.</td>
      <td></td>
    </tr>
    <tr>
      <td>Using previously selected mentor text(s), highlight the use of collective and abstract nouns.</td>
      <td></td>
    </tr>
    <tr>
      <td>Have students choose one collective noun and one abstract noun to use in a sentence or add to a piece of writing.</td>
      <td>Examples will vary.<br>The crowd of people began to grow.<br>It is important to understand the importance of honesty.<br>The team displayed courage as they faced their opponent.</td>
    </tr>
  </tbody>
</table>




3-5.L.GC.2

Evidence of Student Learning

<table>
  <thead>
    <tr>
      <th>Teacher Prompt</th>
      <th>Student Response</th>
    </tr>
  </thead>
  <tbody>
    <tr>
      <td>Create sets of word cards based on short, simple sentences from current content/texts, gradually building towards longer, expanded sentences.</td>
      <td></td>
    </tr>
    <tr>
      <td>Review the concept of a complete sentence.</td>
      <td></td>
    </tr>
    <tr>
      <td>Display word cards, out of order, for the sentence, The fox ran up the hill.</td>
      <td>The fox ran up the hill.</td>
    </tr>
    <tr>
      <td>Ask the following questions and allow students time to respond. • Who or what is doing something? • What did ___ do? • Where?</td>
      <td></td>
    </tr>
    <tr>
      <td>Ask students, How can the words in the sentence be rearranged to make sense?</td>
      <td></td>
    </tr>
    <tr>
      <td>Ask students, How can this simple sentence be changed into a compound sentence?</td>
      <td>By joining two dependent clauses and adding a comma and a conjunction to separate them.</td>
    </tr>
    <tr>
      <td>Guide students in changing the simple sentence into a compound sentence.</td>
      <td>The fox ran up the hill, so he could catch the rabbit.</td>
    </tr>
    <tr>
      <td>Ask students, How we can add more detail to this sentence to better explain what is happening and engage the reader.</td>
      <td>By adding adjectives and adverbs.</td>
    </tr>
    <tr>
      <td>Guide students in adding adjectives and/or adverbs to convey precise meaning.</td>
      <td>The sly fox quickly ran up the hill, so he could catch the unobservant rabbit.</td>
    </tr>
    <tr>
      <td>Ask students how the updated sentence is different from the original sentence.</td>
      <td>The new sentence gives more detail about the fox and rabbit. It helps the reader better understand what the writer is trying to describe.</td>
    </tr>
  </tbody>
</table>




3-5.L.V.1

Evidence of Student Learning

<table>
  <thead>
    <tr>
      <th>Teacher Prompt</th>
      <th>Student Response</th>
    </tr>
  </thead>
  <tbody>
    <tr>
      <td>Select 3-5 words from a selection of text students will be interpreting. A sample list is shown below. • raggedy • lap • alley • except</td>
      <td></td>
    </tr>
    <tr>
      <td>Choose one word to introduce first and write it on the board. Say to students, This word is raggedy. What’s the word?</td>
      <td>Raggedy</td>
    </tr>
    <tr>
      <td>Say to students, Watch me write the word raggedy on the board. Rewrite the word on the board.</td>
      <td></td>
    </tr>
    <tr>
      <td>Say to students, Now, you write the word on your paper.</td>
      <td>Students will write the word raggedy on their paper.</td>
    </tr>
    <tr>
      <td>Say to students, Now I will read the word. (Point to word on board) This word is raggedy. Now, you read the word when I point to it. (Point to word on board) What’s this word?</td>
      <td>Raggedy</td>
    </tr>
    <tr>
      <td>Tell students, The word raggedy means messy, torn, and looking a little dirty. What word means messy, torn, and looking a little dirty?</td>
      <td>Messy, torn, and looking a little dirty</td>
    </tr>
    <tr>
      <td>Write this sentence on the board: You can’t run a marathon in raggedy shoes. After writing the sentence, read the sentence aloud.</td>
      <td></td>
    </tr>
    <tr>
      <td>Point to the word raggedy in the sentence. Say to students: This word is raggedy. What’s the word?</td>
      <td>Raggedy</td>
    </tr>
    <tr>
      <td>Ask students, What does the word raggedy mean?</td>
      <td>Messy, torn, and looking a little dirty</td>
    </tr>
    <tr>
      <td>Say to students, So, in this sentence, I’m being told that I can’t run a marathon in raggedy shoes. Why can’t I run a marathon in raggedy shoes?</td>
      <td>You can’t run a marathon in messy, torn, and dirty shoes.</td>
    </tr>
    <tr>
      <td>Say to students, Here are some non-examples of raggedy. Write the words clean and tidy on the board.</td>
      <td></td>
    </tr>
    <tr>
      <td>Ask students, Why are clean and tidy non-examples of raggedy?</td>
      <td>They are opposites of raggedy.</td>
    </tr>
    <tr>
      <td>Ask students if the word is a noun.</td>
      <td>No</td>
    </tr>
    <tr>
      <td>Ask students if the word is an adjective.</td>
      <td>Yes</td>
    </tr>
    <tr>
      <td>After reading the text, have students explain, in writing, what surprised them in the story by using one of the new vocabulary words.</td>
      <td></td>
    </tr>
  </tbody>
</table>




3-5.L.V.2

Evidence of Student Learning

<table>
  <thead>
    <tr>
      <th>Teacher Prompt</th>
      <th>Student Response</th>
    </tr>
  </thead>
  <tbody>
    <tr>
      <td>Write the base word cover on the board. Say to students, This word is cover. What’s the word?</td>
      <td>Cover</td>
    </tr>
    <tr>
      <td>Say to students, The word cover means to hide from view. What does the word cover mean?</td>
      <td>To hide from view</td>
    </tr>
    <tr>
      <td>Write the sentence I cover my mouth when I cough on the board. Read the sentence aloud.</td>
      <td></td>
    </tr>
    <tr>
      <td>Ask students, What do I do to my mouth when I cough?</td>
      <td>You cover it.</td>
    </tr>
    <tr>
      <td>Say to students, Yes, I cover my mouth when I cough. It’s what I do, so that means cover is a verb in this sentence.</td>
      <td></td>
    </tr>
    <tr>
      <td>Discuss how this meaning of the word cover is a verb, not a noun.</td>
      <td></td>
    </tr>
    <tr>
      <td>Have students turn and talk to use the word cover in a sentence.</td>
      <td></td>
    </tr>
    <tr>
      <td>Recall the previously taught prefix dis-. Remind students that dis- can mean not or opposite of. Ask students to change the base word cover by adding the prefix dis-.</td>
      <td>Add dis- to make discover</td>
    </tr>
    <tr>
      <td>Ask students, What new word do we have?</td>
      <td>Discover</td>
    </tr>
    <tr>
      <td>Ask students how the meaning of the word cover changes when we add the prefix dis-, prompting as needed.</td>
      <td>The meaning of the word cover changes from “to hide from view” to “to find something” when you add the prefix dis- to make the word discover.</td>
    </tr>
    <tr>
      <td>Ask students to change the word discover by adding the suffix –ed.</td>
      <td>Add –ed to make discovered</td>
    </tr>
    <tr>
      <td>Ask students, What new word do we have?</td>
      <td>Discovered</td>
    </tr>
    <tr>
      <td>Ask students how the meaning of the word discover changes by adding the suffix –ed.</td>
      <td>The meaning of the word discover changes to past tense when you add the suffix –ed.</td>
    </tr>
  </tbody>
</table>




3-5.L.V.3

Evidence of Student Learning

<table>
  <thead>
    <tr>
      <th>Teacher Prompt</th>
      <th>Student Response</th>
    </tr>
  </thead>
  <tbody>
    <tr>
      <td>Discuss the concept of synonyms and shades of meaning, providing examples.</td>
      <td></td>
    </tr>
    <tr>
      <td>Say to students, Let’s read this sentence together. It is warm outside today. Ask students, How does the meaning change if I change the word warm to hot?</td>
      <td>It is more specific. It explains exactly how it feels outside. You are going to sweat if you are out there too long.</td>
    </tr>
    <tr>
      <td>It is hot outside today. Ask students, How does the meaning change if I change the word hot to scorching?</td>
      <td>It is more intense. It means unbearably hot. You probably wouldn’t want to go outside if it is scorching outside.</td>
    </tr>
    <tr>
      <td>Say to students, Warm, hot, and scorching are synonyms. Synonyms are different words that express a similar meaning. Sometimes choosing a synonym that is more intense can more accurately express what you are trying to communicate.</td>
      <td></td>
    </tr>
    <tr>
      <td>Have students brainstorm as many words as they can for the word happy. Ask students, How many synonyms can you name for the word happy? Write student responses on the board.</td>
      <td>Happy, joyful, ecstatic, cheerful, jolly, merry, content, satisfied, pleased</td>
    </tr>
    <tr>
      <td>Highlight the shades of meaning (nuances) among the synonyms. Explain how each word displays a slightly different level of happiness.</td>
      <td></td>
    </tr>
    <tr>
      <td>Create a spectrum on the board showing the range of intensity starting with happy and ending with ecstatic. Highlight how using the word ecstatic displays more intensity than using happy.</td>
      <td></td>
    </tr>
    <tr>
      <td>Distribute three synonym cards to each pair of students. Have them work in pairs to arrange the synonyms from least intense to most intense.</td>
      <td>Sample synonym cards w/key<br>big, huge, vast<br>scared, frightened, terrified<br>bad, terrible, dreadful<br>good, great, fantastic</td>
    </tr>
    <tr>
      <td>Discuss the arrangements and why certain words might be considered more intense than others.</td>
      <td>Ex. Students discuss how the word dreadful conveys more intensity than merely using the word bad.</td>
    </tr>
    <tr>
      <td>Discuss how choosing the right synonym can change the tone of a sentence. Ask students, How does the choice of good vs. fantastic change the tone of each sentence below? The book was good. The book was fantastic.</td>
      <td>Students discuss how describing a book as merely “good” may not persuade a person to read the book. By selecting the adjective fantastic instead, someone may be more interested in the book.</td>
    </tr>
  </tbody>
</table>

---------------------------------------
-- Grades 3-5 Practices

Here is the extracted **“Overview of Standard”** text for each standard in your uploaded PDF, with the standard code above each section. I have **removed page numbers/headers/footers** and preserved formatting with HTML tags as requested. Only the **Overview of Standard** sections are included — all other sections (Vocabulary, Instructional Strategies, Evidence of Student Learning, etc.) are omitted.

---

K-12.P.EICC.1
**Overview of Standard**
In this standard, students develop their reader and writer identities for both their personal and academic lives by building a toolkit to engage with texts both as consumers and producers. Students’ confidence will grow as they engage with and create various types of texts, allowing them to seek out new reading materials and writing opportunities.

---

K-12.P.EICC.2
**Overview of Standard**
In this standard, students engage in purposeful conversation as both author and audience to explore ideas, share knowledge, and respond to texts. Through these interactions, students make intentional connections within and across texts, deepening their understanding, constructing meaning, and using language to fulfill their purposes.

---

K-12.P.EICC.3
**Overview of Standard**
In this standard, students will read and comprehend a variety of complex texts across genres, disciplines, and purposes. They will preview texts, activate prior knowledge, set goals, and predict content. Students will also monitor their own understanding while asking questions and summarizing sections of the text, and then reflect on meaning, summarize the text, and apply what they’ve learned.

---

K-12.P.EICC.4
**Overview of Standard**
In this standard, students will create a variety of texts based on audience(s) and purpose(s). They will take an intentional journey through the writing processes such as planning, drafting, evaluating, revising, and editing, making choices based on the audience and purpose of the text.

---

K-12.P.ST.1
**Overview of Standard**
In this standard, students are encouraged to go beyond the surface of a text and consider the broader circumstances that shape its meaning and impact. Understanding the author’s life, purpose, and historical backdrop of the text will help students explain motivations, themes, and perspectives. Students will analyze how historical and contemporary events, along with technological developments, affect texts, helping them understand how ideas evolve over time.

---

K-12.P.ST.2
**Overview of Standard**
In this standard, students will become critical readers and intentional writers by understanding how texts are shaped to suit specific audiences and purposes. They will analyze how authors use language, structure, tone, and techniques to connect with their intended audience. Students will identify the purpose of a text and evaluate the effectiveness of the strategies and techniques used in achieving that purpose. They will also apply knowledge of audience and purpose when creating original texts, using text structures, text techniques, and stylistic choices to engage a target audience.

---

K-12.P.AC.1
**Overview of Standard**
In this standard, students will interpret texts by examining how an author’s craft choices, such as structure, language, tone, and techniques, shape meaning and influence the reader’s experience. They will identify specific techniques, analyzing the techniques’ purposes and effects, and evaluate how they connect to the reader’s own reactions, thoughts, decisions, and questions. Through this standard, students will develop deeper literary analysis skills, fostering critical thinking and personal engagement with texts.

---

K-12.P.AC.2
**Overview of Standard**
In this standard, students will construct texts by considering the target audience as they base decisions about craft choices, such as structure, language, tone, and techniques, to shape meaning and achieve a specific purpose. They will integrate specific techniques to appeal to a target audience and craft words and phrases to influence the reader’s responses, thoughts, decisions, and questions. Through this standard, students will develop deeper literary skills as they utilize their knowledge of context, author, audience, and purpose to construct texts.

---

K-12.P.AC.3
**Overview of Standard**
In this standard, students will analyze how the design and structure of a text influence its effectiveness for different audiences and purposes. They will evaluate how the structure and features of a text support or interfere with its purpose. Students will make deliberate choices about text design when constructing their own texts, tailoring their approach to suit the intended audience and the specific purpose of the text.

---

K-12.P.CP.1
**Overview of Standard**
In this standard, students will articulate their thoughts clearly and listen to others effectively as they participate in structured group projects. Students will be active participants, holding each other accountable to maintain an amicable and productive group dynamic. Students will engage in discussions to reach a consensus or solve a problem. Students will use strategies for resolving conflicts, providing constructive feedback, and maintaining a growth mindset. This prepares students for real-world scenarios involving meaningful collaboration and communication to enhance their skills in engaging with others across a variety of settings and for different purposes.

---

K-12.P.CP.2
**Overview of Standard**
In this standard, students will use presentation skills effectively to communicate a variety of messages to different audiences. They will understand how to adjust their communication style depending on the audience and the purpose of the presentation. Students will gain insight into how audience perspectives affect communication. This standard will prepare students to engage in successful communication in educational and real-world settings.

---

Here is the extracted **Vocabulary** content for each standard from your uploaded PDF. I’ve removed page numbers/headers/footers, preserved bold/italic with HTML, and included the standard code above each section as you requested.

---

**K-12.P.EICC.1**
Vocabulary
K-12 Glossary

* reading and writing goals and preferences
* personal interests; academic relevance
* composition & comprehension skills
* community of readers and writers
* independence; autonomy

**Goals**
**Preferences**
**Interest**
**Relevance**
**Comprehension**
**Composition**
**Community**
**Independence**
**Autonomy**

---

**K-12.P.EICC.2**
Vocabulary
K-12 Glossary

* share real or imagined experiences
* build knowledge, develop skills, make informed decisions, and share information and ideas
* explain and learn concepts and processes
* aid the analysis and evaluation of texts and ideas
* solve problems or influence decisions

**Dialogue**
**Analysis**
**Evaluation**
**Concepts**
**Processes**
**Problems**
**Solutions**
**Background**
**Knowledge**
**Skills**
**Ideas**

---

**K-12.P.EICC.3**
Vocabulary
K-12 Glossary

* establish purpose; set goals; monitor comprehension and adjust
* scan and skim; structures and sections
* prior knowledge; inconsistencies or gaps; knowledge repertoires
* summarize and visualize
* make and track predictions
* make, track, and support inferences
* unfamiliar words and concepts; apply knowledge of context and of academic vocabulary and word parts

**Purpose**
**Goals**
**Comprehension**
**Prior Knowledge**
**Summarize**
**Visualize**
**Predictions**
**Inferences**
**Academic Vocabulary**
**Unfamiliar Words**

---

**K-12.P.EICC.4**
Vocabulary
K-12 Glossary

* purpose and goals; target audience
* organizing texts; modes, genres, structures; achieve purpose; meet needs
* generate ideas; assess prior knowledge; gather information from texts; engage in discussions
* link ideas and information
* construct an initial draft; achieve the purpose; resonate with audience
* evaluate effectiveness; self-review and feedback from others
* make changes based on self-evaluation or external feedback; revising to increase text’s effectiveness
* edit the text; conventions of written language

**Purpose**
**Audience**
**Goals**
**Modes**
**Genres**
**Structures**
**Craft techniques**
**Writing process**
**Comprehension**
**Composition**

---

Here are the remaining **Vocabulary** sections from your PDF, formatted the same way as before.

---

**K-12.P.ST.1**
Vocabulary
K-12 Glossary

* prior knowledge; formal/informal research; discussions with others
* impact of context on purposes of author and audience
* impact of context on author's decisions and audience’s responses

**Context**
**Prior knowledge**
**Background knowledge**
**Research**
**Purposes**
**Author**
**Audience**

---

**K-12.P.ST.2**
Vocabulary
K-12 Glossary

* knowledge of author, audience, and context to establish and support purpose
* knowledge of author, audience, and context to establish point of view or perspective
* knowledge of how an author considers audience and context to design a text

**Author**
**Audience**
**Context**
**Purpose**
**Point of view**
**Perspective**
**Text design**
**Accessibility**
**Word choice (diction)**

---

**K-12.P.AC.1**
Vocabulary
K-12 Glossary

* identify, apply, and analyze the literary, expository, and opinion elements in texts
* identify, apply, and analyze important, interesting, or effective uses of language
* explain, analyze, and evaluate the author’s use of sentence structure and syntax
* describe, analyze, and evaluate the design and organization of the text

**Author’s lens**
**Craft techniques**
**Literary techniques**
**Expository techniques**
**Opinion techniques**
**Rhetorical techniques**
**Target audience**
**Purpose**
**Word choice (diction)**
**Sentence structure**
**Syntax**
**Formats**
**Structures**
**Patterns**
**Features**
**Accessibility**

---

**K-12.P.AC.2**
Vocabulary
K-12 Glossary

* integrate literary, expository, opinion or rhetorical elements to appeal to the audience & achieve the purpose
* craft words & phrases to influence the audience & achieve the purpose
* make decisions about sentence structure & syntax
* organize texts to influence audience & support the purpose

**Craft techniques**
**Literary techniques**
**Expository techniques**
**Opinion techniques**
**Target audience**
**Purpose**
**Word choice (diction)**
**Sentence structure**
**Syntax**
**Formats**
**Structures**
**Patterns**
**Features**
**Accessibility**

---

**K-12.P.AC.3**
Vocabulary
K-12 Glossary

* modes and genres; features impact meaning, tone, style, purpose, and audience
* mode and genre; impact ideas and information included in text
* mode and genre; impact how ideas and information are structured and arranged in text
* consume and produce multimodal texts; integrate a variety of genres, text features, and craft techniques

**Text design**
**Audience**
**Purpose**
**Modes**
**Multimodal texts**
**Genres**
**Features**
**Meaning**
**Tone**
**Style**
**Craft techniques**

---

**K-12.P.CP.1**
Vocabulary
K-12 Glossary

* active participation in group discussions and collaborative meetings
* determine shared project group norms, goals, procedures, and action
* offer ideas, listen to others, provide feedback
* discuss topics, investigate questions, solve problems, and explore and create texts with others

**Collaboration**
**Group discussions**
**Group norms**
**Shared Goals**
**Procedures**
**Productivity**
**Shared Project**
**Feedback**

---

**K-12.P.CP.2**
Vocabulary
K-12 Glossary

* communicate to present ideas, information, and texts
* integrate modes and genres for purpose and audience
* vary tone, pace, and nonverbal gestures for purpose and audience
* ask and answer questions in dialogue with audience
* build background knowledge through recitation

**Presentation**
**Purpose**
**Audience**
**Texts**
**Modes**
**Genres**
**Tone**
**Pace**
**Nonverbal gestures**
**Dialogue**
**Background knowledge**
**Recitation**
**Poems**
**Speeches**


---

### K-12.P.EICC.1

**Instructional Strategies for Teachers**
• Conference with students to set personal reading goals, including suggested texts based on student interest and formative data collection.
• Co-construct rubrics and writing checklists with students that allow space for goal setting and peer and teacher feedback.
• Have students create two identity charts: one for “Me as a Reader” and one for “Me as a Writer,” and have students explore the genres and modes they find that they enjoy for taking in information and those they prefer to use for creating texts.
• Implement student reading interest surveys. Use these surveys to recommend texts to students.
• Have students create a Recommended Books list or chart to share ideas with peers.
• Provide opportunities for students to read independently in the classroom as well as at home.
• Have students engage in a variety of opportunities to share their writing at various points in the writing process, including utilizing writing partners, peer feedback, peer editing, etc., during drafting and revision and author’s chair, gallery walks, recorded read-aloud, etc., for published writing.
• Have students reflect on their own writing journey, including a moment when they felt proud of their writing, a time when they struggled with writing, their favorite type of writing, and a writing goal they have for the future.
• Ask students to create a timeline of their reading experiences, including significant books, reading milestones, and memorable reading moments.
• Teach students how to generate their own discussion questions and take turns facilitating conversations.
• Allow students to form small groups based on shared reading interests. Provide a selection of books for students to choose from, encouraging autonomy.

---

### K-12.P.EICC.2

**Instructional Strategies for Teachers**
• Explicitly teach how to engage in peer dialogue and encourage them to talk before they write.
• Incorporate Think-Pair-Share opportunities.
• Provide opportunities for students to find what they care about–choice leads to voice.
• Share a variety of mentor texts and provide sentence stems to scaffold student responses and deepen dialogue.
• Conference with students early and often.
• Model how to value originality and voice in writing and speaking.
• Create a comfortable environment for writing and speaking and encourage students to take risks in their own writing.
• Utilize writing notebooks for generating ideas and exploring personal interests.
• Provide low-stakes writing and speaking opportunities often, encouraging students to explore word play and experiment with language.
• Create writing and speaking norms that focus on sustained communication every day while allowing opportunities for collaboration.
• Emphasize the importance of quality over quantity when writing and speaking.

---

### K-12.P.EICC.3

**Instructional Strategies for Teachers**
• Provide students with opportunities to develop a reading goal that includes their current reading level, goals they would like to achieve in reading, and how they plan to reach the goals.
• Model and encourage students how to skim and scan the text by previewing illustrations, reading the bold headings, table of contents, and chapter summaries.
• Pre-teach vocabulary concepts within the context of the text and model using a graphic organizer such as a word web.
• Create KWL charts (What I Know, What I Want to Know, and What I Learned) to help students activate their prior knowledge as it relates to the text.
• Explicitly teach context clues, prefixes, suffixes, root words to determine the meaning of unfamiliar words.
• Have students work in pairs or small groups to identify unfamiliar words, analyze context clues and discuss the meaning of words.
• Facilitate a discussion and model think aloud strategies to allow students to make and track predictions (e.g., POSSE: Predict, Organize, Search, Summarize, and Evaluate).
• Provide students with the opportunities to create visual representations of the text and using graphic organizers and using the 5Ws (who, what, where, when, why) questions to guide students in summarizing the text.
• Provide explicit instruction on commonly used academic vocabulary words, their meanings, and how they are used in context.

---

### K-12.P.EICC.4

**Instructional Strategies for Teachers**
• Create a structured environment where students can focus on the different writing processes.
• Explicitly teach specific writing skills such as developing and supporting thesis statements and using transitions to create cohesion.
• Model your thinking as you plan and write for a specific audience and purpose, asking students to note what they notice to apply to their own practice.
• Provide students with purposes and audiences so they can tailor their texts accordingly.
• Partner students with one another to brainstorm their writing and provide graphic organizers to help with the brainstorming process.
• Give students choice in selecting the type of text they would like to create, encouraging multimodality.
• Create guiding questions to think through task, such as, “This will help my audience understand because....”
• Create an anchor chart with students to refer to throughout the writing process.
• Conference with students during each part of the writing process, asking guiding questions about their drafts, helping them clarify purpose or rework organization, and providing specific and actionable feedback to help students set and meet personal writing goals.
• Use wide-ranging texts to illustrate text techniques and structures. Have students analyze how authors use techniques to address different audiences and purposes, then apply those techniques in their own writing.

---


### K-12.P.ST.1

**Instructional Strategies for Teachers**
• Explicitly teach students how to determine the impact of the context in which an author creates a text for specific purpose and/or audience. Focus on how external factors influence an author's writing choices and the meaning of the text.
• Explain how context encompasses the time, place, and other circumstances surrounding a text’s creation.
• Use real-life examples and discussions to illustrate how historical events, current events, and/or the author's personal experiences can shape a text's tone, content, and message. Encourage students to consider how these external factors might have influenced the author's decisions.
• Explicitly teach students how to determine the impact of context in which an audience consumes a text. For example, discuss how students living in a city could have a different context for interpreting a text about public transportation.
• Use interdisciplinary texts related to grade-level science and social studies content to explore context.
• Use advertisements, propaganda posters, artwork, news articles, or newscasts to explain historical contexts.
• Develop text sets to be used to increase background knowledge and that include multiple modalities and genres to explore aspects of context. For example, a text set designed around a specific topic, such as alligators, could be used to explore the impact of how people feel about alligators or how the author approached the purpose and audience.
• Discuss how the historical context of a text, such as the era it was written in or the location it was set in, can influence its themes and characters. For example, a novel set during the Great Depression will have a different tone and focus than one set in a futuristic world.
• Explain how values and beliefs can be reflected in a text, even if they are not explicitly stated. For example, a story that emphasizes family loyalty may be rooted in a specific tradition.
• Discuss how an author's personal experiences and motivations can shape their writing. For example, a memoir about overcoming adversity may be influenced by the author's own struggles and resilience.
• Assign writing activities that require students to consider the context of a text, such as writing a response to a text (consider various modes), analyzing a speech, or creating a fictional character based on a particular historical period.

---

### K-12.P.ST.2

**Instructional Strategies for Teachers**
• Explore how and why authors choose specific modes, genres, or multimodal designs to meet their purpose and audience.
• Model how to consider context when analyzing a text’s design or when designing a text; graphic organizers can be used to help clarify who wrote the text, when and where it was composed, etc.
• Model how to research authors and illustrators using book blurbs (e.g., back cover or the inside book flap) and other sources to understand their choices.
• Use dialogue excerpts from a text with guiding questions to analyze who is speaking, point of view, and narrator perspective; then, use a T-chart to compare point of view (who) versus perspective (how).
• Model techniques such as dialogue, description, pacing, or shifting point of view.
• Compare and contrast texts in the same genre or mode, paying attention to how the authors approach information or ideas in similar and different ways. Discuss how these choices are made based on context.
• Examine the author’s word choice and types of figurative language used and discuss how specific language influences context, purpose, and audience.
• Create anchor charts to support brainstorming discussions on different reasons why an author would create a text (purposes) and on different groups of people that an author creates a text for (audiences).
• Construct shared texts with a specific purpose and audience in mind. Discuss as a class why certain choices are made during the construction of the text.
• Take a previously read mentor text and model how to change who is telling the story to a different character in the text. Model this using dialogue from characters in the story. How did it change from the original story? Why?

---

### K-12.P.AC.1

**Instructional Strategies for Teachers**
• Use mentor texts, short stories, poems, and/or multimodal texts to model read alouds for guiding students to identify the author’s craft within the text and reflect on the effect on the purpose and audience.
• Provide students with opportunities to explore and identify text features and their purposes. For example, bold print shows important vocabulary, captions explain images, and headings and subheadings help with organization of ideas in expository or opinion text.
• Model how to identify author’s crafts within texts and provide students the opportunity to find examples within their own texts using a graphic organizer (e.g., a T-chart).
• Use an anchor chart to guide students in understanding the author’s craft and why authors use craft in their writing. For example, create an anchor chart with three columns: author’s craft moves, example, purpose & audience.
• Teach students in small groups to “seek and find” various crafts based on the prompts or texts provided.
• Provide students with opportunities to collaborate with their peers using Think, Pair, and Share to identify how the specific craft (e.g., word choice, structure, language) aids in their understanding.
• Use two different mentor texts that are rich in techniques and text features and guide students in comparing author’s craft and use of various techniques between two authors.
• Provide opportunities for students to read and reflect on the author’s craft using a graphic organizer, reading logs, or interactive notebooks.
• Guide students in using a specific technique in their own writing (writing like a reader), sharing their writing with a peer to identify the crafts or additional techniques within their writing.

---

### K-12.P.AC.2

**Instructional Strategies for Teachers**
• Guide students in brainstorming and discussing different audiences (e.g., classmates, teachers, parents) and purposes (to inform, to give an opinion, to entertain).
• Use anchor charts to list possible audiences and purposes for various writing tasks.
• Coach students to ask themselves, “Who will read this?” and “Why am I writing this?” before writing.
• Use graphic organizers or sentence stems that prompt students to identify the audience, purpose, and context before drafting. Sentence stems could include: *I am writing this for ___; My goal in writing is to ___; The situation I am writing about is ___.*
• Read and analyze mentor texts aloud, pausing to highlight how the author’s choices (word choice, tone, structure) fit the intended audience and purpose.
• Model constructing your own text and think aloud to model decision making (“I’m using exciting words here because I want my audience to feel surprised.”).
• Guide students in trying out different craft moves (e.g., dialogue, sensory details, questions, humor) and discuss how each could affect the audience’s experience.
• During peer review, have students give feedback specifically on whether the writing fits the intended audience and purpose.
• Have students use peer-review checklists or sentence starters such as *“As a reader, I felt ___”* or *“This part was clear because ___.”*
• Guide students to reread drafts and ask: *“Would my audience understand this?”* or *“Does this achieve my purpose?”*

---

### K-12.P.AC.3

**Instructional Strategies for Teachers**
• Use the Text Design Considerations (P.AC.3) resource to examine the various components that shape how texts are constructed and presented and to leverage these insights to strengthen instruction by helping students recognize, analyze, and apply the elements of text design.
• Use a variety of texts (print, visual, auditory, and digital) to teach text design.
• Co-create an anchor chart to teach students the components of text design, text features, craft techniques and text structure.
• Provide opportunities for students to identify, compare, and discuss text features through exploration of various texts and genres.
• Guide students in exploring text design, meaning, and purpose across various texts using a graphic organizer.
• Ask open-ended questions and encourage students to make predictions about the text.
• Use an anchor chart to guide students in understanding the purpose of text structures.
• Use an anchor chart to guide students in each phase of the writing process (drafting, revising and publishing) as they construct texts using text design and text features.
• Provide students with graphic organizers (Venn diagram, story maps, etc.) to engage in the writing process by using sentence starters or prompts.
• Allow opportunities for students to explore multimodal texts (print, visual, auditory, etc.).
• Provide opportunities for students to create multimodal texts (text illustration, podcast, voice recording etc.).
• Model and teach students how to include craft techniques in their own writing.
• Provide opportunities for students to collaborate with peers to share their work, retell stories and identify text features/craft techniques.
• Conference with students individually or in a small group setting regarding their construction of texts.


---

### K-12.P.CP.1

**Instructional Strategies for Teachers**
• Have students pair up to discuss a question or idea briefly as a turn and talk.
• Have students engage in a Think-Pair-Share: Students think individually, discuss with a partner, then share with the whole group.
• Give each student a specific job or assigned role (e.g., recorder, speaker, materials manager) to promote responsibility and teamwork.
• Allow students the opportunity to assume different roles within a team to enhance their understanding of different perspectives.
• Use cooperative learning activities such as a jigsaw. Divide a topic among students. Each student becomes an “expert” on one part and teaches it to others.
• Demonstrate what good collaboration looks like through modeling how to take turns, use kind words, and actively listen.
• Role-play scenarios where students practice solving problems or sharing materials.
• Post reminders of collaborative norms on anchor charts (e.g., *“We listen,” “We take turns,” “We help each other”*).
• Provide sentence starters for partner and group work such as *“I agree because…”* or *“Can you help me with…?”*
• Daily group discussions such as morning meetings help build community and give students practice with taking turns and listening respectfully.
• STEM challenges (like building a bridge with toothpicks) promote teamwork and problem-solving.
• Use specific praise to reinforce positive collaboration (“I noticed how you waited for your turn.”).
• Reflect with students after group activities: What went well? What can we do better next time?
• Use digital platforms where students can work together on projects.
• Present students with real-world problems and have them work in teams to solve them, fostering collaboration and innovation.
• Explicitly teach and model how to listen and respect diverse opinions and discuss issues proactively.

---

### K-12.P.CP.2

**Instructional Strategies for Teachers**
• Explicitly teach students about verbal and non-verbal communication.
• Model how to adjust tone, pitch, and speed when presenting.
• Provide opportunities for students to participate in role-playing scenarios that require them to adjust their language and presentation style (e.g., talking to friends versus presenting an award at an assembly).
• Explicitly teach students how to use visual aids (e.g., slideshows, digital videos), stressing the importance of the organization of information, color/font choice, and audio as it pertains to purpose and audience.
• Set up feedback routines and explicitly teach students how to give and receive positive feedback.
• Provide students with planning templates, sentence starters, etc., to help support them in creating their presentation.
• Allow students to work in groups on presentations before having them present individually.
• Engage in show and tell with a purpose. Modify the show and tell for various purposes:<ul><li>*Entertain:* Tell a funny story about an object.</li><li>*Inform:* Describe how something works.</li><li>*Persuade:* Convince the class why it's the best toy.</li></ul>
• Use sentence starters to help students organize their ideas before they share in groups (*“Today I want to tell you about…”* / *“I chose this because…”* / *“I hope you learned that…”*).
• Provide simple visuals (charts, drawings, photos) to support communication.
• Create a basic presentation rubric.
• Provide students with multiple, authentic opportunities to present to the class.
• Provide students with opportunities to learn and perform poems, speeches, or monologues.
• Encourage students to engage with the sounds and rhythms of text.
• Encourage students to practice recitation by experimenting with how fast or slow they speak (rate), the melody in their voice (prosody), and different vocal tones to create various effects.

---

K-12.P.EICC.1

<h3>Evidence of Student Learning</h3>
<table>
  <thead>
    <tr>
      <th>Teacher Prompt(s)</th>
      <th>Student Response</th>
    </tr>
  </thead>
  <tbody>
    <tr>
      <td>Work with students to co-construct a writing checklist and rubric for a multimodal writing task. Include a specific audience and purpose.</td>
      <td></td>
    </tr>
    <tr>
      <td>Say to students, We have been drafting our writing piece with a specific purpose and audience in mind. Today, we are going to work with our writing partners to review our drafts to make sure they are aligning with the purpose and audience. Partners will be providing one Glow and one Grow statement to help the author with their draft.</td>
      <td>Students will work with assigned writing partners. Glow and Grow statements can be added to sticky notes and affixed to the drafts.<br><br>Examples might include:<br>- GLOW--I like the way you chose to engage your audience through a strong lead and introduction.<br>- GLOW—I think your choice of the ____ mode will help you share your purpose.<br>- GROW—One thing you could do to engage your audience is create a conclusion that has a call to action.<br>- GROW—You could strengthen this even more and make your purpose clear if you added the mode ____.</td>
    </tr>
    <tr>
      <td>Review students’ Glow and Grow statements to determine understanding.</td>
      <td></td>
    </tr>
    <tr>
      <td>Say to students, Based on your peer feedback, we are going to have a quick focus lesson on ______.</td>
      <td></td>
    </tr>
    <tr>
      <td>Continue through the writing process with varied opportunities for partner and teacher feedback.</td>
      <td></td>
    </tr>
    <tr>
      <td>Say to students, Now that we have had an opportunity to get feedback from our writing partners and the teacher several times, we are going to share our final published writing in a gallery walk.</td>
      <td></td>
    </tr>
    <tr>
      <td>Have students display their published writing and carry out a gallery walk. Potential for adding positive peer feedback at this point to help build writing community.</td>
      <td></td>
    </tr>
    <tr>
      <td>Provide students with an opportunity to add to their ‘Me as a Writer’ chart with their writing preferences based on the genre and modes used within the writing task.</td>
      <td></td>
    </tr>
  </tbody>
</table>

Here is the **Evidence of Student Learning** section for the standard **K-12.P.EICC.2**, extracted and formatted per your instructions:

---

K-12.P.EICC.2

<h3>Evidence of Student Learning</h3>  
<table>
  <thead>
    <tr>
      <th>Teacher Prompt(s)</th>
      <th>Student Response</th>
    </tr>
  </thead>
  <tbody>
    <tr>
      <td>Remind students of a previously read paired text set centered around a common theme, such as family, that includes dialogue.</td>
      <td></td>
    </tr>
    <tr>
      <td>Say to students, We have been studying varying perspectives of authors and speakers in texts where we focused specifically on connections in dialogue from different perspectives.</td>
      <td></td>
    </tr>
    <tr>
      <td>Review with students a previously-created anchor chart with dialogue from different perspectives from each text.</td>
      <td></td>
    </tr>
    <tr>
      <td>Say to students, We recorded dialogue from different perspectives from both texts on this anchor chart. Review the dialogue and highlight the different perspectives presented in and across the two texts.</td>
      <td></td>
    </tr>
    <tr>
      <td>Have students turn and talk to discuss two different perspectives and how the dialogue is the same and/or different. Display the sentence stems below to scaffold student responses and deepen dialogue.<br><br>
        - This author/speaker thinks..., but this one thinks...<br>
        - This author/speaker thinks..., but I think...<br>
        - Both authors/speakers think..., but I think...</td>
      <td>Students discuss two different perspectives presented in and across the two texts.</td>
    </tr>
    <tr>
      <td>Say to students, Today, you are going to share your favorite family story or tradition.</td>
      <td></td>
    </tr>
    <tr>
      <td>Utilize the Think-Pair-Share strategy to have students think about and share their favorite family tradition or story.</td>
      <td>Students take turns sharing a family story or tradition with their partner.</td>
    </tr>
    <tr>
      <td>Actively monitor the discussions, guiding students to consider their spoken dialogue related to the perspective from which they are telling their story.</td>
      <td></td>
    </tr>
    <tr>
      <td>Allow students to jot down notes about their favorite family story, including dialogue, in their writing notebooks.</td>
      <td>Students record information about their favorite family story in their notebook to include dialogue.</td>
    </tr>
  </tbody>
</table>  



---
K-12.P.EICC.3

<h3>Evidence of Student Learning</h3>
<table>
  <thead>
    <tr>
      <th>Teacher Prompt(s)</th>
      <th>Student Response</th>
    </tr>
  </thead>
  <tbody>
    <tr>
      <td>Select a text to read aloud to students. This could be a printed, digital, visual, or auditory text.<br>* A narrative text is being used in this example.</td>
      <td></td>
    </tr>
    <tr>
      <td>Possible prompts before reading the text, say to students,<br>- Today, we are going to read a new book. Based on the title, illustrations, front cover, and back cover of the book, what do you think this book is about?</td>
      <td>Students will share their responses aloud or with a partner. Responses will vary.</td>
    </tr>
    <tr>
      <td>- Now that we have an idea of what this book will be about, let’s start working on the first two columns of our KWL chart.</td>
      <td>Students will complete the first two columns on the KWL chart based on their predictions.</td>
    </tr>
    <tr>
      <td>- Let’s look at the illustrations, bold headings, and titles within the text. We will scan and skim the text. (Review scan and skim, if needed.)</td>
      <td>Allow students the opportunity to scan the text and make notes of unfamiliar words, illustrations, characters, setting, and events.</td>
    </tr>
    <tr>
      <td>- Based on our scanning and skimming of the text, make predictions about what do you think may happen in this story. Why do you think that?</td>
      <td>Allow students to think and make predictions with a partner. Responses may vary, but could include, The author wrote the book to help me learn how to build something.</td>
    </tr>
    <tr>
      <td>Actively monitor student discussions and responses. Review the KWL chart with students.</td>
      <td></td>
    </tr>
    <tr>
      <td>During the reading, ask students to construct a list of unfamiliar words and specific events that occur throughout the story.</td>
      <td></td>
    </tr>
    <tr>
      <td>Possible prompts during the reading:<br>- The main character tells his brother that she is going to build a machine that can swim. Listen for the main character’s response to her brother when he wants to help her. Think about a time when you tried to do something on your own without the help of others.</td>
      <td>Allow students to listen and communicate with their peers to co-construct their understanding. Responses will vary but could include, Her dad encourages her to let her brother help her build the machine.</td>
    </tr>
    <tr>
      <td>- Let’s read about what happens when the girl begins to research how engineers and scientists work to solve problems. Pair up with a partner and share how you work to solve your problems.</td>
      <td>Responses will vary.</td>
    </tr>
    <tr>
      <td>- Monitor comprehension by asking questions. “What is the author wanting you to understand?”</td>
      <td>Responses will vary.</td>
    </tr>
    <tr>
      <td>After reading, lead a classroom discussion about the text, encouraging student reflection. Have students determine if their predictions of the text are accurate. Have students complete the “L” column of the KWL chart.</td>
      <td>Responses will vary.</td>
    </tr>
    <tr>
      <td>Possible prompts after reading:<br>- What was your favorite part of the book and why?</td>
      <td>Responses will vary.</td>
    </tr>
    <tr>
      <td>- How might you retell the events of the story?<br>o (Use the 5w’s and 1H)</td>
      <td>Responses will vary.</td>
    </tr>
    <tr>
      <td>- Discuss with a partner how you would summarize the text to help them understand the story. What are some important details you would include to summarize?</td>
      <td>Responses will vary but could include, Someone would need to know that the main character tried to invent a swimming machine on her own, but it did not work the first time she tried.</td>
    </tr>
  </tbody>
</table>

---

K-12.P.EICC.4
Evidence of Student Learning 

<table>
  <thead>
    <tr>
      <th>Teacher Prompt</th>
      <th>Student Response</th>
    </tr>
  </thead>
  <tbody>
    <tr>
      <td>Provide excerpts of different texts for students and ask them who the text was written for and why. Encourage students to explain their thinking.</td>
      <td>Responses may vary; sample student response: This was written for kids to help them learn how to recycle. I know this because the author says, “Hey kids!” and explains how to sort recycling.</td>
    </tr>
    <tr>
      <td>Say, Great work! Authors are always thinking about their audience and purpose for writing. A way you can tell is by looking at the language authors use and the information they include.</td>
      <td></td>
    </tr>
    <tr>
      <td>Provide students with a topic. Teachers are encouraged to use a topic connected to student learning. Now we are going to write about a topic with the author and audience in mind. Since we’ve been studying animals in class, our topic for today will be pets!</td>
      <td></td>
    </tr>
    <tr>
      <td>Ask students to provide an audience and purpose, Who are we creating our text for? What will our text be about?</td>
      <td>Responses may vary; sample student response: Let’s write a text about different kinds of pets for kindergarteners!</td>
    </tr>
    <tr>
      <td>Say, Great! If I am writing a book about different kinds of pets for kindergarteners, one thing I might do is include a lot of pictures because they are just learning to read. What else might I do for this audience?</td>
      <td>Responses may vary; sample student response: We would use shorter sentences or not have as many words.</td>
    </tr>
    <tr>
      <td>Say, Fantastic job! What about if we created a movie for them? How else would we accommodate our audience with our purpose in mind?</td>
      <td>Responses may vary; sample student response: It would be a funny cartoon.</td>
    </tr>
    <tr>
      <td>Say, Wonderful work! Remember, our purpose was to create a text about different kinds of pets. What if we changed the audience to adults? Turn and talk to your neighbor, how would your book or movie change if the audience were adults?</td>
      <td>Responses may vary; sample student response: We might use more words and fewer illustrations.</td>
    </tr>
    <tr>
      <td>Circulate to listen to student responses and allow students to share out.</td>
      <td></td>
    </tr>
    <tr>
      <td>Say, Good effort! We heard a lot of responses. Now we’re going to begin planning our writing. We’re going to continue with the topic of pets, but now I want you to choose a purpose for writing and an audience you want to write for. Once you’ve chosen your purpose and audience, talk to your table about how you will accommodate your audience in your writing to achieve your purpose.</td>
      <td></td>
    </tr>
    <tr>
      <td>Encourage students to share their ideas with one another and get input from peers to add to their thinking.</td>
      <td></td>
    </tr>
  </tbody>
</table>

 ---
 K-12.P.ST.1
Evidence of Student Learning 

<table>
  <thead>
    <tr>
      <th>Teacher Prompt</th>
      <th>Student Response</th>
    </tr>
  </thead>
  <tbody>
    <tr>
      <td>Say to students, Over the next several days, we are going to be reading a variety of texts as part of our _____ unit. This text set will help us build an understanding of the way that the historical context of this time period impacted the author’s choices they made when they created the texts. As we work, we will complete a graphic organizer to capture our thinking.</td>
      <td>Students will have a graphic organizer to capture information as they engage with each text.</td>
    </tr>
    <tr>
      <td>Read a variety of texts from the chosen time period by multiple authors. Stop purposefully during the course of reading or viewing the texts so students may fill in the graphic organizer in small groups or with a partner. Guide students to generate research questions about the time period.</td>
      <td>Review student notes as needed for formatively assessing and planning next steps based on current understanding of the historical context.<br><br>Have students carry out brief group research to answer their questions related to the time period.</td>
    </tr>
    <tr>
      <td>Guiding questions may include:<br>- What do you notice about this historical time period?<br>- What do you know about this time period based on evidence in the text?</td>
      <td>Have students carry out brief group research to answer their questions related to the time period.</td>
    </tr>
    <tr>
      <td>Say to students, We've noticed a common theme about ___ in this time period. Why do you think so many authors focused on the struggles of families affected by ___ during that time period? Who were they writing for, and how did their choices shape the audience’s understanding? What was the author’s purpose, and what techniques did they use to achieve it? Use your answers to those questions to complete the following writing task:<br><br>--Construct a paragraph that explains the historical context and the impact it may have had on the authors of these texts.</td>
      <td>Students will be able to use their graphic organizer to construct a paragraph that explains the historical context and the impact it may have had on authors of these texts.</td>
    </tr>
  </tbody>
</table>

---
K-12.P.ST.2

<h3>Evidence of Student Learning</h3>
<table>
  <thead>
    <tr>
      <th>Teacher Prompt</th>
      <th>Student Response</th>
    </tr>
  </thead>
  <tbody>
    <tr>
      <td>Review a previously-explored text where the author used imagery to engage the audience and achieve an intended purpose. Bring attention to how the author intentionally uses figurative language to create imagery. Draw students' attention to the anchor chart from previous lessons with definitions and examples of similes, metaphors, idioms, hyperboles, personification.</td>
      <td></td>
    </tr>
    <tr>
      <td>Say, Today, you will use figurative language to create imagery and engage your reader about a specific experience.</td>
      <td></td>
    </tr>
    <tr>
      <td>Prompt students to choose an experience or have students select from a list on the board (riding a roller coaster, eating ice cream, experiencing a thunderstorm, etc.).</td>
      <td>Students choose an experience.</td>
    </tr>
    <tr>
      <td>Say, You are going to write 2-5 sentences describing your selected experience. Think about how you want your reader to feel as they read and use figurative language that helps support those feelings in your writing.</td>
      <td></td>
    </tr>
    <tr>
      <td>Give students time to think and write their sentences. Support students as needed.</td>
      <td>Students write two sentences about their chosen experience.</td>
    </tr>
    <tr>
      <td>Say, Now, read over your sentences and underline any figurative language you used.</td>
      <td>Students read and underline the figurative language they used.</td>
    </tr>
    <tr>
      <td>Give students time to read their sentences and underline figurative language used.</td>
      <td></td>
    </tr>
    <tr>
      <td>Say, Now, you will exchange papers with a partner. You will take turns reading your partner's sentences and explaining how the sentences make you feel about the chosen experience. Then, see if you can identify the type of figurative language your partner used (simile, metaphor, idiom, hyperbole, personification) and explain the mental imagery you created as you read.</td>
      <td>Students exchange papers and discuss the figurative language and what it made them feel and see in their mind as they read.</td>
    </tr>
    <tr>
      <td>As students work in pairs, circulate the room, listening to conversations. Support students as needed.</td>
      <td></td>
    </tr>
    <tr>
      <td>Select 3-5 examples that effectively utilize imagery and have a group discussion about the meanings behind the figurative language.</td>
      <td>
        Possible student examples:<br><br>
        <u>Rollercoaster</u><br>
        Fast as lightning (simile)<br>
        The wind whipped past my face (personification)<br>
        We flew through the air (metaphor)<br><br>
        <u>Thunderstorm</u><br>
        Raining cats and dogs (idiom)<br>
        Pouring down rain (hyperbole)<br>
        The wind howled (personification)<br><br>
        <u>Ice Cream</u><br>
        Cold as ice (simile)<br>
        Flavor explosion (metaphor)<br>
        My heart soared with each bite (hyperbole)
      </td>
    </tr>
  </tbody>
</table>

---
K-12.P.AC.1

<h3>Evidence of Student Learning</h3>
<table>
  <thead>
    <tr>
      <th>Teacher Prompt(s)</th>
      <th>Student Response</th>
    </tr>
  </thead>
  <tbody>
    <tr>
      <td>Select a mentor text to read aloud or share with students. * An expository text is used for this example.</td>
      <td></td>
    </tr>
    <tr>
      <td>Before reading, create an anchor chart to guide students in understanding the author’s craft. Explain the various types of text features and craft moves that authors use in their writing (e.g., word choice, language, structure, techniques).</td>
      <td>Responses will vary but could include: Authors write to tell a story or give information. Students may record their responses in an interactive journal or reading response log or graphic organizer.</td>
    </tr>
    <tr>
      <td>During the reading, ask students how to identify the impact of the author’s craft on purpose and audience. Have students make additional notes to their graphic organizer or interactive notebook.</td>
      <td></td>
    </tr>
    <tr>
      <td>Say, Let’s look at this sentence/paragraph from the story. “There was a bang at the front door. Luca’s heart pounded like a drum in her chest. She peeked through the window with a flashlight.”</td>
      <td></td>
    </tr>
    <tr>
      <td>Ask, Why do you think the author wrote this part of the story this way?</td>
      <td>Responses will vary but could include: The author used certain words to show us that Luca was scared. Students should be able to identify text features and techniques used to create suspense within the story.</td>
    </tr>
    <tr>
      <td>After reading, have students reflect on the anchor charts and responses to facilitate a Think, Pair and Share discussion with a partner.</td>
      <td></td>
    </tr>
    <tr>
      <td>Provide students with additional prompts such as:
        <ul>
          <li>What effect does this technique have on me as a reader?</li>
          <li>What message is the author trying to communicate?</li>
          <li>Did anything surprise you?</li>
        </ul>
      </td>
      <td>Responses will vary. Be sure to circulate and listen as students share their responses to address any misconceptions. Students should reflect on the text and identify the author’s craft and their personal effects on the story.</td>
    </tr>
    <tr>
      <td>Extension Opportunity Provide students with a list of techniques to choose from to construct their own text, then share their writing with a partner. Students will take turns identifying text features and techniques within their writing. </td>
      <td>Extension Responses will vary depending on the individual selection of techniques and features each student uses.</td>
    </tr>
  </tbody>
</table>

---

K-12.P.AC.2

Evidence of Student Learning

<table border="1" cellpadding="4" cellspacing="0">
  <thead>
    <tr>
      <th>Teacher Prompt</th>
      <th>Student Response</th>
    </tr>
  </thead>
  <tbody>
    <tr>
      <td>Review with students the anchor chart for Audience, Purpose, Context, and Author’s Craft previously created.</td>
      <td></td>
    </tr>
    <tr>
      <td>Say, Authors employ many different strategies to create their text, depending upon their audience and their purpose. Today, we’re going to explore how authors do that and how we can do it, too.</td>
      <td></td>
    </tr>
    <tr>
      <td>Provide students with two texts about the same topic (e.g., healthy eating), preferably in two distinct genres (e.g., a story and a letter to the principal).</td>
      <td></td>
    </tr>
    <tr>
      <td>Say, We are going to read two texts, and as we read them, we will pay attention to the purpose, the audience, and how the author writes for their audience and purpose.</td>
      <td></td>
    </tr>
    <tr>
      <td>Read texts with students and ask them to note the audience and purpose, as well as the author’s craft moves.<br><br>Co-create an anchor chart with students noting the author’s move and how it helps the audience. Probe students with questions such as What kind of writing is this? What is the author trying to do?</td>
      <td>Student responses will vary, but could include:
        <ul>
          <li>The letter is addressed to our principal, so I know the audience is the school’s principal.</li>
          <li>The story has characters.</li>
          <li>The author gives their opinion in the letter and the character tells their opinion in the story.</li>
          <li>The author used facts in their letter to the principal to prove why we need to eat healthy lunches at school.</li>
          <li>The story helped us see what happens to people when they eat healthily through the character’s actions.</li>
        </ul>
      </td>
    </tr>
    <tr>
      <td>Say, We noticed how the author catered to their audience and purpose. Sometimes the author used expository techniques, opinion techniques and narrative techniques, or mixed all of them together! Now, let’s take out our writing and see how we can better cater to our audience and purpose.</td>
      <td></td>
    </tr>
    <tr>
      <td>Allow students to work in pairs or groups to find areas in their text to add to or amend with the audience and purpose in mind.</td>
      <td></td>
    </tr>
    <tr>
      <td>Extension Opportunity
A student sample text could be used as a
mentor text with students to help them
create and analyze their own creations.
(Teachers may pull from their own
personal student work libraries; also, a
sample is provided in the 3-5.P.AC.2
Student Resource Sample).</td>
      <td>Provide students with a final context,
purpose, and audience. Have each
student draft an individual short text for
the writing task, making deliberate choices
about word choice and techniques.
Encourage students to annotate their final
creations to explain their choices.</td>
    </tr>
  </tbody>
</table>

---

K-12.P.AC.3

<h3>Evidence of Student Learning</h3>
<table>
  <thead>
    <tr>
      <th>Teacher Prompt</th>
      <th>Student Response</th>
    </tr>
  </thead>
  <tbody>
    <tr>
      <td>Provide students with a variety of texts (mentor text, image, menu, commercial/podcast) and guide students in identifying what they notice about text design.</td>
      <td>
        <ul>
          <li>The font is big and bold so that means it is important.</li>
          <li>The sentences are numbered so this means I need to follow the steps in order.</li>
          <li>The pictures give me a clue to what the book is about. The book is about a ringmaster in a circus.</li>
        </ul>
      </td>
    </tr>
    <tr>
      <td>Before reading the text, ask students, Remember our class discussion about purpose and audience? Let’s look through our text and think about who the author wrote this text for. Why do you think the author designed the text this way? Let’s use a graphic organizer to organize our thoughts.</td>
      <td>Student responses will vary but could include: 
        <ul>
          <li>I think the author included captions and bold titles and words to help me to understand vocabulary words.</li>
          <li>This type of text is a nonfiction text about lions in the Saharan Desert.</li>
          <li>The purpose of the text is to inform us about how lions survive in this environment.</li>
        </ul>
      </td>
    </tr>
    <tr>
      <td>During reading, ask, How is this text organized? What do you notice about the way the author uses bold words? How does the ___ help you understand the text better? How can you tell if the author wants you to learn something new or just enjoy the story?</td>
      <td>Student responses will vary but could include: 
        <ul>
          <li>The text is organized into different sections and each one talks about a different topic.</li>
          <li>The bold words help me know what I should pay attention to.</li>
          <li>Captions are the little sentences under pictures and they tell me what is happening in the pictures.</li>
        </ul>
      </td>
    </tr>
    <tr>
      <td>After reading, ask, 
        <ul>
          <li>Did the way the text was arranged make it easier or harder to read? Why?</li>
          <li>If you could change one thing about how the text looks, what would you change and why?</li>
          <li>Choose one text feature and explain how it helped you understand the text better.</li>
        </ul>
      </td>
      <td>Student responses will vary but could include: 
        <ul>
          <li>The way the text was arranged made it easier for me to read because the paragraphs were short and there were spaces between them.</li>
          <li>I would make the font a little bigger because sometimes the words were hard to see.</li>
        </ul>
      </td>
    </tr>
    <tr>
      <td>Say to students, Now that we have explored the structure, text design, and different craft techniques of our text, we are able to understand the purpose and audience of the text.</td>
      <td></td>
    </tr>
    <tr>
      <td>Say to students, Let’s look at the texts that you have created. I want you to work with a partner to “Think, Pair and Share” and identify the purpose and audience of your texts. Remember to refer back to your graphic organizer to help you.</td>
      <td></td>
    </tr>
    <tr>
      <td>Circulate throughout the groups, providing feedback and addressing any misconceptions.</td>
      <td></td>
    </tr>
  </tbody>
</table>

---

K-12.P.CP.1

<h3>Evidence of Student Learning</h3>

<table>
  <thead>
    <tr>
      <th>Teacher Prompt(s)</th>
      <th>Student Response</th>
    </tr>
  </thead>
  <tbody>
    <tr>
      <td>
        <p>Give students think time. Have a few students share their thoughts.</p>
      </td>
      <td>
        <p>Students share their thoughts on what makes a good collaborator and communicator.</p>
      </td>
    </tr>
      <td>
        <p>Give students think time. Have a few students share their thoughts.</p>
      </td>
      <td>
        <p>Student responses will vary but could include:</p><ul>
          <li>Communicate clearly</li>
          <li>Listen carefully</li>
          <li>Be an active participant</li>
          </ul>
      </td>
    </tr>
    <tr>
      <td>
        <p>After students share their thoughts, explain the steps for effective collaboration and communication. Record them on chart paper for future reference. For example:</p>
        <ol>
          <li>Be an active listener</li>
          <li>Clearly state ideas</li>
          <li>Provide constructive feedback</li>
          <li>Resolve conflicts</li>
        </ol>
      </td>
      <td>
        <p>Students ask questions for clarification.</p>
      </td>
    </tr>
    <tr>
      <td>
        <p>Once students understand the steps for effective collaboration and communication, introduce the group project.</p>
        <p>Say, You will work in small groups to design a new playground for our school. Your group will need to decide what to include on the playground and why it is needed. You will follow these guidelines</p>
        <ol>
          <li>You must include a description of each item you want to include in the playground.</li>
          <li>You must also include a written explanation as to why these items are needed.</li>
          <li>You will respond to the following prompt: What playground items are most beneficial to elementary students?</li>
          <li>Support your group’s opinion with two pieces of evidence. Remember to use credible sources.</li>
        </ol>
      </td>
      <td>
      </td>
    </tr>
    <tr>
      <td>
        <p>Divide students into groups and assign each student a role (e.g., note-taker, presenter, time-keeper). Provide students with brief sources to support recess and playground equipment for elementary students. Students may also benefit from a graphic organizer to structure their thinking and record their evidence.</p>
        <p>Circulate the room, observing and facilitating discussions. Support students in using conflict resolution strategies if disagreements arise. Encourage students to remain positive.</p>
      </td>
      <td>
        
      </td>
    </tr>
    <tr>
      <td>
        <p>Have each group share their chosen playground items and explain their choices. Other groups will provide constructive feedback after each presentation.</p>
      </td>
      <td>
        <p>Students will work collaboratively with their groups to answer the prompt as they engage in discussions to brainstorm and decide on playground items.</p>
        <p>Groups will collaboratively share their chosen playground items, following the guidelines of the group project. Students will use constructive feedback to refine their ideas.</p>
      </td>
    </tr>
    <tr>
      <td>
        <p>After each student group has finished sharing, say, Remember, collaboration is about respecting each other’s ideas and working together toward a common goal. Now, I want you to think about the process you just experienced and write a reflection about what you learned about collaboration. Jot down one goal you want to achieve in future group projects.</p>
        <p>*Portions of this activity may take up more than one class period.</p>
      </td>
      <td>
        <p>Students individually write a personal reflection about what they learned about collaboration from this experience. They will also create a goal they want to achieve as they refine their collaboration skills on future projects (e.g., active listening, constructive feedback).</p>
      </td>
    </tr>
  </tbody>
</table>

------

K-12.P.CP.2

<table>
  <thead>
    <tr>
      <th>Teacher Prompt</th>
      <th>Student Response</th>
    </tr>
  </thead>
  <tbody>
    <tr>
      <td>Show a short video clip of two different types of presentations (a toy commercial and a weather report).</td>
      <td>Students watch the presentations.</td>
    </tr>
    <tr>
      <td>Discuss the differences in presentation styles. Ask students why the presenters chose certain colors, language, sounds, etc.</td>
      <td>Student responses will vary but could include:<br>
        - The bright colors the presenter used in the weather report help the audience distinguish between different types of weather.<br>
        - The sound effects used in the toy commercial help the audience imagine themselves interacting with the toy.</td>
    </tr>
    <tr>
      <td>Say to students, The presenter must communicate their ideas and information considering their target audience.</td>
      <td></td>
    </tr>
    <tr>
      <td>
      Ask students who might be the target audience for the toy commercial. Remind students of the anchor chart used in a previous lesson listing different types of audiences.</td>
      <td>Students should say the target audience for the commercial might be kids or parents shopping for a new toy.<br><br>Students should say the target
audience for the weather report
might be adults or kids who need
to know how to prepare for the
weather ahead. </td>
    </tr>
    <tr>
      <td>Say, The presenter must communicate their ideas and information considering their target audience.<br><br>
      Remind students of the different types of purposes they have been learning about in class (to inform, entertain, persuade).<br><br></td>
      <td></td>
    </tr>
    <tr>
      <td>Ask students what the purpose of the toy commercial might be.</td>
      <td>To persuade</td>
    </tr>
    <tr>
      <td>Ask students what the purpose of the weather report might be.</td>
      <td>To inform</td>
    </tr>
    <tr>
      <td>Note: In 5th grade, students begin
identifying multiple purposes in a text.</td>
      <td></td>
    </tr>
    <tr>
      <td>As a class, share examples of how the same information might be presented differently with a different purpose and/or audience (e.g., weather report to inform kindergarten students about the weather, a commercial to inform parents about an upcoming event).</td>
      <td>Students share how the presentations might be different if presented to a different target audience and/or purpose.</td>
    </tr>
    <tr>
      <td>Say, Today you are going to create a short presentation for a specific audience. I will divide you into small groups and your purpose will be to inform your assigned audience about a hobby. You will have 10 minutes to brainstorm ideas with your group before you begin creating your presentation. Remember, you are creating a short presentation that is about 1 minute long.</td>
      <td></td>
    </tr>
    <tr>
      <td>Divide the class into small groups and assign each group a different audience (e.g., peer, younger student, or adult).</td>
      <td></td>
    </tr>
    <tr>
      <td>Circulate the room, assisting students as needed. Provide planning templates (sample planning template) or sentence starters for students who need additional support. A rubric (sample rubric) could also be provided for clarity. These resources should be aligned to local instruction.</td>
      <td>Students brainstorm ideas with their assigned group to tailor their presentation to their assigned audience and purpose.</td>
    </tr>
    <tr>
      <td>Say, Now that you have had time to brainstorm with your group, you will have 20 minutes to create your presentation. Remember to consider your audience and purpose while planning your presentation.</td>
      <td></td>
    </tr>
    <tr>
      <td>Students may use any mode you choose
to create their presentation (e.g., digital
presentation, live presentation).</td>
      <td>Students work in their assigned group to create a short presentation based on their group’s plans in a teacher-selected mode.</td>
    </tr>
    <tr>
      <td>Circulate the room, assisting students as needed. Consider offering students time to rehearse their presentation prior to presenting to the whole class.</td>
      <td></td>
    </tr>
    <tr>
      <td>After 20 minutes, allow students time to share their presentation with the class. After each presentation, engage in a brief discussion about how the presentation was tailored to the audience and purpose. Allow students to provide constructive feedback to their peers about what went well and what could be improved.</td>
      <td>Student groups present their presentations and receive feedback from their peers as to how the presentation considers the target audience and purpose.</td>
    </tr>
    <tr>
      <td>Have students individually write a short reflection in their writing journals on what they learned about how to tailor their communication to a specific audience and purpose.</td>
      <td>Students write a short reflection on what they learned about tailoring communication to a specific audience and purpose.</td>
    </tr>
  </tbody>
</table>

---


<html>
<body>
<pre>3-5.T.C.1
Overview of Standard
In this standard, students are learning to interpret texts by determining the purpose(s) and the intended audience of various types of text. They acquire knowledge of the text features of various text modes, such as print, auditory, spoken, and visual modes to determine how those features and the author’s choice of mode contribute to the purpose and audience. They will then learn to construct multimodal texts, using the features associated with them to achieve their purpose(s) for a specific audience.</pre>

<pre>3-5.T.C.2
Overview of Standard
In this standard, students will explore texts to uncover different authors’ perspectives and how these perspectives may influence readers. Students will examine the context around the text’s creation to understand why the text looks or sounds a certain way. By analyzing these influences, students will gain a deeper understanding of how different perspectives affect the message and meaning of texts that they interpret and construct.</pre>

<pre>3-5.T.SS.1
Overview of Standard
In this standard, students are learning to describe text organization by using and identifying a variety of text features and organizational structures. They will learn to construct texts and intentionally plan an organizing structure and utilize purposeful text features suited to an intended audience and purpose. Students will continue to grow in their ability to use conjunctions and transition words/phrases to show clear relationships between ideas or information, crafting related sentences into cohesive paragraphs that show those relationships.</pre>

<pre>3-5.T.SS.2
Overview of Standard
In this standard, students will grow in their ability to understand and use figurative language to interpret meaning and create engaging texts. Students are expected to identify and explain how devices such as similes, metaphors, idioms, hyperbole, and personification shape the meaning of ideas and information in texts. They will also be able to describe the impact of these language choices in relation to the author’s purpose, the audience, and the genre or mode of the text. Additionally, students are encouraged to intentionally use figurative language in their own writing to show relationships between ideas, enhance clarity, and engage readers through vivid and expressive language.</pre>

<pre>3-5.T.T.1
Overview of Standard
In this standard, students build their knowledge of narratives while analyzing the narrative techniques authors use. Students will also apply their understanding of narrative techniques to their own texts, choosing the appropriate techniques for their specific purpose and audience. Georgia’s K-12 ELA Standards shift from fixed text types to the flexible use of techniques, emphasizing purpose and audience, with authentic texts often blending narrative, expository, argumentative, and poetic techniques.</pre>

<pre>3-5.T.T.2
Overview of Standard
In this standard, students build their knowledge of expository techniques while analyzing the expository techniques authors use. Students will also apply their understanding of expository techniques to their own texts, choosing the appropriate techniques for their specific purpose and audience. Georgia’s K-12 ELA Standards shift from fixed text types to the flexible use of techniques, emphasizing purpose and audience, with authentic texts often blending narrative, expository, argumentative, and poetic techniques.</pre>

<pre>3-5.T.T.3
Overview of Standard
In this standard, students grow from describing and discussing the techniques used by an author for expressing an opinion or argument to evaluating the effectiveness of the chosen techniques. Techniques used by the author include stating an opinion or claim, naming supporting reasons, and providing evidence. Students apply these techniques to their own text construction using linking words to connect their opinion and reasons. Georgia’s K-12 ELA Standards shift from fixed text types to the flexible use of techniques, emphasizing purpose and audience, with authentic texts often blending narrative, expository, argumentative, and poetic techniques.</pre>

<pre>3-5.T.T.4
Overview of Standard
In this standard, students begin to discuss and explain poetic techniques, including rhyme schemes, and learn to present and design a variety of types of poetry such as haiku, limerick, free verse, and rhymed verse. Georgia’s K-12 ELA Standards shift from fixed text types to the flexible use of techniques, emphasizing purpose and audience, with authentic texts often blending narrative, expository, argumentative, and poetic techniques.</pre>

<pre>3-5.T.RA.1
Overview of Standard
In this standard, students will continue developing their research skills as they become independent, critical thinkers and researchers. They will generate meaningful questions to guide their research and find answers that go beyond basic facts. Students will learn how to recognize and discern credible vs. non-credible sources as they develop their understanding of why source credibility matters. They will communicate relevant and accurate information in logical and organized ways, focusing on key ideas related to their research questions and avoiding irrelevant details.</pre>

<pre>3-5.T.RA.2
Overview of Standard
In this standard, students will gather information from various sources (e.g., books, articles, websites, podcasts) to support their ideas or answer their research questions. They will begin learning how to assess credibility (Is this a trustworthy source?) and relevance (Does this information help answer the question?). Students will begin integrating evidence from various sources into the texts they create, citing sources as appropriate to grade-level expectations.</pre>
</body>
</html>

---

**3-5.T.C.1**
 <b>Vocabulary</b>

* Purpose
* Audience
* Text features
* Text modes
* Multimodal text

---

**3-5.T.C.2**
 <b>Vocabulary</b>

* Authors
* Narrator
* Speakers
* Perspectives
* Influences
* Inferences
* Context

---

**3-5.T.SS.1**
 <b>Vocabulary</b>

* Text feature
* Organizational structure
* Conjunctions
* Transition words
* Paragraph
* Cohesion/Cohesive

---

**3-5.T.SS.2**
 <b>Vocabulary</b>

* Figurative language
* Simile
* Metaphor
* Idiom
* Personification
* Hyperbole
* Audience
* Purpose
* Modes
* Genres

---

**3-5.T.T.1**
 <b>Vocabulary</b>

* Narrative techniques
* Character
* Setting
* Plot
* Problem
* Conflict
* Solution
* Theme
* Characterization
* Myth
* Climax
* Dialogue

---

**3-5.T.T.2**
 <b>Vocabulary</b>

* Expository techniques
* Expository texts
* Facts
* Key details
* Supporting details
* Main idea
* Technical texts
* Firsthand accounts
* Secondhand accounts
* Primary sources
* Secondary sources

---

**3-5.T.T.3**
 <b>Vocabulary</b>

* Techniques
* Opinion statement
* Claim
* Supporting reasons
* Evidence
* Linking words
* Concluding statement or section

---

**3-5.T.T.4**
 <b>Vocabulary</b>

* Rhyme
* Rhyme scheme
* Stanza
* Forms (Haiku, Limerick, Free verse) 
* Rhymed verse
* Structure
* Syllables

---

**3-5.T.RA.1**
 <b>Vocabulary</b>

* Inquiry
* Research
* Research questions
* Credible sources
* Information (Relevance, Accuracy, Integration)
* Summarizing
* Questions (Clarifying, Deepening, Extending, Closed, Open-ended)

---

**3-5.T.RA.2**
 <b>Vocabulary</b>

* Source
* Source text
* Passages
* Quotations
* Page number
* Credibility
* Credible source
* Relevance
* Relevant source
* Integrating evidence
* Citation
* Basic parenthetical citation

---


### 3-5.T.C.1

• Explore a variety of multimodal texts (e.g., brochures with links, various websites, blogs, print text, digital texts, slides decks, video clips, podcasts or auditory clips, timelines, page spreads).
• Analyze texts to explore purposes of writing (persuade, inform, entertain) and examine how word choice and sentence structure align with the intended audience.
• Model close reading to identify the purpose, audience, mode, and text features of the text.
• Collaboratively explore and develop charts or lists of frequently used text features for various modes and genres. (For example—Expository text features often include charts, captions, real photos, maps, and headings; Videos often include an introduction, captions, and visual aids).
• Guide students in recognizing how the author’s inclusion of various techniques enhances the text and impacts their understanding as the audience.
• Use the RAFT (Role-Audience-Format-Topic) strategy to help students understand the role of the author, the intended audience, and the purpose of the writing.
• Use wordless picture books, signs, and posters, and have students explore purpose and audience.
• Demonstrate how to use features of a variety of print and digital texts to build meaning and provide students with a diverse number of texts.
• Model how to use text features within a text to build meaning and comprehend the text.
• Have students create a variety of multimodal texts (possibly including videos, presentations, speeches, vlogs, infographics, etc.) using the various features associated with those modes and genres.
• Provide exemplars and rubrics for multimodal writing assignments, co-creating with students when appropriate.
• Ask students guiding questions to help them consider the needs of their audience to make decisions about modes and features to include.
• Have students write for an assortment of audiences on the same topic.

---

### 3-5.T.C.2

• Create and display an anchor chart that defines key terms—such as author, audience, purpose, and context—for students to reference.
• After reviewing the term author’s perspective, show a short article or picture book and explain what the author’s perspective seems to be.
• Read aloud two short texts on the same topic (e.g., wolves as dangerous vs. wolves as endangered). With students, complete a Venn diagram or T-chart to compare what each author believes and what words/tone show this.
• During a read aloud, model identifying clues to author’s perspective. Pause to think aloud: “Hmm, the author uses the word ‘hero’ to describe the explorer. That tells me the author admires her.” Mark the text with symbols for clue words, opinion statements, and strong feelings or persuasive language.

---

### 3-5.T.SS.1

• Use a variety of texts to create two class anchor charts: one to identify the text features authors use to communicate (e.g., headings, captions, bold print), and another to identify the organizational structures authors use to present information (e.g., cause and effect, compare and contrast, sequence).
• Create a graphic organizer to compare and contrast text features and organizing structures.
• Using a jigsaw format, have students read sections of an authentic text in small groups. Then, bring the groups together to collaboratively identify the text features and organizational structures the author used.
• Give students scenarios where they must create texts for specific audiences and purposes. Ask them to use the anchor charts to decide which text features and organizational structures would be most effective and explain their reasoning.
• Use highlighters to identify and color code various text features and organizing structures and then label them.
• As a class, in small groups, or with elbow partners, evaluate the effectiveness of an author’s choice of text features and organizational structures based on the purpose and audience of a text.
• Utilize close readings of texts to identify words and phrases that authors use to link ideas and show relationships between ideas and information. Underline these words and phrases to emphasize their use and analyze how the use of these impacts the reader’s ability to understand the text.
• As a class, in small groups, or with elbow partners, analyze exemplary paragraphs in authentic texts.
• Provide students with sentence strips from exemplar paragraphs and have them work together to arrange the sentences in a logical order to form a cohesive paragraph.

---

### 3-5.T.SS.2

• Explicitly teach examples of figurative language appropriate to grade level. Take students on a scavenger hunt through texts, finding examples of figurative language throughout the text.
• Have students create a personal anchor chart of figurative language they find in the texts they read.
• Illustrate figurative language examples and label with an explanation of meaning.
• Give students a list of similes or metaphors (or other examples of figurative language) and have them sort them in different ways and explain their category choices.
• Play charades, acting out various examples of figurative language.
• Model analyzing the effectiveness of an author’s use of figurative language to explain meaning.
• Identify examples of figurative language in texts and model re-writing the examples to express the same or opposite meaning.
• Give students a basic sentence to start with (e.g., “The dog barked.”). Model revising the sentence by adding figurative language to make it more vivid or expressive (e.g., “The dog barked its head off,” or “The dog barked as if its tail were on fire.”).
• Model creating original examples of figurative language using a mentor text for inspiration.
• Give students practice time to create their own texts and incorporate or edit to add figurative language.

---

### 3-5.T.T.1

• Use mentor texts to describe, analyze, and apply narrative techniques. After modeling, have students identify and annotate the techniques they find.
• Model how to break down texts by examining mentor texts, facilitating discussion about the author’s choices.
• Introduce the components of narrative structure using visual story arcs. Have students apply this by charting narrative structure in both mentor texts and their own writing.
• Use graphic organizers (e.g., character maps, conflict charts) to help students organize and analyze the structure and elements of narrative texts.
• Model and practice “show, don’t tell,” teaching students to convey emotions, setting, and mood through specific sensory details, actions, and dialogue, rather than direct statements.
• Move from analysis to creation by having students write their own texts, applying the techniques previously studied (e.g., building suspense, developing characters, employing figurative language). Provide structured opportunities for feedback and revision.
• Engage students in peer review or group analysis of mentor texts, encouraging discussion around narrative choices and strategic revisions.
• Guide students in reflection on and discussing how themes are developed in mentor texts and their own writing.
• Engage students in collaborative storytelling where they take turns adding sentences or paragraphs to a collective text, focusing on previously taught narrative techniques and devices.

---

### 3-5.T.T.2

• Explicitly teach students how to recognize how key design elements (e.g., headings, captions, charts, etc.) contribute to meaning.
• Give students different expository texts. Create a scavenger hunt list (e.g., heading, subheading, diagram, caption, bold words) for students to use as they explore the different texts. Have students find and label each feature, then discuss how it helps readers understand the main idea.
• Use a narrative nonfiction or historical text (e.g., about a famous figure or event) to complete a SWBST chart (Somebody, Wanted, But, So, Then). Think aloud the answers to the questions, Why did they act that way? and What caused the outcome?
• Model for students how to evaluate the quality of supporting details. Read aloud a paragraph and think-aloud the questions, What are the strong facts? What are the weak or unrelated facts?
• Using historical and scientific texts that describe events (e.g., life cycle of a butterfly, how a bill becomes a law, etc.), model creating a timeline or flowchart of the events/procedures. Under each event/procedure, write why it happened using evidence from the text.
• Choose two texts on the same topic and, as a class, complete a Venn diagram listing unique ideas/details from Text A, unique ideas/details from Text B, and key points shared by both texts.
• Main Idea Match-Up Card Sort: Print out or display sentences or facts from different texts. Sort cards by key point/topic. Have students identify which text each card came from and explain how it supports the main idea.
• Model color-coding key ideas across texts. Assign each key point (e.g., problem, cause, solution) a color. As you read, highlight corresponding information in the same color across both texts, then explain how the texts contributed to that idea.
• Write or cut up a model expository paragraph into its parts: topic sentence, supporting detail #1, supporting detail #2, concluding sentence. In pairs or small groups, students reassemble the paragraph and explain the purpose of each piece.
• Show a short model paragraph that introduces a topic clearly, includes grouped supporting facts and precise vocabulary, and ends with a solid concluding statement. Then, give students a parallel topic and ask them to imitate the structure.

---

### 3-5.T.T.3

• Model identifying the author’s claim, supporting reasons, and linking words during read-alouds and other multimodal opinion texts.
• Use anchor charts to record features of opinion writing encountered in multimodal texts.
• Notice the opinion techniques found in a variety of multimodal texts (posters, written text, videos, etc.), noting the possibilities and limitations within the various modes.
• Model how to fill out a simple graphic organizer by thinking aloud as you find the author’s main claim, underline or highlight reasons, and add specific evidence from the text. Pause to explain how each part supports the author’s opinion. Show how organizing this information helps us understand what the author is trying to prove.
• Provide graphic organizers to support student text interpretation and understanding of claim, reasons, and evidence.
• Explicitly teach the difference between facts and opinions. Use clear examples and non-examples. Then guide students through a sorting activity where they categorize a variety of statements as either fact or opinion.
• Provide scrambled parts of an opinion writing text for students to order in a logical manner. Color code or layer in linking words to highlight the use of linking words to connect ideas.
• Provide opportunities for students to respond to opinion-based prompts based on given texts and for the construction of texts.
• Model thinking aloud to identify an opinion claim, use a graphic organizer for prewriting, choose the best multimodal format, and begin constructing the text.
• Foster classroom and small group discussions evaluating the effectiveness of an author’s claim, supporting reasons, and evidence as the foundation for discussions.

---

### 3-5.T.T.4

• Explicitly teach poetic techniques based on grade-level expectations. Include examples along with the definitions.
• Select a familiar poem and read the poem aloud to the class. Discuss the techniques used in the poem (e.g., rhyme scheme, imagery, stanza). After reading, ask students to identify specific techniques used in the poem and add to a class anchor chart.
• Engage in a class discussion about the effect of techniques on the reader’s experience (e.g., How does the rhyme make the poem feel? What pictures do you see when you hear these words?).
• Introduce each type of poetry (e.g., haiku, limerick, free verse, rhymed verse) with a simple definition and example.
• Model each type by writing a sample poem together as a class. Emphasize the unique characteristics of each form (e.g., syllable count for haiku, rhyme scheme for limericks).
• Host a poetry walk in which students read each other’s poems posted around the room and leave a sticky note for feedback (use sentence frames or stems to support students as they note rhyme scheme, stanzas, imagery, overall impact, etc.).
• After reading or performing a poem (either by the teacher or students), lead a discussion about the poet’s purpose and audience. Ask questions such as, What emotions or thoughts do you think the poet wanted to express? Which poetic techniques helped you connect with the poem?
• Create a class poetry anthology, highlighting the structure and types of poetry found in the grade progression.
• Provide students with a variety of poetry including content-related examples.
• Host a poetry reading to highlight students’ favorite poems and provide a discussion frame for students to explain the techniques used by the author that created a connection.
• Host a poetry reading to highlight student-created poetry. Provide a class-created rubric for students to use to score their poetry.

---

### 3-5.T.RA.1

• Model for students how to generate meaningful research questions using sentence stems such as: “I wonder why…”, “How does…”, and “What causes…”
• Model how to brainstorm a list of “I wonder” questions related to a broad topic (e.g., animals, natural disasters, inventions), as well as how to narrow those questions to be researchable and specific.
• Introduce students to the concept of credible sources, modeling how to evaluate a source using various characteristics (e.g., author credentials, date of publication, domain name).
• Create a source-sorting game by giving students mixed examples of real and fake sources and having them work in pairs to sort them as “credible” or “not credible.”
• Create a class “What Makes a Source Credible?” anchor chart. Model using a credible, student-friendly website to locate basic facts about a topic, and show students how to use a research organizer to gather information from those sources.
• Teach students how to use structured note-taking tools (e.g., 3-2-1 Organizer, Two-Column notes) to collect accurate and relevant information.
• Model for students how to summarize their research.
• Teach students to collaborate and extend their understanding through peer interaction. After initial research, have students pair up to share what they’ve learned. Each student must ask their partner at least one clarifying or extending question (e.g., “Why do you think that happened?” or “What more would you like to find out?”).

---

### 3-5.T.RA.2

• During a mini lesson, teach students how to check whether a source is credible and relevant. Provide two short texts on the same topic: one from a credible source and one from a less credible source. As a class, discuss what makes the credible source trustworthy (e.g., author credentials, organization reputation, factual tone).
• Create a class anchor chart with examples of credible sources and less credible sources.
• Provide students with a simple research log to note source title/author; key information or quote; why the info or quote is relevant; and citation information. Model completing the log with information from a class text.
• Through a think-aloud, model the construction of a “Fact Sandwich” where the top bread is the idea or topic, the filling is a fact, and the bottom bread is where you explain or connect the fact to the topic.
• Evidence Sort & Rank: Have students sort pieces of evidence from multiple sources into “strong,” “weak,” or “irrelevant” categories, then justify rankings.

---

<p>3-5.T.C.1</p>

<table>
  <thead>
    <tr>
      <th>Teacher Prompt</th>
      <th>Student Response</th>
    </tr>
  </thead>
  <tbody>
    <tr>
      <td>Choose a nonfiction article to read with students.</td>
      <td></td>
    </tr>
    <tr>
      <td>Say, Today, we’re going to read this article about plants and investigate its purpose and techniques. I'm going to think aloud while you follow along.</td>
      <td></td>
    </tr>
    <tr>
      <td>Model for students how the printed text can tell readers the purpose of the text.</td>
      <td></td>
    </tr>
    <tr>
      <td>Say, Listen to this sentence: “Sunlight provides plants with energy, which they use to create food in a process called photosynthesis.” This sentence is telling me a fact, I notice that there are a lot of facts in here, and that’s typical of expository texts to inform audiences.</td>
      <td></td>
    </tr>
    <tr>
      <td>Continue thinking aloud to show students how they can determine audience, pausing throughout the reading as appropriate.</td>
      <td></td>
    </tr>
    <tr>
      <td>Say, I notice that the author included a bolded vocabulary word here, which makes me think that this is probably written for kids.</td>
      <td></td>
    </tr>
    <tr>
      <td>Say, Now that we’ve thought through this text, let’s think about the purpose and audience in another text. This time, we will watch a video.</td>
      <td></td>
    </tr>
    <tr>
      <td>Watch a short clip with students and ask students to explain the text’s purpose and audience.</td>
      <td>Student responses may vary but could include:  <br><br>- I think this video is an opinion because the speaker talks about what she thinks, instead of facts, like in the Plants article. <br><br>- I believe the audience is kids because it is a cartoon and it includes a lot of vocabulary words I already learned.</td>
    </tr>
    <tr>
      <td>Say, Great work, class! You have really noticed details that help us know the intended purpose and audience for these texts! Now you are going to work in pairs to find the audience and purposes in these texts. Be sure to provide rationale to explain your thinking!</td>
      <td></td>
    </tr>
    <tr>
      <td>Provide students with additional multimodal texts to engage with in their groups as they repeat the activity.</td>
      <td></td>
    </tr>
  </tbody>
</table>

---

<p>3-5.T.C.2</p>
<h3>Evidence of Student Learning</h3>
<table>
  <thead>
    <tr>
      <th>Teacher Prompt</th>
      <th>Student Response</th>
    </tr>
  </thead>
  <tbody>
    <tr>
      <td>
        Choose a text to examine with students and provide students with a biography of the text’s author.<br><br>
        Read the text with the students and ask, <em>Based on the author’s biography, what do you think the text will be about? What do you think the author’s attitude towards the topic will be?</em>
      </td>
      <td>
        Student responses will vary but could include:
        <ul>
          <li>The author is a paleontologist, so I think the text will be about extinct animals or fossils.</li>
        </ul>
      </td>
    </tr>
    <tr>
      <td>
        Say, <em>Today we’re going to read a text this author wrote, and while we read, we’re going to be thinking about 4 things:</em><br>
        <ul>
          <li>the author (Who wrote this text?),</li>
          <li>perspectives (What are the thoughts around topics and themes?),</li>
          <li>purpose (Why was it written?), and</li>
          <li>context (What’s happening in the world at this time?)</li>
        </ul>
        Say, <em>This will help us understand the perspectives that may be found in texts. Let’s begin reading.</em><br><br>
        Read a chunk of text with students and pause to analyze portions that point to context, audience, author, or purpose.<br><br>
        Say, <em>The title of the text is The Short, Incredible Journey. Let’s continue reading.</em><br><br>
        <em>“There are woolly mammals all over the trail.”</em> What does that sentence from the text tell us about the context?<br><br>
        Now let’s look at the next sentence, <em>“The majestic and wise woolly mammoths guided us through the treacherous trails and journey ahead of us.”</em> What does the speaker think about woolly mammoths? What is the sentiment around the journey?

        Say, <em>Great effort, class! We were able to see how the words the author used pointed us to his perspective. Now we’re going to work in groups. After each paragraph, pause and ask yourselves if you learned anything about the author, perspectives, purpose, or context.</em><br><br>
        Provide sentence stems, if needed.
        <ul>
          <li>I think the author feels ___ because they said ___.</li>
          <li>The author’s word choice, like ___, shows they believe ___.</li>
          <li>The author seems to care about ___ because ___.</li>
        </ul>
        Allow students to share out their findings at the end of the lesson.
      </td>
      <td>
        Student responses will vary but could include:
        <ul>
          <li>It tells us the time period. I know it’s a long time ago because woolly mammoths have been extinct.</li>
          <li>The narrator thinks positively about the woolly mammoths because he calls them “majestic” and “wise.”</li>
          </ul>
         Student responses may vary but could include:
        <ul>
          <li>In our group, we found that the narrator had conflicting perspectives around the journey. This is because the narrator calls the journey “incredible” but also “heart-breaking.”</li>
        </ul>
        
      </td>
    </tr>
    <tr>
    </tr>
  </tbody>
</table>

---

<p>3-5.T.SS.1</p>

<table>
  <thead>
    <tr>
      <th>Teacher Prompt</th>
      <th>Student Response</th>
    </tr>
  </thead>
  <tbody>
    <tr>
      <td>
        <p>Select a variety of short nonfiction texts which utilize identifiable text features and organizational structures.</p>
        <p>Say to students, Today we are going to examine these texts and ask ourselves how the authors organized them and used particular features to support clear communication and understanding. We’re going to create anchor charts to help us see these features and structures and then use them in our own writing. Let’s start with this first text. What features do you see?</p>
        <p>Show the cover/page of the first text and ask students,</p>
        <ul>
          <li>What do you notice about how this page looks?</li>
          <li>What grabs your attention?</li>
          <li>How does this help you understand the topic?</li>
        </ul>
        
        <p>Read the first page of the text together, pausing to model identifying key text features (e.g., title, subheadings, bold words, captions, diagrams/photos, glossary).</p>  
        <p>With students, create a Text Features Anchor Chart. For each feature, include the name of the feature, an example from the text, and the purpose/why the author used it.</p>   
        
        <p>Say, These features help us understand the text and what the author wants us to better understand. What do we notice about the text itself? How is it organized? Think about that while I reread this section.</p> 
        Reread a short section from the text, focusing on the organizational structure.
      </td>
      <td>
        <p>Student responses will vary but could include:</p>
        <ul>
          <li>There are bold words in the paragraphs.</li>
          <li>There’s a map and pictures with captions.</li>
          <li>I noticed the timeline at the bottom, and it makes me want to look closer.</li>
          <li>The headings tell me what each part is going to be about so I don’t get confused.</li>
        </ul>
      </td>
    </tr>
    <tr>
      <td>
        <p>Ask students, How did the author organize this information? Is the author explaining steps, comparing things, or showing cause and effect? Is it written from first to last, which is chronological order?</p>
      </td>
      <td>
        <p>Student responses will vary but could include:</p>
        <ul>
          <li>It’s organized by explorer. Each section is about a different person.</li>
          <li>The author is mostly showing cause and effect. It says people wanted spices, so explorers went to find new trade routes.</li>
          <li>A lot of the book is in time order. It starts with early explorers and then shows later ones.</li>
        </ul>
      </td>
    </tr>
    <tr>
      <td>
        <p>Divide students into small groups. Give each group a different, short nonfiction text.</p>
        <p>Assign roles: reader, recorder, feature finder, structure detective.</p>
        <p>Have each group find 2-3 text features and mark them with sticky notes, labeling the note with the type of feature and the evidence from the text. Students will then determine the organizational structure of the text and add that to another sticky note, adding text evidence to support their answer.</p>
        <p>Circulate while students are working, providing support and feedback as needed.</p>
        <p>Have each group share one feature and one structural element they found. Add any new findings to the anchor chart, if applicable.</p>
      </td>
      <td></td>
    </tr>
  </tbody>
</table>

----

<p>3-5.T.SS.2</p>
<table>
  <thead>
    <tr>
      <th>Teacher Prompt</th>
      <th>Student Response</th>
    </tr>
  </thead>
  <tbody>
    <tr>
      <td>
        <p>Review previously taught figurative language devices including the definition, examples, and a reason an author may use it.</p>
      </td>
      <td></td>
    </tr>
    <tr>
      <td>
        <p>Write a plain sentence on the board. For example, The sun was shining. Ask students, How can we make this sentence more interesting or creative?</p>
        <p>Model adding figurative language to the sentence such as:</p>
        <ul>
          <li>The sun smiled down on us. (Personification)</li>
          <li>The sun was a glowing fireball in the sky. (Metaphor)</li>
        </ul>
      </td>
      <td></td>
    </tr>
    <tr>
      <td>
        <p>Say to students, Remember that authors often use figurative language to describe or explain an idea. These words or ideas are not literal explanations. For example, to describe how positive someone is feeling, we might say, “I’m on top of the world!” I wouldn’t actually be on the top of the world because that would be silly! But someone would be able to understand just how happy am I based on the figurative language I used.</p>
      </td>
      <td></td>
    </tr>
    <tr>
      <td>
        <p>Say, Today, we are going to continue learning about figurative language and why an author would use it in a text.</p>
      </td>
      <td></td>
    </tr>
    <tr>
      <td>
        <p>Read a short mentor text that uses figurative language. Pause, identifying a few figurative language examples together.</p>
        <p>Ask, What does this sentence really mean? How does it make the writing better?</p>
      </td>
      <td>
        <p>Student responses will vary but could include:</p>
        <ul>
          <li>“The wind howled through the trees” means that the wind was blowing really hard and making a loud sound. It helps me imagine the sound of the wind and makes the story feel a little spooky.</li>
        </ul>
      </td>
    </tr>
    <tr>
      <td>
        <p>Model creating an original figurative sentence as a class:</p>
        <ul>
          <li>Choose a topic (e.g., storm, homework, ice cream).</li>
          <li>Together, brainstorm one example of a simile, metaphor, personification, and hyperbole.</li>
        </ul>
      </td>
      <td></td>
    </tr>
    <tr>
      <td>
        <p>Say to students, Now, you’re going to try this with a partner. I’d like for you to choose a topic (not ice cream) and write one original sentence about that topic for each of the four types of figurative language we’ve talked about today. That means you’ll have four total sentences: one with a simile, one with a metaphor, one with personification, and one with hyperbole.</p>
        <p>Say, Write each sentence on a different sticky note. When you’ve written all four, bring your sticky notes to the chart paper on the board and put each one in the correct box. So, you’ll put your sentence with the simile in the box labeled Simile, the one with a metaphor in the box labeled Metaphor, and so on. Once everyone has put their sticky notes on the chart paper, we’ll discuss and see what we think.</p>
      </td>
      <td>
        <p>Student responses will vary but could include:</p>
        <ul>
          <li>The ice cream melted like a snowman on a sunny day.</li>
          <li>The ice cream was a cold, creamy dream in a cone.</li>
          <li>The ice cream begged me to take one more bite.</li>
          <li>This is the biggest ice cream cone in the whole world!</li>
        </ul>
      </td>
    </tr>
    <tr>
      <td>
        <p>Circulate while students are working, providing feedback and support as needed. Once all groups have added their sticky notes to the chart paper, read a few aloud and decide as a class if the sentence matches the correct device.</p>
      </td>
      <td></td>
    </tr>
    <tr>
      <td>
        <p>Have students choose one of their figurative sentences and expand it into a short paragraph or description, incorporating at least one more figurative language device. For example:</p>
        <ul>
          <li>Original sentence: The storm growled like a dog.</li>
          <li>Expanded description: The storm growled like an angry dog. Lightning danced across the sky and the wind screamed through the trees.</li>
        </ul>
      </td>
      <td></td>
    </tr>
    <tr>
      <td>
        <p>Invite students to read their figurative language descriptions aloud. Ask the class, What type of figurative language did you hear? What picture did it paint in your mind?</p>
      </td>
      <td>
        <p>Student responses will vary but could include:</p>
        <ul>
          <li>I heard a simile in the sentence The storm growled like an angry dog.</li>
          <li>It made me picture a storm cloud making a growling face and making a scary noise.</li>
        </ul>
      </td>
    </tr>
    <tr>
      <td>
        <p>As an exit ticket, have students choose their favorite figurative sentence from the lesson and write it on an index card or sticky note. They will label the type and write one sentence explaining why they like it and what effect it has.</p>
      </td>
      <td></td>
    </tr>
  </tbody>
</table>

---

3-5.T.T.1

<table>
  <thead>
    <tr>
      <th>Teacher Prompt</th>
      <th>Student Response</th>
    </tr>
  </thead>
  <tbody>
    <tr>
      <td>
        Using a shared class reading, choose an excerpt of text to analyze with the class (example below).<br><br>
        Say, Today, we are going to zoom into our story and see what we can learn about our main character, Natalia, and how the author helped us come to this understanding. Let’s look at the excerpt below:<br><br>
        Natalia looked at the test in front of her. She looked at her teacher who gave Natalia a reassuring smile. Natalia thought, I can do this. She picked up her pencil, sat up straight in her chair, and started writing her essay. She wasn’t going to cry this time!
      </td>
      <td></td>
    </tr>
    <tr>
      <td>
        Ask students, What did we learn about our character in this interaction and how did you figure it out?
      </td>
      <td>
        <p>Student responses will vary but could include:</p>
        <ul>
          <li>Natalia feels a lot more confident taking the test this time around. I could tell because she sat up straight like she is ready.</li>
          <li>Natalia is not scared of the test this time. She said, “I can do this.” I think the teacher’s smile helped her remember all the tutoring and hard work Natalia put in.</li>
          <li>I noticed a change in Natalia. She cried the last time a test was in front of her, but now she knows she can do it.</li>
        </ul>
      </td>
    </tr>
    <tr>
      <td>
        If needed, provide support by asking:
        <ul>
          <li>What might Natalia be nervous or worried about?</li>
          <li>Why do you think the author included the line, “She wasn’t going to cry this time”?</li>
          <li>What does the thought, “I can do this” tell us about Natalia?</li>
        </ul>
      </td>
      <td></td>
    </tr>
    <tr>
      <td>
        Say, Great effort! We noticed shifts in Natalia’s attitude and her thoughts, like I can do this, and actions, like sitting up straight in her chair, helped us figure that out. Authors add clues to help us get insights into characters, and a way they can reveal that is through a character’s words, thoughts, actions or feelings.
      </td>
      <td></td>
    </tr>
    <tr>
      <td>
        Ask, What did we learn about Natalia as a character?
      </td>
      <td>
        <p>Student responses will vary but could include:</p>
        <ul>
          <li>We learned that Natalia has a lot of determination and she’s not going to give up.</li>
          <li>We learned that Natalia believes hard work pays off and is a hard worker.</li>
        </ul>
      </td>
    </tr>
    <tr>
      <td>
        Say to students, Now, in your writer’s notebook, finish one of these sentences so you’re telling what we learned about her and how you know:
        <ul>
          <li>Natalia is the kind of person who ___.</li>
          <li>This moment in the story shows that Natalia is ___. </li>
        </ul>
      </td>
      <td></td>
    </tr>
    <tr>
      <td>
        Say, Authors show us who a character is by giving us clues — in what they say, think, do, or feel. Good readers pay attention to these clues so we can really understand the character — just like we did with Natalia today!
      </td>
      <td></td>
    </tr>
  </tbody>
</table>

----
<p>3-5.T.T.2</p>

<h2>Evidence of Student Learning</h2>

<table>
  <thead>
    <tr>
      <th>Teacher Prompt(s)</th>
      <th>Student Response</th>
    </tr>
  </thead>
  <tbody>
    <tr>
      <td>
        Briefly review the difference between facts and opinions and explain that today the focus is on facts and the details that support them.<br><br>
        Say, Today, we’re going to be detectives, but not the kind who look for clues to solve mysteries. We’re going to look closely at a piece of nonfiction text to find out how the author uses facts and details to support their ideas.<br><br>
        Use a short nonfiction paragraph on a topic such as “Why Bees Are Important.” Read it aloud once for general understanding.  <br><br>
        Say, We’re going to read this paragraph again but more closely, and we’ll think about how the author presents facts and supports them with details.  <br><br>
        Read the first sentence aloud: Bees are very important because they help plants grow, make food, and keep nature healthy.  <br><br>
        Say, Hmm. This is the author’s main point or idea—that bees are very important. Now I need to figure out how the author proves this. What do I need to look for?  <br><br>
        Say, That’s right! So, listen to the next sentence and raise your hand when you hear me read a fact or a detail about bees being important. <br><br>
        Read the next sentence: When bees fly from flower to flower, they carry pollen, which helps fruit, vegetables, and flowers grow.  <br><br>
        Say, I saw some hands go up! Here’s a fact about what bees actually do—they carry pollen. The author explains that this helps plants grow. That’s a supporting detail that shows why bees are important.
      </td>
      <td>
         <br><br><br><br><br><br><br>Student response: <br><br>
        - A fact or a detail
      </td>
    </tr>
    <tr>
      <td>
        <br>Read the next sentence: This is called <b>pollination</b>.  <br><br>
        Say, See how <b>pollination</b> is in bold print? The author gives a vocabulary word to explain this process—that’s another way to support the main idea. <br><br>
        Next sentence: Without bees, we wouldn’t have many of the foods we eat, like apples, strawberries, and tomatoes.  <br><br>
        Say, Whoa! This is a strong detail. The author is helping me understand the impact of bees by naming foods we’d miss without them.   <br><br>
        Next sentence: Bees also help plants that animals need for food and shelter.  <br><br>
        Say, Another fact! Bees help animals, too—not just people. That’s more support for the idea that bees keep nature healthy.  <br><br>
        Read the final sentence: So, bees may be small, but they do a big job for the earth! <br><br>
        Ask, What do you think the author wanted to do with this sentence?
      </td>
      <td>
        <br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br>Student responses will vary but could include: <br><br>
        - Remind the audience what the paragraph was about. <br><br>
        - Summarize the details without saying the exact same thing.
      </td>
    </tr>
    <tr>
      <td>
        Say, Yes! This sentence wraps up the paragraph. It’s restating the main point in a creative way—bees are small but very important. All the facts and details we read before helped support this idea. <br><br>
        Say, Now you’re going to practice finding the main idea, facts, and supporting details in a different text titled “Why Trees are Important.”  <br><br>
        Students will work with a partner to find the main idea, facts, details, and concluding statement in the new paragraph. Circulate, providing feedback and support as needed.  <br><br>
        Ask a few groups to share their findings from the new paragraph.
      </td>
      <td>
        <br><br><br><br><br><br><br><br><br><br>Student responses will vary.
      </td>
    </tr>
  </tbody>
</table>

----

<!-- Evidence of Student Learning for 3-5.T.T.3 extracted and formatted as requested. Source: :contentReference[oaicite:0]{index=0} -->

<p>3-5.T.T.3</p>

<table>
  <thead>
    <tr>
      <th>Teacher Prompt</th>
      <th>Student Response</th>
    </tr>
  </thead>
  <tbody>
    <tr>
      <td>
        <i>*For this example, the class previously completed a graphic organizer where they brainstormed their thoughts on the topic “Should kids have screen time limits?” Student reasons for and against screen time limits were listed, and a claim for and against screen time was created.</i><br><br>
        Say to students, Let’s review the anchor chart we created. Turn to your neighbor and state your claim, or response, to the question: Should kids have screen time limits? Remember to state your claim in a complete sentence.<br><br>
        Ask a few students to share their claim.
      </td>
      <td>
        Student responses will vary but could include:
        <ul>
          <li>Kids should have screen time limits because too much screen time can be bad for their health and learning.</li>
          <li>Kids shouldn't have screen time limits because screen time can help them learn new things and connect with friends.</li>
        </ul>
      </td>
    </tr>
    <tr>
      <td>
        Say, Now, select the strongest reason to support your opinion that would also MOST appeal to your audience, which are parents. Share this reason with your partner. Be sure to use a complete sentence.<br><br>
        Circulate while students discuss their reasons.
      </td>
      <td>
        Student responses will vary but could include:
        <ul>
          <li>When kids are on screens too much, they might not read, play outside, or spend time with family.</li>
          <li>Sometimes, kids need screens to do school projects or research.</li>
        </ul>
      </td>
    </tr>
    <tr>
      <td>
        Say to students, I heard some strong claims. Who will share a claim? Let’s give a thumbs up or down for clarity. If you didn’t think the claim was clear, how would you edit it?<br><br>
        Ask a few students to share their claims. If all thumbs are up, ask what makes the claim clear and strong. If some thumbs are down, ask students to provide feedback to make the claim strong.
      </td>
      <td></td>
    </tr>
    <tr>
      <td>
        Say to students, I told you that your audience was parents. Parents sometimes want other people’s opinions to determine what is best for their kids. This could be about screen time. You are going to write to influence them for or against screen time limits. What kinds of reasons and evidence do you think would interest parents? Turn and talk to your partner.<br><br>
        Circulate while students are discussing, providing support and feedback as needed. Ask a few students to share their reasons.
      </td>
      <td>
        Student responses will vary but could include:  
        <ul>
          <li>When I use my tablet at night, I don’t fall asleep easily and I feel tired in the morning. Getting enough sleep is important for my brain to work at school.</li>
          <li>I use my tablet or computer for homework. Sometimes I need to look up answers or watch videos that help me understand things better. It makes my schoolwork easier and it doesn’t take too long to finish!</li>
        </ul>
      </td>
    </tr>
    <tr>
      <td>
        Say to students, Thinking about our audience, let’s review our reasons. Do you think these reasons would convince your parents? Should we edit these or add other reasons to our list?
      </td>
      <td>
        Student responses will vary but could include:
        <ul>
          <li>These are really strong reasons and I don’t think we should change them.</li>
          <li>My parents always want me to learn new things and I could do that on my tablet, so we should add that.</li>
        </ul>
      </td>
    </tr>
    <tr>
      <td>
        Say to students, Through your research and your own experiences of having or not having screen time limits, you have developed a perspective of what is best for children your age. Today you are going to begin crafting a response to the question: Should kids have screen time limits?<br><br>
        Say, Remember, your audience is parents who want to make the best decision for their children. I'm going to give you a blank graphic organizer to help you develop your claim, reasons, and evidence. We have reviewed strong claims, and here is an example on our anchor chart.<br><br>
        Say, We have also reviewed reasons that would appeal to our audience, parents. I’m going to set my timer. On your graphic organizer, write one claim to the prompt and list reasons to support your claim. Tomorrow, we’ll start constructing a text based on our claim and reasons.
      </td>
      <td>
        Students will write their claims and list their supporting reasons. The teacher will circulate to ensure students respond in clear and complete sentences.
      </td>
    </tr>
  </tbody>
</table>

----
<h2>3-5.T.T.4</h2>

<table>
  <thead>
    <tr>
      <th style="text-align:left;">Teacher Prompt</th>
      <th style="text-align:left;">Student Response</th>
    </tr>
  </thead>
  <tbody>
    <tr>
      <td>Activate prior knowledge by asking students, What do you already know about poetry? Can anyone tell me about a poem you’ve read that you really liked? What are some things that make poems special?</td>
      <td>
        Student responses will vary but could include:
        <ul>
          <li>Poetry is like stories, but it sounds different because it has rhyme. Some poems make you feel happy, sad, or even excited.</li>
          <li>I liked a poem by ___ because it talks about flowers in a really beautiful way, and it made me think about nature.</li>
          <li>What makes poems special is that they can be about anything, even small things like a tree or the rain, but they can make you think about them in a new way.</li>
        </ul>
      </td>
    </tr>
    <tr>
      <td>Say, Today, we’re going to talk about some special poetic techniques that we are going to see in the poems we’re going to study. We’ll also learn about a few types of poetry, too.</td>
      <td></td>
    </tr>
    <tr>
      <td>Create a class anchor chart with student-friendly definitions and examples of rhyme, rhyme scheme, stanza, and structure.</td>
      <td></td>
    </tr>
    <tr>
      <td>Say, We’ve talked about those four poetic techniques, and now, we’re going to look at a few poems to answer the question, How do poets use techniques like rhyme and rhyme scheme to connect with readers?</td>
      <td></td>
    </tr>
    <tr>
      <td>Say, Today, we’re going to explore a new type of poem. You’ll learn how to spot and use special poetry techniques, and by the end of the week, you’ll write and share your own poem!</td>
      <td></td>
    </tr>
    <tr>
      <td>Read aloud a few lines from a familiar poem, pointing to the class anchor chart and explaining which technique is used and how it works.</td>
      <td></td>
    </tr>
    <tr>
      <td>Say, Now we’re going to look at one type of poems--limericks. Pay attention to the words of this limerick while I read it out loud.</td>
      <td></td>
    </tr>
    <tr>
      <td>Read aloud a limerick, such as:<br>
        There once was a cat with a hat,<br>
        Who loved to chase this and that.<br>
        He’d pounce and he’d play,<br>
        All night and all day,<br>
        Till he finally caught a small rat!
      </td>
      <td></td>
    </tr>
    <tr>
      <td>Ask students, What did you notice about this poem?</td>
      <td>
        Student responses will vary but could include:  
        <ul>
          <li>It sounded really silly!</li>
          <li>There were some rhyming words.</li>
        </ul>
      </td>
    </tr>
    <tr>
      <td>Write the poem on the board and ask students what else they notice now that they can see the lines.</td>
      <td>
        Student responses may vary but could include:  
        <ul>
          <li>There are five lines.</li>
          <li>There’s rhyme at the end of the lines, but they don’t all rhyme with each other.</li>
        </ul>
      </td>
    </tr>
    <tr>
      <td>Say, I’m going to read the poem out loud one more time, and I want you to follow along with the lines on the board.</td>
      <td></td>
    </tr>
    <tr>
      <td>Read through the limerick again. Once finished, ask students, Who can tell me about any rhyming words and where those words are in each line?</td>
      <td>Student responses may may but could include: <br/>Cat and hat; hat and that; play and day; cat, hat, that, and rat</td>
    </tr>
    <tr>
      <td>Focus students’ attention on the end rhyme and say, This first line ends with <em>hat</em>, and circle the word. Say, The next line ends with <em>that</em>, and circle the word. Do the same for the remaining lines.</td>
      <td></td>
    </tr>
    <tr>
      <td>Say, Look at the last word in each line which is the word that I circled. The word at the end of that line is <em>hat</em>. Let’s give the first line the letter A. Now, only looking at the words I circled, who can tell me which of those circled words rhymes with <em>hat</em>?</td>
      <td>Student response: <br/> that and rat</td>
    </tr>
    <tr>
      <td>Say, Yes! <em>Hat</em>, <em>that</em>, and <em>rat</em> all rhyme, so they get the letter A. Now look at the last word in the other lines. Do <em>play</em> or <em>day</em> rhyme with <em>hat</em>, <em>that</em>, and <em>rat</em>?</td>
      <td>Student response: <br/> No</td>
    </tr>
    <tr>
      <td>Say, Since <em>play</em> and <em>day</em> don’t rhyme with <em>hat</em>, <em>that</em>, and <em>rat</em>, they can’t get the letter A. Let’s look at <em>play</em> and <em>day</em>. What do you notice about those two words?</td>
      <td>Student response <br/> Play and day rhyme!</td>
    </tr>
    <tr>
      <td>Say, Yes! <em>Play</em> and <em>day</em> rhyme with each other, so they get the letter B. So, let’s look at the letters that I put at the end of each line. We have AABBA. That is our rhyme scheme. Every limerick has to have that same AABBA rhyme scheme. You may be looking at a silly poem, but if there isn’t an AABBA rhyme scheme, the poem will not be a limerick. However, limericks have other requirements other than being a silly poem and having an AABBA rhyme scheme, and we’ll talk about those tomorrow.</td>
      <td></td>
    </tr>
  </tbody>
</table>

----
<p>3-5.T.RA.1</p>
<table>
  <thead>
    <tr>
      <th>Teacher Prompt</th>
      <th>Student Response</th>
    </tr>
  </thead>
  <tbody>
    <tr>
      <td>Review the term research question. Ask students, What makes a strong research question?</td>
      <td>
        <ul>
          Responses will vary but may include:
          <li>- A strong research question is clear, focused, and specific. It should be something that can’t be answered with just “yes” or “no,” but instead needs explanation and facts.</li>
          <li>- A good research question helps guide your research by giving you something specific to look for. For example, instead of asking “Is pollution bad?” a stronger question would be “How does pollution affect ocean animals?”</li>
        </ul>
      </td>
    </tr>
    <tr>
      <td>Explain open-ended vs. closed questions. <br/><br/> Say, Closed questions have only one correct or short answer. An example is “Did the main character win?” <br/><br/>Say, Open-ended questions have more than one possible answer and require explanation or thinking. An example is “Why do you think the main character won or lost?”</td>
      <td></td>
    </tr>
    <tr>
      <td>Model turning a closed question into an open-ended one (e.g., “When was the moon landing?” → “Why was the moon landing important to space exploration?”).</td>
      <td></td>
    </tr>
    <tr>
      <td>As a class, brainstorm a list of topics of interest (e.g., animals, space, sports). In groups, students will choose one of the topics and then write two open-ended research questions about that topic on sticky notes.</td>
      <td>
        <ul>
          Responses will vary but may include:
          <li>- How do different types of marine mammals adapt to survive in their ocean environments?</li>
          <li>- How do human activities affect the lives of marine mammals?</li>
          <li>- What impact do changes in weather have on the migration and feeding patterns of marine mammals?</li>
        </ul>
      </td>
    </tr>
    <tr>
      <td>Once students have created their open-ended research questions, they will place their sticky notes on the class “Examples of Strong Research Questions” anchor chart.</td>
      <td></td>
    </tr>
    <tr>
      <td>Discuss a few of the questions as a class to determine if the question is closed or open-ended and why.</td>
      <td></td>
    </tr>
    <tr>
      <td>Provide students with a graphic organizer for their notes. For example, you might supply students with a sample Two-Column Notes template; this sample template is a Word document so that it can be adjusted for local curriculum considerations. It will download to the computer rather than open in a new window.</td>
      <td></td>
    </tr>
    <tr>
      <td>Explain how to use the graphic organizer so that the students capture their notes as they work to research their open-ended questions.</td>
      <td></td>
    </tr>
    <tr>
      <td>Review the term credible source (from a prior lesson), then say to students, You are going to use the two open-ended research questions you created for your chosen topic to research your topic using at least two different credible sources (print and/or digital).</td>
      <td></td>
    </tr>
  <tr>
    <td> Circulate while students are researching and recording answers to their questions, providing feedback and support as needed.  <br/> <br/> At the end of the instructional session, say to students, Tomorrow, you will take the facts you found and combine them as we start working on integrating and summarizing your information.  </td>
  </tr>
  </tbody>
</table>

-----

3-5.T.RA.2

<table>
  <thead>
    <tr>
      <th>Teacher Prompt</th>
      <th>Student Response</th>
    </tr>
  </thead>
  <tbody>
    <tr>
      <td>
        Review or pre-teach vocabulary needed for this lesson. Add terms and meanings to a class anchor chart.<br><br>
        - Credibility: Is this source trustworthy?<br>
        - Relevance: Does this information help me answer my research question?<br>
        - Evidence: Facts or quotes to support your idea.<br>
        - Citation: Giving credit to the source where you got your information. (5th grade)
      </td>
      <td></td>
    </tr>
    <tr>
      <td>
        Ask students, If you wanted to learn about sharks, where would you look? Why would you trust that source?
      </td>
      <td>
        Student responses may vary but could include:<br>
        - A science book from the library<br>
        - A well-known scientist’s website on sharks<br>
        - I would trust these sources because they are written by experts who study sharks.
      </td>
    </tr>
    <tr>
      <td>
        Facilitate a brief class discussion about trustworthy vs. untrustworthy information (e.g., a science book written by a shark expert vs. a blog post that says sharks are aliens) to teach students how to assess credibility and relevance.
      </td>
      <td></td>
    </tr>
    <tr>
      <td>
        Say to students, These are some questions you can use to help you decide if a source is credible and relevant.<br><br>
        - Who wrote this?<br>
        - Is the information accurate and believable?<br>
        - Is it from a trusted source?<br>
        - Does it help answer my research question?
      </td>
      <td></td>
    </tr>
    <tr>
      <td>
        Say to students, Now, you are going to look at three sources for a new topic and research question. The topic is sea turtles, and the research question is “Why are sea turtles endangered?” In your groups, you will read, view, or listen to three short sources and use your Credibility and Relevance questions to evaluate each source. Highlight 1-2 pieces of evidence and fill in the Source Tracker organizer.
      </td>
      <td></td>
    </tr>
    <tr>
      <td>
        While groups are working, circulate while providing feedback and support as needed. When students are finished, have groups share which source they found the most credible and why.
      </td>
      <td>
        Student responses may vary but could include:<br>
        - We thought the book was most credible because it was written by a scientist who studies turtles.<br>
        - We thought the website was most credible because it’s part of a college’s website.
      </td>
    </tr>
  </tbody>
</table>

######6-8

### 6-8.L.GC.1

**Overview of Standard**
As students approach graduation, they encounter and apply grammar, usage, and mechanics conventions in a wide range of academic and real-world contexts. Students will expand their understanding of word and phrase relationships, as well as how to use conventions to convey meaning. See the K-12 Grammar, Usage, & Mechanics (GUM) Chart for information regarding specific grade levels for introducing, continuing, and mastering these skills.

---

### 6-8.L.GC.2

**Overview of Standard**
In this standard, students build upon their prior knowledge of sentences and sentence structures to continue developing their syntactic awareness. Students analyze model sentences, using the syntax of those sentences to create their own. They also practice manipulating sentences and sentence parts, using skills such as sentence combining and sentence elaboration, to produce more sophisticated writing.  See the K-12 Grammar, Usage, & Mechanics (GUM) Chart for information regarding specific grade levels for introducing, continuing, and mastering these skills.

---

### 6-8.L.V.1

**Overview of Standard**
In this standard, students will acquire and use vocabulary with accuracy and precision. They will expand their vocabulary by studying words in context rather than in isolation. Students will explore a wide range of common words used across multiple subjects and in everyday language; words frequently used in academic contexts across various disciplines; and subject-specific terms essential for understanding particular fields or topics. Students deepen their understanding and ability to use words effectively across a range of contexts.

---

### 6-8.L.V.2

**Overview of Standard**
Students will increase their knowledge of word etymologies, Greek and Latin roots, root words, and affixes, as well as parts of speech. They will be able to analyze complex words based on their knowledge of etymologies, word parts, and parts of speech and apply those understandings to aid comprehension and to create new texts.

---

### 6-8.L.V.3

**Overview of Standard**
As students approach graduation, they encounter and internalize new vocabulary in a range of circumstances, and they apply their understanding of these new terms in a variety of real-world contexts. Students will expand their understandings of word relationships, as well as the effect of nuanced meanings and the way those meanings affect word choice.

The intent of this standard is to ensure that students can analyze and understand the meanings of words and phrases in different contexts and apply that understanding when reading, listening, writing, or creating. This involves interpreting meaning, recognizing nuance, and using words effectively in communication.

---


### 6-8.L.GC.1

**Vocabulary**
K-12 Glossary

Attributions
Capitalization
Clause
Colons
Comma
Conjunctive Adverbs
Correlative Conjunctions
Dialogue
Ellipses
End Punctuation
Essential phrases/clauses
Function
Hyphens
Nonessential phrases/clauses
Parentheses
Participle
Parts of Speech
Pronouns
 Demonstrative
 Intensive
 Vague
Quotation Marks
Semicolons
Textual Evidence
Verb
 Aspects
 Tenses

---

### 6-8.L.GC.2

**Vocabulary**
K-12 Glossary

Sentence Structure Patterns (<i>simple, compound, complex, compound-complex</i>)
Verb tense
Active and Passive Voice
Subject-Verb Agreement
Modifiers
Misplaced Modifiers
Dangling Modifiers
Modifier Phrases and Clauses

---

### 6-8.L.V.1

**Vocabulary**
K-12 Glossary

Academic Vocabulary
Disciplinary Vocabulary
General Vocabulary
Print Text
Digital Text
Multimodal Text

---

### 6-8.L.V.2

**Vocabulary**
K-12 Glossary

Affixes
Etymology
Morphology
Parts of Speech
Noun
Verb
Adjective
Adverb
Prefixes
Roots
Root Words
Suffixes

---

### 6-8.L.V.3

**Vocabulary**
K-12 Glossary

Analogies
Antonyms
Connotations
Contextual Clues
Denotations
Digital Sources
Meaning
Multiple-meaning Words
Nuances
Phrases
Print Sources
Reference Materials
Synonyms
Word Processing Features
Word Relationships
Words

---

### 6-8.L.GC.1

**Instructional Strategies for Teachers**
• Provide a supportive environment for writing.
• Have students analyze their own writing for patterns so that they grow and learn.
• Model strategies for students using mentor sentences and mentor texts.
• Use graphic organizers.
• Use and develop students’ academic and specialized vocabularies to support instruction.
• Use style guides and resources to make determinations when creating, revising, and editing texts.
• Explicitly teach strategies for planning and goal setting, drafting, evaluating, revising, and editing.

---

### 6-8.L.GC.2

**Instructional Strategies for Teachers**
• Reinforce understanding of sentence elements (subject, predicate, independent clause, dependent clause) and structures (simple, compound, complex, compound-complex).
• Allow students to examine models of good writing and model the analysis of well-written sentences.
• Model sentence imitation for students, using mentor text sentences and strong student-written sentences.
• Provide students opportunities to imitate mentor sentences in their own writing.
• Provide students opportunities to manipulate, add, and/or remove words in sentences through activities such as sentence scrambles, sentence combining, and sentence elaboration.

---

### 6-8.L.V.1

**Instructional Strategies for Teachers**
• Dedicate a portion of regular class time to explicit vocabulary instruction.
• Provide repeated exposure to new words in multiple contexts.
• Provide direct, explicit, and systematic instruction to teach difficult vocabulary.
• Select specific, high-utility words when identifying vocabulary words for study.
• Give students opportunities to use new vocabulary in a variety of contexts and modes (discussion, writing, presenting).
• Make explicit connections between the words and student work, in ELA as well as other content-area classes.
• Choose a brief, engaging piece of text that includes academic vocabulary as a platform for vocabulary instruction.
• Pre-teach difficult vocabulary.
• Use graphic organizers (including semantic maps).
• Leverage students’ prior knowledge to learn new vocabulary.
• Incorporate digital tools and strategies to learn, clarify, expand, and use vocabulary.
• Teach multiple meanings of words to foster word consciousness.

---

### 6-8.L.V.2

**Instructional Strategies for Teachers**
• Dedicate a portion of regular class time to explicit vocabulary instruction.
• Teach students to break down words into parts (roots, root words, prefixes, suffixes) to understand meanings.
• Teach students how words may change due to their part of speech (e.g., nominalization).
• Teach students how to research and locate a word’s etymology.
• Provide students with the opportunity to practice using word analysis skills.
• Teach students to use context and background knowledge to infer word meanings.
• Teach students how to combine word parts to create words based on their roots/root words and affixes.
• Incorporate digital tools and strategies to learn, clarify, expand, and use vocabulary.
• Teach students how and when to use structural word analysis to determine meanings.
• Visualize and reinforce word relationships.
• Use graphic organizers, like Frayer models.
• Leverage content area background knowledge by collaborating with content area teachers.

---

### 6-8.L.V.3

**Instructional Strategies for Teachers**
• Dedicate a portion of regular class time to explicit vocabulary instruction.
• Provided repeated exposure to new words in multiple contexts.
• Provide direct, explicit, and systematic instruction to teach difficult vocabulary.
• Give students opportunities to use new vocabulary in a variety of contexts and modes.
• Pre-teach difficult vocabulary.
• Use graphic organizers (including semantic maps).
• Leverage students’ prior knowledge to learn new vocabulary.
• Incorporate print and digital tools and strategies to learn, clarify, expand, and use vocabulary.
• Teach multiple meanings of words to foster word consciousness.
• Teach students to use context and background knowledge to infer word meanings.
• Visualize and reinforce word relationships.
• Use graphic organizers that show the relationships between words, such as the Frayer model.
• Collaborate with content area teachers to leverage content area background and vocabulary knowledge.

---
<h2>6-8.L.GC.1</h2>

<h3>Evidence of Student Learning</h3>

<table border="1" cellspacing="0" cellpadding="6" style="border-collapse: collapse; width: 100%;">
  <thead>
    <tr style="background-color: #f2f2f2;">
      <th style="width: 50%;">Teacher Prompt</th>
      <th style="width: 50%;">Student Response</th>
    </tr>
  </thead>
  <tbody>
    <tr>
      <td>Say to students, Good writing often uses pronouns to avoid repeating names or nouns, right? Let’s test your memory—what are some common pronouns?</td>
      <td>Answers may vary, but they will probably include pronouns such as she, he, they, we, us, them, I, you, me, his, its, ours, mine.</td>
    </tr>
    <tr>
      <td>Say to students, Does anyone remember the reflexive pronouns? What were those words? Do you remember the list?</td>
      <td>Words that use “self” or “selves”—myself, yourself, himself, herself, itself, ourselves, yourselves, themselves.</td>
    </tr>
    <tr>
      <td>Ask students, What were their purpose?</td>
      <td>To refer back to the subject.</td>
    </tr>
    <tr>
      <td>Ask students, Would you say that the sentence is using a reflexive pronoun?<br><br><em>I will go dine on steak myself.</em></td>
      <td>Yes</td>
    </tr>
    <tr>
      <td>Say to students, Today, we are looking at a cousin of those words. Intensive pronouns emphasize a noun or pronoun that appears earlier in the same sentence. They are identical in form to reflexive pronouns but serve a different function.</td>
      <td></td>
    </tr>
    <tr>
      <td>The word list is the same: myself, yourself, himself, herself, itself, ourselves, yourselves, themselves.</td>
      <td></td>
    </tr>
    <tr>
      <td>It may be useful to show the sample sentences side-by-side.</td>
      <td></td>
    </tr>
    <tr>
      <td>Say to students: Let me give you a sample sentence that uses an intensive pronoun:<br><br><em>I myself wouldn’t open that door, but it’s your decision.</em></td>
      <td></td>
    </tr>
    <tr>
      <td>Ask students, How is the usage of the intensive pronoun different than the reflexive?</td>
      <td>Answers may be on formation or style. There were words between the pronoun and its antecedent with the reflexive pronoun, but it’s side-by-side with the intensive pronoun version. It’s adding a punch.</td>
    </tr>
  </tbody>
</table>
---

<h2>6-8.L.GC.2</h2>

<h3>Evidence of Student Learning</h3>

<table border="1" cellspacing="0" cellpadding="6" style="border-collapse: collapse; width: 100%;">
  <thead>
    <tr style="background-color: #f2f2f2;">
      <th style="width: 50%;">Teacher Prompt</th>
      <th style="width: 50%;">Student Response</th>
    </tr>
  </thead>
  <tbody>
    <tr>
      <td>Provide students with the following sentences:<br><br>
        • The cat slept.<br>
        • The cat was tired.<br>
        • The dog barked.<br><br>
        Ask students, Are there any sentences in this group of three that could possibly be put together? (wait for students to respond Yes)
      </td>
      <td>Yes, there are two sentences about a cat that can be put together.</td>
    </tr>
    <tr>
      <td>Ask students, How could we put the two cat sentences together to make just one sentence?</td>
      <td><em>The cat slept because it was tired.</em></td>
    </tr>
    <tr>
      <td>--If students create a compound sentence instead of a complex sentence, provide scaffolding.<br><br>
        Say, I know that the cat slept because it was tired, so I was able to make a complex sentence from the two simple cat sentences.<br><br>
      </td>
    <tr>
      <td>
        Ask students, What word did we use to connect those two sentences? </td>
      <td>Because</td>
    </tr>
    <tr>
      <td>Ask students, Why did we decide to use the subordinating conjunction because when we combined sentences? </td>
      <td> The cat did something because it was tired.</td>
    </tr>
    <tr>
      <td> --If needed, review with students the reason for using because (there is a cause-and-effect relationship between tired and slept).
      </td>
    </tr>
    <tr>
      <td>Ask students, Now that I have a strong complex sentence, how can I add in the sentence about the dog barking? </td> <td>The cat slept because it was tired, and the dog barked. </td>
    </tr>
    <tr>
      <td>
        --If needed, provide scaffolding so students can create a compoundcomplex sentence. <br/> <br/> Say, Now I have an even stronger sentence that is compoundcomplex. We were able to take those three short simple sentences and turn them into a more sophisticated sentence. 
      </td>
    </tr>
    <tr>
      <td>
        Ask students, Why would sentencecombining be an important step during the revision process. 
      </td>
      <td>Student responses will vary, but they may focus on how it adds variety, makes their ideas more clear, or helps their writing flow better. </td>
    </tr>

    ---

    <h2>6-8.L.V.1</h2>

<h3>Evidence of Student Learning</h3>

<table border="1" cellspacing="0" cellpadding="6" style="border-collapse: collapse; width: 100%;">
  <thead>
    <tr style="background-color: #f2f2f2;">
      <th style="width: 50%;">Teacher Prompt</th>
      <th style="width: 50%;">Student Response</th>
    </tr>
  </thead>
  <tbody>
    <tr>
      <td>Say to students, We’re going to explore vocabulary, or the words we know and use to communicate. There are three main types of vocabulary we use: general words that we hear and say every day, academic words that help us understand schoolwork across subjects, and specialized words that you’d find in specific subjects like science or history. By learning to identify and use all three types, you’ll be able to express ideas more clearly and sound like a pro in any class or conversation!</td>
      <td></td>
    </tr>
    <tr>
      <td>Let's start by defining each type of vocabulary.<br><br>
      First, we have general vocabulary. These are words we use in our everyday lives, like <em>happy</em>, <em>problem</em>, or <em>idea</em>. They’re useful in casual conversation and are easy to understand because they’re familiar.<br><br> </td>
    </tr>
    <tr>
      <td>
      Ask students, Can anyone think of just a general word you use in your everyday life?</td>
      <td>Answers will vary: lunch, hand, note, game, call, sport, cheese</td>
    </tr>
    <tr>
      <td>Then, we have academic vocabulary. These words are often used in school, and they’re important because they help us express ideas more precisely and answer questions in ways that teachers expect. Words like <em>analyze</em> and <em>compare</em> are academic words—they help you describe what you’re doing in each subject.<br><br> </td>
    </tr>
    <tr>
    <td>
      Ask students, Can anyone think of another academic vocabulary word you use across all your classes?</td>
      <td>Answers will vary: read, write, speak, listen, collaborate, answer, explain, describe, project</td>
    </tr>
    <tr>
      <td>Finally, disciplinary vocabulary refers to words that belong to a specific subject or area of knowledge. In science, for instance, you might hear words like <em>photosynthesis</em> or <em>ecosystem</em>, which are not as useful outside of science but are very important when you’re talking about biology.<br><br> </td> 
    </tr>
    <tr>
    <td>
      Ask students, What’s another word you would most likely ONLY use in a science class?</td>
      <td>Answers will vary: vertebrate, aorta, molecule</td>
    </tr>
  </tbody>
</table>

---
<h2>6-8.L.V.2</h2>

<h3>Evidence of Student Learning</h3>

<table border="1" cellspacing="0" cellpadding="6" style="border-collapse: collapse; width: 100%;">
  <thead>
    <tr style="background-color: #f2f2f2;">
      <th style="width: 50%;">Teacher Prompt</th>
      <th style="width: 50%;">Student Response</th>
    </tr>
  </thead>
  <tbody>
    <tr>
      <td>Say to students, Today is about investigation and application—detective work.</td>
      <td></td>
    </tr>
    <tr>
      <td>Ask students, Have you ever come across a word that you didn’t know but could figure out anyway? How did you do it? What did you do?</td>
      <td>Answers may vary. They may say they have, but they are not sure how they did it. Some may discuss breaking a word down into its root, root word, and/or affixes. If so, more conversation can help bridge their answers back to the skill.</td>
    </tr>
    <tr>
      <td>Say to students, You may have done this by breaking down the word’s parts and thinking about its roots. Our goal today is to get good at deconstructing words—taking them apart to figure out their meaning—and constructing words, putting parts together to make new words that have real meanings.</td>
      <td></td>
    </tr>
    <tr>
      <td>Say to students, Many of the words we use today come from ancient Greek and Latin. The roots of these words tell us their basic meaning. For example, in the word <em>biology</em>, the root <em>bio</em> means “life,” and the suffix <em>-logy</em> means “the study of.” So <em>biology</em> is the study of life. Even if we’ve never seen that word before, we could probably guess what it means by knowing just those two parts.</td>
      <td></td>
    </tr>
    <tr>
      <td>Say to students, Roots and affixes are the building blocks of words. We’re going to focus on some common Greek and Latin roots and affixes—prefixes that go at the beginning and suffixes that go at the end. Let’s look at a few.</td>
      <td></td>
    </tr>
    <tr>
      <td>Write or project a few roots and affixes on the board and review meanings briefly. The list should be based on grade-level expectations.<br><br>
      <em>bio</em> (life), <em>geo</em> (earth), <em>pre-</em> (before), <em>-ology</em> (study of), <em>-meter</em> (measure)</td>
      <td></td>
    </tr>
    <tr>
      <td>Work through the roots and affixes with students, modeling how to use word parts to construct and deconstruct words.</td>
      <td>Students demonstrate their constructions and explain their deconstructions.</td>
    </tr>
  </tbody>
</table>

---

<h2>6-8.L.V.3</h2>

<h3>Evidence of Student Learning</h3>

<table border="1" cellspacing="0" cellpadding="6" style="border-collapse: collapse; width: 100%;">
  <thead>
    <tr style="background-color: #f2f2f2;">
      <th style="width: 50%;">Teacher Prompt</th>
      <th style="width: 50%;">Student Response</th>
    </tr>
  </thead>
  <tbody>
    <tr>
      <td>Say to students, Determining word meanings can rely on deciphering word relationships, relationships like synonyms (words with similar meanings), antonyms (words with opposite meanings), or analogies (comparisons showing relationships between pairs of words). Another way we understand words is by using contextual clues, or hints in sentences, to figure out what a word might mean.</td>
      <td></td>
    </tr>
    <tr>
      <td>Ask students, Can you share an example of two words that are synonyms?</td>
      <td>Answers will vary (e.g., happy and elated).</td>
    </tr>
    <tr>
      <td>Ask students, Can you share an example of two words that are antonyms?</td>
      <td>Answers will vary (e.g., happy and sad).</td>
    </tr>
    <tr>
      <td>Ask students, Can you share an example of an analogy? <br><br>
      <span style="font-style: italic;">[A mini lesson might be necessary on the analogy format/purpose if it is unfamiliar to students.]</span><br>
      Explain whatever they share. Think of the relationship between a dog and a puppy. A puppy is a young dog, right? Similarly, a kitten is a young cat. So, in this analogy, <em>dog</em> relates to <em>puppy</em> in the same way that <em>cat</em> relates to <em>kitten</em>. They both describe the young versions of those animals.</td>
      <td>Answers will vary (e.g., dog is to puppy as cat is to kitten).</td>
    </tr>
  </tbody>
</table>

----

### K-12.P.EICC.1

**Overview of Standard**
In this standard, students develop their reader and writer identities for both their personal and academic lives by building a toolkit to engage with texts both as consumers and producers. Students’ confidence will grow as they engage with and create various types of texts, allowing them to seek out new reading materials and writing opportunities. 

---

### K-12.P.EICC.2

**Overview of Standard**
In this standard, students engage in purposeful conversation as both author and audience to explore ideas, share knowledge, and respond to texts. Through these interactions, students make intentional connections within and across texts, deepening their understanding, constructing meaning, and using language to fulfill their purposes. 

---

### K-12.P.EICC.3

**Overview of Standard**
In this standard, students will read and comprehend a variety of complex texts across genres, disciplines, and purposes. They will preview texts, activate prior knowledge, set goals, and predict content. Students will also monitor their own understanding while asking questions and summarizing sections of the text, and then reflect on meaning, summarize the text, and apply what they’ve learned. 

---

### K-12.P.EICC.4

**Overview of Standard**
In this standard, students will create a variety of texts based on audience(s) and purpose(s). They will take an intentional journey through the writing processes such as planning, drafting, evaluating, revising, and editing, making choices based on the audience and purpose of the text. 

---

### K-12.P.ST.1

**Overview of Standard**
In this standard, students are encouraged to go beyond the surface of a text and consider the broader circumstances that shape its meaning and impact. Understanding the author’s life, purpose, and historical backdrop of the text will help students explain motivations, themes, and perspectives. Students will analyze how historical and contemporary events, along with technological developments, affect texts, helping them understand how ideas evolve over time. 

---

### K-12.P.ST.2

**Overview of Standard**
In this standard, students will become critical readers and intentional writers by understanding how texts are shaped to suit specific audiences and purposes. They will analyze how authors use language, structure, tone, and techniques to connect with their intended audience. Students will identify the purpose of a text and evaluate the effectiveness of the strategies and techniques used in achieving that purpose. They will also apply knowledge of audience and purpose when creating original texts, using text structures, text techniques, and stylistic choices to engage a target audience. 

---

### K-12.P.AC.1

**Overview of Standard**
In this standard, students will interpret texts by examining how an author’s craft choices, such as structure, language, tone, and techniques, shape meaning and influence the reader’s experience. They will identify specific techniques, analyzing the techniques’ purposes and effects, and evaluate how they connect to the reader’s own reactions, thoughts, decisions, and questions. Through this standard, students will develop deeper literary analysis skills, fostering critical thinking and personal engagement with texts. 

---

### K-12.P.AC.2

**Overview of Standard**
In this standard, students will construct texts by considering the target audience as they base decisions about craft choices, such as structure, language, tone, and techniques, on how they intend to shape meaning and achieve a specific purpose. They will integrate specific techniques to appeal to a target audience and craft words and phrases to influence the reader’s responses, thoughts, decisions, and questions. Through this standard, students will develop deeper literary skills as they utilize their knowledge of context, author, audience, and purpose to construct texts. 

---

### K-12.P.AC.3

**Overview of Standard**
In this standard, students will analyze how the design and structure of a text influence its effectiveness for different audiences and purposes. They will evaluate how the structure and features of a text support or interfere with its purpose. Students will make deliberate choices about text design when constructing their own texts, tailoring their approach to suit the intended audience and the specific purpose of the text. 

---

### K-12.P.CP.1

**Overview of Standard**
In this standard, students will articulate their thoughts clearly and listen to others effectively as they participate in structured group projects. Students will be active participants, holding each other accountable to maintain an amicable and productive group dynamic. They will engage in discussions to reach a consensus or solve a problem. They will use strategies for resolving conflicts, providing constructive feedback, and maintaining a growth mindset. This prepares students for real-world scenarios involving meaningful collaboration and communication to enhance their skills in engaging with others across a variety of settings and for different purposes. 

---

### K-12.P.CP.2

**Overview of Standard**
In this standard, students will use presentation skills effectively to communicate a variety of messages to different audiences. They will understand how to adjust their communication style depending on the audience and the purpose of the presentation. Students will gain insight into how audience perspectives affect communication. This standard will prepare students to engage in successful communication in educational and real-world settings. 

---

Here are all the **“Vocabulary”** sections extracted from the uploaded PDF, each labeled by its corresponding standard code.
Formatting follows your instructions — page headers, footers, and numbers are removed, and italic/bold are formatted using HTML tags.

---

### K-12.P.EICC.1

**Vocabulary**
Goals
Preferences
Interest
Relevance
Comprehension
Composition
Community
Independence
Autonomy

---

### K-12.P.EICC.2

**Vocabulary**
Dialogue
Analysis
Evaluation
Concepts
Processes
Problems
Solutions
Background
Knowledge
Skills
Ideas

---

### K-12.P.EICC.3

**Vocabulary**
Purpose
Goals
Comprehension
Prior Knowledge
Summarize
Visualize
Predictions
Inferences
Academic Vocabulary
Unfamiliar Words

---

### K-12.P.EICC.4

**Vocabulary**
Purpose
Audience
Goals
Modes
Genres
Structures
Craft techniques
Writing process
Comprehension
Composition

---

### K-12.P.ST.1

**Vocabulary**
Context
Prior knowledge
Background knowledge
Research
Purposes
Author
Audience

---

### K-12.P.ST.2

**Vocabulary**
Author
Audience
Context
Purpose
Interpret
Construct
Text design
Language structures
Craft techniques

---

### K-12.P.AC.1

**Vocabulary**
Author’s lens
Craft techniques
Literary techniques
Expository techniques
Opinion techniques
Rhetorical techniques
Target audience
Purpose
Word choice (diction)
Sentence structure
Syntax
Formats
Structures
Patterns
Features
Accessibility

---

### K-12.P.AC.2

**Vocabulary**
Craft techniques
Literary techniques
Expository techniques
Opinion techniques
Target audience
Purpose
Word choice (diction)
Sentence structure
Syntax
Formats
Structures
Patterns
Features
Accessibility

---

### K-12.P.AC.3

**Vocabulary**
Text design
Audience
Purpose
Modes
Multimodal texts
Genres
Features
Meaning
Tone
Style
Craft techniques

---

### K-12.P.CP.1

**Vocabulary**
Collaboration
Group discussions
Group norms
Shared Goals
Procedures
Productivity
Shared Project
Feedback

---

### K-12.P.CP.2

**Vocabulary**
Presentation
Purpose
Audience
Texts
Modes
Genres
Tone
Pace
Nonverbal gestures
Dialogue
Background knowledge
Recitation
Poems
Speeches

---

### **K-12.P.EICC.1**

**Instructional Strategies for Teachers**
• Have students create two identity charts: one for “Me as a Reader” and one for “Me as a Writer,” encouraging them to include their strengths, preferences, challenges, and goals.
• Introduce the concept of “writing identity” by sharing a well-known middle-grades author’s experiences as a writer.
• Have students reflect on their own writing journey, including a moment when they felt proud of their writing, a time when they struggled with writing, their favorite type of writing, and a writing goal they have for the future.
• Ask students to create a timeline of their reading experiences, including significant books, reading milestones, and memorable reading moments.
• Allow students to select texts that interest them, fostering ownership and motivation, and model book selection.
• Teach students how to generate their own discussion questions and take turns facilitating conversations.
• Allow students to form small groups based on shared reading interests. Provide a selection of books for students to choose from, encouraging autonomy.
• Analyze mentor texts to identify craft moves and structure, then have students emulate these techniques in their own writing.

---

### **K-12.P.EICC.2**

**Instructional Strategies for Teachers**
• Model analyzing text connections (“This reminds me of…”) and have students annotate their own textual connections.
• In small groups, have students take turns summarizing, questioning, and clarifying texts, fostering deeper comprehension and peer dialogue.
• Provide sentence and talk stems (e.g., “This was impactful because...”; “I believe the author included this because…”) to scaffold student responses and deepen dialogue.
• Pair students in inner/outer circles to discuss prompts, then rotate to new partners for varied perspectives.
• Assign roles (e.g., summarizer, questioner) during group reading to foster dialogue about the text’s meaning.
• Provide structured feedback that highlights strengths (e.g., “Your connection to the character’s conflict deepened our understanding”) to encourage critical thinking.

---

### **K-12.P.EICC.3**

**Instructional Strategies for Teachers**
• Clearly define why students are reading the text (e.g., to analyze tone, to understand a historical event).
• Encourage students to write personal reading goals before engaging with text.
• Encourage students to skim headings, subheadings, and any visuals to get a sense of the text's structure and content.
• Use KWL charts (Know, Want to Know, Learned) to connect new information to what students already know (activating and/or developing prior knowledge).
• Provide explicit instruction and opportunities for guided and independent practice in examining how text mode, genre, structure, and features aid in comprehension.
• Teach students to highlight or underline key ideas, make notes in the margins, and ask questions as they read, and create an anchor chart with annotation symbols and examples for students to use throughout the year.
• Explicitly teach summarization and annotation skills to students.
• Model and discuss metacognitive strategies (e.g., self-monitoring, rereading).
• Break the text into manageable chunks and have students summarize each section before moving on.
• Select and preview high-utility vocabulary words.
• Facilitate group discussions where students can share their insights and ask questions about the text.
• Assign tasks that require students to apply what they've learned from the text to new situations or problems.

---

### **K-12.P.EICC.4**

**Instructional Strategies for Teachers**
• Create a structured environment where students can focus on the different writing processes.
• Explicitly teach specific writing skills such as developing and supporting thesis statements and using transitions to create cohesion.
• Model the different aspects of the editing and revising processes, then set up learning stations focusing on the different parts of editing and revising.
• Create profiles for different audiences and discuss their needs and preferences.
• Model for students how they can revise their writing, keeping the content the same but focusing on a different audience.
• Provide targeted mini-lessons, breaking the writing process into bite-sized, focused lessons (e.g., identifying audience and purpose; writing an engaging hook; adding descriptive language or evidence; and using peer review constructively).
• Provide models of effective writing from familiar mentor texts.
• Allow students to use digital tools such as blogs, writing apps, and digital storyboards to enhance the writing process.
• Conference with students during each part of the writing process, asking guiding questions about their drafts, helping them clarify purpose or rework organization, and providing specific and actionable feedback to help students set and meet personal writing goals.
• Use wide-ranging texts to illustrate text techniques and structures. Have students analyze how authors use techniques to address different audiences and purposes, then apply those techniques in their own writing.

---

### **K-12.P.ST.1**

**Instructional Strategies for Teachers**
• Develop and use curated text sets—primary and secondary sources, films, art, maps, timelines, and artifacts—to build students’ contextual knowledge before or alongside reading anchor texts.
• Model how to identify and interpret context clues in texts by thinking aloud as you analyze passages.
• Demonstrate how to use context to infer the meaning of unfamiliar words and how context extends beyond vocabulary to include setting and time period.
• Introduce key background materials before reading (e.g., newspaper clippings, photos, government documents) and ask students to predict how these may have shaped the author’s choices or framed the audience’s interpretation.
• Design short, structured research tasks or jigsaws where students explore key contextual components (e.g., author’s background, time period, geography) relevant to a text.
• Use mentor texts from a wide range of contexts. Guide students to analyze how context influenced authorial decisions such as genre, tone, style, structure, and/or language.
• Use graphic organizers to track and synthesize contextual information while reading.

---

### **K-12.P.ST.2**

**Instructional Strategies for Teachers**
• Use a blend of comprehension, analysis, and writing strategies that emphasize author’s choice and audience awareness.
• Have students preview texts to activate prior knowledge and make predictions about content, purpose, and audience, focusing on how authors tailor their writing for specific readers and goals.
• Encourage students to generate questions before, during, and after reading such as: “Who is the intended audience?” and “What strategies does the author use to achieve their purpose?”
• Guide students in examining specific techniques such as word choice, figurative language, and point of view. Model for students citing evidence of these techniques and discussing their impact on the reader.
• Model the use of graphic organizers to help plan writing, focusing on audience and purpose.
• Incorporate peer feedback strategies where students evaluate each other’s drafts for effective use of strategies and techniques suited to the intended audience and purpose.
• Encourage students to keep a journal in which they reflect on how they interpreted a text and the strategies they used for that interpretation, as well as how they chose techniques in their own text creations in order to reach the audience.

---

### **K-12.P.AC.1**

**Instructional Strategies for Teachers**
• Have students engage routinely in conversations about the craft of writing.
• Review key terms like figurative language, word choice, sentence structure, and tone, and discuss how they impact meaning in texts.
• Utilize mentor texts that showcase specific craft elements.
• Guide students through multiple readings of a text, each time focusing on a different craft technique.
• Model how to analyze texts and identify author’s craft choices in a variety of different texts and genres.
• Model your thinking aloud as you read and analyze craft choices within texts.
• Provide students with opportunities for close reading and annotation to identify and discuss various craft elements in a variety of texts.
• Utilize anchor charts and graphic organizers to support students in synthesizing information as they explore author’s craft.

---

### **K-12.P.AC.2**

**Instructional Strategies for Teachers**
• Use high-quality mentor texts to model how authors make choices about language, structure, and style to engage specific audiences and fulfill specific purposes.
• Model for students how to identify and discuss craft techniques (e.g., tone, word choice, organization) and their impact on the reader.
• Have students identify the intended audience for different texts and discuss how the author’s choices reflect an understanding of that audience.
• Encourage students to define the purpose of their writing before drafting and to make craft choices that support that purpose.
• Implement structured peer review sessions where students evaluate each other’s drafts for effectiveness in addressing the intended audience and achieving the text’s purpose.
• Have students reflect on their writing choices in relation to audience and purpose, both before and after revision.
• Encourage multiple drafts, with each revision focusing on enhancing clarity, engagement, and appropriateness for the audience.
• Facilitate discussions about how context (time, place) influences both the creation and reception of texts.
• Use protocols like Socratic Seminars to deepen understanding of author decisions and audience impact.

---

### **K-12.P.AC.3**

**Instructional Strategies for Teachers**
• Use the Text Design Considerations (P.AC.3) resource to examine the various components that shape how texts are constructed and presented and to leverage these insights to strengthen instruction by helping students recognize, analyze, and apply the elements of text design.
• Select a single topic and provide students with multimodal texts (e.g., news articles, infographic, video) to provide access and exposure to different modes of communication. Have students identify the intended audience and purpose for each text, noting how design choices support the purpose(s).
• Facilitate group discussions where students compare how the same content is shaped differently depending on audience and purpose.
• Co-construct an anchor chart to help students delineate the most important information to look for in the lesson.
• Annotate a text for audience and purpose while modeling and verbalizing your thinking through a think-aloud to show students what the process may look like.
• Challenge students with the option of rewriting a text using different organizational structures.
• Have students construct text sets on a self-selected topic, using materials in different modes and genres.
• Allow students to work in groups or pairs in order to provide feedback and perspective on whether the text’s design effectively reached its intended audience and achieved its purpose.

---

### **K-12.P.CP.1**

**Instructional Strategies for Teachers**
• Model collaboration by demonstrating effective group behaviors such as active listening, respectful disagreement, and consensus-building. Use think-alouds to show how to navigate group decision-making.
• Discuss with students that true collaboration involves co-creating new ideas, not just dividing work or sharing answers. Use examples and reflection to help them recognize these distinctions in their own group work.
• Use checklists where students record their contributions and reflect on their group dynamics.
• Pose a question, have students think about a response individually, discuss with a partner, then share with the class.
• Coach students to give specific, actionable feedback to each other during group work. Use sentence starters and model constructive criticism.
• After collaborative tasks, have groups reflect on what worked well, what challenges they faced, and how they can improve their collaboration next time.
• Utilize collaborative digital workspaces for students to collaborate in real time—building and revising content, adding comments, and tracking contributions.

---

### **K-12.P.CP.2**

**Instructional Strategies for Teachers**
• Explicitly teach key presentation skills such as body language, eye contact, vocal variety, and use of visuals.
• Model effective presentations by delivering a sample presentation, deliberately demonstrating both strong and weak techniques (e.g., body language, pacing, eye contact). Have students use a rubric to evaluate your presentation, noting strengths (“Stars”) and areas for improvement (“Wishes”).
• Practice each skill in isolation before integrating them into full presentations.
• Use checklists or peer feedback forms to help students focus on specific skills during practice.
• Discuss how an author’s choices (e.g., tone, content, visuals) would change for different audiences or purposes.
• Provide sentence starters, graphic organizers, or outlines to support students in presentation planning.
• Allow students to practice in small groups before presenting to the whole class, gradually increasing audience size as confidence grows.
• Facilitate brief question-and-answer sessions after each group presentation to help students clarify their ideas, deepen understanding, and practice responding to audience questions.
• Have students analyze sample presentations to identify how language, tone, and content shift based on audience and purpose.
• Use role-playing activities where students must adapt their message for different audiences (e.g., presenting the same topic to peers vs. school administrators).
• Facilitate structured peer feedback and encourage self-reflection, where students can set goals for their next presentation based on the feedback received.
• Incorporate opportunities to memorize and perform short speeches, monologues, or poetry to engage with the auditory elements of the text and to practice expressive delivery through experimenting with rate, prosody, and tone to achieve various effects.

---

### K-12.P.EICC.1

**Evidence of Student Learning**

<table>
  <thead>
    <tr>
      <th>Teacher Prompt</th>
      <th>Student Response</th>
    </tr>
  </thead>
  <tbody>
    <tr>
      <td>
        Provide students with a selection of short texts divided into areas of interest. Make sure each text includes figurative language, connotative language, and/or literary devices that contribute to meaning, tone, and/or mood.<br><br> </td>
      <td>Have students get into their pre-determined groups based on reading interests.</td>
    </tr>
    <tr>
      <td>
        Say to students, We have been studying how authors use figurative language and other literary devices to help add to the mood and tone of a text.<br><br>
        Conduct a short review of figurative language, literary devices, mood, and tone.<br><br> </td>
    </tr>
    <tr>
        <td>
        Say to students, Today, you are going to read one of the texts your group has received and determine how the author used figurative language and other literary devices to set the mood of the text. As you read your text, highlight or annotate the figurative language and literary devices you find, and make notes on how those devices contribute to the mood. </td>
        <td>Within their group, students will choose a text from the selection provided.<br><br></td>
    </tr>
    <tr>
      <td>
        Provide students with independent reading time, circulating around the room to gauge students’ ability to recognize examples of figurative language and literary devices.<br><br> </td>
      <td>Students will read independently, highlighting and/or annotating the various examples of figurative language and literary devices.</td>
    </tr>
    <tr>
      <td>
        When students have finished reading independently, say, Now that you have finished reading, write down one discussion question you want to ask the rest of your group members about what they marked in the text.</td>
        <td>Students will jot down one discussion question they would like to ask their group members. <br/><br/>  </td>
    </tr>
    <tr></tr>
      <td>
        <br/>Say, Once everyone has written a question, begin the group discussion and continue until all questions have been asked and answered.<br><br>
      </td>
      <td> Students will ask and answer each of the group’s discussion questions.</td>
    </tr>
    <tr>
        <td>Visit each group at least once, listening to the questions and answers, without participating in the conversation. <br/><br/>
        <em>Extension Opportunity</em><br>
        Have students write a short descriptive paragraph using figurative language or other literary devices to enhance the mood or tone of the writing. This can be added to a writing journey notebook or journal.
      </td>
      <td>
       
      </td>
    </tr>
  </tbody>
</table>

---
### K-12.P.EICC.2

**Evidence of Student Learning**

<table>
  <thead>
    <tr>
      <th>Teacher Prompt</th>
      <th>Student Response</th>
    </tr>
  </thead>
  <tbody>
    <tr>
      <td>
        Provide students with a graphic organizer (sample below), and copies of the text the class will be reading. Be sure the excerpts being read include the narrative techniques that will be analyzed in class.<br><br>
        <strong>Narrative Technique | Impact</strong><br><br> </td> </tr>
    <tr>
      <td>        
        Begin with a group discussion or quick write with the following prompt: <em>Think about a text that had a powerful moment. What did the author do to make it so effective?</em> Capture key concepts (e.g., flashback, foreshadowing, pacing) as students share out.<br><br>
      <td>Students answer the prompt in writing, or orally with peers before discussing as a whole group.<br><br></td>
      </tr>
      <tr>
        <td>
        Review the narrative techniques with the class, building on the student responses from above. Say, <em>Today we are going to build on our knowledge of text techniques and see how authors use these techniques to shape meaning. We are going to do this by reading our text and filling out our graphic organizer. We are going to begin this work together. As we read, raise your hand if you come across a technique the author uses so we can discuss it as a class.</em><br><br>
        </td>
        <td>One student reads as others follow along. Students will be looking for the techniques discussed in class and will share when they find the first one.<br><br>Students fill out the graphic organizer with the teacher and provide responses.<br><br> </td>
      </tr>
      <tr>
        <td>
        Say, <em>Now it’s your turn. Continue filling out this graphic organizer with your groups.</em><br><br> </td>
        <td>Students continue filling out the graphic organizer with their group. Once it’s time for group work, students will read the text and mark the narrative techniques they see being used along with the impact the technique has.<br><br></td> 
      </tr>
      <tr>
        <td>
        Circulate and listen to conversations, making note of understandings and misconceptions to review as a full class. Select students to share some of their findings for the whole group discussion.<br><br> </td>
        <td>Students share out and add to their graphic organizer based on the classroom discussion.<br><br></td>
      </tr>
      <tr>
        <td>
        Review the graphic organizer and clarify any misunderstandings.<br><br>
        <strong>Exit Ticket (example):</strong><br>
        Identify a part of the text that stood out to you. How did the author’s use of narrative techniques make that moment powerful?<br><br>       
        <td>
        Students complete the exit ticket independently.
        </td>
      </tr>
      <tr>
        <td> 
        <em>Extension Opportunity:</em><br>
        Have students add to the texts they just read using expository, and/or opinion or argumentative techniques. Ask students to consider how the different techniques impacted the text and the purpose they fulfill in the text.
      </td>
    </tr>
  </tbody>
</table>

---

### K-12.P.EICC.3

**Evidence of Student Learning**

<table>
  <thead>
    <tr>
      <th>Teacher Prompt</th>
      <th>Student Response</th>
    </tr>
  </thead>
  <tbody>
    <tr>
      <td>
        Say, <em>We have been reading a variety of complex texts as we conduct research from credible sources on our individual topics. We really need to understand the information we are reading well so we can expand on those ideas. One comprehension-enhancing strategy we can use to do this proficiently is annotation.</em><br><br>
        Model proper annotation for students by selecting a short piece of text and projecting it on the board. Read the text, stopping to underline important parts and jot quick notes in the margin (questions, connections, etc.). Model thinking aloud for students to hear.<br><br> </td>
    </tr>
    <tr>
      <td>
        Say, <em>What do you notice about my annotations?</em> Give students time to respond. (Consider showing a non-example where many sentences are highlighted and have students share why that does not aid in comprehension.)<br><br> </td> 
        <td>Sample student responses could include: <br> You underlined with a pencil instead of using a highlighter. You wrote notes in the margin to help you better understand what you read.
        <br> </td>
    </tr>
    <tr>
      <td>
        Say, <em>Now I want you to practice properly annotating your text to extract and construct meaning from what you read. Underline information that is important, surprising, interesting, or thought provoking. Then, before you continue reading, stop and jot down a sentence or two that explains why you chose to underline that specific information.</em><br><br> </td> <td>Students independently begin annotating their text.<br><br></td>
    </tr>
    <tr>
      <td>
        Monitor students as they annotate texts, supporting as needed.<br><br> </td>
    </tr>
    <tr>
      <td>
        After students have had time to annotate a portion of their text, have them work in pairs to discuss their understanding of the text, comparing what they annotated to their thinking.
      </td>
      <td>
        Students share their understanding from their text, highlighting how those understandings connect to their annotations.
      </td>
    </tr>
  </tbody>
</table>

---


### K-12.P.EICC.4

**Evidence of Student Learning**

<table>
  <thead>
    <tr>
      <th>Teacher Prompt</th>
      <th>Student Response</th>
    </tr>
  </thead>
  <tbody>
    <tr>
      <td>
        Discuss the importance of writing for different purposes and audiences. Ask students to share examples of texts they encounter daily.<br><br> </td>
        <td>        Sample student responses: emails, text and video messages, social media posts, advertisements.<br><br>
        </td>
    </tr>
    <tr>
      <td>
        Ask students, <em>Why do writers write? For whom do they write?</em> Chart student responses and review the concepts of purpose and audience in writing, explaining how these elements influence the writing process.<br><br> </td>
        <td>Student responses could include:<br>
        <ul>
          <li><strong>WHY</strong> — to express thoughts, feelings, and opinions; for personal satisfaction or enjoyment; to share stories, provide an argument, or inform.</li>
          <li><strong>FOR WHOM</strong> — teachers, classmates, or a broader public; online readers; themselves.</li>
        </ul><br></td>
    </tr>
    <tr>
      <td>
        Guide students in creating various audience profiles (parents, community members, classmates, band director, etc.) and discuss how writing changes based on the audience (e.g., format, organization, language). Model analyzing short mentor texts, identifying the purpose and audience for each.<br><br></td>
    </tr>
    <tr>
      <td>
        Present students with a choice of writing tasks, each with a different intended audience and purpose (e.g., a letter to the principal, an op-ed for the school paper, an imagined story for younger students).<br><br> </td>
        <td>Students select a writing task and use a graphic organizer to plan their ideas, considering how their choices, including choice of text techniques, will shift based on audience and purpose.<br><br></td>
    </tr>
    <tr>
      <td>
        Remind students of the processes of planning, drafting, evaluating, revising, and editing. Encourage brainstorming and idea mapping, providing sentence frames or graphic organizers as scaffolds.<br><br></td>
      <td>Students brainstorm and write a first draft while the teacher circulates, conferencing with students as needed.<br><br>
        </td>
    </tr>
    <tr>
      <td>
        Teach a mini lesson on providing constructive feedback during the peer review process. Explicitly teach students how to engage in the peer review process using models such as “Glows and Grows” or structured peer review forms.<br><br>
        Model examples and non-examples of specific feedback, role-playing a peer review session with a sample text.<br><br></td>
    </tr>
    <tr>
      <td>
        Have students exchange drafts for peer review, using a checklist focused on clarity of purpose, appropriateness for audience, use of text techniques, and organization and development of ideas.<br><br> </td>
      <td>Students provide constructive feedback to their partners.<br><br></td>
    </tr>
    <tr>
      <td>
        Model revision strategies by showing how to clarify ideas or adjust tone for a specific audience and purpose.<br><br>
        Review common editing issues such as sentence structure, wordiness, and grammar (consult grade-level skills within the GUM Chart) with students.<br><br> </td>
    </tr>
    <tr>
      <td>
        As students finish their final drafts, provide them with reflection questions such as: <em>What did you change in your writing to better suit your audience and purpose? What part of the process was most helpful?</em>
      </td>
      <td>
        Students revise and edit based on teacher and peer feedback, creating a final draft.<br><br>
        Students complete a self-reflection. Responses will vary but may include: I had to change my language because it was too informal for my intended audience. I changed my introduction to include more argumentative techniques since that was my purpose. I added examples that would be more relatable to teenagers because that’s my audience.
      </td>
    </tr>
  </tbody>
</table>

---



### K-12.P.ST.1

**Evidence of Student Learning**

<table>
  <thead>
    <tr>
      <th>Teacher Prompt</th>
      <th>Student Response</th>
    </tr>
  </thead>
  <tbody>
    <tr>
      <td>
        Select a text aligned with local policies to serve as the anchor text; it should be clearly anchored in the historical and/or contemporary events of its time. Gather any contextual background materials for this text (e.g., articles, maps, timelines, photos).<br><br> </td>
    </tr>
    <tr>
      <td>
        Review what it means to interpret something. Ask students, <em>Before you even begin reading, what influences how you interpret something? Think about your background, your experiences, the time and place you live in.</em><br><br></td>
        <td>Student responses will vary, but could include:<br>
        <ul>
          <li>My family’s values.</li>
          <li>Where we live.</li>
          <li>What I watch on social media.</li>
        </ul><br></td>
    </tr>
    <tr>
      <td>
        Engage students in a follow-up discussion focusing on these two questions:<br><br>Ask students, What kinds of things might influence an author the same way? <br><br> </td>
        <td>Students’ responses will vary, but they may echo their responses from earlier.  </td>
      </tr>
    <tr>
      <td>Ask students, How might different people respond to the same text based on their personal contexts? </td>
      <td>Students’ responses will vary, but they may include responses about how people will focus on different parts of texts, identify different themes, and apply their respective knowledge to the text. </td>
    <tr>
      <td>
        Provide students with an excerpt or an image from the anchor text. Based on the selected text, use a think-aloud to model how one might approach considering context.<br><br>
        Say, <em>This passage is about ________. Without knowing _______, we might miss the point. Let’s figure out what context matters most here.</em><br><br>
        Provide students with a graphic organizer for the various contextual components, as well as any necessary background materials. Organize students into small groups or partners. Use a jigsaw structure to have each group, partner set, and/or individual research one of the contextual components (e.g., time period, geographic location, author’s background, and contemporary events).<br><br> </td>
    </tr>
    <tr>
      <td>
        Say, <em>Now you’re going to conduct some research about your assigned contextual component. Add what you know or learn to your handout and then write a short explanation of how knowing what you know will help you to better understand the text. We’ll come back together to discuss what you’ve found.</em><br><br> </td>
        <td>Students engage in research and enter their findings into the appropriate rows in their handout. They then engage in discussion with their groups or partners to complete the explanation.<br><br></td>
    </tr>
    <tr>
      <td>
        Allow students time to research and then ask each group’s representative to share what the group has learned with the whole class.<br><br> </td>
        <td>One representative from each group shares their findings and explanation of how context helps them better understand the text. Students take notes from others’ presentations.<br><br>
        Students re-read the excerpt, discuss their new insights, and answer the provided discussion questions in their groups.</td>
    </tr>
    <tr>
      <td>
        After all groups have shared out, instruct each group to read the excerpt from the anchor text a second time, applying their new contextual understandings as they re-read. Then, instruct students to discuss and answer the following questions together in their groups:<br>
        <ul>
          <li>What piece of context helped you understand the text in a new or deeper way? Why?</li>
          <li>How do you think the context surrounding the text’s creation shaped the author’s purpose or message?</li>
          <li>How might different audiences (now or in the past) respond to this text based on their own context?</li>
        </ul><br>
        After students have time for group discussion, facilitate a whole-class discussion.<br><br>
        As an exit ticket, have students individually respond to the following question:<br>
        <em>How does your own background or context influence how you read or relate to this text?</em>
      </td>
      <td>
        Sample student responses:<br>
        <ul>
          <li>Knowing that the story was written during the <em>___ War</em> helped me understand why the characters were so focused on survival and financial struggles.</li>
          <li>Since the text was written during a war, I think the author was trying to inspire people to get involved.</li>
          <li>People from different backgrounds might connect with the text in different ways—some might need more background knowledge to fully understand it.</li>
        </ul><br>
        Student exit ticket responses will vary, but should reflect personal context and its impact on interpretation.
      </td>
    </tr>
  </tbody>
</table>

---

Here is the extracted **Evidence of Student Learning** section for **standard K-12.P.ST.2: Author, Audience, & Purpose**, formatted according to your specifications:

---

**K-12.P.ST.2**

<h3>Evidence of Student Learning</h3>

<table>
  <thead>
    <tr>
      <th>Teacher Prompt</th>
      <th>Student Response</th>
    </tr>
  </thead>
  <tbody>
    <tr>
      <td>
        Say to students, <i>What do you already know about why authors write? What strategies do they use to connect with their readers?</i> Have a 1–2 minute class discussion where students share out their responses.<br><br> </td>
      <td>
        <b>Sample responses could include:</b><br>
        – Sometimes authors want to teach us something.<br>
        – Some authors write stories to entertain us or to make us laugh.<br>
        – Authors might write because they are curious about a topic and want to share what they learn.<br>
        – Authors use techniques like dialogue, interesting characters, and exciting plots to keep the audience interested.<br><br>
      </td>
    </tr>
    <tr>
      <td>
        Say, <i>Every writer makes choices based on three things: what they want to say, who they want to say it to, and why they want to say it. Today, we’ll look at how these three elements work together to create meaningful communication.</i><br><br>
        Read a short mentor text (e.g., an editorial, a letter, a speech) and model a think-aloud. Say, <i>Notice how the author uses ____ because ____ (connect to audience/purpose). The author’s choice to use ____ appeals to both the purpose and audience.</i><br><br>
        Say, <i>Now you will analyze how writers achieve their purpose(s) and meet the needs of their target audience(s).</i><br><br> </td>
    </tr>
    <tr>
      <td>
        Provide each small group with a short text to review. In small groups, students complete a graphic organizer.<br><br>
        Circulate the room, prompting groups with questions such as:<br>
        – What word choices stand out, and who are they for?<br>
        – How does the structure support the message?<br>
        – Would this work on a different audience?<br><br>
        Allow groups to share their thoughts or share a synopsis of their comments to segue into composition.<br><br>
        Say, <i>Just now, we looked at how authors tailor their language, structure, and ideas to suit their audience and purpose. Now, you’ll become the author and make those decisions yourself.</i><br><br>
        Say, <i>Write a short text (letter, blog post, speech, or editorial) with a clearly defined purpose, target audience, and contextual setting. Before you begin, think through the items on your planning checklist.</i><br><br> </td>
      <td>
        Student responses will vary based on the text but could include: <br>
        - I noticed the use of technical terms like “carbon footprint.” That suggests the author expects the audience to have some background knowledge.<br> - The text gives an anecdote, then facts, and ends with a call to action. That structure makes the message more convincing because it builds emotional connection first and then supports it with evidence.<br> - The paragraphs are short, and some sentences are bolded. That helps focus the reader.<br> - I think the message could work on a different audience if the tone and examples were adjusted. For instance, using workplace examples instead of school ones might help it connect better with adults. </td>
    </tr>
    <tr>
      <td>
        <b>Student Planning Checklist:</b><br>
        – Who am I writing to?<br>
        – What do I want them to think, feel, or do?<br>
        – What context or situation makes this writing important?<br><br>
        Students write, revise, and reflect using this checklist. After students have time to write, revise, and reflect on their own writing, they can engage in peer review.<br><br>
        Say, <i>Now we will trade texts and evaluate each other’s work for purpose and audience using a simple checklist:</i><br>
        – Is the purpose clear?<br>
        – Are the choices appropriate for the audience and context?<br>
        – What part was most effective? What could be strengthened?<br><br>
        Circulate and facilitate conversation, making notes of student strengths and areas for potential, future explicit instruction.<br><br></td>
        <td>Students’ peer feedback will vary, but they may include remarks like, <br>
        – Your tone was perfect for students, but you could add more facts to make your argument stronger.<br>
        – I wasn’t sure what your goal was at first—maybe add a clearer thesis or purpose statement.<br>
        – You did a great job choosing words that match the audience—your tone was friendly and clear.<br>
        – I think adding a heading would help your audience understand your main point faster.<br><br></td>
    </tr>
    <tr>
      <td>
        Ask students the following exit prompt:<br>
        <i>What is one strategy you used today to match your writing to your audience and purpose? How did you know it would be effective?</i>
      </td>
      <td>Student responses will vary, but they may focus on choices such as their language, organization, or rhetorical appeals. </td>
    </tr>
  </tbody>
</table>

---
### **K-12.P.AC.1**

#### **Evidence of Student Learning**

<table>
  <thead>
    <tr>
      <th>Teacher Prompt</th>
      <th>Student Response</th>
    </tr>
  </thead>
  <tbody>
    <tr>
      <td>
        Select a mentor text previously used for instruction. Display the text on the board or provide each student with a copy of the text. For this activity, we will assume students have their own copy of the text.<br><br>
        Say, <i>Today we are going to reread this text through the eyes of a writer. As we read through the text, I want you to make note of places where you like how the writer wrote or illustrated something.</i><br><br>
        Read through the text aloud as students follow along.<br><br>
        After reading through the text, have students share their favorite parts of the text.<br><br>
        Reread a student-selected section of the text aloud.<br><br>
        Ask, <i>What do you notice the writer did in this part?</i><br>
        Ask, <i>Why do you think the author used that technique?</i><br><br>
        Record examples on an anchor chart (Where/What/Why) for students to reference in the future.<br><br>
        Repeat this process of having students analyze other parts of the texts they liked.<br><br>
        Encourage students to engage in conversation about why the author may have used various techniques.
      </td>
      <td>
        Students mark the parts of the text they enjoy.<br><br>
        Student responses will vary but could include: <br>
        – The author used figurative language.<br>
        – The author used a lot of key details.<br>
        – The author used ellipses.<br><br>
        Student responses will vary but could include: <br>
        – The author used figurative language to help get their point across.<br>
        – The author used a lot of key details to help us better understand the topic.<br>
        – The author used ellipses to signal to us that more is about to happen.
      </td>
    </tr>
  </tbody>
</table>

---

**K-12.P.AC.2**

Evidence of Student Learning

<table>
  <thead>
    <tr>
      <th>Teacher Prompt</th>
      <th>Student Response</th>
    </tr>
  </thead>
  <tbody>
    <tr>
      <td>Ask students, What do you already know about author’s purpose and audience? Why do you think writers make different choices depending on who will read their work?<br><br></td>
    </tr>
    <tr>
      <td>Give students 3–5 minutes to write their responses or share with a partner, small group, or whole class.</td>
      <td><i>Student responses will vary but could include:</i><br>- I know that an author’s purpose is the reason why they write something.<br>- The audience is who the author is writing for, like kids, adults, or people interested in a certain topic.<br>- The audience is important because the author has to think about who will read their work and what they will understand.</td>
    </tr>
    <tr>
      <td>Review the definitions of audience, purpose, and context.<br><br>Display and discuss examples of texts written for different audiences and purposes, highlighting how word choice, tone, and details change depending on audience and purpose.<br><br></td>
    </tr>
    <tr>
      <td>  
      Divide students into small groups and assign each group a writing task. For their group’s task, students should answer the following questions:<br>- Who is the audience?<br>- What is the purpose?<br>- What language, tone, and details would be the most effective?<br><br>Have groups share their analysis with the class, noting similarities and differences in their approaches to the task.<br><br>When writing, a student sample text could be used as a mentor text with students. (Teachers may pull from their own personal student work libraries; also, a sample is provided in the 6-8.P.AC.2 Student Resource Sample.)</td>
      <td><i>Student responses will vary but could include:</i><br>- <b>Word Choice:</b> Uses vivid words like “secret hideaway,” “heavy wooden doors,” and “golden rectangles.”<br>- <b>Tone:</b> The tone is peaceful and appreciative, showing how much the student values the library.<br>- <b>Details:</b> Specific details about the sights, smells, and feelings help the reader imagine the scene.</td>
    </tr>
    <tr>
      <td>Provide students with a final context, purpose, and audience based on the instructional design (group responses). Have each student draft an individual short text for the writing task, making deliberate choices about word choice, tone, and details. Encourage students to refer to their original analysis as they write.<br><br></td>
    </tr>
    <tr>
      <td>
      Ask volunteers to read their drafts aloud. Discuss with the class how the writer’s choices reflected the intended audience and purpose.<br><br>
      <td>Responses will vary</td>
    </tr>
    <tr>
      <td>
      Have students write a reflection in their journals: <i>How did thinking about audience and purpose change the way you wrote your text?</i></td>
      
      <td><i>Student responses will vary but could include:</i><br>- Thinking about my audience and purpose changed the way I wrote my text because I had to consider who would be reading it and why I was writing.<br>- My purpose was to inform them about a topic, so I focused on giving facts and details instead of just sharing my opinion.<br>- Overall, thinking about the audience and purpose helped me organize my ideas better and choose the right words to get my message across.</td>
    </tr>
  </tbody>
</table>

---

**K-12.P.AC.3**

<h3>Evidence of Student Learning</h3>

<table border="1" cellspacing="0" cellpadding="6">
  <tr>
    <th>Teacher Prompt</th>
    <th>Student Response</th>
  </tr>
  <tr>
    <td>
      Provide students with a variety of texts (e.g., news article, social media post, how-to blog post) and ask, 
      <em>What design choices do you notice authors making in their texts? How do those choices impact the audience?</em><br><br></td>
    <td>       <p>Student responses will vary but could include: </p>
      <ul>
        <li><em>The bulleted list makes it easier to read and it’s more welcoming than a wall of text.</em></li>
    </td>
  </tr>
  <tr>
    <td>
      Say, <em>Let’s look more closely at our texts and find the different ways authors organize or lay out their text.</em> 
      Guide students through a comparison of the texts’ arrangements.<br><br></td>
    <td><p>Student responses will vary; sample student responses: </p>
      <ul>
      <li><em>I noticed that the news article and blog post both had bulleted lists, but the news article made a list to provide summary points whereas the blog post’s list was to walk us through the steps in order.</em></li>
      </ul>
    </td>
  </tr>
  <tr>
    <td>
      Say, <em>Great work! We are finding how we can use the same organizational structures to meet different purposes. What do you notice about the social media post?</em><br><br> </td>
    <td><p>Student responses will vary; sample student responses: </p>
      <ul>
      <li><em>I notice that all of the texts use images to convey information. The news article has a copyrighted image of the topic of the article. The blog post has images for each step of the instructions to help us better understand how to follow them. The social media post, however, uses emojis to express the author’s feelings. </li></em>
      </ul>
    </td>
  </tr>
  <tr>
    <td>
      Say, <em>Now that we’ve explored the way these texts are arranged and the potential purposes behind them, let’s think about the audience. Who is the audience for these texts and how do you know?</em>
    </td>
    <td><p>Student responses will vary; sample student responses: </p>
      <ul>
      <li><em>The blog post seems to be for an adult audience looking to complete a task. I think this because while the layout is very friendly and easy to navigate thanks to the steps, I notice that the pictures have an adult doing the task and using supplies that would require adult supervision. I also noticed that there is some specialized language, so it might be for an adult who is familiar with the topic.  
      </li></em>
      </ul>
    </td>
    </td>
  </tr>
  <tr>
    <td>
      Say, <em>We’ve seen how authors arrange texts to meet their purpose and cater to their audience. Now let’s take out a text you’ve been working on creating. Who is the audience? What is your purpose? How can you arrange your texts to better meet the needs of your audience and purpose?</em><br><br>
    </td>
    <td>
      <p>Student responses will vary; sample student responses:</p>
      <ul>
        <li><em>The audience of my text is the school principal. The purpose is to convince her to start a recycling program. Maybe I could add bulleted lists to call attention to the main point like the article for adults did. Perhaps I could also include quotes from students since the principal cares about what students think and feel.</em></li>
      </ul>
    </td>
  </tr>
  <tr>
    <td>
      Allow students to work in pairs or individually to pinpoint areas of their text that can be refined with audience and purpose in mind. To help organize student thoughts, you may want to provide them with a graphic organizer.<br><br>
      Provide students with the opportunity to share out their answers, or have them submit a written response as a ticket-out-the-door.
    </td>
  </tr>
</table>

---

K-12.P.CP.1

Evidence of Student Learning

<table>
  <thead>
    <tr>
      <th>Teacher Prompt</th>
      <th>Student Response</th>
    </tr>
  </thead>
  <tbody>
    <tr>
      <td>Ask students, What is a research question? What makes a good research question?<br><br>Have students jot down ideas, discuss with a partner, then share out. Record key qualities (open-ended, specific, researchable, etc.) on the board.</td>
      <td>Student responses will vary but could include:<br>- A good research question is something you can’t just answer with yes or no.<br>- A good research question is clear and specific and shouldn’t be too broad or too narrow.</td>
    </tr>
    <tr>
      <td>Briefly explain the difference between simple and complex questions.<br><br>- Simple questions usually have only one correct answer and don’t need a lot of explanation.<br><br>- Complex questions need longer, more detailed answers, and there is usually more than one correct answer.</td>
      <td></td>
    </tr>
    <tr>
      <td>Model turning a simple topic (e.g., healthy eating) into layered complex questions. For example, a simple question for this topic could be, “What is one healthy snack you can eat after school?” A complex question could be, “How could making small changes to your daily eating habits affect your overall health in the long run?”</td>
      <td></td>
    </tr>
    <tr>
      <td>Divide students into small groups. Assign each group a broad topic and have groups write their topic in the center of a piece of chart paper.</td>
      <td>Each group writes their topic in the center of a piece of chart paper.</td>
    </tr>
    <tr>
      <td>Using sticky notes, have students take turns generating questions about the topic and add the sticky notes to the chart paper. Model for students how questions could be connected and how questions could lead to new ideas, then have students do the same with their questions.<br><br>Student Sample: Group Question Web<img src="https://lor2.gadoe.org/gadoe/file/084babe9-f368-453a-91d8-dcfc8efff272/1/6-8.P.CP.1_Student_Sample_Artificial_Dyes.pdf" style="max-width:100%"></td>
      <td>Students take turns adding questions to the chart paper. As questions are added, students will draw lines to connect related questions and discuss how the questions connect or branch off into new ideas.</td>
    </tr>
    <tr>
      <td>Circulate to get an idea of the collaborative discussions groups are having and redirect as needed.<br><br>As students finish their discussions, instruct the groups to hang their question webs around the room and conduct a gallery walk to see what types of questions they found most interesting.<br><br>For a closing discussion, ask students, What types of questions were the most interesting to you? How did seeing others’ questions help you think differently? How did collaborating with others help you ask better questions?</td>
      <td>Student responses will vary but could include:<br>- The questions that added examples were most interesting to me.<br>- Seeing others’ questions made me realize that there are many ways to look at the same topic.<br>- When someone else asked a question I hadn’t thought of, it made me think deeper about the topic.<br>- When we discussed things as a group, I realized what I didn’t understand so I could ask more specific questions.</td>
    </tr>
  </tbody>
</table>

---
K-12.P.CP.2

<h3>Evidence of Student Learning</h3>
<table>
  <thead>
    <tr>
      <th>Teacher Prompt</th>
      <th>Student Response</th>
    </tr>
  </thead>
  <tbody>
    <tr>
      <td>Ask students, Have you ever changed the way you talk depending on whom you’re talking to? Why?<br><br>Allow students to discuss their responses in pairs before sharing out to the whole class.</td>
      <td>Student responses will vary but could include:<br>- I talk one way when I’m with my friends, but if their parents come around, I change my language to be more polite because I want to show them respect.<br>- I think I change how I talk because different people expect different kinds of conversations.</td>
    </tr>
    <tr>
      <td>Say to students, When you’re thinking about presenting information to others, whether it’s in or out of school, there are a few things you need to keep in mind. Many of you mentioned changing the way you talk based on who is listening to you. When you do that, you are thinking about your audience. Think about who is listening to you. Who are some possible audiences?</td>
      <td>Student responses will vary but could include:<br>- Friends<br>- Teachers<br>- Parents<br>- Younger kids</td>
    </tr>
    <tr>
      <td>Say, You also want to keep your purpose in mind when presenting to others. Your purpose will also drive the choices you make when designing your presentation. What are some reasons or purposes for presenting to others?</td>
      <td>Student responses will vary but could include:<br>- to inform others about a topic<br>- to argue for or against a topic<br>- to entertain an audience</td>
    </tr>
    <tr>
      <td>Say, Now, let’s talk about some important skills for making a presentation effective. Talk with your partner about what some of those skills are and be ready to share out.<br><br>Redirect student responses, if needed.</td>
      <td>Student responses will vary but could include:<br>- tone, volume, and speed<br>- word choice<br>- body language and eye contact</td>
    </tr>
    <tr>
      <td>Model a 1-minute speech on the topic Why Reading is Important. Present the speech twice: once for a kindergarten audience, and once for a teacher/adult audience. Have students jot down notes during each speech of differences and similarities.</td>
      <td></td>
    </tr>
    <tr>
      <td>Ask students, What did you notice during those two speeches? What was the same? What was different? Have students share with a partner and then discuss as a whole group.</td>
      <td>Student responses will vary but could include:<br>- In the first speech, you used simple words, an energetic tone, and lots of gestures.<br>- In the second speech, you used more formal language, more facts, and fewer body gestures.</td>
    </tr>
    <tr>
      <td>Provide pairs of students with a scenario (examples below). In pairs, students will plan a short (2-3 minute) presentation tailored to their assigned audience and purpose.<br><br>Scenario Options:<br>- Teach a group of 2nd graders how to recycle.<br>- Inform your parents about a new school rule.<br>- Convince your friends to see a movie you choose.<br><br>Say to students, Make sure you think of these questions as you plan your presentation: who is your audience, what is your purpose, and what presentation skills will you use?</td>
      <td></td>
    </tr>
    <tr>
      <td>Provide students with a presentation planning template (<a href="https://url.gadoe.org/i0lkq" target="_blank">sample planning template</a>) and/or a checklist or rubric (<a href="https://url.gadoe.org/mh3aq" target="_blank">sample rubric</a>) aligned to local instructional design. Introduce each document and explain their functions.</td>
      <td>Students will plan their presentations based on their given scenario.</td>
    </tr>
    <tr>
      <td>As students are planning then preparing their presentations, circulate to provide support and suggestions.</td>
      <td></td>
    </tr>
    <tr>
      <td>Have pairs present to the class as the audience listens to how the presentation is tailored. After each presentation, ask, What did that group do to connect with their audience? Were they successful? Why or why not?</td>
      <td>Student responses will vary but could include:<br>- They used eye contact and spoke directly to us instead of just reading to us.<br>- They asked us questions during their slides to keep us involved.<br>- The group was successful because everyone paid attention, and it didn’t feel boring.<br>- They used good examples, but they spoke too quietly for us to hear sometimes.</td>
    </tr>
    <tr>
      <td>*This lesson could take more than one class period.</td>
      <td></td>
    </tr>
  </tbody>
</table>

### 6-8.T.C.1

**Overview of Standard**
In this standard, students will identify the author’s purpose and explain how this purpose shapes the text’s context, structure, style, and tone. They will analyze how the intended audience influences the author’s word choice, examples, forms of evidence, and level of detail. Students will also examine the effects of these choices on meaning and interpretation, looking at how different audiences might interpret the same text differently and how modifying the purpose or audience could change the text. 

---

### 6-8.T.C.2

**Overview of Standard**
In this standard, students will explore how the author’s or speaker’s perspective shapes the way a text is constructed and what ideas or details are included. They will also look at the context around the text’s creation (e.g., author’s background, historical time) to understand why the text looks or sounds a certain way. By analyzing these influences, students will gain a deeper understanding of how different perspectives affect the message and meaning of texts that they interpret and construct. 

---

### 6-8.T.SS.1

**Overview of Standard**
In this standard, students explore text structures and features, and how text purpose and audience can influence their use. Students will create their own texts, utilizing their understanding of purpose and audience to guide decisions on organizational structures and features. Additionally, students will be learning about the organization of language and how to use language to achieve clarity and cohesion in their texts. Students will also work on creating extended texts, including an introduction, related details, and a conclusion. 

---

### 6-8.T.SS.2

**Overview of Standard**
Authors make deliberate craft choices to shape meaning, tone and audience experience, and fulfill specific purposes. This standard emphasizes the investigation and application of craft choices such as literary devices, figurative language, connotative language, and informal and formal style by the author; students will evaluate how these craft moves influence and are influenced by purpose, meaning, tone, mood, and audience perception, and then apply them in their own writing. Students must become intentional in their use of craft - reading like writers to notice patterns and writing like readers to make purposeful, audience-aware decisions that elevate clarity, voice, and impact.  

---

### 6-8.T.T.1

**Overview of Standard**
In this standard, students are building on their knowledge of narrative techniques while analyzing narrative techniques authors use to achieve a purpose. They will also begin applying their understanding of narrative techniques to their own texts, choosing the appropriate techniques for their specific purpose and audience. Georgia’s K-12 ELA Standards shift from fixed text types to the flexible use of techniques, emphasizing purpose and audience, with authentic texts often blending narrative, expository, argumentative, and poetic techniques. 

---

### 6-8.T.T.2

**Overview of Standard**
In this standard, students are building on their knowledge of expository techniques while analyzing expository techniques authors use to achieve a purpose. They will also begin applying their understanding of expository techniques to their own texts, choosing the appropriate techniques for their specific purpose and audience. Georgia’s K-12 ELA Standards shift from fixed text types to the flexible use of techniques, emphasizing purpose and audience, with authentic texts often blending narrative, expository, argumentative, and poetic techniques. 

---

### 6-8.T.T.3

**Overview of Standard**
In this standard, students are building on their knowledge of opinion techniques as they are introduced to argumentative techniques. They will analyze argumentative techniques authors use to achieve a purpose. They will also begin applying their understanding of argumentative techniques to their own texts, choosing the appropriate techniques for their specific purpose and audience. Georgia’s K-12 ELA Standards shift from fixed text types to the flexible use of techniques, emphasizing purpose and audience, with authentic texts often blending narrative, expository, argumentative, and poetic techniques. 

---

### 6-8.T.T.4

**Overview of Standard**
In this standard, students continue to build their knowledge of poetic techniques while recognizing, describing, and analyzing authors’ uses of poetic techniques to achieve a purpose or to appeal to the target audience. Students will also apply their understanding of poetic techniques to their own texts, choosing the appropriate techniques for their specific purpose and audience. Georgia’s K-12 ELA Standards shift from fixed text types to the flexible use of techniques, emphasizing purpose and audience, with authentic texts often blending narrative, expository, argumentative, and poetic techniques. 

---

### 6-8.T.RA.1

**Overview of Standard**
In this standard, students generate guiding questions, locate and evaluate credible sources, and use evidence to support their thinking. Through this process, students learn to refine their inquiries, analyze and connect findings across texts, and integrate information effectively to build and extend ideas. 

---

### 6-8.T.RA.2

**Overview of Standard**
This standard equips students to locate and evaluate the credibility and relevance of sources while gathering evidence to address a research question or topic. They practice integrating evidence from multiple print and digital texts into their own work and develop citation skills that grow across grades—beginning with basic attribution in 6th grade, moving to standard citation practices in 7th grade, and applying Modern Language Association (MLA) formatting in 8th grade—to ensure accuracy and avoid plagiarism. 

---

### 6-8.T.PM.1

**Overview of Standard**
In this standard, students will begin to analyze how texts reflect, respond to, or challenge the ideas, values, and events of the time periods in which they were produced. They will read to understand how ancient or traditional stories (e.g., myths, legends, folktales, historical accounts) are reimagined by modern authors. Students will analyze these texts, especially focusing on how stories are transformed over time and what elements remain the same or change. 

---

**6-8.T.C.1**
Vocabulary

Context
Author’s purpose
Audience
Text mode features
Multimodal/Multimodality

---

**6-8.T.C.2**
Vocabulary

Authors
Speakers
Perspectives
Circumstances
Credibility
Credible sources
Background information
Context
Author’s bias
Distinguishes
Corroborates

---

**6-8.T.SS.1**
Vocabulary

Text Structure
Purpose
Audience
Cohesion
Coherence
Style
Transitions
Introduction
Conclusion
Supporting facts

---

**6-8.T.SS.2**
Vocabulary

Figurative language
Connotative language
Mood
Tone
Formal style
Informal style
Literary Devices
Figurative Language
Purpose
Audience
Context

---

**6-8.T.T.1**
Vocabulary

Narrative techniques
Narrative devices
Plot structures
Theme
Conflict
Setting
Characters
Characterization
Plot pacing
Modes
Genres
Event patterns

---

**6-8.T.T.2**
Vocabulary

Expository techniques
Main ideas
Facts
Key details
Statistics
Sense of Closure
Text features

---

**6-8.T.T.3**
Vocabulary

Argumentative techniques
Claim
Relevant evidence
Logical evidence
Counterclaim
Rebuttal
Logical conclusion

---

**6-8.T.T.4**
Vocabulary

Poetic techniques
Stanza
Rhyme
Rhyme scheme
Imagery
Figurative language
Sound devices
Cacophony
Prose

---

**6-8.T.RA.1**
Vocabulary

Research
Inquiry
Questions
Generation
Connections
Investigation
Information
Formulation
Curation
Integration
Credible sources
Print communication
Digital communication
Personal communication
Accumulated knowledge
Analysis/analyses

---

**6-8.T.RA.2**
Vocabulary

Curation
Sources
Print texts
Digital texts
Topics
Questions
Credibility
Relevance
Integration
Evidence
Plagiarism
Central idea or question
Basic bibliographic information (<em>6th</em>)
Author
Title
Page number
Standard bibliographic information (<em>7th</em>)
Website Name
Publication year
Modern Language Association (<em>MLA</em>) format (<em>8th</em>)
Modes
Genres
Unreliable sources
Investigation
Accuracy
Parenthetical citations
Quoting
Paraphrasing
Works Cited page

---

**6-8.T.PM.1**
Vocabulary

Period
Theme
Genre
Verbal
Style
Myths
Fictional stories
Historical stories

---

### 6-8.T.C.1:

**Instructional Strategies for Teachers**

• Review with students the terms <b>purpose</b> and <b>audience</b>, using clear examples and anchor charts to reinforce definitions and examples.
• Model audience analysis by presenting a short, clear text and walk students through an audience analysis using a graphic organizer. Focus on identifying audience characteristics such as background knowledge and communication style. Guide students in considering how these factors shape the author’s language and choices.
• Assign groups different audiences for a similar topic, then have each group identify the most likely audience and discuss how the content, tone, and structure would change to suit that specific group.
• Provide students with sentence starters and guiding questions such as: “The author’s purpose for constructing this text is probably ___ because ___.” and “The intended audience seems to be ___. I think this because ___.”
• Provide students with practice analyzing purpose and audience in groups, circulating to provide immediate feedback and ask clarifying questions.
• Use the <i>Situating Texts</i> resource to develop and support context.

---

### 6-8.T.C.2:

**Instructional Strategies for Teachers**

• Model for students how to identify and analyze the author’s perspective and word choice that reveals tone and bias.
• Use a graphic organizer to help students visually track how an author’s background and circumstances influence the author’s work. On the graphic organizer, include sections for author’s background, historical context of the text, clues from the text that show bias or viewpoint, and how the author’s perspective shapes the message or tone.
• Model for students how to compare how two authors treat the same topic differently based on perspective and circumstance.
• Encourage students to think critically about author intent and background by creating questions they could ask the author/speaker about their perspective and purpose. Model writing responses to the questions “in character” as the author, using evidence from the text and historical context.
• Use anchor charts to help students track recurring techniques authors use to express perspective (e.g., tone, anecdotes, statistics, word choice).
• Using a class text, build a class timeline with key historical events, trends, and author facts. Link moments in the text to items on the timeline to show how context influenced the text.
• Use conferencing and collaboration for guided support and tailored instruction.
• Build in Socratic Seminars or class debates to discuss how different perspectives affect interpretation of a text.
• Provide reflection sessions where students share insights about authors’ perspectives and how context affects texts.
• Use the <i>Situating Texts</i> and <i>Periods & Movements</i> resources to develop and support context.

---

### 6-8.T.SS.1:

**Instructional Strategies for Teachers**

• Review key concepts and vocabulary words such as <b>text structure</b>, <b>text features</b>, <b>purpose</b>, and <b>audience</b>.
• Model a think-aloud, pausing to make comments about structure, purpose, audience, and text features while students take notes.
• Provide students with probing questions, such as, “Why did the author use this particular text feature? How does it help purpose and audience?” and “What kind of audience would need this degree of background knowledge? How do you know?”
• Provide sentence- and talk-stems to support students as they construct texts with their peers orally and in writing.
• Using mentor texts, guide students in highlighting organizational structures, text features, and transitions. Reference the <i>P.AC.3 Text Design Considerations</i> resource.
• Examine multiple texts within the same genre or relating to the same topic to identify shared organizational patterns and features.
• Guide students in choosing a topic and defining the author and purpose before drafting a text. Show students how to use a template or organizer which focuses on a hook/introduction tailored to audience, supporting facts, transitions for cohesion, and a conclusion that reflects on the purpose.
• Provide mini lessons on writing introductions for different audiences, using transitions for clarity, and writing strong conclusions.
• Strategically pair students to complete a Venn Diagram, circulating to provide support as needed.

---

### 6-8.T.SS.2:

**Instructional Strategies for Teachers**

• Review figurative language, literary devices, and connotative language with students prior to the lesson, providing examples.
• Provide students with sentence- and talk-stems to engage in the lesson and promote academic language.
• Model a think-aloud for students to show the process behind unpacking sentences.
• Using a mentor sentence as a guide, co-create sentence stems with students to help them imitate authors’ craft moves.
• Use short, engaging mentor texts to model annotating craft moves and answering questions such as “Why did the author use this device here?”, “What effect does it create?”, and “How would it feel different without it?”
• Compare and contrast different authors’ craft moves to investigate the different ways to appeal to a target audience or achieve specific purposes.
• Have students apply author craft moves to their own writing while mimicking the structure and style of a mentor sentence or paragraph. Provide sentence starters (e.g., “Just like [author], I used [device] to create a [tone/mood].”) so students can defend their craft choices.
• Challenge students to revise flat sentences with figurative language that appeals to their audience or helps achieve their purpose.
• Ask students to rewrite sentences with powerful language for different target audiences and purposes.

---

### 6-8.T.T.1:

**Instructional Strategies for Teachers**

• Use mentor texts to describe, analyze, and apply narrative techniques. After modeling, have students identify and annotate the techniques they find.
• Model how to break down texts by examining mentor texts, facilitating discussion about the author’s choices.
• Introduce the components of narrative structure using visual story arcs. Have students apply this by charting narrative structure in both mentor texts and their own writing.
• Use graphic organizers (e.g., character maps, conflict charts) to help students organize and analyze the structure and elements of narrative texts.
• Model and practice “show, don’t tell,” teaching students to convey emotions, setting, and mood through specific sensory details, actions, and dialogue, rather than direct statements.
• Move from analysis to creation by having students write their own texts applying the techniques previously studied (e.g., building suspense, developing characters, employing figurative language). Provide structured opportunities for feedback and revision.
• Engage students in peer review or group analysis of mentor texts, encouraging discussion around narrative choices and strategic revisions.
• Guide students in reflection on and discussing how themes are developed in mentor texts and their own writing.
• Engage students in collaborative storytelling where they take turns adding sentences or paragraphs to a collective text, focusing on previously taught narrative techniques and devices.

---

### 6-8.T.T.2:

**Instructional Strategies for Teachers**

• Use direct instruction to explicitly teach expository text structures (e.g., cause/effect, compare/contrast, sequence). Provide students with models and real examples, highlighting how transitions and organizational patterns clarify ideas.
• Use mentor texts to analyze well-written expository texts as a class. Discuss how authors sequence information, use formatting features, and present evidence.
• Create and reference anchor charts for structures (e.g., cause/effect, compare/contrast, sequence).
• Use the Gradual Release of Responsibility model. Provide guided practice and scaffolding by beginning with teacher modeling (thinking aloud while annotating structure or planning a paragraph), then provide guided group practice, and finally, independent work with feedback.
• Teach students to use graphic organizers both for interpreting texts and constructing texts to help them visualize and organize key ideas according to expository structures and features.
• After reading texts, organize discussions that require students to cite evidence, explain the author’s choices, and evaluate the effectiveness of techniques, promoting analytical skills.
• Use peer review sessions focusing on structure, clarity, and use of expository techniques. One-on-one writing conferences and structured rubrics can help students assess and improve their drafts.

---

### 6-8.T.T.3:

**Instructional Strategies for Teachers**

• Use explicit instruction to build/add to students’ background knowledge of argumentative techniques (e.g., claim, supporting relevant evidence, counterclaim, logical conclusion).
• Utilize well-chosen mentor texts to show how authors craft arguments, including how they introduce claims, organize evidence, and address counterclaims.
• Model and guide students through annotating a text, highlighting the argumentative technique(s) found in the text. Discuss why the author chose to use those argumentative techniques and whether the use of techniques was effective.
• Use informal debates to give students authentic experience identifying and defending claims with evidence, building students’ confidence in applying argumentative techniques.
• Encourage a classroom environment of respectful debate with an emphasis on learning from other perspectives.
• Provide graphic organizers that help students plan arguments based on the argumentative technique(s) being used in students’ texts.
• Provide sentence stems and models to help students write effective claims, counterclaims, and rebuttals.

---

### 6-8.T.T.4:

**Instructional Strategies for Teachers**

• Use explicit instruction to build/add to students’ background knowledge of poetic techniques.
• Create and refer to a class anchor chart of poetic techniques (e.g., stanzas, rhyme/rhyme scheme, imagery, figurative language, sound devices, cacophony).
• Model annotation and analysis of a short poem for various poetic techniques. Then provide guided poem annotation in pairs.
• Analyze how poets intentionally craft language to serve a specific purpose (e.g., evoke emotion, create rhythm, provoke thought).
• Model annotation and analysis of texts from other genres where the author has intentionally used poetic techniques for the specific audience and purpose.
• Have students rehearse and perform poems aloud to analyze how sound devices affect the text’s impact.

---

### 6-8.T.RA.1:

**Instructional Strategies for Teachers**

• Teach students to categorize questions to move from surface to deep inquiry or before, during, and after reading, using models such as the <i>Question-Answer-Relationship (QAR)</i> Model, a <i>K-W-L (Know, Want to Know, Learned)</i> Chart, or Socratic questioning.
• KWL+: Extend the KWL chart to include a column for new questions generated during reading.
• Model “lateral reading” by opening new tabs and verifying author/source claims in real time.
• Engage students in inquiry circles (small group collaborative research where students co-create and refine driving questions).
• <b>Wonder Wall:</b> Have students post “I wonder…” questions around a central theme, and have peers refine them into researchable questions.
• Create a gallery walk of questions where students rotate around the room, adding follow-up or clarifying questions to peers’ posted prompts.
• Provide sentence stems (e.g., “How might…?”, “In what ways…?”, “Why does…?”) to scaffold higher-order questioning.
• Have students deliberately find evidence against their own position to strengthen reasoning for the development of counterclaims.
• Design instruction using evidence-based practices, using resources such as the <i>Adolescent Literacy Infographic</i> from the Florida Center for Reading Research.
• Analyze exemplar student work or professional mentor texts to model structure, integration of sources, and style guide usage.

---

### 6-8.T.RA.2:

**Instructional Strategies for Teachers**

• Conduct think-alouds on source credibility (e.g., author background, citations, publication) while projecting the source.
• <b>Evidence Sort & Rank:</b> Have students sort pieces of evidence from multiple sources into “strong,” “weak,” or “irrelevant” categories, then justify rankings.
• Model “lateral reading” by opening new tabs and verifying author/source claims in real time to determine source credibility.
• Use the <i>Situating Texts</i> resource for questions to assist with establishing source credibility.
• Provide students with a curated set of sources and have students sort them along a credibility spectrum and defend their placement.
• Conduct a think-aloud and model checking “About Us” pages, author information, publication dates, and domain types (.edu, .gov, .org) to gauge credibility.
• Provide curated sets of sources and model extracting relevant information.
• <b>Citation Detectives:</b> Have students identify missing elements in sample citations (e.g., author, date, page) and fix errors.
• Highlight parts of a citation in color (author, title, publication, date, container, etc.) and have students replicate this color coding in practice citations.

---

### 6-8.T.PM.1:

**Instructional Strategies for Teachers**

• Co-create an anchor chart as a class to define <b>genre</b>, <b>time period</b>, <b>style elements</b>, and <b>common themes</b>. Include examples of each, giving students a reference point for future analysis and discussion.
• Pair an original myth, legend, or historical story with a modern adaptation. Read both texts aloud, then use a graphic organizer (e.g., Venn diagram, T-chart) to compare plot, characters, setting, theme, and style.
• Use the <i>Situating Texts</i> and/or <i>Periods & Movements</i> resources for instruction to develop and support context.
• After reading an original story and a modern adaptation, model identifying and tracking recurring themes in both versions. Think-aloud to show how the theme may be preserved, modernized, or shifted in tone or meaning.
• After reading an original story and a modern adaptation, hold a guided discussion or Socratic seminar, focusing on questions such as: “Why might a modern writer adapt this story?” and “What modern issues or values does the adaptation reflect?”
• Incorporate film clips, audio versions, graphic novels, or podcasts as examples of modern adaptations.
• Have students situate a short myth, legend, or historical story in a modern setting, maintaining an original theme but updating the style and setting in their version/creation.

---
### 6-8.T.C.1

Evidence of Student Learning

<table>
  <thead>
    <tr>
      <th>Teacher Prompt</th>
      <th>Student Response</th>
    </tr>
  </thead>
  <tbody>
    <tr>
      <td>Say to students, Write a short summary of yesterday’s lesson to catch your best friend up on what was missed.</td>
      <td>        <p>Student responses may vary, but could include:</p>
        <p>- Hey! Yesterday in ELA, we learned about taking someone’s work and pretending it’s really yours. You have to write a lot of stuff down to show you don’t mean to steal what somebody else wrote.</p>
        </td>
    </tr>
    <tr>
      <td>Provide students with a few minutes to write, and then say, Now, rewrite that short summary for the principal.</td>
      <td>        <p>Student responses may vary, but could include:</p>
        <p>- Yesterday in our ELA class, we learned about plagiarism, which is when someone takes another person’s work and pretends it’s their own. We discussed how important it is to give credit by writing down information properly to show that you didn’t intend to steal someone else’s work.</p></td>
    </tr>
    <tr>
      <td>Ask students to share and discuss as a class, What changed and why?</td>
      <td>        <p>Student responses may vary, but could include:</p>
        <p>- The tone changed from informal to more formal and respectful.<br>
        - The words were changed from more friendly words to more professional-sounding words.</p></td>
    </tr>
    <tr>
      <td>Review the terms purpose and audience. Use a sample paragraph to model identifying the purpose and audience of a text. Then show the same paragraph written for a different audience and/or purpose. Use think-aloud to ask and answer these questions:<br>
      - What clues suggest why the author created this text?<br>
      - How does the language shift based on who the text is meant for?<br>
      - How do choices such as language and tone serve the purpose and engage the specific audience?</td>
      <td>
        <p>Student responses may vary, but could include:</p>
        <p>- I think the author’s purpose is to inform the reader about how pollution affects the environment.<br>
        - The audience is lawmakers who can make laws about pollution.<br>
        - The language in the first text is focused on the science of pollution, but the second text uses less formal language.</p>
      </td>
    </tr>
    <tr>
      <td><br><br>Put students in pairs and provide them with two short texts on the same topic (e.g., a news article for adults vs. a social media post for teens). After students read both texts, have them answer:<br>
      - What is the author’s purpose?<br>
      - Who is the intended audience?<br>
      - What clues in the text tell you this?<br>
      - How does tone and language shift between the texts?</td>
      <td></td>
    </tr>
    <tr>
      <td>Divide students into groups and assign each a different text, a different purpose, and a different audience (e.g., younger students, teachers, parents, peers).<br><br></td><td></td></tr>
    <tr><td>
      Say, Now, you will rewrite your group’s short text for your assigned purpose and audience. Make sure you adjust your language, tone, and details based on your group’s purpose and audience.<br><br>
      Circulate while groups are working, providing feedback and clearing up any misconceptions.<br><br></td><td><p>Responses will vary.</p></td></tr>
    <tr><td>
      Provide time for students to answer the following reflection question: How did thinking about purpose and audience change the way you interpreted and rewrote the text?</td>
      <td>
        <p>Student responses may vary, but could include:</p>
        <p>- When I first read the text, I just thought about what was happening, but when I had to think about why the author wrote it and who they were writing for, I noticed a deeper message because of the language and tone.<br>
        - When I rewrote the text for a younger audience, I used simpler words and shorter sentences so it would be easier for little kids to understand.</p>
      </td>
    </tr>
  </tbody>
</table>

---

### 6-8.T.C.2

Evidence of Student Learning

<table>
  <thead>
    <tr>
      <th>Teacher Prompt</th>
      <th>Student Response</th>
    </tr>
  </thead>
  <tbody>
    <tr>
      <td>Ask students to answer the question, Can two people describe the same event differently? Why or why not?<br><br>
      Have students journal a quick response and then share out.</td>
      <td>
        <p>Student responses may vary, but could include:</p>
        <p>- Yes, two people can describe the same event differently because everyone sees things through their own eyes, and people notice different details based on what they care about or how they feel.</p>
      </td>
    </tr>
    <tr>
      <td>Show two photos of the same scene taken from different angles and discuss how each photo might tell a different story.<br><br>
      Sample think-aloud response:<br>
      – One photo is zoomed in on one thing showing what’s most important to the photographer. The other photo shows the whole area, so maybe the photographer wanted to show that everything is important.<br><br>
      Review the terms author, perspective, and context.</td>
      <td></td>
    </tr>
    <tr>
      <td>Share with students a short text with a clearly influential author perspective. Provide students with a brief bio of the author and discuss what was happening during the time the text was written.<br><br>
      Read the text aloud or have students read in pairs. Encourage students to annotate while reading, underlining emotional words, circling repeated phrases, and noting anything surprising.<br><br>
      Complete the first two rows of the graphic organizer (shown below) together.<br><br>
    <table border="1" cellpadding="6" cellspacing="0">
  <thead>
    <tr>
      <th>Category</th>
      <th>Student Response</th>
    </tr>
  </thead>
  <tbody><tr><td><br></td><td></td></tr><tr><td><br></td><td></td></tr>
</tbody></table>
    </tr>
    <tr>
      <td>Discuss as a class how those two categories might influence the way the author writes and what they focus on.<br><br>
      Students will work in pairs to finish the graphic organizer. Provide sentence starters for students needing additional support.<br><br>
      *Student responses may vary; those here are only samples.*</td>
      <td>
      </td>
    </tr>
    <tr>
      <td>Have pairs share one insight from their graphic organizer (see possible responses above) and facilitate a class discussion around those insights.</td>
      <td>    <table border="1" cellpadding="6" cellspacing="0">
  <thead>
    <tr>
      <th>Category</th>
      <th>Student Response</th>
    </tr>
  </thead>
  <tbody><tr><td>Author's Background</td><td>John Smith was a male astronaut and pilot who went into space in teh 1960s.</td></tr><tr><td>Historical Context</td><td>This was during the Space Race between the US and the Soviet Union. Space travel was still dangerous.</td></tr><tr><td>Clues from the Text that Show Author's Perspective</td><td>He uses technical words like module and capsule to describe the spaceship. He talks about how amazing it was to see Earth from space.</td></tr><tr><td>How the Author's Perspective Shapes the Message</td><td>Because the author was actually there, the story feels real and exciting. His background as a pilot helped him explain things clearly for the reader.</td></tr>
</tbody></table></td>
    </tr>
    <tr>
      <td>As a summarizer, students can respond in writing to the following question:<br><br>
      <em>What’s one way the author’s personal perspective shaped how the text was written or what was said?</em></td>
      <td>
        <p>Student responses may vary, but could include:</p>
        <p>- One way the author’s perspective changed the text is that he used very detailed language because he was an actual astronaut.</p>
      </td>
    </tr>
  </tbody>
</table>

---

### 6-8.T.SS.1

Evidence of Student Learning

<table>
  <thead>
    <tr>
      <th>Teacher Prompt</th>
      <th>Student Response</th>
    </tr>
  </thead>
  <tbody>
    <tr>
      <td>
        Prepare a news article and a short video clip around the same topic (for example, food waste).  
        <br><br>
        Say, <em>We’re going to watch a news clip and read an article about food waste. As we engage with the texts, ask yourself these questions:</em>  
        <ul>
          <li>Who is the audience?</li>
          <li>What is the purpose?</li>
          <li>How do you know?</li>
        </ul>
        Provide students with a Venn Diagram.  
        <br><br></td></tr>
        <tr><td>
        Say, <em>Let’s talk about what’s similar about both texts and how they differ. Who will share with the class?</em>  
        <br><br>
        Capture student responses on the board. </td><td>Student responses may vary but could include:  <br>- The reporter says the numbers in an excited way, and in the article, the numbers are big and bold so they stand out. </td></tr>
        <tr><td>
        <br><br>
        Say, <em>Great work! Now we’re going to expand on this. We saw how the authors of the texts used different structures and features to convey the same message. Sometimes authors choose specific structures or features to appeal to a certain audience or achieve a specific purpose. We’re going to look at our Venn Diagram and mark whether the structure or feature was used to appeal to a specific audience or achieve a certain purpose. Who would like to share their thoughts?</em>  
        <br><br>
        Begin filling out the Venn Diagram with students, asking them to provide their rationale.  
        <br><br>
        Allow students to complete the Venn Diagram in groups or pairs. After students complete the work, ask them to share out what they found in a whole group setting.
      </td>
      <td>
        <p>Student responses may vary but could include:</p>
        <p>- The reporter says the numbers in an excited way, and in the article, the numbers are big and bold so they stand out.</p>
        <p>Student responses may vary but could include:</p>
        <p>- I think the reporter says the number on purpose to show how big of a problem food waste is. He wants people to really understand it’s serious. He also might be trying to get the audience’s attention and keep them interested by being energetic and fun.</p>
      </td>
    </tr>
  </tbody>
</table>

---

### 6-8.T.SS.2

Evidence of Student Learning

<table>
  <thead>
    <tr>
      <th>Teacher Prompt</th>
      <th>Student Response</th>
    </tr>
  </thead>
  <tbody>
    <tr>
      <td>
        Show students two distinct and captivating headlines and say, <em>Let’s look at these headlines together. Which one gets more of a reaction out of you? How did the author get that reaction from you?</em>
        <br><br></td><td>        <p>Student responses will vary but could include:</p>
        <p>- The first headline got more of a reaction out of me because it used statistics to shock the audience and catch their attention.</p></td></tr>

    <tr><td>
        Provide students with a See-Think-Wonder graphic organizer and two texts around the same topic (for example, healthy foods).
        <br><br>
        Say, <em>Today we are going to read two texts. As we read, we’re going to try to figure out why the authors chose specific words or language to meet their purpose or appeal to their audience.</em>
        <br><br></td></tr>

    <tr><td>
        Read the first text with the students and capture their responses.
        <br><br></td><td>       <p>Student responses will vary but could include:</p>
        <p>- I see that in the text it says, “Junk food is like a thief that steals your energy.” I think the author used a simile to compare junk food to a thief, giving it a negative connotation and supporting the author’s attitude towards the subject of junk food.</p></td></tr>

    <tr><td>
        Say, <em>Now work with your elbow partner to complete your graphic organizer with the second text. When you are done, I want you to circle the sentence that is most captivating to you. Be prepared to defend your choice of sentence.</em>
        <br><br>
        Ask students to share their chosen sentence and choose one to show the class.
      </td>
      <td>
        <p>Student responses will vary but could include:</p>
        <p>- I choose the sentence, “The vending machine snacks were calling his name, but Muhammad walked past it like a boss, opening up his bag of trail mix instead.”<br>
        - I chose this sentence because it makes Muhammad sound like walking past junk food in a vending machine is no big deal.</p>
      </td>
    </tr>
    <tr>
      <td>
        Say, <em>Let’s look more closely at this sentence and see how the author crafted it intentionally.</em>
        <br><br>
        Unpack the sentence with students using the graphic organizer. After each chunk, ask students what language stands out (<strong>see</strong>), what mood or tone it creates (<strong>think</strong>), and how the language responds to audience or purpose (<strong>wonder</strong>).
        <br><br></td></tr>

    <tr><td>
        Ask students to share their chosen sentence and choose one to show the class. 
      </td>
      <td>
        <p>Student responses will vary but could include:</p>
        <p>- The chunk that says “like a boss” stood out to me. I think it creates a confident tone and I’m wondering if the audience is young people like us because it’s informal language we use.</p>
      </td>
    </tr>
  </tbody>
</table>

---
### 6-8.T.T.1

Evidence of Student Learning

<table>
  <thead>
    <tr>
      <th>Teacher Prompt</th>
      <th>Student Response</th>
    </tr>
  </thead>
  <tbody>
    <tr>
      <td>
        Ask students, <em>What is a flashback? Why might authors use this narrative technique?</em>
        <br><br></td><td>Student responses may vary but could include: <br>- A flashback is a technique where the author takes the reader back in time to an event that already happened.  <br>- Authors use flashbacks to help the reader understand the character better by showing their past experiences.  <br>- Flashbacks also make the story more interesting by mixing up the order of events instead of just telling everything in order.  </td></tr>
    <tr><td>
        Briefly review a few previously studied narrative techniques.
        <br><br>
        Explain that today, students will analyze mentor sentences—strong sentences from published authors—to learn how to write their own flashbacks.
        <br><br>
        Display 2–3 mentor sentences that use flashback clearly and effectively. For example:
        <br><em>The mention of summer camp made me think of the time I got lost in the woods.</em>
        <br><br></td></tr>
        <tr><td>
        Ask students:
        <ul>
          <li>What clues show us the action in this sentence is taking place in the past?</li>
          <li>How does flashback connect to the present memory of the story?</li>
          <li>What transition words or phrases does the author use to signal a flashback?</li>
        </ul>
      </td>
      <td>Student responses may vary but could include:  <br>- One clue that shows something from the past is the words “made me think of” and “the time I got lost.” These phrases tell us that the speaker is remembering something that already happened.  </td>
    </tr>
    <tr>
      <td>
        Say to students, <em>Now, I want you to use our mentor sentence to create your own flashback. Let’s use this sentence frame:</em>  
        <br><em>The mention of ____ made me think of…</em>
        <br><br>
        Write the mentor sentence frame on the board and allow students to work individually or with a partner on creating their own flashback sentence.
        <br><br></td><td>        <p>Student responses may vary but could include:</p>
        <p>- The mention of a new puppy made me think of the first time I got a pet.</p>
        <p>- The mention of summer vacation made me think of long, sunny days at the beach.</p></td>
    </tr>
    <tr>
      <td>
        Circulate as students are working, providing feedback. Have one or two pairs share their new mentor sentence with the class.
        <br><br>
        Set up stations with 6–8 additional mentor sentences, each using flashback. In pairs, students rotate between stations, annotating how each sentence signals a flashback and could contribute to a longer text.
        <br><br>
        At each station, students will write an imitation of the mentor sentence using their own subject but the same flashback structure.  
        <br>Sample mentor sentences could include:
        <ul>
          <li><em>The smell of paint reminded me of when my parents painted my room.</em></li>
          <li><em>When I heard the drum solo in my favorite song, it took me back to band classes.</em></li>
        </ul>
    </td>
    </tr>
    <tr>
      <td>
        Collect student imitation sentences as a ticket-out-the-door and use them as a formative assessment to drive further instruction with narrative techniques.
      </td>
      <td>
        <p>Responses will vary.</p>
      </td>
    </tr>
  </tbody>
</table>

---

### 6-8.T.T.2

Evidence of Student Learning

<table>
  <thead>
    <tr>
      <th>Teacher Prompt</th>
      <th>Student Response</th>
    </tr>
  </thead>
  <tbody>
    <tr>
      <td>
        Review previously taught expository techniques.  
        <br><br>
        Say, <em>Today, we are going to focus on the expository techniques of key details and statistics. We will look at texts where the authors have used those two techniques, and soon you will practice using key details and statistics in texts that you construct.</em>  
        <br><br></td></tr>
    <tr><td>
        Ask students, <em>Why do authors use key details and statistics in their texts?</em>  
        Have students jot down a quick response and discuss as a class.  
        <br><br>
        <em>Guide students to the realization that key details and statistics can be used in multiple genres for multiple purposes.</em>  
        <br><br></td><td>      <p>Student responses may vary but could include:</p>
        <p>- To make an argument clear and convincing.</p>
        <p>- To show how important a fact is and that it has proof.</p></td></tr>
    <tr><td>
        With the class, create an anchor chart for key details and statistics (example shown below):  
        <br><br>
            <table border="1" cellpadding="6" cellspacing="0">
  <thead>
    <tr>
      <th>Key Details</th>
      <th>Statistics</th>
    </tr>
  </thead>
  <tbody><tr><td><br></td><td></td></tr><tr><td><br></td><td></td></tr>
</tbody></table>
      </td>
    </tr>
    <tr>
      <td>
        Use a short text excerpt or infographic and model identifying the main idea, 2-3 key details, and 1-2 statistics. Think aloud as you annotate. For example:  
        <br><em>The statistic makes the author’s point more credible because numbers give us evidence we can measure.</em>  
        <br><br>
        As a class, add one or two examples for key details and statistics that are specific to the think-aloud excerpt.
      </td>
      <td>
  
        <p>Student responses may vary but could include:</p>
            <table border="1" cellpadding="6" cellspacing="0">
  <thead>
    <tr>
      <th>Key Details</th>
      <th>Statistics</th>
    </tr>
  </thead>
  <tbody><tr><td>details that are the most important</td><td>facts in number form</td></tr><tr><td>EX: Social media helps teens stay in touch with friends.</td><td>EX: Over 60% of teens use social media every day.</td></tr>
</tbody></table>
    </tr>
    <tr><td>Say, The statistic makes the author’s point more credible because numbers give us evidence we can measure. <br><br>As a class, add one or two examples for key details and statistics that are specific to the think-aloud excerpt.  </td></tr>
    <tr>
      <td>
        Provide students with various topics (e.g., screen time, climate change, fast food) so they may choose one to quickly research, and provide students with a graphic organizer for locating expository techniques in source texts.  
        <br><br>
        Say to students, <em>Find at least two key details and two statistics from credible sources related to your chosen topic. Jot those details and statistics down, along with the bibliographic information you will need for those sources.</em>  
        <br><br>
        Circulate while students research their chosen topics and gather their key details, statistics, and bibliographic information, providing support as needed.  
        <br><br></td>      <td>
        <p>Responses will vary by topic, source, and grade level, but they may resemble:</p>
        <p>- 7th-grade graphic organizer sample where the student located two sources.</p>

      </td></tr>
    <tr>
      <td>
        During the next class session, move students toward using their key details and statistics to create a rough draft (using expository or argumentative techniques) to share with a peer for feedback.
      </td>
      <td>
        <p>Responses will vary.</p>
      </td>
    </tr>
  </tbody>
</table>

---
### 6-8.T.T.3

Evidence of Student Learning

<table>
  <thead>
    <tr>
      <th>Teacher Prompt</th>
      <th>Student Response</th>
    </tr>
  </thead>
  <tbody>
    <tr>
      <td>
        Review previously taught argumentative techniques.  
        <br><br>
        Ask students, <em>What makes an argument convincing?</em>  
        As students respond, record their responses on an anchor chart.  
        <br><br></td><td>        <p>Student responses may vary but could include:</p>
        <p>- Strong claim with strong evidence and facts with explanation.</p>
        <p>- Persuasive language without going overboard.</p>
        <p>- The author addresses a counterargument.</p></td></tr>

<tr><td>
        Review and clarify the meanings of <strong>claim</strong>, <strong>counterclaim</strong>, and <strong>rebuttal</strong>:  
        <ul>
          <li><strong>Claim:</strong> a statement that asserts something is true; the main argument or stance the writer takes</li>
          <li><strong>Counterclaim:</strong> an argument presented against a claim; an opposing viewpoint to the claim</li>
          <li><strong>Rebuttal:</strong> a response to the counterclaim that defends the original claim with clear evidence and reasoning</li>
        </ul>
        Share a short argumentative text that includes a strong claim, counterclaim, and rebuttal.  
        <br><br>
        Say, <em>We’re going to do a short practice activity to review these three argumentative techniques. With your partner, read this sample text and highlight these techniques when you find them:</em>  
        <ul>
          <li>Claim — yellow</li>
          <li>Counterclaim — green</li>
          <li>Rebuttal — blue</li>
        </ul>
        Say, <em>Also, underline the strong evidence the author used to support the claim. Be ready to explain why you considered the evidence to be strong.</em>  
        <br><br>
        Provide students with time to read and annotate the sample text. Circulate while students are working, providing support as needed.
      </td>
      <td>
      </td>
    </tr>
    <tr>
      <td>
        When students have finished annotating, have a class discussion where you ask the following questions:
        <ul>
          <li>What is the author’s main claim?</li>
          <li>What evidence supports the claim? Is it strong evidence? Why or why not?</li>
          <li>Are any counterclaims addressed? If so, what is the counterclaim?</li>
          <li>If there is a counterclaim, is there also a rebuttal? If so, what is it?</li>
        </ul>
        <br></td><td>        <p>Student responses may vary but could include:</p>
        <p>- The main claim is “Sugar consumption among teenagers is dangerously high and needs to be reduced to protect their health.”</p>
        <p>- The evidence to support the claim is “In fact, the American Heart Association recommends that teens consume no more than…” This evidence is strong because it includes a specific statistic from a credible source.</p>
        <p>- The counterclaim is “Some people argue that teens should be free to eat what they want and that sugar in moderation is not harmful.”</p>
        <p>- The rebuttal to the counterclaim is “While it’s true that having a sweet treat now and then isn’t dangerous, the problem is…”</p></td>
    </tr>
    <tr>
      <td>
        Have students respond to the items below in their writing journals, reflecting on today’s lesson:
        <ul>
          <li>In one or two sentences, explain what made the argument in today’s text convincing.</li>
          <li>How can you use your learning from today as you begin working on your own short argumentative text?</li>
        </ul>
      </td>
      <td>

      </td>
    </tr>
  </tbody>
</table>

---


### 6-8.T.T.4

Evidence of Student Learning

<table>
  <thead>
    <tr>
      <th>Teacher Prompt</th>
      <th>Student Response</th>
    </tr>
  </thead>
  <tbody>
    <tr>
      <td>
        Review previously taught poetic techniques, as well as the difference between poetry and prose.  
        <br><br>
        Provide students with this prompt:  
        <em>What do poetry and prose have in common? What makes them different?</em>  
        <br><br>
        Allow students to record their answers and then engage in a brief class discussion on student responses.  
        <br><br>
        If not mentioned during discussion, emphasize that while prose is written in paragraphs and poetry in lines/stanzas, both can use poetic techniques like imagery, sound devices, and figurative language.
      </td>
      <td>
        <p>Student responses may vary but could include:</p>
        <p>- Poetry and prose are both types of writing that tell stories or share ideas. They both use words, sentences, and sometimes use description.</p>
        <p>- The difference is that poetry often has rhyme and figurative language, and it is written in lines and stanzas. Prose is written in paragraphs and usually sounds like normal talking. Poetry can be more emotional and artistic, while prose is more regular.</p>
      </td>
    </tr>
    <tr>
      <td>
        Show students a model prose excerpt that uses the lesson’s focus poetic techniques.  
        <br><br>
        For example:  
        <em>The wind whispered through the trees, brushing leaves like fingertips trailing across skin. The forest pulsed with quiet life, shadows dancing on the mossy floor.</em>  
        <br><br></td></tr>
<tr><td>
        Ask students, <em>What poetic techniques can you find? How does this enhance the imagery or the tone?</em>  
        <br><br>
        As students respond, model annotating the excerpt with their responses.
      </td>
      <td>
        <p>Student responses may vary but could include:</p>
        <p>- <strong>Personification:</strong> “The wind whispered” and “shadows dancing” give human traits to nature, making the forest feel alive.</p>
        <p>- <strong>Simile:</strong> “Brushing leaves like fingertips trailing across skin” compares the wind's movement to a gentle human touch.</p>
        <p>- <strong>Imagery:</strong> Vivid sensory descriptions—sight (“shadows dancing,” “mossy floor”), sound (“whispered”), and touch (“fingertips trailing”)—create a rich, detailed scene.</p>
        <p>- These techniques create a gentle, mysterious, and almost magical tone. The personification and simile make the forest feel intimate and alive, as if it’s interacting with the observer. The imagery helps the reader imagine the place clearly, using sights, sounds, and smells to make it feel calm and a little magical.</p>
      </td>
    </tr>
    <tr>
      <td>
        Students will work in pairs/groups to annotate a prose excerpt that contains poetic techniques. Provide each pair/group with a different excerpt.  
        <br><br>
        Students can use a graphic organizer (sample below) to keep track of the techniques used in the excerpt.  
        <br><br>
        Ask groups to share their excerpts and one row from their graphic organizer.  
        <br><br>
        <strong>Sample Organizer:</strong>  
        <table border="1" style="border-collapse: collapse;">
          <tr>
            <th>Poetic Technique</th>
            <th>Example from Text</th>
            <th>Effect on the Reader</th>
          </tr>
          <tr>
            <td>Imagery</td>
            <td>"Sheets of rain poured from the sky, drenching the porch and drumming against the windows like a thousand tiny hammers."</td>
            <td>Appeals to sight and sound, helping the reader feel as if they’re right there in the scene.</td>
          </tr>
          <tr>
            <td>Personification</td>
            <td>"The storm paced across the sky, growling in frustration and roaring with hunger."</td>
            <td>Makes the storm feel alive and dramatic, enhancing tension and mood.</td>
          </tr>
        </table>
        <br>
        Provide students with the following prompt:  
        <em>Write a short descriptive paragraph (4–6 sentences) about a place you love or a memorable moment. Use at least three poetic techniques in your writing. Complete a graphic organizer including your techniques, the example from the text, and the technique’s effect on the reader.</em>
      </td>
      <td>
        <p>Student responses may vary but could include:</p>
        <p><em>My favorite place is the quiet beach at sunset. The sky looks like a giant painting, with orange and pink clouds floating like cotton candy. The waves whisper softly as they kiss the shore, and the salty breeze smells fresh and clean. I love how the sand feels warm under my toes, sparkling like tiny diamonds in the fading light. Being there makes me feel calm and happy, like the whole world is smiling just for me.</em></p>
        <table border="1" style="border-collapse: collapse;">
          <tr>
            <th>Poetic Technique</th>
            <th>Example from Text</th>
            <th>Effect on the Reader</th>
          </tr>
          <tr>
            <td>Imagery</td>
            <td>"The sand feels warm under my toes, sparkling like tiny diamonds in the fading light."</td>
            <td>Appeals to the senses of touch and sight, helping the reader feel the warmth and see the sparkling sand, which makes the place come alive in their mind.</td>
          </tr>
          <tr>
            <td>Alliteration</td>
            <td>"Waves whisper" and "salty breeze smells"</td>
            <td>The repetition of the ‘w’ and ‘s’ sounds creates a soft, soothing rhythm that’s like the gentle sounds of the beach, making the description more calming.</td>
          </tr>
        </table>
      </td>
    </tr>
    <tr>
      <td>
        As an exit ticket, students can respond in writing to the following question:  
        <br><br>
        Circle one:  
        <ul>
          <li>I can confidently identify poetic techniques.</li>
          <li>I can somewhat identify poetic techniques.</li>
          <li>I need more help identifying poetic techniques.</li>
        </ul>
        <br>
        Use the results of this exit ticket to plan future instruction.
      </td>
      <td>
        <p>Responses will vary, but they will fall into one of the three categories above.</p>
      </td>
    </tr>
  </tbody>
</table>

---
### 6-8.T.RA.1

Evidence of Student Learning

<table>
  <thead>
    <tr>
      <th>Teacher Prompt</th>
      <th>Student Response</th>
    </tr>
  </thead>
  <tbody>
    <tr>
      <td>
        Ask students, <em>Have you ever seen the grade posted on the door or window of a restaurant? That grade comes from a health inspection. Why might this be important to us as customers?</em>  
        <br><br></td><td>        <p>Responses will vary but may include:</p>
        <p>- It shows if the restaurant is clean.</p>
        <p>- It tells us if the food is safe.</p>
        <p>- If the score is low, you probably don’t want to eat there.</p></td></tr>
    <tr><td>
        Affirm students’ responses. Say, <em>This is a clear case where having a question, such as “What is the health score, and why is it that way?” can directly impact your physical health. Today, we’ll generate our own questions about restaurant health scores.</em>  
        <br><br></td></tr>
    <tr><td>
        Ask students, <em>Have any of you ever read that report at a restaurant?</em>  
        <br><br>
        Provide students with a health inspection report (blank form or created sample).  
        <br><br></td><td>        <p>Responses will vary but may include:</p>
        <p>- I’ve seen the score on the wall, but I didn’t read the details.</p>
        <p>- I saw one with a big ‘C,’ and my family left because we didn’t feel safe eating there.</p></td></tr>
    <tr><td>
        Say, <em>Here’s a copy of a health inspection report. Let’s take a close look together. When I read an inspection report, I ask myself: “What do these numbers mean? What’s the difference between an A and a C? What kinds of violations are most common?” Those are research questions that guide my reading. To be a real research question, I want questions that can be answered with more than just a ‘yes’ or a ‘no.’</em>  
        <br><br></td></tr>
    <tr><td>
        Ask students, <em>What questions do you have?</em>  
        Students can take turns sharing or can add questions to sticky notes or chart paper for their group.
      </td>
      <td>
        <p>Responses will vary but may include:</p>
        <p>- What happens if a restaurant fails?</p>
        <p>- How low can the score be?</p>
        <p>- How are the points calculated?</p>
        <p>- What’s the most common reason restaurants lose points?</p>
        <p>- Who decides the score?</p>
        <p>- Do some mistakes count as more points than others?</p>
        <p>- How can a health score prevent people from getting sick?</p>
      </td>
    </tr>
    <tr>
      <td>
        Affirm students’ responses. Circulate the room, asking clarifying questions and offering feedback. Model asking questions or providing statements that extend or challenge ideas and information (for example:  
        <br><em>If a student asks about losing points for improper food storage, a follow-up question might be, “Why might improper food storage matter for customers?”</em>  
        <br>or  
        <br><em>If a student asks about the score it takes for a restaurant to close, a follow-up statement might be, “You’re asking if restaurants ever get shut down. That’s a strong question because it pushes us to think about how the system works to protect the public.”</em>)  
        <br><br></td></tr>
    <tr><td>
        Say, <em>After everyone in your group creates questions, decide as a group which 2–3 questions you want to focus on. Then, begin trying to locate the answers for your questions from credible sources.</em>  
        <br><br>
        <strong>Note:</strong> To adhere to local policy and/or to provide scaffolding based on student need, curated resources could also be provided to students.  
        <br><br>
        Circulate the room, ensuring students are using credible sources and asking or answering additional clarifying questions.  
        <br><br></td><td>        <p>Student groups select 2–3 research questions and begin conducting research to locate answers. Responses will vary based on questions.</p></td></tr>
    <tr><td>
        Ask students, <em>For your exit ticket, what will you look for on the health inspection report the next time you are in a restaurant?</em>  
        <br><br></td>      <td>
        <p>Responses will vary but may include:</p>
        <p>- I’ll look at the violations, not just the letter grade.</p>
        <p>- I’ll pay attention to whether it’s an A, B, or C, and why.</p>
      </td></tr>
    <tr><td>
        Say, <em>Well done! You’ve shown that you can generate thoughtful questions, look for evidence in credible sources, and connect what you learn back to real life. That’s the heart of research and inquiry.</em>
      </td>

    </tr>
  </tbody>
</table>

---
6-8.T.RA.2

<table>
  <thead>
    <tr>
      <th>Teacher Prompt</th>
      <th>Student Response</th>
    </tr>
  </thead>
  <tbody>
    <tr>
      <td>Say, Today we’ll explore how superhero stories influence the world. Think about it—superheroes, storylines, even the art. Our research question today is “Why do superhero stories appeal to so many people?” What are your ideas before we even begin the actual research?</td>
      <td>
        <em>Responses will vary but could include:</em>
        <ul>
          <li>They gave people hope during wars.</li>
          <li>They inspire movies.</li>
          <li>They have cool costumes.</li>
        </ul>
      </td>
    </tr>
    <tr><td>Say, Today we’re going to work with three different sources about superhero stories — one from history, one that’s datadriven, and one that’s multimodal. Our goal is to practice deciding what makes a source credible and relevant, and then use the evidence correctly.  Provide students with curated texts about the topic or research question; sample source excerpts are provided to accompany the research question above.</td></tr>
    <tr>
      <td>Say, Now, Let’s read our mock sources. Remember—credible sources are usually written by experts, contain evidence, or come from reliable publications. At first glance, which of these sources seems more credible for research?</td>
      <td>
        <em>Responses will vary but could include:</em>
        <ul>
          <li>I think the historical article shows what comics used to mean.</li>
          <li>The data one seems more like numbers and facts.</li>
          <li>The online one looks more current, and it even has a podcast.</li>
        </ul>
      </td>
    </tr>
    <tr>
      <td>Direct students to review Source #1 and ask students, Who is the author, and why does that matter?</td>
      <td>It’s by Dr. Helena Morris, a historian. That makes it more credible.</td>
    </tr>
    <tr>
      <td>Say, We generally like to have current sources for a few reasons. Information changes quickly, so what was true a few years ago may not be true (or the most accurate) now. Older sources can be valuable for history, but if you’re answering a modern question, you need modern evidence.<br><br>Ask a follow-up question, Is this source current enough for our question?</td>
      <td>It’s from 1998, so it’s older, but it still helps us understand history.</td>
    </tr>
    <tr>
      <td>Ask students, For Source #2, who is the author, and why does that matter?</td>
      <td>International Media Studies Institute (IMSI). It’s an institute, so it is probably credible.</td>
    </tr>
    <tr>
      <td>Ask a follow-up question, Is this source current enough for our question, or do you see any initial issue with the credibility of this source?</td>
      <td>
        Yes. It’s from 2021.<br><br>
        We don’t know the institute, or if it has some sort of agenda or bias.
      </td>
    </tr>
    <tr>
      <td>Ask students, For Source #3, who is the author, and why does that matter?</td>
      <td>It’s a journalist named Lin Zhao.</td>
    </tr>
    <tr>
      <td>Ask a follow-up question, Is this source current enough for our question, or do you see any initial issue with the credibility of this source?</td>
      <td>The source is pretty current and seems relevant, but it may include  more opinion than facts.</td>
    </tr>
    <tr><td>
       Provide students with graphic organizers (sample) to organize the information. Explain that students need to choose the two sources that they feel best support the research question; they should list their respective authors, facts, perspective notes (if applicable), and a brief explanation of how each one responds to the research question. Circulate the room as students work on their graphic organizer, providing support.  
    </td><td>Students work on completing a graphic organizer to extract information from the curated sources. </td></tr>
    <tr><td>Say, Next, you will use the evidence you just gathered to support your idea using the sources.<br><br> After students complete their information-gathering, think-aloud and model a sample response: Superhero stories have shaped society in both the past and present. In the 1940s, comic books sold over 25 million copies a month, giving readers hope during World War II (Morris). Today, 72% of teenagers worldwide engage with superhero media weekly, proving these stories remain powerful (IMSI). Together, the sources show that superheroes have inspired generations while still capturing audiences today. </td></tr>
    <tr><td>Say, Now, you will work on taking your graphic organizer and creating your own paragraph using the facts you selected.  Circulate the room as students work on their graphic organizer, providing support.</td><td>Responses will vary based on selected information. </td></tr>
    <tr><td>Say, Well done! You evaluated sources for credibility and relevance, and you are using evidence and citations to support your ideas!  </td></tr>
  </tbody>
</table>

-----

###6-8.T.PM.1

<table>
  <thead>
    <tr>
      <th>Teacher Prompt</th>
      <th>Student Response</th>
    </tr>
  </thead>
  <tbody>
    <tr><td>Review vocabulary pertinent to the lesson/standard.  <br><br>Have students answer the following writing prompt:   <br><br><i>-Why do you think ancient stories are still told today? </i> </td></tr>
    <tr><td>Provide a few minutes for students to quickly write their responses or discuss with a partner. Discuss a few responses as a class.  </td><td>Student responses may vary but could include: <br>- Ancient stories like myths are still told today because they teach important lessons, explain how things came to be, and are really interesting.  <br>- Even though they were made a long time ago, people still enjoy them because they have cool characters, exciting adventures, and messages that still matter today, like being brave or learning from mistakes. </td></tr>
    <tr><td>Provide students with copies of a short myth, along with the modern adaptation. Have students read/view/listen to each text with a partner before completing a Tchart such as the example below. <br>
            <table border="1" style="border-collapse: collapse;">
          <tr>
            <th></th>
            <th>Original Myth</th>
            <th>Modern Version</th>
          </tr>
          <tr> <td>Characters</td><td></td><td></td></tr>
          <tr><td>Theme</td><td></td><td></td></tr>
          <tr><td>Tone</td><td></td><td></td></tr>
          <tr><td>Style</td><td></td><td></td></tr>
          <tr><td>Setting</td><td></td><td></td></tr>
          </table>
          <br>
          Use these key questions to guide students as they complete their chart:  <br>- How are the themes similar and/or different?  <br>- What stylistic changes do you notice?  
    </td><td>
        Student responses may vary but could include: <br><br>
                    <table border="1" style="border-collapse: collapse;">
          <tr>
            <th></th>
            <th>Original Myth</th>
            <th>Modern Version</th>
          </tr>
          <tr> <td>Characters</td><td> The main character is rich and greedy and always wants more </td><td>The main character is a tech millionaire who wants more money and more success </td></tr>
          <tr><td>Theme</td><td>Being greedy can lead to losing something important </td><td>Being obsessed with success can lead to unhappiness</td></tr>
          <tr><td>Tone</td><td>More serious and not very relatable </td><td>More relatable and humorous </td></tr>
          <tr><td>Style</td><td>Formal, old-fashioned language </td><td>Modern slang and more conversation al and it has humor </td></tr>
          <tr><td>Setting</td><td>Ancient Greece</td><td>Modern-day city</td></tr>
          </table>
    </td>
</tr>
<tr><td>Provide students with sentence stems, if needed.  - In both texts, the theme is ___. - One big difference in theme is ___. - The original style is more ___, while the new version is ___. </td></tr>
<tr><td>As a ticket-out-the-door, have students respond to the question, <br>- Why might the author have made the changes you found in the modern adaptation?  <br><br>Provide students with a sentence stem, if needed. <br>- The author probably made these changes to ___. </td><td>Student responses may vary but could include: <br>- The author probably changed the story to make it easier for today’s readers to relate to.  <br>- Not many people think about gold now, but they do think about money, fame, or social media. By using a modern setting and characters, readers can see how the same lesson still matters today.  <br>- Using modern language makes the story easier to understand and more fun to read. </td></tr>

######9-12

### 9-12.L.GC.1

**Overview of Standard**
As students approach graduation, they encounter and apply grammar, usage, and mechanics conventions in a wide range of academic and real-world contexts. Students will expand their understandings of word and phrase relationships, as well as how to use conventions to convey meaning. 

---

### 9-12.L.GC.2

**Overview of Standard**
In this standard, students build upon their prior knowledge of sentences and sentence structures to continue developing their syntactic awareness. In high school, the focus is on reinforcement of those skills and applying those skills in intentional, strategic ways to meet purpose and audience. Using available resources (style guides, etc.) becomes a focus as students grow in their independence to find answers and craft texts (across a variety of disciplines). Students may analyze model sentences, using the syntax of those sentences to create their own. They can also practice manipulating sentences and sentence parts, using skills such as sentence combining and sentence elaboration, to produce more sophisticated writing. 

---

### 9-12.L.V.1

**Overview of Standard**
In this standard, students will expand their vocabulary knowledge by studying words in context rather than in isolation. They will explore a wide range of common words used across multiple subjects and in everyday language; words frequently used in academic contexts across various disciplines; and subject-specific terms essential for understanding particular fields or topics. Students will apply the understandings of these new terms in a variety of real-world contexts. 

---

### 9-12.L.V.2

**Overview of Standard**
As students approach graduation, they encounter and internalize new vocabulary in a wide range of academic and real-world circumstances. Students draw upon their prior knowledge of word parts and etymology, as well as the function of parts of speech, to deconstruct, analyze, and interpret unfamiliar words and phrases. Students also apply these understandings to construct words for clear, concise communication across various contexts. 

---

### 9-12.L.V.3

**Overview of Standard**
As students approach graduation, they encounter and internalize new vocabulary in a range of circumstances, and then apply the understandings of these new terms in a variety of real-world contexts. Students will expand their understandings of word relationships, as well as the effect of nuanced meanings and the way those meanings affect word choice. 

---


### 9-12.L.GC.1

**Vocabulary**
Capitalization
Colon
Comma
Dash
End Punctuation
Parentheses
Quotation Marks
Style Guide
Textual Evidence
Verb
    <i>Aspects</i>
    <i>Moods</i>
    <i>Tenses aspects</i>
Verbal
    <i>Gerunds</i>
    <i>Infinitives</i>
    <i>Participles</i>
Verbal Phrases

---

### 9-12.L.GC.2

**Vocabulary**
Active and Passive Voice
Modifiers
Dangling Modifiers
Misplaced Modifiers
Modifier Phrases and Clauses
Parallel Structure
<i>Sentence Structure Patterns</i>
    simple, compound, complex, compound-complex
Subject-Verb Agreement
Verb Tense
Verb Aspects
Verb Moods

---

### 9-12.L.V.1

**Vocabulary**
Academic Vocabulary
Disciplinary Vocabulary
General Vocabulary
Professional Vocabulary
Technical Vocabulary

---

### 9-12.L.V.2

**Vocabulary**
Affixes
Etymology
Morphology
Parts of Speech (Noun, Verb, Adjective, Adverb)
Prefixes
Roots
Root Words
Suffixes

---

### 9-12.L.V.3

**Vocabulary**
Connotations
Contexts
Denotations
Digital Sources
Meaning
Multiple-Meaning Words
Nuances
Phrases
Print Sources
Reference Materials
Style Guide
Word Processing Features
Word Relationships
Words

---

**9-12.L.GC.1**

**Instructional Strategies for Teachers**
• Provide a supportive environment for writing.
• Have students analyze and evaluate their own writing for patterns so that they grow and learn.
• Model strategies for students using mentor sentences and mentor texts.
• Use graphic organizers.
• Use style guides and resources to make determinations when creating, revising, and editing texts.
• Explore different resources so that students understand the capabilities of each.
• Explicitly teach strategies for planning and goal setting, drafting, evaluating, revising, and editing.
• Utilize a model, practice, and reflect cycle.

---

**9-12.L.GC.2**

**Instructional Strategies for Teachers**
• Reinforce understanding of sentence elements and their functions (<i>subject</i>, <i>predicate</i>, <i>independent clause</i>, <i>dependent clause</i>), as well as structures (<i>simple</i>, <i>compound</i>, <i>complex</i>, <i>compound-complex</i>).
• Allow students to examine models of good writing and model the analysis of well-written sentences.
• Model writing for students, using mentor texts and/or sentences and strong student-written sentences.
• Review, analyze, and evaluate sentences of various syntactical patterns.
• Chunk sentences into phrases and clauses to help determine functions.
• Color-code/highlight sentence parts in mentor and/or personal sentences for syntactical evaluation (e.g., verbs as green, subjects as orange, modifying phrases as blue).
• Allow students to locate their own mentor texts/sentences to share with peers/small groups.
• Provide students with opportunities to imitate mentor sentences in their own writing.
• Provide students with opportunities to manipulate, add, and/or remove words in sentences through activities such as sentence scrambles, sentence combining, and sentence elaboration.
• Provide students with a graphic organizer to track syntactical approaches in their writing, which can be followed by revision to increase syntactical variety.

---

**9-12.L.V.1**

**Instructional Strategies for Teachers**
• Dedicate a portion of regular class time to explicit vocabulary instruction.
• Provide repeated exposure to new words in multiple contexts.
• Provide direct, explicit, and systematic instruction to teach difficult vocabulary.
• Give students opportunities to use new vocabulary in a variety of contexts and modes (<i>discussion</i>, <i>writing</i>, <i>presenting</i>).
• Choose a brief, engaging piece of text that includes academic vocabulary as a platform for vocabulary instruction.
• Pre-teach difficult vocabulary, using graphic organizers (including semantic maps).
• Leverage students’ prior knowledge to learn new vocabulary.
• Incorporate digital tools and strategies to learn, clarify, expand, and use vocabulary.
• Teach multiple meanings of words to foster word consciousness.

---

**9-12.L.V.2**

**Instructional Strategies for Teachers**
• Dedicate a portion of regular class time to explicit vocabulary instruction.
• Teach students to break down words into parts (<i>roots</i>, <i>root words</i>, <i>prefixes</i>, <i>suffixes</i>) to understand meanings.
• Teach students how words may change due to their part of speech (e.g., <i>nominalization</i>).
• Provide students with the opportunity to practice using word analysis skills.
• Teach students to use context and background knowledge to infer word meanings.
• Teach students how to combine word parts to create words based on their roots/root words and prefixes and/or suffixes.
• Teach students how and when to use structural word analysis to determine meanings.
• Visualize and reinforce word relationships.
• Use graphic organizers, such as <i>Frayer models</i>, allowing students to analyze roots and affixes critically, make connections between related words, and develop a deeper understanding of word structure and meaning.
• Leverage content area background knowledge by collaborating with content area teachers.
• Provide repeated exposure to new words in multiple contexts.
• Incorporate digital tools and strategies to learn, clarify, expand, and use vocabulary.

---

**9-12.L.V.3**

**Instructional Strategies for Teachers**
• Dedicate a portion of regular class time to explicit vocabulary instruction.
• Provide repeated exposure to new words in multiple contexts.
• Provide direct, explicit, and systematic instruction to teach difficult vocabulary.
• Give students opportunities to use new vocabulary in a variety of contexts and modes.
• Pre-teach difficult vocabulary, using graphic organizers (including semantic maps) as appropriate.
• Leverage students’ prior knowledge to learn new vocabulary.
• Incorporate print and digital tools and strategies to learn, clarify, expand, and use vocabulary.
• Teach multiple meanings of words to foster word consciousness.
• Teach students to use context and background knowledge to infer word meanings.
• Visualize and reinforce word relationships.
• Use graphic organizers that show the relationships between words, such as the <i>Frayer model</i>.
• Collaborate with content area teachers to leverage content area background and vocabulary knowledge.

---

9-12.L.GC.1

Evidence of Student Learning

<table>
  <thead>
    <tr>
      <th>Teacher Prompt</th>
      <th>Student Response</th>
    </tr>
  </thead>
  <tbody>
    <tr>
      <td>Teachers can prepare samples of any of the scenarios below to heighten student engagement.<br><br></td>
      <td></td>
    </tr>
    <tr>
      <td>Ask students, Why is it important to use textual evidence in your writing?  Additional questions may be layered to allow for an extended discussion. <br><br></td>
      <td>Answers may include building your own credibility as a writer, avoiding plagiarism, etc.</td>
    </tr>
    <tr>
      <td>Ask students, How do we set that textual evidence apart, and how do we show its original source?</td>
      <td>We can quote the source. We can use citations. We use quotation marks.<br><br></td>
    </tr>
    <tr>
      <td>Ask students, When you incorporate textual evidence into your writing, what are some of the common grammar conventions you use?  Additional prodding questions could be utilized to have students expound upon their responses and the specifics.</td>
      <td>Responses may vary, but they may center on the use of quotation marks, end punctuation, commas, parentheses, and capitalization.<br><br><br><br></td>
    </tr>
    <tr>
      <td>Say, When you integrate textual evidence into your own argument as a direct quotation, how do you format that? How do you know HOW to format?<br><br></td>
      <td>It depends on the situation—what you are using, how much you are using, whether it’s in your own words or not.</td>
    </tr>
    <tr>
      <td>Say, Look at this sample: In her article “Creating Evidence Examples,” Smith writes, “Creating new evidence examples can be time-consuming, but ultimately the time spent is worth it” (17).</td>
      <td></td>
    </tr>
    <tr>
      <td>Say: This example is cited in MLA format. Where would I find information on how that needs to look?</td>
      <td>Style guides show that information. We use MLA/APA. [Grades 9-12 may use MLA; grades 11-12 may use APA.]  Students might share a resource like Purdue’s Online Writing Lab (OWL) MLA.</td>
    </tr>
    <tr>
      <td>Say: Using that guidance, draft a sentence integrating a line from the text as a cited direct quotation and a sentence paraphrasing information from the same source.</td>
      <td>Student responses will vary based on source texts, but they should demonstrate correct formatting using the appropriate style guide.</td>
    </tr>
  </tbody>
</table>

----
9-12.L.GC.2

Evidence of Student Learning

<table>
  <thead>
    <tr>
      <th>Teacher Prompt</th>
      <th>Student Response</th>
    </tr>
  </thead>
  <tbody>
    <tr>
      <td>Ask students, What does it mean to be active? Have you ever been asked to engage in active participation? Go outside and be active?</td>
      <td>Responses will vary. To move. To exercise. To do something.</td>
    </tr>
    <tr>
      <td>Say to students, Active voice in writing follows the same idea. It all goes back to the idea of subject and verb. Does the subject “do” the action of the verb, or does the action happen to the subject?</td>
      <td></td>
    </tr>
    <tr>
      <td>Typically, active voice is more direct and concise, which is why it is used more in ELA and history. Passive voice tends to be used more in the sciences.</td>
      <td></td>
    </tr>
    <tr>
      <td>Use either the sample sentence below or one of your own. Writing or projecting it for students might be beneficial.</td>
      <td></td>
    </tr>
    <tr>
      <td>Grace baked chocolate chip cookies, and they were eaten by her friends.</td>
      <td></td>
    </tr>
    <tr>
      <td>Ask students, First, what are the main verbs of the sentences (the two independent clauses)?</td>
      <td>baked, were eaten</td>
    </tr>
    <tr>
      <td>Ask students, Now, what are the subjects? Who or what is “doing” the action of the verbs?</td>
      <td>Grace, friends</td>
    </tr>
    <tr>
      <td>If students identify “they” as the subject, that might open the door for scaffolding. Are “they” the ones doing the eating?</td>
      <td></td>
    </tr>
    <tr>
      <td>Ask students, Why do you think schools (and people) in general prefer writing to be in active voice?</td>
      <td>To be more accurate. To be more direct. To be more specific.</td>
    </tr>
    <tr>
      <td>Present students with a mentor sentence within a larger context that illustrates active or passive voice. Different samples could be given to different groups, depending on the instructional design.</td>
      <td></td>
    </tr>
    <tr>
      <td>Ask students: Does this sample show active or passive voice? How do you know?</td>
      <td>Student answers will depend on the sample provided.</td>
    </tr>
    <tr>
      <td>Say to students, There ARE some disciplines that use passive voice (sciences). It’s not that passive voice is wrong, but you need to consider the context and purpose of the text before using passive voice.</td>
      <td></td>
    </tr>
    <tr>
      <td>Ask students, Why do you think some writers use passive voice? How is it connected to the scientific disciplines?</td>
      <td>Students provide their position and explain their rationales.</td>
    </tr>
    <tr>
      <td>Ask students, Would anyone share an example from your writing that features active voice?</td>
      <td>Individual student work may be shared.</td>
    </tr>
  </tbody>
</table>

----

9-12.L.V.1

Evidence of Student Learning

<table>
  <thead>
    <tr>
      <th>Teacher Prompt</th>
      <th>Student Response</th>
    </tr>
  </thead>
  <tbody>
    <tr>
      <td>Ask students, Have you ever felt like you knew the meaning of a word but not exactly its specific meaning? Follow-up by asking, Have you ever tried to use that word only to learn that you used it incorrectly?</td>
      <td>Students may share personal anecdotes.</td>
    </tr>
    <tr>
      <td>Provide students with an example of your experience with not truly understanding the specific meaning of a word.</td>
      <td></td>
    </tr>
    <tr>
      <td>Say to students, Learning new vocabulary words (and using them correctly) is part of life, especially as you near graduation. In many career paths, specialized vocabularies exist that you don’t find anywhere else.</td>
      <td></td>
    </tr>
    <tr>
      <td>Here are some terms from specific fields (write on the board as you read aloud): esthetics, cross-fade, chassis, basic metabolic panel, aerator, algorithm, demographics, jurisdiction, aperture</td>
      <td></td>
    </tr>
    <tr>
      <td>Ask students, Have you ever heard any of these terms before? Which ones have you heard? How well do you know them on a scale of 1-5?</td>
      <td>Students may share with a partner those terms they have heard before and how well they think they know those terms.<br><br> Students hold up the number of fingers related to the level of their content knowledge on presented words. </td>
    </tr>
    <tr>
      <td>Say to students, Now, we are going to practice our vocabulary skills as we prepare to read <i>insert your text here.</i> We will all read the text then write what we think the underlined words mean based on what we read and understand. Then, we will come back together to discuss and clarify.</td>
      <td></td>
    </tr>
    <tr>
      <td>Allow students to have adequate time to engage with the text. Encourage annotation.</td>
      <td></td>
    </tr>
    <tr>
      <td>Say, Now, take a moment and record your thoughts about what the word means based on what you read. Did anyone’s thoughts change?</td>
      <td>Mixed responses are possible, but students may mention terms more like methodology, demographics, jurisdiction, exfoliant, appeal (words that are more in the language of the world they encounter).</td>
    </tr>
    <tr>
      <td>Provide students with each word’s denotation(s) and part(s) of speech, as used in the text.</td>
      <td></td>
    </tr>
    <tr>
      <td>Say, Now, we will re-read the text with this new knowledge, and I want you to see if that helps with your understanding.</td>
      <td></td>
    </tr>
    <tr>
      <td>Re-read the text with the confirmed vocabulary knowledge to aid comprehension.</td>
      <td></td>
    </tr>
    <tr>
      <td>Say, Did your understanding change? How did your reading change after clarifying the meanings of those words?</td>
      <td>Yes. No. Students may explain their differing (or unchanging) responses based on the context they encountered in the text.</td>
    </tr>
  </tbody>
</table>

----

9-12.L.V.2

Evidence of Student Learning

<table>
  <thead>
    <tr>
      <th>Teacher Prompt</th>
      <th>Student Response</th>
    </tr>
  </thead>
  <tbody>
    <tr>
      <td>Ask students, Can anyone provide us with an overview of how roots, root words, prefixes, and suffixes function—what they do?</td>
      <td>A student (or multiple) student explains that they are the building blocks for words (or something along those lines). Someone might mention Latin or Greek etymologies.</td>
    </tr>
    <tr>
      <td>Validate student responses and clear up any misconceptions.</td>
      <td></td>
    </tr>
    <tr>
      <td>Ask students, What do you think the root word mech means?</td>
      <td>Answers may vary, but they may be connected to “mechanical” or “mechanic.” Validate any answers in the ballpark.</td>
    </tr>
    <tr>
      <td>Ask students, Now, using your resource, what does the root word mech mean?</td>
      <td>Mech means machine or tool.</td>
    </tr>
    <tr>
      <td>Say to students, A closely related suffix is -an, which means “a person or thing who performs an action.</td>
      <td></td>
    </tr>
    <tr>
      <td>Ask students, What does the suffix -ism mean?</td>
      <td>Ism is a suffix that just turns the word into an abstract noun.</td>
    </tr>
    <tr>
      <td>Ask students, When we put these word parts together, what do we get?</td>
      <td>Mechanism</td>
    </tr>
    <tr>
      <td>Say to students, Let’s take the word mechanism. That’s probably a word many of us know.</td>
      <td></td>
    </tr>
    <tr>
      <td>Ask students, What’s a mechanism?</td>
      <td>Answers may vary, but some may focus on something like a lever or tool—a piece of machinery. Some may talk about a process to get something done.</td>
    </tr>
    <tr>
      <td>Say to students, In the past, the meaning of this word was more related to machinery and tools, but over time, it has come more to mean any sort of thing or process to get something done. Both meanings are denotations.</td>
      <td></td>
    </tr>
    <tr>
      <td>Ask students, What are some other words that use the suffix -ism to change words into an abstract noun?</td>
      <td>Answers may vary, but could include: capitalism, journalism, heroism, optimism, criticism</td>
    </tr>
    <tr>
      <td>Say, Now that we've explored these word parts, let’s put it all together. With a partner, create a short paragraph using at least five words containing roots, prefixes, and/or suffixes using your chart. Underline each word and explain its components in the margin. Then, we will share out.</td>
      <td>Students share out their paragraphs, explaining their words based on the meanings of the separate word parts and how they interact to form definitions for each word as a whole.</td>
    </tr>
  </tbody>
</table>

-----

9-12.L.V.3

Evidence of Student Learning

<table>
  <thead>
    <tr>
      <th>Teacher Prompt</th>
      <th>Student Response</th>
    </tr>
  </thead>
  <tbody>
    <tr>
      <td>Ask students, How do we tell the difference between words that share the same basic denotation? For instance, disappointed, upset, distressed, and frustrated. What common denotation do they all share?</td>
      <td>Answers may vary, but they should center around a negative denotation – sad.</td>
    </tr>
    <tr>
      <td>Say to students, Yes, they all share the same common denotation of sad. But do all those words mean exactly the same thing, though?</td>
      <td>Facilitate a conversation where students explain the difference between those words in their own language. If not covered in conversation, provide students with definitions and/or examples for disappointed, upset, distressed, and frustrated.</td>
    </tr>
    <tr>
      <td>Ask students, For instance, would you be “frustrated” or “sad” by your inability to change your work schedule?</td>
      <td>Frustrated</td>
    </tr>
    <tr>
      <td>Say to students, Frustrated is a more precise term for this situation because it indicates being upset, but it is complicated by the perceived (or real) inability to change the “frustrating” factor.</td>
      <td></td>
    </tr>
    <tr>
      <td>Say to students, So, what happens when you realize you are being repetitive when writing a paper? Do you just blindly click on the thesaurus for synonyms? We just saw what happened with “sad,” right?</td>
      <td>Answers will vary. Some will probably admit to blindly clicking. Others may not. Facilitate a discussion about practice, which can then cross over into 9-12.L.V.3.d (using resources).</td>
    </tr>
    <tr>
      <td>Say to students, Let’s look at a sample: The student’s original sentence reads, “My aunt baked a delicious birthday cake.” However, in the rest of the paper, the student uses the term “delicious” four times within one paragraph. She looked up “delicious” in a thesaurus and chose the first term she saw: “savory.” The sentence now reads, “My aunt baked a savory birthday cake.” While “savory” does indicate something is pleasing to the taste, its meaning is when something has a salty or spicy flavor. Imagine a birthday cake made of chicken and cheese. While it is an intriguing concept, it was not the student’s original intent. The student had access to resources but did not employ them in a way that benefited the writing.</td>
      <td></td>
    </tr>
    <tr>
      <td>Say to students, Take a moment to think about what you do now. How will you will use resources moving forward to ensure you are communicating clearly?</td>
      <td>Answers will vary (if given). Students may just engage in reflection but not discussion.</td>
    </tr>
  </tbody>
</table>

---

### K-12.P.EICC.1:

**Overview of Standard**
In this standard, students develop their reader and writer identities for both their personal and academic lives by building a toolkit to engage with texts both as consumers and producers. Students’ confidence will grow as they engage with and create various types of texts, allowing them to seek out new reading materials and writing opportunities.

---

### K-12.P.EICC.2:

**Overview of Standard**
In this standard, students engage in purposeful conversation as both author and audience to explore ideas, share knowledge, and respond to texts. Through these interactions, students make intentional connections within and across texts, deepening their understanding, constructing meaning, and using language to fulfill their purposes.

---

### K-12.P.EICC.3:

**Overview of Standard**
In this standard, students will read and comprehend a variety of complex texts across genres, disciplines, and purposes. They will preview texts, activate prior knowledge, set goals, and predict content. Students will also monitor their own understanding while asking questions and summarizing sections of the text, and then reflect on meaning, summarize the text, and apply what they’ve learned.

---

### K-12.P.EICC.4:

**Overview of Standard**
In this standard, students will create a variety of texts based on audience(s) and purpose(s). They will take an intentional journey through the writing processes such as planning, drafting, evaluating, revising, and editing, making choices based on the audience and purpose of the text.

---

### K-12.P.ST.1:

**Overview of Standard**
In this standard, students are encouraged to go beyond the surface of a text and consider the broader circumstances that shape its meaning and impact. Understanding the author’s life, purpose, and historical backdrop of the text will help students explain motivations, themes, and perspectives. Students will analyze how historical and contemporary events, along with technological developments, affect texts, helping them understand how ideas evolve over time.

---

### K-12.P.ST.2:

**Overview of Standard**
In this standard, students will become critical readers and intentional writers by understanding how texts are shaped to suit specific audiences and purposes. They will analyze how authors use language, structure, tone, and techniques to connect with their intended audience. Students will identify the purpose of a text and evaluate the effectiveness of the strategies and techniques used in achieving that purpose. They will also apply knowledge of audience and purpose when creating original texts, using text structures, text techniques, and stylistic choices to engage a target audience.

---

### K-12.P.AC.1:

**Overview of Standard**
In this standard, students will interpret texts by examining how an author’s craft choices, such as structure, language, tone, and techniques, shape meaning and influence the reader’s experience. They will identify specific techniques, analyzing the techniques’ purposes and effects, and evaluate how they connect to the reader’s own reactions, thoughts, decisions, and questions. Through this standard, students will develop deeper literary analysis skills, fostering critical thinking and personal engagement with texts.

---

### K-12.P.AC.2:

**Overview of Standard**
In this standard, students will construct texts by considering the target audience as they base decisions about craft choices, such as structure, language, tone, and techniques, on how they intend to shape meaning and achieve a specific purpose. They will integrate specific techniques to appeal to a target audience and craft words and phrases to influence the reader’s responses, thoughts, decisions, and questions. Through this standard, students will develop deeper literary skills as they utilize their knowledge of context, author, audience, and purpose to construct texts.

---

### K-12.P.AC.3:

**Overview of Standard**
In this standard, students will analyze how the design and structure of a text influence its effectiveness for different audiences and purposes. They will evaluate how the structure and features of a text support or interfere with its purpose. Students will make deliberate choices about text design when constructing their own texts, tailoring their approach to suit the intended audience and the specific purpose of the text.

---

### K-12.P.CP.1:

**Overview of Standard**
In this standard, students will collaborate with others to accomplish shared goals and complete group projects. They will learn to contribute meaningfully to discussions, offer and respond to feedback, and help establish group norms and procedures. Students will engage in collaborative work by sharing ideas, listening actively, and participating in problem-solving and text creation. Through these experiences, they will develop and refine communication and collaboration skills necessary for both academic and real-world settings.

---

### K-12.P.CP.2:

**Overview of Standard**
In this standard, students will use presentation skills to communicate ideas, information, and texts effectively to target audiences for specific purposes. They will make intentional choices about modes, genres, tone, pacing, and nonverbal gestures to enhance their message. Students will also engage their audiences through interactive dialogue. Through these practices, they will develop the skills to present ideas clearly and purposefully in a wide variety of contexts. 

---

### K-12.P.EICC.1

**Vocabulary**
Goals
Preferences
Interest
Relevance
Comprehension
Composition
Community
Independence
Autonomy

---

### K-12.P.EICC.2

**Vocabulary**
Dialogue
Analysis
Evaluation
Concepts
Processes
Problems
Solutions
Background Knowledge
Skills
Ideas

---

### K-12.P.EICC.3

**Vocabulary**
Purpose
Goals
Comprehension
Prior Knowledge
Summarize
Visualize
Predictions
Inferences
Academic Vocabulary
Unfamiliar Words

---

### K-12.P.EICC.4

**Vocabulary**
Purpose
Audience
Goals
Modes
Genres
Structures
Craft techniques
Writing process
Comprehension
Composition

---

### K-12.P.ST.1

**Vocabulary**
Context
Prior knowledge
Background knowledge
Research
Purposes
Author
Audience

---

### K-12.P.ST.2

**Vocabulary**
Author
Audience
Context
Purpose
Point of view
Perspective
Text design
Accessibility
Word choice (diction)
Language structures
Craft techniques

---

### K-12.P.AC.1

**Vocabulary**
Author’s lens
Craft techniques
Literary techniques
Expository techniques
Argumentative techniques
Rhetorical techniques
Target audience
Purpose
Word choice (diction)
Sentence structure
Syntax
Formats
Structures
Patterns
Features
Accessibility

---

### K-12.P.AC.2

**Vocabulary**
Craft techniques
Literary techniques
Expository techniques
Argumentative techniques
Rhetorical techniques
Target audience
Purpose
Word choice (diction)
Sentence structure
Syntax
Formats
Structures
Patterns
Features
Accessibility

---

### K-12.P.AC.3

**Vocabulary**
Text design
Audience
Purpose
Modes
Multimodal texts
Genres
Features
Meaning
Tone
Style
Craft techniques

---

### K-12.P.CP.1

**Vocabulary**

Collaboration
Group discussions
Group norms
Shared Goals
Procedures
Productivity
Shared Project
Feedback

---

### K-12.P.CP.2

**Vocabulary**
Presentation 
Purpose 
Audience 
Texts 
Modes 
Genres 
Tone 
Pace 
Nonverbal gestures 
Dialogue 
Background knowledge 
Recitation
Poems 
Speeches

---

### K-12.P.EICC.1

**Instructional Strategies for Teachers**
• Allow students to select texts that interest them, fostering ownership and motivation, and model book selection.
• Provide students with talk/sentence stems including academic language to practice with their peers (e.g., “I know this source is credible because_________”).
• Strategically partner students together to allow opportunities for students to learn from different perspectives and thoughts.
• Utilize a consistent annotation strategy that students can use each time they encounter texts.
• Encourage students to engage with the text by asking questions, making predictions, clarifying thoughts, and making inferences.
• Provide students with additional support, such as a Venn Diagram, for engaging with texts.
• Analyze mentor texts to identify craft moves and structure, then have students emulate these techniques in their own writing.
• Partner with content area teachers to determine comprehension and annotation strategies that could be utilized across all courses to engage with text.
• Encourage students to share the texts they engage with in their lives outside of school (e.g., signs, chore chart, blogs, cookbooks, medicine instructions, novels, podcasts, videos, music).

---

### K-12.P.EICC.2

**Instructional Strategies for Teachers**
• Model analyzing text connections (“This reminds me of…”) and have students annotate their own textual connections.
• In small groups, have students take turns summarizing, questioning, and clarifying texts, fostering deeper comprehension and peer dialogue.
• Have students draft scripts for podcasts, debates, or product pitches, then present them orally, mimicking real-world scenarios.
• Have students use discussions such as Think-Pair-Share to generate ideas before writing. Provide sentence stems for students who need scaffolding.
• Assign dialogues where students adopt perspectives from different texts.
• Use discussion protocols (e.g., Socratic Seminar) to encourage intentional engagement.
• Model various storytelling techniques including ways to establish plot and character, use sensory language and dialogue to deepen stories, etc.

---

### K-12.P.EICC.3

**Instructional Strategies for Teachers**
• Clearly define why students are reading the text (e.g., to analyze tone, to understand a historical event).
• Encourage students to write personal reading goals before engaging with text.
• Activate prior knowledge (or develop background knowledge) before reading.
• Provide explicit instruction and opportunities for guided and independent practice in examining how text mode, genre, structure, and features aid in comprehension.
• Select and preview high-utility vocabulary words.
• Model using graphic organizers to activate prior knowledge, track understanding, organize information, and summarize and synthesize.
• Teach students to generate their own questions before, during, and after reading, using models such as the Question-Answer-Relationship (QAR) Model, a K-W-L Chart, or Socratic questioning.
• Model think-alouds when approaching complex texts, sections, and sentences.
• Chunk long or complex text into smaller sections and teach students how to do the same in their own reading.
• Explicitly teach summarization and annotation skills to students.
• Model and discuss metacognitive strategies (e.g., self-monitoring, rereading).

---

### K-12.P.EICC.4

**Instructional Strategies for Teachers**
• Create a structured environment where students can focus on the different writing processes.
• Explicitly teach specific writing skills such as thesis statements and transitions.
• Model the different aspects of the editing and revising processes, then set up learning stations focusing on the different parts of editing and revising.
• Create profiles for different audiences and discuss their needs and preferences.
• Model for students how they can revise their writing, keeping the content the same but focusing on a different audience.
• Provide targeted mini-lessons, breaking the writing process into bite-sized, focused lessons on identifying audience and purpose; writing an engaging hook; adding descriptive language or evidence; and using peer review constructively.
• Provide models of effective writing from familiar mentor texts.
• Allow students to use digital tools such as blogs, writing apps, and digital storyboards to enhance the writing process.
• Conference with students during each part of the writing process, asking guiding questions about their drafts, helping them clarify purpose or rework organization, and providing specific and actionable feedback.
• Use wide-ranging texts to illustrate techniques and structures. Have students analyze how authors use techniques to address different audiences and purposes, then apply those techniques in their own writing.

---

### K-12.P.ST.1

**Instructional Strategies for Teachers**
• Develop and use curated text sets—primary and secondary sources, films, art, maps, timelines, and artifacts—to build students’ contextual knowledge before or alongside reading anchor texts.
• Introduce key background materials before reading (e.g., newspaper clippings, photos, government documents, artifacts) and ask students to predict how these may have shaped the author’s choices or framed the audience’s interpretation.
• Use discussion protocols (e.g., Socratic seminars) where students can explore how contextual components affect text interpretation, using text-based evidence and shared inquiry.
• Design short, structured research tasks or jigsaws where students explore key contextual components (e.g., author’s background, time period, geography) relevant to a text.
• Before reading, use anticipation guides with statements tied to historical or topical themes in the text. Students will agree/disagree and explain why—activating prior knowledge and revealing students’ existing assumptions.
• Use mentor texts from a wide range of contexts. Guide students to analyze how context influenced authorial decisions such as genre, tone, style, structure, and/or language.
• Use graphic organizers to track and synthesize contextual information while reading.
• Engage students in an analysis protocol, such as SOAPStone (Speaker, Occasion, Audience, Purpose, Subject, Tone), to consider how context influences rhetorical decisions.
• Ask students to write from the perspective of an author responding to a specific historical moment (e.g., write an editorial from the perspective of a stockbroker following the 1929 crash) and explain their choices based on the context and intended audience.

---

### K-12.P.ST.2

**Instructional Strategies for Teachers**
• Allow students to choose a position or idea and write about it from three different perspectives (e.g., journalist, scientist, politician, business owner, content creator, high school student) and then analyze how audience and context influence their varying tones, focuses, and rhetorical approaches.
• Model the decision-making process behind writing choices as a think-aloud (e.g., “Given this audience, I’m choosing this tone…”; “Since it’s a public speech, I’m using repetition…”).
• Use mentor texts to demonstrate text features used for accessibility (e.g., alternative text (alt text), headings, bullet points, plain language) and multimodal text design for real-world communication tasks (e.g., flyers, public health notices, slide decks).
• Provide students with an audience reflection as part of the writing process. After drafting a piece, students complete a structured reflection that asks questions such as: *Who is your audience? What parts of your text were written with them in mind? What words/phrases did you choose to suit their expectations? How did your layout or format improve clarity?*
• Design a purpose-specific rubric to evaluate (or self-evaluate) texts. *Is the text design aligned with the audience’s needs? Is the tone well suited to the purpose? Does the structure address the audience’s needs?*
• Utilize an established peer review protocol to ensure that student partners evaluate whether the purpose is clear, the strategies are effective for the target audience, and recommendations to strengthen the alignment with purpose.

---

### K-12.P.AC.1

**Instructional Strategies for Teachers**
• Intentionally select mentor texts rich in rhetorical and argumentative techniques (e.g., *ethos, logos, pathos, counterclaim, rebuttal*) and have students analyze the mentor texts for their appeal to specific audiences.
• Guide students through multiple readings of a text, each time focusing on a different craft technique.
• Engage students in connotation mapping—identifying key word choices in a passage then charting their connotations, emotional impact, and rhetorical intent.
• Model how to analyze texts and identify author’s craft choices in a variety of different modes and genres.
• Utilize anchor charts and graphic organizers to support students in synthesizing information as they explore author’s craft.
• Have students rewrite sentences using alternative diction and then analyze how the audience’s reaction might shift.
• Compare texts from different modes and genres and evaluate how format, organization, features, and layout influence accessibility, tone, and audience engagement.
• Annotate passages of text to identify noteworthy (effective or ineffective) diction, syntax, rhetorical techniques, and/or organizational features.

---

### K-12.P.AC.2

**Instructional Strategies for Teachers**
• Model think-alouds for author’s craft to make thinking and writing “visible” in real time while verbalizing decision-making. Emphasize changing authorial decisions and revision considerations as you write and annotate your changes in an exemplar that students can use as a reference.
• Develop real-world writing tasks with authentic audiences when possible.
• Have students annotate their own compositions to explain their personal craft choices.
• Select strong examples to use as mentor texts and guide students in identifying technique applications, syntactical choices, purposeful language, etc.
• Design short, targeted mini-lessons using explicit instruction on specific craft techniques.
• “Catch-and-release” while students are engaged in independent work to touch base for small-group targeted segments of explicit instruction, based on student need.
• Provide meaningful feedback that drives student growth; for example, the *Georgia EdTalks “How Learning Works”* video on feedback.
• Task students with crafting texts using the same message but for two different audiences, adjusting tone, diction, and structure.
• Have students locate their own mentor texts for the mode and genre they choose for a task, then have them analyze the craft choices before writing.
• Use planning tools that prompt students to articulate purpose, identify the target audience, and determine overarching mode, genre, and structure.
• Graphic organizers (teacher-provided or student-created) can be used to map out organizational approaches, including which craft techniques to use.  
• Format-specific organizers can be used for additional scaffolding or when teaching new genres (e.g., PSA storyboard, blog post outline, business letter template). 
• Train students to engage in productive and meaningful peer feedback  (not just editing grammar). .
• Invite students to regularly share their writing in the Author’s Chair where they can also explain 1-2 key craft decisions they made for their target audience. You can make the experience fun (e.g., the author wears a cardboard crown when in the chair, the chair is decorated). The Author’s Chair can also be used purposefully to demonstrate effective uses of specific techniques. 

---

### K-12.P.AC.3

**Instructional Strategies for Teachers**
• Use the *Text Design Considerations (P.AC.3)* resource to examine the components that shape how texts are constructed and to help students recognize and apply elements of text design.
• Provide explicit instruction on elements of text design and related academic vocabulary (e.g., modal features, genre conventions, structural considerations, features) as related to purpose and audience.
• Create anchor charts and visual scaffolds to show why and how different modes and features can be used; continue to reference these throughout units of study.
• Compare and contrast text layouts on the same topic to evaluate how design elements influence tone and audience comprehension.
• Select mentor texts based on text design and/or features (e.g., formatting, layout, genre conventions, multimodal elements).
• Use a variety of written exemplars to highlight design elements and to model authorial decisions.
• Think-aloud to model design decisions bridging the gap between interpreting and constructing texts.
• Encourage students to annotate texts to identify genre conventions and text features and map how each contributes to the message.
• Facilitate peer review sessions where students provide constructive feedback based on design effectiveness.
• Design tasks with clear purpose(s) and target audience(s), prompting students to create multimodal texts that incorporate appropriate modal features and genre-specific conventions.
• Provide mode- and/or genre-specific graphic organizers or templates to help students plan their approach to text design (e.g., organizational structure, genre conventions, text features, formatting, layout); these graphic organizers can be used for scaffolding as indicated by student need. 
• Engage students in text transformation (“remix”) where they turn a text from one mode or genre into another (e.g., a news video into an infographic or a short story into a podcast script).

---

### K-12.P.CP.1

**Instructional Strategies for Teachers**

• Assign specific roles (e.g., facilitator, recorder, summarizer, questioner) during group tasks to promote shared accountability and balanced participation in shared work.
• Provide students with sentence stems/sentences to support productive and respectful collaborative discussions and group work. Potential samples are listed below for different phases of the work:<ul><li>“How should we divide the work so that everyone has a role?”</li><li>“Does anyone have a preference for which part they would like to take on?”</li><li>“What are your thoughts on this?”</li><li>“I appreciated when you…”</li><li>“That’s a great point—how can we build on it?”</li><li>“One idea we might consider is…”</li><li>“Can you explain what you meant by…?”</li><li>“Just to clarify, are we saying that…?”</li><li>“That’s a strong point. It makes me also think about…”</li><li>“Based on the text, I think we could also say…”</li><li>“Can someone summarize what we’ve decided?”</li></ul>
• Facilitate a process for students’ collaborative generation of group norms (e.g., be respectful of classmates, listen to others thoughtfully, cite the text, paraphrase before disagreeing).
• Engage students in project-based learning aligned to ELA content, where they co-design and implement long-term projects, sharing responsibility for timelines, research, and final deliverables.
• Provide explicit instruction on chosen peer feedback protocol (e.g., *Notice & Wonder*, *Plus/Delta*, *Four Quadrant Feedback*, *Ladder of Feedback*, *Success Criteria Checklists*) that guides students in constructively giving and receiving feedback and then practice its use in the classroom.
• Utilize collaborative digital workspaces for students to collaborate in real time—building and revising content, adding comments, and tracking contributions.
• Facilitate the jigsaw method to showcase content while building collaborative skills, where each student becomes an expert in one portion of a topic and then teaches it to peers. After all students share, they assimilate those portions into a shared group understanding.
• Plan, guide, and facilitate a Socratic Seminar to develop students’ collaborative discussion skills through structured, student-led dialogue focused on the interpretation of complex texts. Scaffolding might include explicit instruction on developing norms, protocol steps (e.g., fishbowl structure), active listening strategies, question generation, and text citation.

---

### K-12.P.CP.2

**Instructional Strategies for Teachers**

• Provide explicit instruction and modeling on presentation elements (contact, volume, pacing, tone, nonverbal gestures, posture). 
• Develop clear presentation rubrics that outline expectations for content, organization, delivery, and audience engagement and clarify success criteria and that support self-assessment. 
• Use multimodal presentation tools to enhance message and delivery. (e.g., not reading every word on a slide). 
•  Practice with short, informal presentations (e.g., “lightning talks,” gallery walks, think-pair-share) to build capacity. 
• Guide students in identifying and analyzing their target audience’s needs, background knowledge, and expectations before developing a presentation. 
• Build time for guided rehearsals with teacher or peer coaching on delivery, pacing, transitions, and audience engagement strategies. 
• Arrange for students to present to a real-world or unfamiliar audience (e.g., community members).  
• Model the use of digital engagement tools (e.g., polls, forms, QR codes, games). 
• Incorporate opportunities to memorize and perform short speeches, monologues, or poetry to engage with the auditory elements of the text and to practice expressive delivery through experimenting with rate, prosody, and tone to achieve various effects.  



---

**K-12.P.EICC.1**

<table>
<thead>
<tr>
<th>Teacher Prompt</th>
<th>Student Response</th>
</tr>
</thead>
<tbody>
<tr>
<td>Provide students with texts of differing opinions or perspectives around the same topic.</td>
<td></td>
</tr>
<tr>
<td>Review the terms <i>perspective</i>, <i>context</i>, <i>purpose</i>, and <i>credibility</i> and introduce anchor chart or notes page (sample below) to help students identify these concepts in texts.</td>
<td>Ask students to participate in the creation of the anchor chart/notes page.</td>
</tr>
<tr>
<td>Say, Authors leave clues about their perspective, purpose, and context, and we’re going to practice finding them today.</td>
<td></td>
</tr>
<tr>
<td>Hand out the first selected text excerpt to students. Model how to find author’s perspective, context, purpose, and credibility in texts. <br><br>
Ask students to repeat the process with the other text excerpt that contains an opposing viewpoint.
</td>
<td>Students follow along and add ideas as the teacher leads the discussion. Student responses will vary but may include: <br><br> - The author uses the words "brilliant" and "unparalleled" to describe teen social media use; the author mus support it.<br> - This was written in 2008, when there were even fewer social media sites.<br> - The author uses journal articles as evidence. However, the articles were funded by a commercial company.   </td>
</tr>
<tr>
<td>Circulate, taking notes on student understandings and potential misconceptions. Address any misunderstandings or misconceptions during whole group instruction. Use these notes to design future whole and/or small group instruction.</td>
<td></td>
</tr>
<tr>
<td>Discuss what students found in the text. Compare and contrast the ways the text approaches these concepts and ask, How does considering these factors help us as readers?</td>
<td>
Student responses may vary but could include:<br>
– It helps us consider the tools we could use in our own writing.<br>
– It helps us understand why the author created the text.
</td>
</tr>
</tbody>
</table>

---

**K-12.P.EICC.2**

<table>
<thead>
<tr>
<th>Teacher Prompt</th>
<th>Student Response</th>
</tr>
</thead>
<tbody>
<tr>
<td>Discuss with the students the idea that the term <i>dialogue</i> does not always have to mean conversations written in a text. Dialogue can also refer to casual conversations students have with their peers during lunch or via texting. Ask students, What are some other examples of everyday dialogue?</td>
<td>Student responses will vary, but examples could include:<br>
– talking in the hall about the upcoming weekend<br>
– participating in a group text about a group project in biology<br>
– creating a flyer for an upcoming club fundraiser
</td>
</tr>
<tr>
<td>Display a dialogue-rich excerpt from a class text and guide students in annotation: Why did the author include this dialogue? How does the dialogue link to broader themes or real-world issues?</td>
<td>Student responses will vary, but examples could include:<br>
– to develop character<br>
– to advance the plot<br>
– to build relationships between characters<br>
– to express characters’ emotions<br>
– to make connections to historical or political context<br>
– to make connections to moral and ethical questions
</td>
</tr>
<tr>
<td>Say to students, Now, let’s look at the same dialogue excerpt, but this time, use a sentence analysis lens. <br> <br>Ask students, Did the author use certain syntactical patterns in sentence length or complexity that had an impact on the dialogue? If so, what patterns do you notice and why do you think the author used them? Would you have used the same (or different) patterns if you wrote the dialogue? Why? <br><br>Have students discuss in small groups and share out.</td>
<td>Student responses will vary, but examples could include:<br>
– The author used shorter sentences to make the dialogue more exciting and engaging.<br>
– The author used longer, more complex sentences to slow down the pace of the dialogue.<br>
– The author used sentence complexity as a characterization tool.
</td>
</tr>
<tr>
<td>Discuss with students how written or spoken dialogue might be altered to reflect a different context (time period, setting, etc.). <br><br></td>
</tr>
<tr>
<td>Ask students, What are some characteristics an author could use to make those alterations? Which one(s) would have the greatest impact?</td>
<td>Student responses will vary, but examples could include:<br>
– changes to language and vocabulary used by the author<br>
– changes to the style and tone based on the new context<br>
– changing the characters’ behaviors and attitudes
</td>
</tr>
</tbody>
</table>

---
**K-12.P.EICC.3**

<table>
<thead>
<tr>
<th>Teacher Prompt</th>
<th>Student Response</th>
</tr>
</thead>
<tbody>
<tr>
<td>Ask students, Have you ever read something and immediately had a question pop into your head—not because you didn’t understand, but because you wanted to know more?</td>
<td>Student responses could include:<br>
– Yeah, like when something feels missing or unexplained.<br>
– Sometimes I read a claim, and I want to know if it's even true.
</td>
</tr>
<tr>
<td>Say, Exactly. Those questions aren’t just natural—they’re essential for research. Today, we’ll learn about a topic and practice generating questions that could lead to a meaningful investigation.</td>
<td></td>
</tr>
<tr>
<td><br>Provide students with a topic or possibly allow students to vote on a topic. For the purposes of this exercise, the topic for students will be financial habits using any relevant, available article/excerpt.</td>
<td></td>
</tr>
<tr>
<td>Say, We’re going to research to find information about a topic: financial habits, and I have an article/text excerpt for you to read. Before we start, let’s set our purpose.</td>
</tr>
<tr>
<td> Ask students, What kinds of questions do we want to generate?</td>
<td>Student responses will vary, but they may include discussion about ideas that interest them or questions that direct them to sources.</td>
</tr>
<tr>
<td>Say, First let’s start by learning about some different types of questions. (For this example, the QAR model is used.) The Question-Answer-Relationship (QAR) Model presents four types of questions. Present each type of question, explain it, and model a think aloud for each one.
 <br><br>
  Present each type of question, explain it, and model a think aloud for each one. <br><br> Say, With “Right There Questions,” the answer is explicitly stated in one place in the text. <br><br> Say, An example of this type might be: What is the definition of a budget according to the article?  
</td>
<td></td>
</tr>
<tr>
<td>Say, With “Right There Questions,” the answer is explicitly stated in one place in the text. <br><br> Say, An example of this type might be: What is the definition of a budget according to the article? <br><br> After modeling, ask students, What are some “Right There” questions you can think of?</td>
<td>Student responses will vary, but they may include: What tool or app does the article recommend to track spending? What percentage of your income does it recommend saving each month? Who is the author?<br><br></td>
</tr>
<tr>
<td>Say, With “Think & Search Questions,” the answer is in the text but requires synthesizing information from multiple places. <br><br>Say, An example of this type might be: What evidence does the article provide that tracking expenses helps improve financial habits? After modeling, ask students, What are some “Think & Search” questions you can think of?<br><br></td>
<td>Student responses will vary, but they may include: How do the examples of budgeting mistakes in the article help explain why it’s important to track spending? What are the different ways the article says I can earn money, and how should I decide what to do with it?<br><br></td>
</tr>
<tr>
<td>Continue this strategy through the remaining question types (“Author & Me” and “On My Own” questions). <br><br>Ask students, Which type of these questions do you think would be best for research? What makes a good research question?</td>
<td>Student responses will vary, but they may include: The author says budgeting helps reduce stress—why do I sometimes feel overwhelmed by it instead? The article gives a lot of tips, but which ones would actually work for someone with limited income or support at home?</td>
</tr>
<tr>
<td>Celebrate answers and provide direction, if needed. Additional discussion and/or the creation of an anchor chart could help scaffold the learning. <br><br> Ask students to start determining their own research questions by following the same process with a text about a topic of their choice. <br><br>Have students begin generating questions. A graphic organizer like this could be used for scaffolding: Supplementary Questions for Research & Inquiry.<br><br> Based on instructional design, students could engage in partner work, or they can complete it independently. Questions could be shared as a “Ticket-out-the-Door.”</td>
<td>Student answers will vary, but they may include: focused (not too broad), open-ended (not a yes/no), able to be researched.</td>
</tr>
</tbody>
</table>

---

**K-12.P.EICC.4**

<table>
<thead>
<tr>
<th>Teacher Prompt</th>
<th>Student Response</th>
</tr>
</thead>
<tbody>
<tr>
<td>Begin with a discussion: Why do writers write? For whom do they write? Chart student responses and review the concepts of purpose and audience.</td>
<td>Student responses will vary but could include:<br>
<b>Purpose</b><br>
– to express their thoughts, feelings, and opinions;<br>
– for personal satisfaction or enjoyment;<br>
– to share stories;<br>
– to provide an argument; or<br>
– to inform<br><br>
<b>Audience</b><br>
– teachers,<br>
– classmates,<br>
– a broader public,<br>
– online readers,<br>
– themselves</td>
</tr>
<tr>
<td>Model analyzing selected short mentor texts, identifying the purpose and audience for each.</td>
<td></td>
</tr>
<tr>
<td>Present students with a choice of writing tasks, each with a different intended audience and purpose (e.g., a letter to the principal, an op-ed for the school paper, an imagined story for younger students).</td>
<td>Students will select a writing task and use a graphic organizer to plan their ideas, considering how their choices, including choice of text techniques, will shift based on audience and purpose.</td>
</tr>
<tr>
<td>Remind students of the processes of planning, drafting, evaluating, revising, and editing. Encourage brainstorming and idea mapping, providing sentence frames or graphic organizers as scaffolds.</td>
<td>Students will brainstorm and write a first draft while the teacher circulates, conferencing with students as needed.</td>
</tr>
<tr>
<td>Have students exchange drafts for peer review, using a checklist focused on clarity of purpose, appropriateness for audience, use of appropriate text techniques, and organization and development of ideas.</td>
<td>Students will provide constructive feedback to their partners.</td>
</tr>
<tr>
<td>Model revision strategies by showing how to clarify ideas or adjust tone for a specific audience and purpose.</td>
<td>Students will revise and edit based on teacher and peer feedback, creating a final draft.</td>
</tr>
<tr>
<td>Review common editing issues such as sentence structure, wordiness, and grammar (consult grade-level skills within the GUM Chart) with students. <br><br></td>
</tr>
<td>As students finish their final drafts, provide them with questions for a brief reflection including, What did you change in your writing to better suit your audience and purpose? What part of the process was most helpful?<br><br> **This lesson may take more than one class period.  </td>
<td>Students will complete the self-reflection; responses will vary but could include:<br>
– I had to change my language because it was too informal for my intended audience.<br>
– I changed my introduction to include more argumentative techniques since that was my purpose.<br>
– I added examples that would be more relatable to teenagers because that’s my audience.</td>
</tr>
</tbody>
</table>

---

**K-12.P.ST.1**

<table>
<thead>
<tr>
<th>Teacher Prompt</th>
<th>Student Response</th>
</tr>
</thead>
<tbody>
<tr>
<td>Select a text aligned with local policies to serve as the anchor text; it should be clearly anchored in the historical events of its time. Gather any contextual background materials for this text (e.g., articles, maps, timelines, photos).</td>
<td></td>
</tr>
<tr>
<td>Ask students, Before you even begin reading, what influences how you interpret something? Think about your background, your experiences, the time and place you live in.</td>
<td>Student responses will vary, but they may include responses such as:<br>
– my family’s values<br>
– where we live<br>
– what I watch on social media</td>
</tr>
<tr>
<td>Engage students in a follow-up discussion focusing on these two questions:<br>• What kinds of things might influence an author the same way?<br>• How might different people respond to the same text based on their personal contexts?</td>
<td>Student responses will vary, but they may echo their responses from earlier.<br><br>Student responses will vary, but they may include responses about how people will focus on different parts of texts, identify different themes, and apply their respective knowledge to the text.</td>
</tr>
<tr>
<td>Provide students with an excerpt or an image from the anchor text. Based on the selected text, use a think-aloud to model how one might approach considering context. <br><br>Say, This passage is about ___. Without knowing ___, we might miss the point. Let’s figure out what context matters most here.</td>
<td></td>
</tr>
<tr>
<td>Provide students with a graphic organizer on contextual components and access to any background materials. <br><br> Organize students into small groups or partners. A jigsaw structure could be utilized to have each group, partner set, and/or individual research one of the following contextual considerations: time period; geographic location; influential customs and traditions; author’s background; and contemporary events.</td>
</tr>
<tr>
<td>Say, Now you are going to engage in a short research period about your assigned contextual component. Enter what you know or learn from your research in your handout and then write a short explanation of how knowing that helps you better understand the text. We will come back together to discuss what you’ve found.</td>
<td>Students engage in research and enter their findings into the appropriate rows on their handout. They then may engage in discussion with their groups or partners to complete the explanation.<br><br></td>
</tr>
<tr>
<td>Following an appropriate period of time for research, ask groups to have a representative share out. <br><br><br><br><br></td><td>One representative from each group will share their findings and explanation of how context helps them to better understand the text. Students take notes from the others’ presentations.</td>
<tr><td>After all groups have shared, instruct each group to read the excerpt from the anchor text a second time, applying their new contextual understandings as they re-read. Then, instruct students to discuss and answer the following questions:<br>– What aspect of context helped you understand the text in a new or deeper way? Why?<br>– How do you think the context surrounding the text’s creation shaped the author’s purpose or message?<br>– How might different audiences (now or in the past) respond to this text based on their own context?</td>
<td>Student responses will vary but should address all questions. Answers will be dependent upon the text. Sample responses could include:<br>
– Knowing that the story was written during the Great Depression helped me understand why they were so focused on survival and financial struggles.<br>
– Since the text was written during a war, I think the author was trying to inspire people to get involved.<br>
– People from different backgrounds might connect with the text in different ways; some might need more background knowledge to fully understand it.<br>
– An audience in the past might have seen the message as controversial or even dangerous, but a modern audience could view it as inspiring.</td>
</tr>
<tr>
<td>As an exit ticket, students individually answer the question below:<br>How does your own background or context influence how you read or relate to this text?</td>
<td>Student responses will vary.</td>
</tr>
</tbody>
</table>

---

**K-12.P.ST.2**

<table>
<thead>
<tr>
<th>Teacher Prompt</th>
<th>Student Response</th>
</tr>
</thead>
<tbody>
<tr>
<td>Ask students, What’s something you’ve written where you really thought about who would read it? How did that affect what you wrote or how you said it?</td>
<td>Student responses will vary, but they might include:<br>
– When I wrote a speech for my club’s elections, I tried to sound more confident and use simple words so everyone would understand.</td>
</tr>
<tr>
<td>Say, Every writer makes choices based on three things: what they want to say, who they want to say it to, and why. Today, we’ll look at how these three elements work together to create meaningful communication.</td>
<td></td>
</tr>
<tr>
<td>Read a short mentor text (e.g., an editorial, a letter, a speech) and model a think-aloud. Say, Notice how the author uses ____ because ____ (connect to audience/purpose). The author’s choice to use ____ appeals to both the purpose and audience. <br><br>Say, Now you will analyze how writers achieve their purpose(s) and meet the needs of their target audience(s).</td>
<td></td>
</tr>
<tr>
<td>Provide each small group with a short text to review. In small groups, students complete a graphic organizer. <br><br>

  <table border="1" cellspacing="0" cellpadding="5">
          <tr>
            <th></th>
            <th>Textual Evidence</th>
            <th>Explanation</th></tr>
          <tr><td>Author's Purpose</td><td><br></td><td><br></td></tr>
          <tr><td>Target Audience</td><td><br></td><td><br></td></tr>
          <tr><td>Key Craft Moves</td><td><br></td><td><br></td></tr>
        </table><br><br>
  </td>
  </tr>
  <tr>
    <td>      
  Circulate the room, prompting groups with questions such as:<br>
– What word choices stand out, and who are they for?<br>
– How does the structure support the message?<br>
– Would this work on a different audience?<br><br> 
Allow groups to continue to share their thoughts or a synopsis of their comments to segue into composition.</td>
<td>Student responses will vary based on the text but could include:<br>
– I noticed the use of technical terms like “carbon footprint” and “sustainability.” That suggests the author expects the audience to have some background knowledge.<br>
– The text gives an anecdote, then facts, and ends with a call to action. That structure makes it more convincing because it builds emotional connection first and then supports it with evidence. <br>
- The paragraphs are short, and some sentences are bolded. That keeps the focus clear and helps the reader stay engaged.  <br>
- I think the message could work on a different audience if the tone and examples were adjusted.    </td>
</tr>
<tr>
</tr>
<tr>
<td>Say, We looked at how authors tailor their language, structure, and ideas to suit their audience and purpose. Now, you’ll become the author and make those decisions yourself. <br><br>Say, Write a short text (letter, blog post, speech, or editorial) with a clearly defined purpose, target audience, and contextual setting. Before you begin, define your rhetorical situation.<br><br></td>
<td>Students choose their own rhetorical situation and compose a text responding to that situation. Students should use the planning checklist as a tool for reflection and revision as time allows.</td>
</tr>
<tr>
<td>Student Planning Checklist:<br>
– Who am I writing to (who is my audience)?<br>
– What do I want them to think, feel, or do?<br>
– What context or situation makes this writing important?</td>
<td></td>
</tr>
<tr>
<td>Students write, revise, and reflect using this checklist. After students have time to write, revise, and reflect on their own writing, they can engage in peer review. <br><br> Say, Now trade texts and evaluate each other’s work for purpose and audience using a simple checklist:<br>
– Is the purpose clear?<br>
– Are the choices appropriate for the audience and context?<br>
– What part was most effective?<br>
– What could be strengthened?</td>
<td>Students’ peer feedback will vary, but they may include remarks like:<br>
– Your tone was perfect for students, but I think you could add more facts to make your argument stronger.<br>
– I wasn’t totally sure what your goal was at first—maybe add a clearer thesis or purpose statement in the opening paragraph.<br>
– You did a great job choosing words that match the audience—your tone was friendly and clear, which works for a student audience.</td>
</tr>
<tr>
<td>Ask students the following exit prompt:<br><b>What is one strategy you used today to match your writing to your audience and purpose? How did you know it would be effective?</b></td>
<td>Student responses will vary, but they may focus on choices such as their language, organization, or rhetorical appeals.</td>
</tr>
</tbody>
</table>

---

**K-12.P.AC.1**

<table>
<thead>
<tr>
<th>Teacher Prompt</th>
<th>Student Response</th>
</tr>
</thead>
<tbody>
<tr>
<td>Say, Think about a commercial, song, or social post that really stuck with you. What specific choices—like language, tone, or structure—made it effective?</td>
<td>Student responses will vary, but may include:<br>
– The music had a catchy beat.<br>
– The photographs of the neglected dogs paired with the sad music hurt my heart.<br>
– The design—how it was laid out with the text, the white space, and the fonts they used.</td>
</tr>
<tr>
<td>Say, Writers of all kinds make intentional choices to affect their audience. Today, we’ll read like writers—looking closely at how authors craft their messages to connect with us. Ask students, What does it mean to you to “read like a writer”?</td>
<td>Student responses will vary, but may include:<br>
– When you read like a writer, you're not just thinking about what the text says—you're examining how the author says it.<br>
– You're analyzing the author's craft: their word choices, sentence structure, organization, and use of rhetorical strategies.<br>
– You are thinking like a writer, from their perspective, about the choices they make and why they make them.</td>
</tr>
<tr>
<td>Say, Today, we are going to focus on the following craft techniques: diction (word choice and connotation), syntax, rhetorical devices, and text design. Note: These concepts may require explicit instruction depending on students’ familiarity/proficiency. <br><br>Read a sample paragraph aloud and model a think-aloud on one or more of those technique categories. </td>
</tr>
<tr>
<td>Ask students, Do all audiences respond the same way to a text? Why or why not?</td>
<td>Student responses will vary, but they may include:<br>
– People might not be as familiar with the topic.<br>
– People with different life experiences or background knowledge might interpret things differently.</td>
</tr>
<tr>
<td>Say, Writers often shape their decisions based on whom they’re trying to reach. Today we’ll think more deeply about how context, audience, and purpose shape craft.<br><br> Provide students with a mentor text (possibly excerpt) to consider in partners and/or groups; different groups may use different mentor texts. You may also provide students with this 9–12.P.AC.1 resource, which contains a copy of the anchor chart below, possible analysis questions, and sample student responses.<br><br> </td>
</tr>
<tr>
<td>Say, I want you to take a few moments to read and annotate your text and make notes about what you observe. Pay special attention to:<br>
– effective word choices;<br>
– moments where sentence structure changes;<br>
– any narrative, expository, argumentative, rhetorical, and/or poetic techniques;<br>
– organizational features (transitions, shifts, pacing).</td>
<td>Students read, listen to, and/or view the mentor text, annotating any of the craft techniques they notice the author using.</td>
</tr>
<tr>
<td>Say, Now, as a group, discuss the author’s craft moves in your text. Complete an anchor chart and focus on the three or four craft techniques that you as a group think were most noteworthy; be prepared to share your findings.<br><br>
  <table border="1" cellspacing="0" cellpadding="5">
          <tr>
            <th>Authorial<br>decisions</th>
            <th>How it affects<br>the audience</th>
            <th>How it supports<br>the author's purpose</th><tr>
          <tr><td><br></td><td><br></td><td><br></td></tr>
          <tr><td><br></td><td><br></td><td><br></td></tr>
          <tr><td><br></td><td><br></td><td><br></td></tr>
        </table><br><br>
      Provide groups with time to meet, discuss, and complete their anchor chart. Each group can make an informal presentation on their thoughts. If groups read different texts, then they may also need to share some context.</td>
<td>Group responses will vary, and much of that will be dependent upon text selection. Sample responses: <br><br>
    <table border="1" cellspacing="0" cellpadding="5">
          <tr>
            <th>Authorial<br>decisions</th>
            <th>How it affects<br>the audience</th>
            <th>How it supports<br>the author's purpose</th><tr>
          <tr><td>diction choices (“shattered,” “aching”)</td><td>draws the audience into an experience with empathy</td><td>enhances the tone and mood</td></tr>
          <tr><td>shifts from past to present tense midway through</td><td>helps the audience feel more of a sense of urgency</td><td>reinforces the theme throughout the text</td></tr>
          <tr><td>includes compelling statistics (e.g., "1 in 5 children experience food insecurity")</td><td>builds credibility and appeals to logic </td><td>establishes the author’s credibility and provides supporting factual evidence</td></tr>
        </table><br><br></td>
</tr>
<tr>
<td></td>
<td></td>
</tr>
<tr>
<td>Say, Think back through what you and your group discussed about craft techniques and about your own engagement experience. Respond to this question as your ticket-out-the-door: What author’s craft technique from this text would you like to try in your own writing? Why?</td>
<td>Student responses will vary based on text and personal engagement experience.</td>
</tr>
</tbody>
</table>

---

**K-12.P.AC.2**

<table>
<thead>
<tr>
<th>Teacher Prompt</th>
<th>Student Response</th>
</tr>
</thead>
<tbody>
<tr>
<td>Say, Writers don’t just write—they make decisions. Whether it’s a short sentence for impact or a metaphor to connect with the audience, everything is intentional. <br><br>
</td>
</tr>
<tr><td>Ask students, What have you learned from studying mentor texts that you apply in your own writing?</td>
<td>Student responses will vary, but may include:<br>
– Good writers use short sentences sometimes to make a point stand out.<br>
– Mentor texts helped me understand how tone changes depending on the audience.<br>
– They helped me see that writing is a series of choices. Now I ask myself how each choice might land with my audience.<br>
– I learned that word choice affects how a reader feels about the topic, so I think about that when I write.</td>
</tr>
<tr>
<td>Say, Today you will have an opportunity to craft a text where you really put those skills to work! First, let’s look at a student work sample. (Teachers may pull from their own personal student work libraries; also, a sample is provided in the 9–12.P.AC.2 Student Resource Sample.) <br><br></td></tr>
<tr><td>Ask students, What craft techniques do you see at play here? Why do you think the author used them? Let’s look at this opening. What do you notice about how the writer draws us in?<br><br><br><br>Continue guiding students through the sample text, facilitating conversation about the craft techniques and why the author might have chosen them. </td>
<td>Student responses will vary, but they may include:<br>
– It’s like a mini story—“late-night study sessions,” “championship wins”—it pulls on memories.<br>
– The short sentence hits harder.<br>
– They make it really personal.</td>
</tr>
<tr>
<td>Distribute an annotation of the student sample (page 2). If using a personal sample, this could be created, or it could simply be done as a group discussion.<br><br> Ask students, How do the author’s annotations align with what you said? <br><br>Facilitate the discussion and segue into the composition task. *This process may take more than one instructional segment.</td>
<td>Student responses will vary, but they may include:<br>
– We talked about how the tone shifted, and the author explained how sentence length created that effect. I hadn’t thought about syntax being part of tone before.<br>
– I thought the repetition helped tie it all together, and the author confirmed that purpose.<br>
– I noticed the sentence was short and powerful, and the author said it was for emphasis, which is what I thought too.</td>
</tr>
<tr>
<td>Say, Now, with that sample in mind, you will engage in the same process. Provide students with an authentic writing task (context, purpose, and audience) relevant to your community. The number of craft decisions to highlight can change based on the students and/or the lesson design. <br><br>Say, I want you to include at least three intentional craft decisions in your draft, and then I want you to annotate your draft when you are done. Identify your conscious author’s craft choices and then annotate why you made those decisions.</td>
<td>Students create their original texts and identify then annotate intentional craft decisions. Annotations could be done as comments. See the annotated student work sample above that can be used as a mentor text.</td>
</tr>
<tr>
<td>Circulate the room/digital space, posing and answering questions. Potential questions for analysis and self-reflection are provided in the sample linked above. Small groups can be cycled to deliver targeted, explicit instruction on specific techniques or skills indicated by need.</td></tr>
<tr><td> Time permitting, students can engage in peer review and/or share from the Author’s Chair. Say, As you leave today, I want you to reflect on your growth as an author. Take a moment and share what your favorite craft technique used and why. *This lesson may take more than one class period.*</td>
<td>Student responses will vary, but may include:<br>
– I tried using short sentences in some places to emphasize my main points.<br>
– I used parallel structure in my final paragraph because it gave the ending a rhythm that made it feel complete and persuasive.</td>
</tr>
</tbody>
</table>

---


**K-12.P.AC.3**

<table>
<thead>
<tr>
<th>Teacher Prompt</th>
<th>Student Response</th>
</tr>
</thead>
<tbody>
<tr>
<td>Gather excerpts from a variety of multimodal texts; this learning experience might take multiple days.<br><br> Say, Today, we’re exploring how an author’s design decisions—like mode, genre conventions, layout, formatting, headings, captions, hyperlinks, or even color—can completely change how a text is experienced. This is called <i>text design</i>. It’s about how the mode, genre, and features work together to serve a specific audience and purpose.</td>
<td></td>
</tr>
<tr>
<td>Display two multimodal texts on the same topic (e.g., an article on a website with an embedded video and an infographic on the same topic).</td></tr>
<tr>
  <td> Say, Let’s compare these two texts. What do you notice about how they’re designed? Who is their target audience? Additional questions could be:<br>
– What does the author want the audience to think, feel, or do? What is the purpose?<br>
– How is the text accessed or experienced?<br>
– What genre is this text, and what are common conventions for it? How does this text use conventions?<br>
– How is the text organized, and what features does it use?<br><br>
Affirm student responses during the discussion. For instance, say, Exactly. Those are design choices, and design decisions should be intentional. The infographic uses print and visual modes, a genre-specific layout, and features like color blocks, graphics, and graphs to quickly reach a broad audience—maybe on social media. The article uses a more traditional structure but with embedded media for detailed explanation. <br><br>Provide students with another multimodal text; different partners could receive different texts based on interest or readiness</td>
<td>Responses will vary depending on the texts displayed, but may include:<br>
– They both focus on the same topic, but they approach it in different ways.<br>
– They have similar titles.<br>
– The infographic is more visual—it’s got charts and color coding to catch your eye. It would probably suit a younger audience.<br>
– The graphics match what each section is talking about.<br>
– The article is more formal, with longer paragraphs. It has headings and subheadings. With the embedded video, we hear words, see what is happening, and read the article’s text. It’s posted online, so it’s probably trying to reach a wide audience of people interested in that topic.</td>
</tr>
<tr>
<td>.</td>
<td></td>
</tr>
<tr>
<td>Say, Now you will work with a partner and use your <i>Text Design Square</i> to identify the purpose and audience, mode and genre, text structure, and at least three text features that shape how the message is communicated.<br><br> Circulate and encourage students to go deeper into the content.  </td>
<td>Student responses will center on determining how each of the square’s sides contributes to the text’s meaning, as well as how effective those choices were. Responses may include:<br>
– They used bullet points—that helps you skim faster to get the main ideas.<br>
– They used color-coding to emphasize and connect main points.<br>
– They organized it chronologically to help the audience follow along.<br>
– They included images and graphics to catch the reader’s attention.</td>
</tr>
<tr>
<td>Say, Now it’s your turn to be the designer. I’m assigning each group a purpose and audience. For example, Group 1—you’re creating a PSA for high schoolers about digital safety. Group 2—you’re writing an FAQ article for parents about graduation requirements. <br><br>Each group will create a multimodal text in a specific genre (e.g., flyer, webpage, article, poster) that demonstrates an appropriate organizational structure with at least four relevant text features. <br><br></td></tr>
<tr><td>Say, Remember to think like a designer—how will you help the audience understand or engage with your message?<br><br>Students work on their multimodal text while the teacher circulates, working with individuals or groups based on need. </td>
<td>Responses will vary, but may include:<br>
– We used a sidebar with quick tips to make it easier to skim.<br>
– We used a timeline to show the events’ progression, which worked well; the audience had a clear sense of order.</td>
</tr>
<tr>
<td>Say, Take a moment to reflect: How did your choices about text design impact how your message came across? What would you keep or revise? Create author’s notes that explain your rationale for your design choices as your ticket-out-the-door. <br><br><i>**This lesson may take more than one class period.</i></td>
<td>Reflections will vary, but may resemble:<br>
– Color coding helped show cause and effect, but we forgot the legend—I’d add that.<br>
– Our infographic had too much text. I’d simplify it and use icons instead.</td>
</tr>
</tbody>
</table>

---

**K-12.P.CP.1**

<table>
<thead>
<tr>
<th>Teacher Prompt</th>
<th>Student Response</th>
</tr>
</thead>
<tbody>
<tr>
<td>Say, Collaboration isn't just group work—it’s purposeful communication that leads to deeper understanding. What makes some group discussions more productive than others?</td>
<td>Responses will vary but may include:<br>
– When people actually listen and not just wait to talk.<br>
– If everyone has a job or knows what they’re supposed to do—and actually does it.</td>
</tr>
<tr>
<td>Say, Yes! Today, you’ll be practicing real collaboration—not just dividing tasks, but researching, exchanging ideas, and making decisions together. <br><br></td></tr>
<tr><td>Ask, What does effective collaboration look and sound like? Let’s establish some group norms. Teacher records ideas on the board and then facilitates conversation for final accepted norms.</td>
<td>Responses will vary but may include: respect turn-taking, stay focused, listening to one another, build on each other’s ideas. </td>
</tr>
<tr>
<td>Say, Now, each of your groups will tackle an inquiry question tied to a current issue or course theme (e.g., How should ethical considerations shape scientific and technological progress? How do primary sources from America’s founding reflect the hopes and fears of different groups at the time?). Most likely, your inquiry question will lead to other questions. How will your group tackle addressing this inquiry question?<br><br>Students form groups of 3–4 and select a shared inquiry question.</td>
<td>Group responses might include:<br>  - We’ll split the question into parts, assign roles, and compare our findings.<br> - We’re using a shared doc to drop sources and notes, and we’ll color code by subquestion.<br>  - We plan to summarize each source in our own words and then talk through how it answers the question—or how it changes it.<br>  - We’ll keep a running list of new questions to track what needs follow-up. </td>
</tr>
<tr>
<td>Students gather, curate, read, evaluate, and discuss findings, using their chosen method for collaboration. The associated time for these activities may differ on the students or lesson’s focus and the depth of research expected. <br></td></tr>
<tr>
<td>Following the final discussion, students come to consensus and create a response to their inquiry question—and possibly a list of questions they now have.</td><td>Responses will vary based on inquiry question and research topic.</td>
</tr>
<tr>
<td>Groups quickly share inquiry questions and research-supported responses with a neighboring group. </td></tr>
<tr>
<td>Say, Now I would like for you to complete a short self-reflection over today’s collaborative experience: <br> - Did we abide by our group norms? <br> - What did I do to support my group’s success? <br> - How did our group work together to solve challenges? <br> - What would I do differently in our next collaboration? </td><td>Responses will vary but may include: <br> - I helped clarify our main ideas when we got off track. <br> - We divided tasks based on each person’s strengths.<br> - We had a shared doc where we commented on each other’s work.<br> - I’d manage our time better so we’re not rushing at the end.<br> - I’d make sure we actually used all our team roles the way we planned. </td>
</tr>
<tr>
<td>Say, Let’s finish by sharing one thing your group did well today—was it organization? Listening? Building off each other’s ideas?</td>
<td>Responses will vary but may include: <br> - We stayed on task and added ideas to each other’s instead of just dividing up work.<br>  - We listened to one another, and that changed our thinking.<br> - We were open to changing our thinking based on what we learned.<br> - We valued each other’s ideas. </td>
</tr>

</tbody>
</table>

---

K-12.P.CP.2

Evidence of Student Learning

<table>
  <thead>
    <tr>
      <th>Teacher Prompt</th>
      <th>Student Response</th>
    </tr>
  </thead>
  <tbody>
    <tr>
      <td>Provide students with a presentation planning template (sample template) and/or a checklist or rubric (sample rubric) aligned to local instructional design. Introduce each document and explain their functions.</td>
      <td></td>
    </tr>
    <tr>
      <td>Say, When we present, we don’t just share information—we communicate it on purpose. That means how we speak, what we show, and even what we emphasize should depend on whom we’re speaking to and why.</td>
      <td></td>
    </tr>
    <tr>
      <td>Display (play) two forms of presentations (e.g., a TED-style talk and a school board meeting clip).</td>
      <td></td>
    </tr>
    <tr>
      <td>Ask students, What’s different in how these speakers present their ideas?</td>
      <td>Responses will vary but may include:<br/>- The tone’s different—one’s conversational and one’s more formal.<br/>- The visuals are different, too. One used lots of graphics.</td>
    </tr>
    <tr>
      <td>Say, These are intentional design decisions for their presentations—aligned to their audience and purpose. This is exactly what we will do today.</td>
      <td></td>
    </tr>
    <tr>
      <td>Ask, What have you learned about delivering engaging presentations based on your personal past experiences? Affirm student responses and provide any necessary clarifications.</td>
      <td>Responses will vary but may include:<br/>- Don’t just read everyone on the slides. Make an outline then just talk.<br/>- Make eye contact with the audience.<br/>- Speak loud enough so people can hear you at the back of the room.<br/>- Everyone in the group should own a part of the presentation and speak.<br/>- I was more interested when people used QR codes and I could interact.</td>
    </tr>
    <tr>
      <td>Students (individually or in pairs or groups) select or are assigned a brief topic, purpose, and audience. They will determine their mode and genre (e.g., speech, recorded video, slides with embedded commentary) and will make design decisions, such as visuals, tone, text features, and anticipated questions using the Presentation Planning Template. The teacher circulates.</td>
      <td></td>
    </tr>
    <tr>
      <td>Ask students and/or groups, What’s your goal with this presentation? What are you trying to accomplish? How will you achieve that with your presentation design?</td>
      <td>Responses will vary based on presentation topic, but could include:<br/>- I want everyone to know why BMWs are the best cars, and I will show a comparison chart with specs to prove it.<br/>- We want to share the process for restaurants to get health scores—and the scores of those around us!<br/>- I want to raise awareness about _________.</td>
    </tr>
    <tr>
      <td>Ask follow-up questions related to student’s design choices (e.g., visuals, tone, features) based on student responses.</td>
      <td></td>
    </tr>
    <tr>
      <td>Students complete their planning sheet and begin designing their presentation.</td>
      <td></td>
    </tr>
    <tr>
      <td>After engaging in research (if applicable), students develop the base for their presentation (e.g., slides, video, script, visuals), using their rubric as a reference. The allocated time for this segment will depend on instructional design priorities; practice time could also be allotted.</td>
      <td></td>
    </tr>
    <tr>
      <td>Say, Now we will begin presentations. Review success criteria (and students’ thoughts from earlier). As you listen, note one effective design choice and one question you could ask the speaker.</td>
      <td>Students note effective design choices in each presentation. Questions/answers will vary but might include:<br/>- Q: Why did you include that image? A: I wanted something emotional—it’s a powerful image about ocean pollution.<br/>- Q: Why did you want to present about that topic? A: I am gluten free, and more people need to know about it.</td>
    </tr>
    <tr>
      <td>Students/groups present (3–5 minutes each) to small groups or the whole class, depending on time. Time permitting, encourage a brief Q&amp;A after each presentation.</td>
      <td></td>
    </tr>
    <tr>
      <td>Students submit their peer feedback to the teacher; digital tools (e.g., Microsoft/Google form) could make this an efficient process for feedback review, sorting, and then distribution.</td>
      <td></td>
    </tr>
    <tr>
      <td>Say, I want you to use your rubric to self-evaluate your presentation and then answer the question, “What are you most proud of from that presentation?”</td>
      <td>Responses will vary:<br/>- I stayed calm and spoke clearly despite my nerves.<br/>- I kept good eye contact and didn’t just read off the screen.<br/>- I used examples relatable to the audience (my friends), and that made it engaging.<br/>- Our group transitioned smoothly between speakers, and it made it cohesive.</td>
    </tr>
    <tr>
      <td>This lesson may take more than one class period.</td>
      <td></td>
    </tr>
  </tbody>
</table>

---

**9-12.T.C.1**

**Overview of Standard**
In this standard, students will consider how context and language shape audience reception, and they will incorporate these understandings when they craft texts with a clear understanding of purpose and audience at the center, drawing upon disciplinary, personal, or technical communication goals. Students will construct and evaluate multimodal compositions to achieve a range of purposes.

---

**9-12.T.C.2**

**Overview of Standard**
In this standard, students will analyze and compare how authors and speakers present varying perspectives on a topic across multiple texts, while considering how a speaker’s reliability shapes audience interpretation. Students will also examine how and why attitudes toward a topic may shift over time and the effect of those changes on meaning. They synthesize information from credible sources to explore and answer relevant academic and personal questions.

---

**9-12.T.SS.1**

**Overview of Standard**
Effective text organization enhances clarity, purpose, and audience engagement. This standard emphasizes the strategic use of organizational structures and text features across genres and modes, which includes the selection and analysis of structure for specific purposes and audiences, the use of transitions to ensure cohesion and logical flow, and the intentional construction of texts that reflect an understanding of how structure shapes meaning. The key is guiding students to both analyze and apply text structure thoughtfully.

---

**9-12.T.SS.2**

**Overview of Standard**
Writers make deliberate craft choices to shape meaning, tone, and audience experience. This standard emphasizes the analysis and application of craft techniques such as diction, syntax, imagery, literary devices, rhetorical appeals, rhetorical and figurative language by the author. Students will evaluate how these techniques influence purpose, meaning, tone, mood, and audience perception and then apply them in their own writing. Students must become intentional in their use of craft—reading like writers to notice patterns and writing like readers to make purposeful, audience-aware decisions that elevate clarity, voice, and impact.

---

**9-12.T.T.1**

**Overview of Standard**
In this standard, students continue to build their knowledge of narrative techniques while evaluating authors’ uses of those techniques to achieve a purpose or to appeal to their target audience. They will also apply their understanding of narrative techniques to their own texts, strategically choosing the appropriate techniques for their specific purpose and audience. Georgia’s K-12 ELA Standards shift from fixed text types to the flexible use of techniques, emphasizing purpose and audience, with authentic texts often blending narrative, expository, argumentative, and poetic techniques.

---

**9-12.T.T.2**

**Overview of Standard**
In this standard, students continue to build their knowledge of expository techniques while evaluating authors’ uses of those techniques to achieve a purpose or to appeal to their target audience. They will also apply their understanding of expository techniques to their own texts, strategically choosing the appropriate techniques for their specific purpose and audience. Georgia’s K-12 ELA Standards shift from fixed text types to the flexible use of techniques, emphasizing purpose and audience, with authentic texts often blending narrative, expository, argumentative, and poetic techniques.

---

**9-12.T.T.3**

**Overview of Standard**
In this standard, students continue to build their knowledge of argumentative techniques, including rhetorical devices and appeals, while evaluating authors’ uses of those techniques to achieve a purpose or to appeal to their target audience. They will also apply their understanding of argumentative techniques to their own texts, strategically choosing the appropriate techniques for their specific purpose and audience. Georgia’s K-12 ELA Standards shift from fixed text types to the flexible use of techniques, emphasizing purpose and audience, with authentic texts often blending narrative, expository, argumentative, and poetic techniques.

---

**9-12.T.T.4**

**Overview of Standard**
In this standard, students continue to build their knowledge of poetic techniques while evaluating authors’ uses of those techniques to achieve a purpose or to appeal to their target audience. They will also apply their understanding of poetic techniques to their own texts, strategically choosing the appropriate techniques for their specific purpose and audience. Georgia’s K-12 ELA Standards shift from fixed text types to the flexible use of techniques, emphasizing purpose and audience, with authentic texts often blending narrative, expository, argumentative, and poetic techniques.

---

**9-12.T.RA.1**

**Overview of Standard**
In this standard, students ask compelling questions, gather and synthesize relevant information from multiple credible sources, and use evidence purposefully to develop and support their ideas. Through this process, students learn to clarify their research focus, integrate findings effectively, and document sources accurately.

---

**9-12.T.RA.2**

**Overview of Standard**
This standard equips students to critically evaluate the credibility, relevance, and quality of sources and the evidence they present. Students distinguish between facts, reasoned judgments, and opinions while identifying conflicting information or perspectives, author bias, rhetorical appeals, and/or logical fallacies that influence meaning and reliability. In grades 9–12, students are expected to use Modern Language Association (MLA) formatting when conducting research and citing sources. By grades 11–12, students also apply their understanding of style guides to appropriately use American Psychological Association (APA) formatting when warranted by task, purpose, or discipline. 

---

**9-12.T.PM.1**

**Overview of Standard**
In this standard, students will analyze how texts reflect, respond to, or challenge the ideas, values, and events of the time periods and/or movements in which they were produced. They will also examine how authors draw on, transform, or depart from the stylistic and/or thematic conventions and characteristics of specific literary periods or movements —including the use of archetypes—to shape meaning and impact. 

---

### 9-12.T.C.1

**Vocabulary**
Purpose
Audience
Knowledge
Disciplinary purpose
Personal purposes
Technical purposes
Comprehension
Language
Audience reception
Construction
Self-evaluation
Multimodal texts and/or presentations
Text features
Modes

---

### 9-12.T.C.2

**Vocabulary**
Authors
Speakers
Perspectives
Circumstances
Reliability
Credibility
Changing Attitudes
Credible sources
Research
Questions
Answers
Academic topics
Individual topics of interest

---

### 9-12.T.SS.1

**Vocabulary**
Organizational structures
Style
Genres
Purpose
Audience
Mode
Central message
Transitions
Cohesion
Paragraphs
Text sections
Design
Coherence
Focus
Supporting facts
Reasons
Explanations
Details
Descriptions
Events
Conclusion
Viewpoint(s)

---

### 9-12.T.SS.2

**Vocabulary**
Language
Figurative language
Connotative language
Rhetorical language
Meaning
Tone
Mood
Purpose
Literary devices
Rhetorical appeals
Audience
Formal style
Informal style
Context
Credibility
Authoritative tone
Diction

---

### 9-12.T.T.1

**Vocabulary**
Narrative techniques
Archetypes
Multiple perspectives
Plot structure
Symbolism
Textual evidence
Conflict
Word choice
Craft techniques
Theme
Social relevance
Passages
Reasoning
Event patterns
Character types

---

### 9-12.T.T.2

**Vocabulary**
Expository techniques
Purpose
Audience
Organizational Patterns
Conflicting information
Opposing viewpoints
Matters of fact
Interpretations
Clarity of information
Cohesive text
Types of information
Tone

---

### 9-12.T.T.3

**Vocabulary**
Argumentative techniques
Purpose
Audience
Content
Meaning
Central Idea
Rhetorical appeals
Ethos
Logos
Pathos
Logical fallacies
Rhetorical language
Rhetorical devices

---

### 9-12.T.T.4

**Vocabulary**
Poetic techniques
Purpose
Audience
Content
Meaning
Theme

---

### 9-12.T.RA.1

**Vocabulary**
Research
Questions
Investigations
Complex topics
Credible sources
Analyses
Creative solutions
Focus
Text creation
Analytical findings
Research question
Thesis
Citation
Paraphrasing
Summarizing
Original texts
Quoting
Modern Language Association (MLA) format
American Psychological Association (APA) format

---

### 9-12.T.RA.2

**Vocabulary**
Curation
Sources
Print sources
Digital sources
Evidence
Information
Credibility
Academic databases
Central argument
Topic
Question
Misconceptions
Conflicting information or perspectives
Author bias
Validity
Relevancy
Accuracy
Modern Language Association (MLA) format
American Psychological Association (APA) format
Inferential questions
In-text (parenthetical) citations
Works cited page

---

### 9-12.T.PM.1

**Vocabulary**
Period
Movement
Theme
Genre
Style
Archetypes
Myths
English literary history
American literary history
Stylistic features

---

### 9-12.T.C.1

**Instructional Strategies for Teachers**

• Present two texts about the same topic but written for different audiences; guide students in identifying how purpose shapes tone, structure, and evidence.
• Model a think-aloud while reading, explicitly noting cues for purpose and audience.
• Develop an anchor chart identifying different text types (disciplinary, personal, technical) with example purposes and audiences.
• Use the SOAPSTone method (Speaker, Occasion, Audience, Purpose, Subject, Tone) for annotation.
• Have students rewrite an excerpt of a text for a new audience (e.g., from academic to general public).
• Ask students to take a text (e.g., short story, poem, news article) and transform it into a different genre (e.g., infographic, skit, editorial), reflecting a new purpose.
• Use the Situating Texts and Periods & Movements resources to develop and support context.
• Assign students specific audience perspectives (e.g., policymaker, teen, scientist) and have them evaluate how a text speaks to that audience.
• Use the RAFT strategy (Role, Audience, Format, Topic) to engage students in purposeful composition.
• Pair two texts on the same topic but with different purposes (e.g., a memoir and an academic article) and have students discuss key differences.
• Use two different advertisements or PSAs targeting different demographics and facilitate discussion around language, layout, and impact.
• After reading/viewing, students reflect on who the intended audience is and how language and context affect understanding, including any personal “aha” moments.
• Design instruction using evidence-based practices, using resources such as this *Adolescent Literacy Infographic* from the Florida Center for Reading Research.

---

### 9-12.T.C.2

**Instructional Strategies for Teachers**

• Pair a literary or nonfiction text with a primary source from the same time period (e.g., speech, newspaper) and compare insights.
• Use the Situating Texts and Periods & Movements resources to develop and support context.
• Have students annotate quotations from a text and reflect on how the author's background or historical moment might shape the meaning.
• Present a short biography or interview of the author before reading and ask students to make predictions about how it may influence the text.
• “What Would You Change?” Ask students to imagine how the text would be different if written in a different time or place or written from a different perspective.
• Students work in groups to defend different interpretations of an author’s intent, citing evidence.
• Post excerpts with embedded contextual clues around the room; students rotate, annotate, and discuss authorial or historical influence.
• Spot the Sponsored Content: Challenge students to identify advertisements and sponsored material disguised as objective reporting.
• Have students reframe a passage from a different speaker’s point of view to highlight how perspective shifts meaning.
• *Perspective Bingo*: Create a bingo card with features influenced by perspective (e.g., bias, tone, diction, structure); students mark them as they find examples in the text.
• Students create a timeline showing historical or personal events relevant to the text and note how each might have influenced the author’s choices.
• Design instruction using evidence-based practices, using resources such as this *Adolescent Literacy Infographic* from the Florida Center for Reading Research.
• Exit Ticket: *Influence Inventory.* Ask students to list 2–3 influences (e.g., beliefs, events, audiences) that may have shaped the author’s message and explain why.

---

### 9-12.T.SS.1

**Instructional Strategies for Teachers**

• Use mentor texts to illustrate author’s choices on organizational patterns, structures, and features. For example, diagram the organizational pattern (e.g., cause-effect, problem-solution) or color-code the organizational structure (e.g., hook, background, thesis, transitions) of mentor texts.
• Collaboratively create a signal words anchor chart that compiles transition words for various organizational patterns (e.g., sequence, cause/effect).
• Conduct think-alouds to analyze how different authors’ structural choices shape meaning, tone, and clarity. Reference the *P.AC.3 Text Design Considerations* resource.
• Provide a scrambled essay and have students reorder paragraphs logically.
• Model nonlinear text structures: Explore and practice structures like *in media res*, flashback, or circular narratives.
• Model then have students color-code to demonstrate organizational/paragraph structure elements.
• Deliver explicit instruction on crafting strong thesis statements and aligning organizational structures to them; using cohesion strategies (e.g., transitions, key word/phrase repetition, parallel structure); developing clear, purposeful topic sentences.
• Peer Review for Structure: Use checklists or rubrics that emphasize text flow, transitions, and logic.
• Provide sentence and paragraph frames to scaffold effective organizational patterns, as needed.
• Examine multiple texts within the same genre to identify shared organizational patterns and features.
• Use graphic organizers (organizational patterns, top-down topic web, Venn diagrams, outlines) to plan text structure.
• Use mentor texts and/or mentor sentences to identify organizational choices and analyze their impact; then, have students emulate those same structures – *Teaching Secondary Students to Write Effectively* (Graham et al., 2016).

---

### 9-12.T.SS.2

**Instructional Strategies for Teachers**

• Use mentor texts and/or mentor sentences to identify “craft moves” and analyze their impact; then, have students emulate those same moves – *Teaching Secondary Students to Write Effectively* (Graham et al., 2016).
• Have students annotate mentor texts, highlighting where and how the author’s craft shapes tone, meaning, or impact.
• Carousel Activity: Students rotate around the classroom—physically or digitally—to engage with multiple texts, prompts, or questions at different stations.
• Text Coding with Symbols: <b>★</b> = important idea, <b>?</b> = question, <b>∞</b> = repetition or pattern, <b>!</b> = new or surprising info, <b>→</b> = connection, <b>♥</b> = strong rhetorical move.
• *CATCH Activity*: Circle unfamiliar words or confusing sections. Add margin notes or emojis to show reactions. Talk back to the author, connect to current events, and highlight arguments.
• Offer a menu of craft techniques (e.g., alliteration, juxtaposition, imagery) for students to incorporate in drafts.
• Have students replace “flat” words with more precise choices to clarify meaning.
• *Show vs. Tell*: Model how to “show” emotions or actions through sensory detail and diction choices.
• Conduct timed freewriting challenges focusing on one craft element.
• Facilitate small group discussions on diction choices and explore alternatives.
• Use graphic organizers to develop connotative vocabulary (e.g., *Frayer Model*, *Four Square*).
• *Craft Gallery Walks*: Have students display drafts highlighting a specific craft move and receive feedback from peers.

---

### 9-12.T.T.1

**Instructional Strategies for Teachers**

• Use mentor texts to analyze then apply narrative techniques (e.g., provide mentor texts with annotations that highlight narrative technique choices, analyze inner monologues to learn how to weave a character’s thoughts into action for depth and complexity).
• *Show, Don’t Tell* Mini lessons: Teach students how to replace abstract statements with vivid imagery and action.
• Use multimodal storytelling formats (e.g., podcasts, animations) to experiment with pacing, tone, and structure.
• Have students talk through narrative techniques use before writing to strengthen sequencing and voice.
• Peer groups evaluate use of narrative techniques using a focused revision checklist.
• Use graphic organizers (e.g., plot diagrams) to help students situate elements of plot.
• *Six Word Memoirs*: Encourage concise storytelling where students tell the story of their lives in six words, experimenting with tone and diction (e.g., “Standards by day, stories by night”; “Chemo fought me; family carried me”; “Lost my phone, found real friends.”)
• Use rubrics that explicitly assess use of narrative techniques, voice, and coherence.
• Invite students to regularly share their writing in the *Author’s Chair* where they can also explain 1–2 key decisions using techniques to appeal to their target audience. You can make the experience fun (e.g., the author wears a cardboard crown when in the chair, the chair is decorated).
• *Character Interviews*: Students role-play interviews with characters to better understand motivation and internal conflict and then to apply when developing authentic voice.
• Teach circular endings where the final image echoes the first, emphasizing coherence.
• Use mentor texts and/or mentor sentences to identify techniques and analyze their impact; then, have students emulate those same techniques – *Teaching Secondary Students to Write Effectively* (Graham et al., 2016).

---

### 9-12.T.T.2

**Instructional Strategies for Teachers**

• *Mentor Text Feature Hunt*: Students examine published expository texts to find and label features like headings, comments, captions, transitions, and/or embedded content.
• Create and reference anchor charts for structures (e.g., cause/effect, compare/contrast, sequence).
• Model expository writing using think-alouds to demonstrate the identification and application of sequencing, facts, details, examples, and/or quantitative facts or statistics.
• Have students explain real-life routines (e.g., making coffee) using expository techniques and transitions.
• Use sentence combining as a tool to build clarity and conciseness in explanatory writing.
• Provide small group mini lessons focused on removing redundancy, clarifying ideas, and strengthening cohesion, as necessary.
• Give students mixed statements to sort into fact, explanation, or irrelevant—then revise for clarity and depth.
• Use a problem-solution framework to help students structure their texts: define problem → propose solution → explain steps.
• Have students contrast well-developed texts using expository techniques against texts that are vague in their use.
• Scaffold instruction as necessary by providing stems like “First…, then…, finally…” or “For example…”.
• *Chunking Complex Texts*: Practice identifying and chunking texts into parts or sections to inform student drafts.
• Use mentor texts and/or mentor sentences to identify techniques and analyze their impact; then, have students emulate those same techniques – *Teaching Secondary Students to Write Effectively* (Graham et al., 2016).

---

### 9-12.T.T.3

**Instructional Strategies for Teachers**

• Model identifying thesis statements, claims, evidence, reasoning, counterclaims, rebuttals, logical fallacies, rhetorical language, and/or rhetorical appeals in real-world texts.
• Foster a classroom environment of respectful debate that values learning from other perspectives.
• Use visual and multimodal texts to help students analyze and apply rhetorical appeals.
• *Counterargument Stations*: Students rotate to identify, strengthen, and respond to opposing viewpoints.
• *Fallacy Debate Charades*: Assign each student a fallacy (e.g., hasty generalization, bandwagon, circular reasoning) that they have to use in a mini debate; the other students try to call it out.
• Use tools (e.g., exemplars, graphic organizers, vocabulary activities) to provide scaffolding and help students develop debatable, precise thesis statements and arguments.
• *Op-Ed Comparisons*: Analyze and compare opinion pieces from different sources on the same topic.
• *Mentor Text Analysis*: Examine how writers transition between claims, evidence, and refutation.
• *What’s the Assumption?*: Ask students to identify unstated assumptions and revise for clarity.
• *Real-World Argumentative Techniques in Action*: Bring in texts aligned with local policies that students encounter in their daily lives (e.g., ads, videos) and have students analyze their use of techniques.
• *Evidence Sort and Rank*: Students sort pieces of evidence by credibility, relevance, and persuasive impact (e.g., “strong,” “weak,” “irrelevant”).
• Use a framework (e.g., *Claim-Evidence-Reasoning (CER)*) to teach students argument organization.
• Provide authentic tasks/audiences to students (e.g., letters to the editor, presentations for the Chamber of Commerce).
• Facilitate structured peer feedback to support strengthening and revision.
• Scaffold instruction as necessary by providing sentence stems for claims, counterclaims, and rebuttals (e.g., “Some argue that ___, but evidence shows ___.”).
• Give students a short, intentionally flawed paragraph filled with one or two fallacies. Have them identify the fallacy, then revise the paragraph to strengthen the writing; paragraphs can be differentiated by ability level.
• Use mentor texts and/or mentor sentences to identify techniques and analyze their impact (including how they transition between claims, evidence, and refutation); then, have students emulate those same techniques – *Teaching Secondary Students to Write Effectively* (Graham et al., 2016).

---

### 9-12.T.T.4

**Instructional Strategies for Teachers**

• *Found Poetry*: Students create poems by rearranging words from existing texts, focusing on theme and tone.
• Use mentor texts (including those not entirely poetic in nature) to analyze how authors use poetic techniques for intended purposes; then, students imitate the mentor texts’ use of techniques in their own original works.
• Create an anchor chart of poetic devices (e.g., alliteration, enjambment, metaphor) with examples together as a class.
• Use pre-assessments or formative assessments to tailor instruction based on student need. For example, you could use a poetic techniques terminology pre-assessment; this file will download as a Word document that you can customize for your local curriculum.
• Explicate poems using analysis protocols/graphic organizers to aid analysis (e.g., *SOAPSTone* (Speaker-Occasion-Audience-Purpose-Subject-Tone), *TPCASTT* (Title-Paraphrase-Connotation-Attitude-Shifts-Title-Theme)).
• Analyze how poets craft language to evoke emotion, create rhythm, or provoke thought.
• Engage students in close reading of familiar song lyrics, treating them as poetry to analyze figurative language, imagery, rhythm, and repetition.
• Guide students in analyzing how authors embed poetic techniques or excerpts within longer prose works (e.g., epics, novels) to enhance meaning, develop themes, or achieve specific effects.
• *Poetry Out Loud*: Have students rehearse and perform poems aloud to analyze how sound and rhythm affect impact.
• Provide a visual image and have students describe it using sensory detail, which can then be used to craft figurative lines.
• Have students engage in *metaphor mapping* (building extended metaphors around abstract ideas, e.g., “Freedom is a river…”).
• Use graphic organizers to develop vocabulary (e.g., *Frayer Model*, *Four Square*).
• *Personal Poetry Anthologies*: Students create and curate a mini collection of their own poems with introductions explaining technique and purpose.
• Use mentor texts and/or mentor sentences to identify techniques and analyze their impact; then, have students emulate those same techniques – *Teaching Secondary Students to Write Effectively* (Graham et al., 2016).

---

### 9-12.T.RA.1

**Instructional Strategies for Teachers**

• Provide a curated set of texts for students to analyze prior to beginning independent research to build background knowledge.
• Have students create annotated bibliographies that include source evaluation and explain how each source supports their research.
• Use visual tools (e.g., Venn diagrams, synthesis charts) to help students synthesize sources.
• Design instruction using evidence-based practices, using resources such as this Adolescent Literacy Infographic from the Florida Center for Reading Research.
• Analyze exemplar student work or professional mentor texts to model structure, integration of sources, and style guide usage.
• Utilize a protocol (e.g., Three-Step Paraphrasing Protocol (Read, Restate, Review), Visual Paraphrasing) or sentence starters to scaffold paraphrasing.
• Model using graphic organizers to activate prior knowledge, track understanding, organize information, and summarize and synthesize.
• Teach students to generate their own questions before, during, and after reading, using models such as the Question-Answer-Relationship (QAR) Model, a K-W-L (Know, Want to Know, Learned) Chart, or Socratic questioning.
• Extend K-W-L charts by adding a column for new questions to guide continued research.
• Explicitly teach summarization strategies (e.g., GIST—Generating Interactions between Schemata and Text) and annotation skills to students.
• Model then have students sort excerpts of text into categories: summary, paraphrase, or synthesis, explaining their rationale.
• Have students practice embedding partial quotations into their own sentences for enhanced fluency.
• Use a graphic organizer to map out questions to ensure a broad pool for research.

---

### 9-12.T.RA.2

**Instructional Strategies for Teachers**

• Pair two texts that present conflicting information on the same issue; students annotate for bias, rhetorical appeals, and logical fallacies.
• Use color-coded annotation for credibility (green), bias (yellow), and gaps/misconceptions (red).
• Have students sort pieces of evidence from multiple sources into “strong,” “weak,” or “irrelevant” categories, then justify rankings.
• Assign “micro-inquiries” where students use databases, news outlets, and primary sources to curate 3–5 credible sources addressing a question.
• Scaffold MLA/APA practice by providing partially completed citations or Works Cited pages to correct.
• Use the Situating Texts resource for questions to assist with establishing source credibility.
• Map sources to claims: Use graphic organizers that require students to match evidence directly to claims or questions.
• Conduct think-alouds on source credibility: Model evaluating a webpage/article in real time: “This author has expertise, but this source has an agenda. How might that impact reliability?”
• Collaborative Source Vetting: Use a jigsaw where each student evaluates one source, then groups synthesize to decide which sources are most reliable for a shared project.
• Spotting sponsored content challenge: Challenge students to detect advertising, misinformation, or sponsored “content.”
• Model the development of an annotated bibliography by summarizing each source, explaining its contribution to the inquiry, and citing in the appropriate format.
• Develop practice activities for quotation integration. Provide sentences with dropped-in quotes (“quote dumping”) and have students revise by weaving in signal phrases and correct in-text citations.
• Create a classroom reference chart with MLA and APA templates for common sources (books, websites, journal articles, videos).
• Have students generate citations using online tools, then critique and correct errors.
• Highlight parts of a citation in color (author, title, publication, date, container, etc.) and have students replicate this color coding in practice citations.
• Encourage students to engage in a reverse source search where they trace a secondary source’s cited evidence back to its origin, evaluating reliability at each step. Evidence of Student Learning

---

### 9-12.T.PM.1

**Instructional Strategies for Teachers**

• Have students research authors' historical and cultural backgrounds to contextualize literary choices.
• Literary Time Travel: Students “visit” a literary period and create multimedia presentations showing how key texts reflect that era’s beliefs and values.
• Gallery Walk: Display quotes, images, and excerpts from different periods/movements around the room. Students walk, read, and reflect in writing on themes and values.
• Utilize an archetype tracking chart, where students trace recurring archetypes (e.g., hero, outcast, trickster) across texts and periods.
• Have students maintain a chart where they track expected literary conventions and then identify authors they study who subvert those expectations.
• Host Socratic Seminars focused on period influence (exploring how values of an era shaped author’s choices).
• Use an anchor text per period and surrounding works (e.g., poems, speeches) to illuminate context.
• Engage students in a jigsaw protocol so that different groups investigate different periods/movements and share findings to build understanding for the entire class.
• Students design infographics representing the key traits, values, and representative works of a period.
• Trace how a theme (e.g., individualism, alienation) appears across periods and how authors’ treatment of the theme shifts using a timeline.
• Use a “Juxtaposition Journal” graphic organizer where students compare primary historical sources (e.g., speeches, pamphlets, paintings, photographs) with literary texts to analyze, reflect, and critique.

---

9-12.T.C.1

Evidence of Student Learning

<table>
  <thead>
    <tr>
      <th>Teacher Prompt</th>
      <th>Student Response</th>
    </tr>
  </thead>
  <tbody>
    <tr>
      <td><b>See also 9-12.P.ST.1 Evidence</b></td>
      <td></td>
    </tr>
    <tr>
      <td>Say, Today, your goal is to draft a message encouraging your peers to attend a local career fair.* You’ll also write a second version directed at your local chamber of commerce to encourage business participation. Same topic, different audience and purpose. Why do we need two versions?</td>
      <td>Student responses may vary but could include:  <br>- Because our peers care, but we’d speak to them differently—probably more casual, maybe even emotional. With the chamber of commerce, we need to be more formal and use data.</td>
    </tr>
    <tr>
      <td>Say, Exactly. Let’s pause. What decisions will you have to make for each?<br><br> NOTE: The topics in this lesson could be based on something in your local context.</td>
      <td>Student responses may vary but could include:  <br>- For the peer version, I might use a call to action like, “Make all the $$ by finding a summer job!” and include hashtags if it's a social post. But for the chamber of commerce, I’d highlight how student workers support their businesses and maybe cite statistics on youth employment or share local success stories.  <br><br>- If it’s on socials, the design and tone matter—a punchy opener and an image that resonates. But a letter to the chamber needs to sound informed and respectful.</td>
    </tr>
    <tr>
      <td></td>
    </tr>
    <tr>
      <td>Say, So, whether you realize it or not, you’re already thinking about purpose and how your language impacts reception. The way you speak to your friends isn’t the same as how you’d write to your principal—or your grandma. That’s because audience and purpose drive how we communicate.</td>
      <td></td>
    </tr>
    <tr>
      <td>Say, Now, in groups (or partners), I want you to think about a different scenario. Your high school club, sports team, or program is hosting a fundraiser, and your job is to advertise it. I want you to create a multimodal product that must: <br>- Serve more than one purpose (for example: inform + invite) <br>- Target a specific audience (like students, parents, or local business owners), <br>- Use multiple, clearly identifiable features from different modes.</td>
      <td></td>
    </tr>
    <tr>
      <td>Say, How you choose to approach this project is up to you. Think about what would genuinely get your audience to act, show up, or contribute.<br><br>Circulate and facilitate conversation with groups, answering questions and making notes of student strengths and areas for potential, future explicit instruction.</td>
      <td>Groups work on their multimodal products. Texts will vary, but they may include:<br>
- Short promotional video (with voiceover, music, captions, and embedded stats)<br>
- Digital story series (GIFs, visuals, polls)<br>
- Digital flyer or infographic (images + text + QR code + embedded links)<br>
- Podcast segment or radio PSA (scripted audio with music, sound effects, and interviews)<br>
- Interactive presentation (slides with video clips, images, and hyperlinks)<br>
- Email campaign (newsletter layout with embedded images and links for donations)<br>
- Scripted speech with slideshow (presented to a booster club)</td>
    </tr>
    <tr>
      <td></td>
      <td></td>
    </tr>
    <tr>
      <td>Say, You've each chosen your audience, defined your purposes, and begun creating your multimodal fundraiser products. Before we end today, I want to check in. Let’s talk about the decisions you’re making and how they’re connected to purpose and audience. Who can share?</td>
      <td><br>Student responses may vary but could include: <br><br>- We are making an animated reel for our band’s car wash. The purpose is to get students to support us, but also to show what the money goes toward—like new uniforms. <br>- My group is making a digital pitch deck for local businesses to support our robotics team with charts, a voiceover, and our mission statement to inform and persuade. We used clean visuals and a professional tone to match what businesses expect.</td>
    </tr>
    <tr>
      <td>As you finish your multimodal projects, take a few minutes to reflect: <br>- What modes and features did you choose, and why? <br>- How do those choices support your purpose and speak to your audience?</td>
      <td>Responses will vary.</td>
    </tr>
  </tbody>
</table>

----
9-12.T.C.2

Evidence of Student Learning

<table>
  <thead>
    <tr>
      <th>Teacher Prompt</th>
      <th>Student Response</th>
    </tr>
  </thead>
  <tbody>
    <tr>
      <td>Say, Let’s start with a simple but powerful question: “Can two people witness the same event and tell completely different stories?” Has this ever happened to you?</td>
      <td>Student responses may vary but could include:
        <ul>
          <li>Yes—because people see things based on their own experiences or goals, just like when my brother and I totally remember our vacation differently.</li>
        </ul>
      </td>
    </tr>
    <tr>
      <td>Say, Exactly. That’s the heart of today’s work. We’re going to examine how authors and speakers shape what we understand based on their perspective—and how those perspectives are shaped by when, where, and why they speak.<br><br>
        Provide students with two contrasting texts on a topic (e.g., digital privacy). For example, you might furnish
        <ul>
          <li>an excerpt from a tech company’s privacy policy statement and</li>
          <li>an editorial from a student or parent perspective.</li>
        </ul>
      </td>
    </tr>
    <tr>
      <td>
        Say, Think about your phone right now. Who has access to your photos? Your messages? Your location? Even when you’re not using it?
      </td>
      <td>Student responses may vary but could include:
        <ul>
          <li>Probably the apps—like, I think the companies track a lot. But we agree to that when we install stuff.</li>
        </ul>
      </td>
    </tr>
    <tr>
      <td>Say, Exactly. That’s why today’s focus is on digital privacy—how different people talk about it, how their circumstances influence what they say, and how we can use that awareness to construct our own messages. We want to examine each text’s purpose and audience, tone, bias, use of evidence, and speaker reliability.<br><br>
        Model the use of a graphic organizer (e.g., perspective tracker) and think aloud.<br><br>
        Say, Now, I want you and your partner to analyze the two different perspectives on topic and complete your “Perspective Tracker” as you go.<br><br>
        NOTE: This lesson could be a jigsaw activity, or differentiated texts could be used. Also, a menu of texts could be offered, with each pair selecting the two that most engage them.
      </td>
      <td>In pairs, students analyze two perspectives on digital privacy and complete their graphic organizer.</td>
    </tr>
    <tr>
      <td>Circulate the room, listening to conversations and engaging in clarifying dialogue as needed until everyone is finished.<br><br>
            </td>
    </tr>
    <tr>
      <td>
        Ask students, The company says, ‘We prioritize user security and transparency,’ but this is also part of their brand. Their purpose is not only to inform but to build trust. Let’s ask: Do their actions match their words? What details are included or left out?
      </td>
      <td>Student responses may vary but could include:
        <ul>
          <li>They say they care about security, but they don’t really explain what they do. There aren’t any examples or data, so it feels more like a statement than proof.</li>
          <li>They talk about security and transparency, but they leave out any mention of past privacy issues the company’s had. That makes me question them.</li>
          <li>Their message is designed to sound reassuring, but it avoids specifics like what data they collect or who they share it with. That omission seems intentional.</li>
        </ul>
      </td>
    </tr>
    <tr>
      <td>Say, Excellent observations, everyone. You’re noticing that what a speaker chooses not to say can be just as important as what they include. What you’re doing here is key to mastering this standard: you’re evaluating reliability based not just on what the speaker says, but on their purpose, their position, and the context of their message. Keep that in mind because you’ll want your audience to trust you, too.<br><br>
          </td>
    </tr>
    <tr>
      <td>
        Say, Now it’s your turn. You’ll pick a specific digital privacy issue—like app permissions, facial recognition, or data tracking in schools—and create a multimodal message with a clear perspective. Define your audience, and include at least two clear craft moves to impact them.<br><br>
        Say, Now we will share your fantastic creations that share a clear perspective. Please share your product and explain two different craft or structure choices you make for your audience.<br><br>
        Celebrate strong student work and craft decisions; note challenges and plan next steps. Highlight exemplars. <br><br>
        **This may take multiple instructional periods.
      </td>
      <td>Students work on creating their individual messages using their chosen modes and genre (e.g., PSA videos, infographics, blog post, carousel/story series, digital poster, presentation, comic), making note of their audiences and craft moves.<br><br>
        Responses will vary but may include:
        <ul>
          <li>I used short video clips of phone screens in my PSA, along with a fast-paced voiceover and music to grab students’ attention—attention spans are short when scrolling.</li>
          <li>I opened my video with an anecdote and lots of imagery—my little brother accidentally shared his location in a game—to make it personal for my audience.</li>
        </ul>
      </td>
    </tr>
    <tr>
      <td></td>
      <td></td>
    </tr>
  </tbody>
</table>

-----

9-12.T.SS.1

<h3>Evidence of Student Learning</h3>

<table>
  <thead>
    <tr>
      <th style="text-align:left;">Teacher Prompt</th>
      <th style="text-align:left;">Student Response</th>
    </tr>
  </thead>
  <tbody>
    <tr>
      <td>
        Say, Let’s start with a quick truth: Good writing doesn’t just happen—it’s designed. It’s not an accident. The way a text is organized tells the reader how to move through it. So, we’re going to explore how authors make decisions about the big picture structure—and then you’ll get to make some of your own.<br><br>
        Provide students with mentor texts about the same topic but from different genres (e.g., editorial, blog post, infographic) that use different organizational patterns.<br><br>
           </td>
    </tr>
    <tr>
      <td>
        Say, Both of these texts are about _______________. However, let’s examine their differences.
        <ul>
          <li>What are their target audiences?</li>
          <li>Which one feels clearer? Why?</li>
          <li>What organizational pattern is used (problem-solution, compare-contrast, chronological, etc.)?</li>
          <li>Where do transitions guide you? How effective are they?</li>
          <li>How does the organizational structure support the intended purpose and audience? Rate it and explain.</li>
        </ul>
        After providing students with time to review and annotate the texts, facilitate a conversation, affirming when students noticed purpose, mode, and/or genre affect the text’s structure.<br><br>
      </td>
      <td>
        Students work in pairs to identify the organizational patterns and use of transitions in short mentor texts. Student responses may vary but could include:
        <ul>
          <li>The editorial is clearer to me. It has a claim up front, then goes point by point.</li>
          <li>The blog post kind of bounces around to different sections, even though it's interesting.</li>
          <li>This passage uses a problem-solution structure. First, it describes the challenges faced then it offers solutions.</li>
          <li>The transition 'As a result' helped me see the connection between the problem and the proposed solution. It made the argument feel more logical and connected.</li>
          <li>I’d rate it a 4 out of 5. The structure matched the purpose really well—since the author was trying to inform other teens, the chronological structure made it easy to follow and relatable, but it needed a clearer ending.</li>
        </ul>
      </td>
    </tr>
    <tr>
      <td>
        Explicitly teach each text’s organizational structure, explaining why the author may have chosen that pattern and how it supports the text’s purpose and audience. <br><br>
        If scaffolding is needed, provide graphic organizers to help students analyze and break down the structure(s). Students can then apply the same technique by using a graphic organizer to plan and map their own writing, apprenticing the strategies modeled by the author.<br><br>
        Say, Now that you’ve seen how structure shapes meaning, it’s time to intentionally craft a text, paying close attention to choosing one of the organizational structures we studied today.<br><br>
            </td>
    </tr>
    <tr>
      <td>
        Say, You’ll choose a topic you care about—for example, school stress, college football, international politics, the environment—and develop a short text.<br><br>
        Say, be sure your text
        <ul>
          <li>serves a clear purpose and audience,</li>
          <li>follows a deliberate organizational structure, and</li>
          <li>uses transitions for cohesion.</li>
        </ul>
        Annotate your key structural choices. As students work, circulate the room, asking clarifying questions.<br><br>
        Teachers may want to choose a limited menu of options or include a chart of potential transitions as scaffolds. Topics can also be determined by local priorities.<br><br>
            </td>
                  <td>
        Students choose their topic, purpose, audience, mode(s), and genre(s) and begin working. Students replicate one of the mentor texts’ organizational patterns. <br><br>Final products will vary but may include a wide variety of modes and genres, including but not limited to print, digital, or multimodal editorials, personal narratives, speeches, proposal letters, blogs, videos, how-to guide, infographic, podcast or video, FAQ, visual essay.<br><br> </td>
    </tr>
    <tr>
      <td>
        Say, Now, I invite you to share your creations. As you share, I want you to not only present your piece but walk us through the authorial decisions you made. Let’s listen closely to how these authors shaped meaning through structure—and be ready to offer specific praise or questions afterward.<br><br>
        Celebrate students’ demonstration of mode, genre, and structure working together in support of the purpose and audience.<br><br>
        **This may take multiple instructional periods.
      </td>
      <td>
        Student responses may vary but could include:
        <ul>
          <li>I created a short podcast script for teens. The structure is compare-contrast—what it was like for college athletes before NIL (Name, Image, and Likeness) deals and what’s happening now. My transitions helped me keep it balanced.</li>
          <li>I wrote a blog, “Why We Need Meatless Mondays.” I used problem-solution to describe the issue (the lack of cafeteria vegetarian items) and to proposed a solution of student menu input. My transitions (“Here’s the real problem,” “One fix could be”) helped me guide readers logically.</li>
        </ul>
      </td>
    </tr>
  </tbody>
</table>


-----

9-12.T.SS.2

Evidence of Student Learning

<table>
  <thead>
    <tr>
      <th>Teacher Prompt</th>
      <th>Student Response</th>
    </tr>
  </thead>
  <tbody>
    <tr>
      <td>Select text excerpts to share with students; these excerpts can be pulled from course texts. However, four sample texts are provided in the 9-12.T.SS.2: Craft Carousel Resource. This resource can easily be adapted to local texts and timelines.</td>
      <td></td>
    </tr>
    <tr>
      <td>Say, Craft is what gives a text its voice. It’s not just what’s being said—it’s how it’s said. The punctuation, the figurative language, the rhythm, the tone—that’s what draws readers in or pushes them away. Today, we’re going to explore four very different texts on topic and trace how craft choices shift based on audience and purpose.</td>
      <td></td>
    </tr>
    <tr>
      <td>Provide students with the annotation directions for each round and access to all the texts. If opting for a Gallery Walk, texts need to be printed out and hung on the walls. Texts and time limits can be adapted based on student need.</td>
      <td></td>
    </tr>
    <tr>
      <td>Provide and review the context for each of the passages supplied to students (mode, genre, author, target audience). They will discuss the purposes later.</td>
      <td></td>
    </tr>
    <tr>
      <td>Say, Now, you can begin cycling through your stations. I will run a timer (if possible, use a digital timer so everyone can see) and let you know when it’s time to move to the next station. After reading all four passages, groups will return to their original passage and review the annotations left by others.<br><br> Circulate the room, providing feedback and clearing up any points of confusion as students engage in annotating the text.</td>
      <td>Students rotate through the Craft Carousel, analyzing the same passages included in your attached document. At each station, they follow a different craft-focused annotation protocol:<br>
1. Passage 1 – Highlight key phrases using figurative, connotative, and/or rhetorical language (yellow)<br>
2. Passage 2 – Highlight single words that using figurative, connotative, and/or rhetorical language (blue)<br>
3. Passage 3 – Add synonyms for impactful words via sticky note or comment<br>
4. Passage 4 – Respond with antonyms to reflect</td>
    </tr>
    <tr>
      <td></td>
      <td></td>
    </tr>
    <tr>
      <td>Debrief the activity with students (e.g., whether they enjoyed the activity, what they would change, what they liked) to assist with future planning.</td>
      <td></td>
    </tr>
    <tr>
      <td>Ask students, What did you learn from annotating the texts? Did anything surprise you?</td>
      <td>Student responses may vary but could include:<br>- It surprised me how much style changes based on the audience. The entrepreneur’s editorial sounded serious and polished, but the influencer’s video used slang and emojis—and they both made their points clearly.<br>- I realized how much a single word can change the tone.</td>
    </tr>
    <tr>
      <td>Ask students, What were the purposes for all the passages?</td>
      <td>Responses will vary based on passages provided.</td>
    </tr>
    <tr>
      <td>Ask students, How did the craft choices you notice support those specific purposes? Or did they? Facilitate the discussion.</td>
      <td>Responses will vary based on the provided passages.</td>
    </tr>
    <tr>
      <td>Say, Let’s take a vote on which one addressed their audience and purpose the best using craft techniques.</td>
      <td>Student responses may vary but could include:<br>- I picked C because the tone felt authentic. The short sentences, emojis, and jokes made it feel like someone talking directly to teens. That matched the purpose: to relate and build a brand.</td>
    </tr>
    <tr>
      <td>Announce each passage and allow students to vote on the most effective passage (e.g., show of hands, sticky dots, digital survey). Then, ask students to defend their answers with an explanation.</td>
      <td></td>
    </tr>
    <tr>
      <td>Say, Now that you've evaluated how craft choices work in different modes and genres, it’s time to put those tools to work in your own writing. You’ll choose a mode, genre, perspective, purpose, and audience and compose a short passage using at least two specific craft strategies about _______________(topic).</td>
      <td>Students work on applying their new understandings of craft in a text of their choosing. Depending on the topic, the students could choose any mode and genre, including but not limited to an op-ed, public service announcement, podcast or video script, monologue from a persona, speech, visual essay, interactive presentation).</td>
    </tr>
    <tr>
      <td>Invite students to introduce their context, share their final products, and explain their craft choices.<br><br> **This may take multiple instructional periods.</td>
      <td>Responses will vary.</td>
    </tr>
  </tbody>
</table>

____

9-12.T.T.1

Evidence of Student Learning

<table>
  <thead>
    <tr>
      <th>Teacher Prompt</th>
      <th>Student Response</th>
    </tr>
  </thead>
  <tbody>
    <tr>
      <td>Say, Writers often use stories to make abstract issues concrete and memorable. Take a moment and think of what advertising is most effective, which commercials have the biggest influence on you. Before we look at techniques, let’s think about the power of a simple story.  <br><br>
      </td>
    </tr>
    <tr>
      <td>
      Ask students, What do you think makes storytelling so powerful? Why do advertising firms use storytelling?</td>
      <td>- Responses will vary but may include: <br>Facts give you the information, but stories give you the feeling. <br>- Because they make us feel something. <br>- We can picture them. <br>- It’s easier to remember a story than a number. <br>- They’re relatable. <br>- You can connect with a story or experience, and that makes you want to learn more.</td>
    </tr>
    <tr>
      <td>Say, Let’s explore our next project.  Provide students with a copy of the 9-12.T.T.1-4 Student Exemplar Resource (or another exemplar). Review the details of the context, purpose, audience, and task with students, along with slide 1 that introduces the topic.</td>
      <td></td>
    </tr>
    <tr>
      <td>Say, Now that you know our task, let’s look together at a slide that applies narrative techniques. Share the following and provide time to read silently. <br><br>Read aloud and discuss the two quotations and the script. Ask students, What do you notice? <br><br>Say, Notice how the students aren’t giving data yet—they’re connecting with the audience emotionally by using narrative techniques.</td>
      <td>Responses will vary but could include: <br>- They tell stories with real-life characters (grandmother, neighbor).  <br>- They both use first person and imagery. <br>- They connect an event to a bigger concept.</td>
    </tr>
    <tr>
      <td>Ask students, How do these stories make you feel? Do any of you connect with one or both of these stories? <br><br>
      </td><td>Responses will vary.</td>
    </tr>
    <tr>
      <td>
        Say, Authors can use narrative techniques in all kinds of writings. The key is to align them with their purpose.  <br><br>Ask students,  <br>- What do you notice about these stories?  <br>- How do you think they develop the author’s purpose?  <br>- What details make this story vivid? How do these personal stories set up the bigger argument for the garden?  <br><br>Affirm student responses, especially those that discuss specific narrative techniques (e.g., symbolism, plot structures, narrative devices, word choices, themes).  <br><br>Say, Yes, excellent observation! The story can be a vehicle for making something symbolic, which really expands its application.</td>
      <td>Responses will vary but may include: <br>- Tomatoes become more than just a fruit; they are a symbol for whatever “feeds” your soul. <br>- It’s specific—"tomatoes,” “grandmother”—not general. <br>- It connects gardening to family and tradition. <br>- The imagery helps you connect with the experience, and the experience helps you connect with the idea.</td>
    </tr>
    <tr>
      <td>Say, Now, in your groups, brainstorm a how to use narrative techniques in your own community initiative presentation. You could tell an anecdote, use symbolism, develop a theme. However, your choice should connect to the larger issue your project will address. <br><br></td>
      <td>Responses will vary based on group initiative, but texts may be connected to: <br>- recycling campaigns, <br>- new sports facilities or new sports offerings, or <br>- conservation.</td>
    </tr>
    <tr>
      <td>As students work, circulate the room, asking: <br>- What narrative technique(s) are you using?  <br>Why did you make that choice?  <br>- How does your choice lead into the issue you’re addressing? <br><br>Say, Let’s hear a few narrative openings. As we listen, think: How does this personal story set up the group’s larger proposal?  <br><br>Continue to facilitate groups’ sharing and reflection.</td>
      <td>Responses will vary based on initiative but could include:  <br>- We’re starting with imagery and description of an abandoned playground I used to play on. The description of the abandoned playground highlights loss. That makes it natural to move into our proposal for revitalizing the park so kids today can have the same experiences we did.</td>
    </tr>
    <tr>
      <td>Say, For an exit ticket today, what narrative technique did you use (plot structure, How did it help audience engagement?</td>
      <td>Responses will vary.</td>
    </tr>
  </tbody>
</table>

    
_____

9-12.T.T.2

Evidence of Student Learning

<table>
  <thead>
    <tr>
      <th>Teacher Prompt</th>
      <th>Student Response</th>
    </tr>
  </thead>
  <tbody>

    <tr>
      <td>Say, We know that stories can make an audience care. Today we’ll look at how exposition makes an audience understand. If you tell me a story about food insecurity, I might care—but unless you explain the plan step by step, I won’t know what to do with that feeling.</td>
      <td></td>
    </tr>
    <tr>
      <td>Ask students, What are expository techniques? Can anyone tell me what it is or give an example?</td>
      <td> Responses will vary but may include:
        <ul>
          <li>It’s like explaining something really clearly—kind of like giving directions so people understand what you mean.</li>
          <li>Expository techniques are when you add details, like numbers or steps, to show how something works.</li>
          <li>It’s basically the facts, not opinions. Like if you say, “The school cafeteria produces 600 bottles of waste a week,” that’s exposition.</li>
          <li>I think it means describing something in detail, like what it looks like.</li>
        </ul>
      </td>
    </tr>
    <tr>
      <td>Affirm and discuss student responses.</td>
      <td></td>
    </tr>
    <tr>
      <td>Say, Great ideas! Description can be part of exposition, but you’ll also need sequencing, numbers, and examples to make it complete. Exposition provides information or an explanation; in our projects, it means explaining clearly with facts, details, and steps.</td>
      <td></td>
    </tr>
    <tr>
      <td>Say, Let’s explore our project. Provide students with a copy of the 9-12.T.T.1-4 Student Exemplar Resource (or another exemplar). Allow students to review the presentation independently, and then emphasize the context, purpose, audience, and task with students. Read aloud the script to students for slide 7 and discuss.</td>
      <td></td>
    </tr>
    <tr>
      <td>Ask students, What expository techniques do you notice in this text??</td>
      <td> Responses will vary but may include:
        <ul>
          <li>Quantitative Detail: $10,000 makes the request concrete.</li>
          <li>Examples of specific benefits: produce, classroom, shared space</li>
          <li>Explanation in cause-effect format: “With that support, we can…” shows what happens if the funding is approved.</li>
        </ul>
      </td>
    </tr>
    <tr>
      <td>Affirm student responses and facilitate continued conversation.</td>
      <td></td>
    </tr>
    <tr>
      <td>Say, Notice: exposition is not about making people feel—it’s about making them see clearly. It gives the audience enough information to trust that your idea is possible.</td>
      <td></td>
    </tr>
    <tr>
      <td>Say, Now, it’s your turn. In your groups, answer these three questions about your project:<br>1. What exactly is your proposal?<br>2. Where will it take place?<br>3. How will it work, step by step?</td>
      <td></td>
    </tr>
    <tr>
      <td>Say, Write 3–4 sentences that use expository techniques to explain your idea or to provide information about it.</td>
      <td>Responses will vary.</td>
    </tr>
    <tr>
      <td>As students work, circulate the room, asking:<br>- Where’s your specific detail?<br>- Can your audience follow the sequence?<br>- Did you add an example or a number to make it clearer?</td>
      <td></td>
    </tr>
    <tr>
      <td>Say, Let’s share one group’s example aloud. As you listen, ask yourself: Can I picture the plan? Do I know where and how it will work?</td>
      <td>Responses will vary but may include:
        <ul>
          <li>The park is two blocks from school but is overgrown and unused. The city owns the land; adding benches and lights would make it safe again. Students and families could then use it.</li>
        </ul>
      </td>
    </tr>
    <tr>
      <td>Continue to facilitate groups’ sharing and reflection.</td>
      <td></td>
    </tr>
    <tr>
      <td>Say, For an exit ticket today, what expository technique did you use (specific detail, logical sequence, examples, illustrations, definition) quantitative detail)? How did it make your project clearer?</td>
      <td>Responses will vary but may include:
        <ul>
          <li>We added quantitative detail. We said students throw away 600 plastic bottles every week. That number makes the problem more real.</li>
        </ul>
      </td>
    </tr>
  </tbody>
</table>

-----
9-12.T.T.3

Evidence of Student Learning

<table>
  <thead>
    <tr>
      <th>Teacher Prompt</th>
      <th>Student Response</th>
    </tr>
  </thead>
  <tbody>
    <tr>
      <td>Ask students, Have you ever changed your mind about something or someone? What changed your mind?</td>
      <td>
        Responses will vary but may include:<br>- Yeah, I used to think soccer was boring, but after playing on a team I realized it’s way harder and more fun than I thought.<br>
        - At first, I thought group projects were the worst, but after working with friends on one, I realized it can actually make the work easier.<br>
        - I changed my mind about fast food. After watching a documentary, I don’t eat it as much anymore.
      </td>
    </tr>
    <tr>
      <td>Say, When we want to change people’s minds, it’s not enough to just tell a story or explain facts. We also have to argue—make a claim, back it with evidence, and acknowledge and respond to other perspectives.</td>
      <td></td>
    </tr>
    <tr>
      <td>If students require additional scaffolding on argumentative techniques, this vocabulary activity could be beneficial.</td>
      <td></td>
    </tr>
    <tr>
      <td>Say, Let’s explore our project. Provide students with a copy of the 9-12.T.T.1-4 Student Exemplar Resource (or another exemplar). Allow students to review the presentation independently, and then emphasize the context, purpose, audience, and task with students.</td>
      <td></td>
    </tr>
    <tr>
      <td>Read the slide aloud. Say, Let’s break this down. Can you identify a claim, evidence, and reasoning?</td>
      <td> Responses will vary but may include:<br>
        - Claim: A community garden helps solve food insecurity.<br>
        - Evidence: ‘1 in 6 families…’ (credible statistic).<br>
        - Reasoning: Gardens provide food for families.
      </td>
    </tr>
    <tr>
      <td>Say, This is what sets argument apart—argumentative techniques support ideas with evidence and reasoning.</td>
      <td></td>
    </tr>
    <tr>
      <td>Ask students, What makes that argument stronger than just saying, ‘We should build a garden’?</td>
      <td>Responses will vary but may include:<br>
        - They give numbers to prove it’s a real problem.<br>
        - It shows why the garden matters, not just that it exists.
      </td>
    </tr>
    <tr>
      <td>Say, Now, let’s practice. In your groups, draft one strong claim about your project, one piece of evidence, and one possible counterargument with a rebuttal. Use the mentor sample for inspiration.</td>
      <td></td>
    </tr>
    <tr>
      <td>As students work, circulate the room, asking:<br>
        - Is your evidence credible and specific?<br>
        - Have you explained how your evidence proves your claim?<br>
        - Do you use any rhetorical appeals or language?<br>
        - What might someone argue against your idea? How will you respond?</td>
      <td></td>
    </tr>
    <tr>
      <td>Let’s share one example. As you listen, think: Did they state a clear claim? Did they back it with credible evidence? Did they anticipate opposition?</td>
      <td>Responses will vary but may include:<br>
        - We argued recycling saves money, showed EPA data, and countered that bins cost too much by explaining long-term savings.
      </td>
    </tr>
    <tr>
      <td>Celebrate students’ understanding. If applicable, say, You’ve moved from just explaining your plan to defending it. That’s the shift from exposition to argument.</td>
      <td></td>
    </tr>
    <tr>
      <td>Continue to facilitate groups’ sharing and reflection.</td>
      <td></td>
    </tr>
    <tr>
      <td>Say, For an exit ticket today, what argumentative technique did you use? How did it make your project stronger?</td>
      <td>Responses will vary but may include:<br>
        - We used a statistic about park safety to make our point—it gave proof, not just opinion.
      </td>
    </tr>
  </tbody>
</table>

----
9-12.T.T.4

<h2>Evidence of Student Learning</h2>

<table>
  <thead>
    <tr>
      <th>Teacher Prompt</th>
      <th>Student Response</th>
    </tr>
  </thead>
  <tbody>
    <tr>
      <td>Say, Think about an ad, slogan, or lyric you remember. Why do you think it stuck with you? Was it the facts—or was it the words?<br><br>Discuss and affirm student responses.</td>
      <td>Responses will vary but may include:<br>
      - Because it sounded cool or catchy.<br>
      - It had a rhyme or rhythm.<br>
      - The words painted a picture. </td>
    </tr>
    <tr>
      <td>Say, Today we’re learning how poetic techniques—like imagery and metaphor—make your ideas stick with an audience.</td>
      <td></td>
    </tr>
    <tr>
      <td>Ask students, What are poetic techniques that you know or have used?</td>
      <td>Responses will vary but may include but are not limited to figurative language, sound devices, and/or structural techniques: imagery, metaphor, simile, personification, symbolism, alliteration, assonance, consonance, onomatopoeia, repetition, parallelism, enjambment, rhyme, meter.</td>
    </tr>
    <tr>
      <td>Say, Let’s refine our project and make it last. Review the 9-12.T.T.1-4 Student Exemplar Resource (or another exemplar). Allow students to review the presentation independently, and then emphasize the context, purpose, audience, and task with students.</td>
      <td></td>
    </tr>
    <tr>
      <td>Say, What do you notice about this slide?</td>
      <td>Responses will vary but may include:<br>
      - It’s a map that shows the garden’s proximity to the school.<br>
      - It uses green to pinpoint the garden site. </td>
    </tr>
    <tr>
      <td>Then, read aloud the script for slide 4.</td>
      <td></td>
    </tr>
    <tr>
      <td>Ask students, What poetic techniques do you notice in this part of the script?</td>
      <td>Responses will vary but may include:<br>
      - Imagery: “rows of green” creates a picture.<br>
      - Metaphor: soil as “canvas,” plot as “promise”<br>
      - Symbolism: paths as “threads”<br>
      - Figurative phrasing: “weaving neighbors” connects the metaphor to the community </td>
    </tr>
    <tr>
      <td>Say, Notice that on this slide, the author is providing factual information as well—it’s what you immediately noticed. What kind of techniques are those?</td>
      <td>Expository! </td>
    </tr>
    <tr>
      <td>Ask students, So, why doesn’t the author just say, “We’ll grow vegetables.” Does the author’s use of poetic techniques enhance the slide’s content? Why or why not?</td>
      <td>Responses will vary but may include:<br>
      - Yes, it makes it more memorable.<br>
      - It connects the garden to people, not just plants.<br>
      - No, I just want to see the map. It’s enough for me.<br>
      - It helps the audience make connections.</td>
    </tr>
    <tr>
      <td>Say, Now, I want you to write two lines about your project using imagery or metaphor. Ask yourselves,<br>- What do I want the audience to see or feel?</td>
      <td></td>
    </tr>
    <tr>
      <td>Say, Poetic techniques elevate vision and create impact. Let’s share one example.<br><br> Celebrate students’ understanding and growth. Say, Now, we want to see how your use of poetic techniques continues to strengthen your multimodal presentation for your target audience. <br><br>Continue to facilitate groups’ sharing and reflection.</td>
            <td>Responses will vary but may include:<br>
      - The empty park is a sleeping giant waiting to wake. We thought that metaphor would make people want to wake it up<br>
      - Each bottle we save is a drop of tomorrow’s water. </td>
    </tr>
    <tr>
      <td>Say, For an exit ticket today, which poetic technique did you use? How did it support your purpose or speak to your target audience? How did it enrich your project as a whole?</td>
      <td>Responses will vary but may include:<br>
      - We wrote that ‘the cafeteria whispers with wasted plastic bottles.’ It made the issue of recycling more urgent and memorable for students. </td>
    </tr>
  </tbody>
</table>
----

9-12.T.RA.1

Evidence of Student Learning

<table>
  <thead>
    <tr>
      <th>Teacher Prompt</th>
      <th>Student Response</th>
    </tr>
  </thead>
  <tbody>
    <tr>
      <td>Say, Raise your hand if you’ve ever clicked ‘Accept All Cookies’ without reading what you agreed to.</td>
      <td>Responses will vary, but most hands will probably go up.</td>
    </tr>
    <tr>
      <td>Say, That’s digital privacy. Every day, we leave digital footprints—sometimes without realizing it. Let’s start with a big question: What do you want to know about how your privacy is being used online?</td>
      <td>Responses will vary but may include:<br>- Do apps sell my data?<br>- Why do I get ads for things I just talked about?<br>- Is my phone listening to everything I say?</td>
    </tr>
    <tr>
      <td>Great—these questions show curiosity. Now let’s learn how to refine them into strong research questions. When we ask research questions, we want them to be answerable with evidence.</td>
      <td></td>
    </tr>
    <tr>
      <td>Ask students, Why don’t I want a research question to be answered with a yes or no?</td>
      <td>Responses will vary but may include:<br>- Yes or no doesn’t give you enough evidence to build an argument.<br>- Research questions should make you think, not just look up a quick answer.<br>- A yes/no answer won’t show multiple perspectives.<br>- Because then the answer is too short—you can’t dig deeper.</td>
    </tr>
    <tr>
      <td>Provide a think-aloud for students of how you would refine a research question.</td>
      <td></td>
    </tr>
    <tr>
      <td>Say, Watch how I refine this:<br>- Too broad: Is digital privacy important?<br>- Better: How do social media platforms collect and use teen data?<br>- Strong: What are the effects of social media data collection on teen privacy rights?</td>
      <td></td>
    </tr>
    <tr>
      <td>With a partner, write down three questions about digital privacy. Use these prompts:<br>- What is happening?<br>- Why is it happening?<br>- What are the impacts?</td>
      <td>In partners, students draft three questions.<br><br></td>
    </tr>
    <tr>
      <td>Now let’s check: Are your questions researchable? Are they too broad, too narrow, or just right? <br><br> Circulate the room, asking students clarifying questions to help them craft a solid research question related to digital privacy.</td>
      <td>Responses will vary but may include:<br>- Why do companies track location data?<br>- What are the benefits and risks of location tracking for teens?</td>
    </tr>
  
    <tr>
      <td>Say, After you determine your question, jump into an “inquiry sprint,” where you engage in efficient research of your question to see what you can learn to answer your question, and be sure to evaluate the credibility of the sources you locate as you go.</td>
      <td>Responses will vary but may include:<br>- Is online shopping safe? That feels too big. Maybe: How do online retailers protect or fail to protect teen financial information? <br><br> Students engage in research and make notes about potential answers to their research questions.</td>
    </tr>
    <tr>
      <td>Say, Today, you practiced moving from curiosity to inquiry, turning your thoughts about digital privacy into strong, researchable questions. You asked questions that can be investigated, supported with credible sources, and used to form evidence-based answers. For your exit ticket, share your takeaway from today.</td>
      <td>Responses will vary but could include: <br>
- I learned to avoid yes/no questions—digging into the ‘why’ makes it better.<br>
- Research questions need to bring out multiple perspectives about a topic.<br>
- I learned to think carefully before clicking "Accept cookies."</td>
    </tr>
  </tbody>
</table>

    
---

9-12.T.RA.2

<table>
  <thead>
    <tr>
      <th>Teacher Prompt</th>
      <th>Student Response</th>
    </tr>
  </thead>
  <tbody>
    <tr>
      <td>Say, Think about a time you felt stressed—maybe before a test or after an argument. Did you listen to music? Did it help? Why?</td>
      <td>Responses will vary but may include:
        <ul>
          <li>I listen to upbeat songs when I’m nervous. It distracts me.</li>
          <li>I go for calm music—it helps me relax.</li>
          <li>I listen to music while I’m doing homework because it helps me focus.</li>
        </ul>
      </td>
    </tr>
    <tr>
      <td>Say, Great—your experiences connect to what researchers are studying. Let’s see what the evidence says. Today, we’re asking: What role does music play in helping people cope with stress? Our goal isn’t just to answer this question, but to learn how to curate and integrate evidence from different sources.</td>
      <td></td>
    </tr>
    <tr>
      <td>
        Here are excerpts from four sources:<br>
        - Source 1: A peer-reviewed psychology study on music and stress hormones.<br>
        - Source 2: A blog post about one person’s experience using playlists to relax.<br>
        - Source 3: A news article about music as a tool.<br>
        - Source 4: A podcast episode excerpt featuring an interview with a music therapist.
      </td>
      <td></td>
    </tr>
    <tr>
      <td>
        Say, As you examine these sources, ask yourself:<br>
        - Who is the author, and what are their credentials?<br>
        - What’s the purpose of the text—inform, persuade, share experience?<br>
        - Who is the audience, and how does that affect tone or style?<br>
        - How credible is this source for answering our question?
      </td>
      <td>Responses will vary but may include:
        <ul>
          <li>It’s a journalist, so it’s not a study, but it’s written for the public.</li>
          <li>That makes it easier to understand, but maybe less detailed than the real research.</li>
          <li>The study is the most credible; it’s scientific.</li>
          <li>But the blog is good for showing personal experience.</li>
        </ul>
      </td>
    </tr>
    <tr><td>
    The
Situating Texts resource can provide additional questions.<br><br>
Say, Exactly—credibility and accessibility both matter when we curate sources. Sources can add perspective.<br><br></td></tr>
Affirm student responses and ask clarifying questions.
    <tr> 
      <td>Ask students, Now, in pairs, rank the four sources from strongest to weakest. Which would you use first if you were building an argument? Which might you use only for context or perspective?</td>
      <td>Student pairs create a ranked list with justification. Responses will vary but may include:
        <ul>
          <li>The study is strongest, the blog is weakest, but the blog shows how real teens feel.</li>
          <li>The podcast is between—it has an expert but not as formal as a study.</li>
        </ul>
      </td>
    </tr>
    <tr>
      <td>
        Say, Now I want you to craft a short synthesis statement together using at least two sources.<br>
        <br><br>Provide students with a mentor synthesis statement: The study shows calming music lowers cortisol, and the podcast gives an example of a teen using playlists to manage exam stress. Together, this suggests music’s power is both biological and emotional.
      </td>
      <td>In pairs, students talk through the sources and create synthesis statements using at least two sources. Responses will vary but could include:
        <ul>
          <li>The news article says most teens think music helps, and the blog shows one person’s story. Together, that’s both data and lived experience.</li>
        </ul>
      </td>
    </tr>
    <tr><td>
    Celebrate students’ understanding and growth as students continue to share. <br><br>
    Say, Today, you evaluated sources, ranked them, and synthesized them to craft a statement that revealed how the perspectives complemented or contrasted one another.
    </td></tr>
  </tbody>
</table>

---

9-12.T.PM.1

Evidence of Student Learning

<table>
  <thead>
    <tr>
      <th>Teacher Prompt</th>
      <th>Student Response</th>
    </tr>
  </thead>
  <tbody>
    <tr>
      <td>Say, Think about a song that came out five years ago versus one released this year. Even without the title, you can probably tell when it was produced—maybe by style, lyrics, or even what was happening in the world. Literature works the same way: we ‘situate’ texts in their period or movement by examining context, author, audience, and purpose.</td>
      <td></td>
    </tr> 
    <tr>
      <td>Ask students, Can anyone explain the difference between periods and movements?</td>
      <td>Responses will vary but may include:<br>
      - Periods are the broader classification, and movements are more specific.<br>
      - A period is like the full football season; a movement is like a specific playbook or strategy within that season?<br>
      - A period is the act and movements are the scenes.</td>
    </tr> 
    <tr>
      <td>Say, Think of literature like a group chat across time. Writers don’t create in isolation—they’re influenced by what came before, and they often respond to what’s happening around them. Some even band together to form movements.</td>
      <td></td>
    </tr> 
    <tr>
      <td>Say, One of our guiding questions is: What was happening in the world when this text was produced? Today, we’ll explore how to recognize the themes, genres, and styles that define a period or movement—and how those features help us situate texts historically.</td>
      <td></td>
    </tr> 
    <tr>
      <td>Provide students with a sample passage with no author or identifying information and the final pages of the Periods &amp; Movements resource (or a similar resource), if applicable to your selected texts. Say, Let’s analyze this passage without knowing the author. We’ll use our framework: context, author, audience, and purpose.</td>
      <td></td>
    </tr> 
    <tr>
      <td>Ask students, With the following questions in mind, what do you notice about this sample passage?<br>
      - Context: What historical or cultural events might shape this text?<br>
      - Author: What values or perspectives seem to come through?<br>
      - Audience: Who was this text written for? Who might disagree with it?<br>
      - Purpose: What was the author trying to accomplish?<br><br> Say, When we combine answers to those questions, we can place the text into a period or movement.</td>
      <td>Students should be able to apply skills to address questions based on what they notice about the content (themes), genre (forms/structures), and styles (language). They should then try to situate them in relation to a broader period or movement. Sample responses might include:<br>
- The formal style makes me think it’s from an earlier period.<br>
- It seems to value loyalty and family.<br>
- It seems like it was written for people who love the outdoors.<br>
- It seems like the author is trying to persuade people—so maybe the purpose is to influence public opinion?</td>
    </tr> 
    <tr><td>Guide students’ discussion of the passage, affirming correct insights and modeling think-alouds or quick collaborative research as needed to scaffold their ability to situate the text.</td></tr>
    <tr>
      <td>Provide student groups with two to four short passages of major works from a literary period. Say, Let’s look at these short passages. I won’t tell you who wrote them or when they wrote them. First, go through the same questions about context, author, audience, and purpose. Then, consider what themes stand out, what stylistic features you see, and whether it feels like it’s responding to something particular in history.</td>
      <td>Students read the texts together and provide as any responses on context, author, audience, purpose, theme(s), and stylistic features, as possible. Students can make notes and compare the passages against the Periods & Movements resource.</td>
    </tr> 
    <tr>
      <td>Ask students, What themes, genres, or styles link these texts? Predict their period or movement, and consider how history or culture shaped their differences.</td>
      <td>Responses will vary but may include:<br>
- Both talk about society’s rules, but one celebrates breaking them and the other warns against it.<br>
- If this one was written during war, that could explain the focus on justice.<br>
- And if this one came later, maybe it reflects disappointment after the war.<br>
- They all seem to share a theme, but they take it in different directions.</td>
    </tr> 
    <tr>
      <td>Say, Excellent! You have shown one of our main points: Literature both responds to and shapes history.</td>
      <td></td>
    </tr> 
  </tbody>
</table>

** K-12.END
PROCESS FINAL SECTION
`
}